import { jsx as m, jsxs as P, Fragment as ze } from "react/jsx-runtime";
import * as g from "react";
import Te, { createContext as Jt, useContext as yr, useCallback as ke, useState as De, useRef as Ee, useEffect as xe, useMemo as Zo, createElement as _h, forwardRef as At, cloneElement as Jl, useLayoutEffect as xh, useReducer as $h, Component as kh } from "react";
import * as Gl from "react-dom";
import ds from "react-dom";
import { D as pa, p as Eh, s as Sh, a as Ch } from "./communicationBanner-vYlZuX5X.js";
import { g as WL, h as qL } from "./communicationBanner-vYlZuX5X.js";
const Oh = (e, t, n, o) => {
  const r = [n, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(r, "warn", "react-i18next::", !0);
  zt(r[0]) && (r[0] = `react-i18next:: ${r[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...r) : console?.warn && console.warn(...r);
}, fa = {}, Ci = (e, t, n, o) => {
  zt(n) && fa[n] || (zt(n) && (fa[n] = /* @__PURE__ */ new Date()), Oh(e, t, n, o));
}, Yl = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, Oi = (e, t, n) => {
  e.loadNamespaces(t, Yl(e, n));
}, ha = (e, t, n, o) => {
  if (zt(n) && (n = [n]), e.options.preload && e.options.preload.indexOf(t) > -1) return Oi(e, n, o);
  n.forEach((r) => {
    e.options.ns.indexOf(r) < 0 && e.options.ns.push(r);
  }), e.loadLanguages(t, Yl(e, o));
}, Nh = (e, t, n = {}) => !t.languages || !t.languages.length ? (Ci(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: n.lng,
  precheck: (o, r) => {
    if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !r(o.isLanguageChangingTo, e)) return !1;
  }
}), zt = (e) => typeof e == "string", Rh = (e) => typeof e == "object" && e !== null, Ah = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Ih = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Ph = (e) => Ih[e], Th = (e) => e.replace(Ah, Ph);
let Lh = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Th
};
const jh = () => Lh;
let Dh;
const zh = () => Dh, Xl = Jt();
class Mh {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Fh = (e, t) => {
  const n = Ee();
  return xe(() => {
    n.current = e;
  }, [e, t]), n.current;
}, Ql = (e, t, n, o) => e.getFixedT(t, n, o), Vh = (e, t, n, o) => ke(Ql(e, t, n, o), [e, t, n, o]), Gt = (e, t = {}) => {
  const {
    i18n: n
  } = t, {
    i18n: o,
    defaultNS: r
  } = yr(Xl) || {}, i = n || o || zh();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new Mh()), !i) {
    Ci(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const _ = (C, k) => zt(k) ? k : Rh(k) && zt(k.defaultValue) ? k.defaultValue : Array.isArray(C) ? C[C.length - 1] : C, x = [_, {}, !1];
    return x.t = _, x.i18n = {}, x.ready = !1, x;
  }
  i.options.react?.wait && Ci(i, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const s = {
    ...jh(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: a,
    keyPrefix: l
  } = s;
  let c = e || r || i.options?.defaultNS;
  c = zt(c) ? [c] : c || ["translation"], i.reportNamespaces.addUsedNamespaces?.(c);
  const u = (i.isInitialized || i.initializedStoreOnce) && c.every((_) => Nh(_, i, s)), d = Vh(i, t.lng || null, s.nsMode === "fallback" ? c : c[0], l), f = () => d, h = () => Ql(i, t.lng || null, s.nsMode === "fallback" ? c : c[0], l), [b, p] = De(f);
  let y = c.join();
  t.lng && (y = `${t.lng}${y}`);
  const $ = Fh(y), v = Ee(!0);
  xe(() => {
    const {
      bindI18n: _,
      bindI18nStore: x
    } = s;
    v.current = !0, !u && !a && (t.lng ? ha(i, t.lng, c, () => {
      v.current && p(h);
    }) : Oi(i, c, () => {
      v.current && p(h);
    })), u && $ && $ !== y && v.current && p(h);
    const C = () => {
      v.current && p(h);
    };
    return _ && i?.on(_, C), x && i?.store.on(x, C), () => {
      v.current = !1, i && _ && _?.split(" ").forEach((k) => i.off(k, C)), x && i && x.split(" ").forEach((k) => i.store.off(k, C));
    };
  }, [i, y]), xe(() => {
    v.current && u && p(f);
  }, [i, l, u]);
  const w = [b, i, u];
  if (w.t = b, w.i18n = i, w.ready = u, u || !u && !a) return w;
  throw new Promise((_) => {
    t.lng ? ha(i, t.lng, c, () => _()) : Oi(i, c, () => _());
  });
};
function Uh({
  i18n: e,
  defaultNS: t,
  children: n
}) {
  const o = Zo(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return _h(Xl.Provider, {
    value: o
  }, n);
}
function eu(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = eu(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function be() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = eu(e)) && (o && (o += " "), o += t);
  return o;
}
const Bh = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Hh = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Kh = Bh.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Hh[e]
})), Wh = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, qh = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function Zh(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ m("span", { className: n }, n));
}
const he = At(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...r }, i) => {
    const s = Kh.find((l) => l.name === e), a = be("icon", `ds-${s?.class}`, qh[t], Wh[n], o);
    return /* @__PURE__ */ m("i", { className: a, ...r, ref: i, children: Zh(s?.paths) });
  }
);
he.displayName = "Icon";
const Jh = "_loader_1ksyv_29", Gh = "_circle_1ksyv_41", nn = {
  loader: Jh,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Gh,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Yh = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Xh = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Qh({ onDark: e, size: t = "medium", color: n = "primary", className: o }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      className: be(
        nn.loader,
        nn[Yh[t]],
        nn[Xh[n]],
        e && nn["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ m("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ m("circle", { className: nn.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ P(
          "circle",
          {
            className: nn["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ m("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ m(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const em = "_button_z1os6_29", tm = "_disabled_z1os6_43", nm = "_loader_z1os6_263", wt = {
  button: em,
  disabled: tm,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: nm,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, ps = At(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: o = !1,
    icon: r,
    iconPosition: i = "left",
    isLoading: s = !1,
    iconSize: a = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...f
  }, h) => {
    const b = be(
      wt.button,
      wt[om[t]],
      wt[rm[n]],
      o && wt["is-full-width"],
      c && wt.disabled,
      i === "right" && wt["has-icon-right"],
      l && wt["is-contrasted"],
      s && wt["is-loading"],
      u
    ), p = /* @__PURE__ */ P(ze, { children: [
      s && /* @__PURE__ */ m(Qh, { className: wt.loader, onDark: !0, size: "small" }),
      r && i === "left" && /* @__PURE__ */ m(he, { color: "inherit", size: a, name: r }),
      d ?? e,
      r && i === "right" && /* @__PURE__ */ m(he, { color: "inherit", size: a, name: r })
    ] });
    if (im(f))
      return /* @__PURE__ */ m(
        "a",
        {
          ...f,
          href: c ? void 0 : f.href,
          className: b,
          target: f.target,
          ref: h,
          children: p
        }
      );
    if (sm(f))
      return /* @__PURE__ */ m(
        "button",
        {
          disabled: s || c,
          ...f,
          className: b,
          ref: h,
          children: p
        }
      );
  }
);
ps.displayName = "Button";
const om = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, rm = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function im(e) {
  return "href" in e && typeof e.href == "string";
}
function sm(e) {
  return !("href" in e);
}
const ma = {
  MOBILE: 640,
  TABLET: 768
}, am = "_text_19q11_29", Tt = {
  text: am,
  "is-small": "_is-small_19q11_34",
  "is-ellipsis": "_is-ellipsis_19q11_38",
  "is-center": "_is-center_19q11_44",
  "color-primary": "_color-primary_19q11_47",
  "color-secondary": "_color-secondary_19q11_50",
  "color-tertiary": "_color-tertiary_19q11_53",
  "color-eco-green": "_color-eco-green_19q11_56",
  "color-success": "_color-success_19q11_59",
  "color-error": "_color-error_19q11_62",
  "color-inverted": "_color-inverted_19q11_65",
  "color-warning": "_color-warning_19q11_68",
  "color-inherit": "_color-inherit_19q11_71",
  "is-bold": "_is-bold_19q11_74",
  "size-xs": "_size-xs_19q11_77",
  "size-sm": "_size-sm_19q11_80",
  "size-base": "_size-base_19q11_83",
  "size-lg": "_size-lg_19q11_86",
  "size-xl": "_size-xl_19q11_89",
  "dialog-overlay-show": "_dialog-overlay-show_19q11_1",
  "dialog-content-show": "_dialog-content-show_19q11_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_19q11_1"
};
function Le({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: n,
  ellipsis: o,
  isSpan: r,
  className: i = "",
  color: s = "primary",
  isBold: a,
  size: l,
  title: c,
  center: u,
  ...d
}) {
  const f = be(
    Tt.text,
    n && Tt["is-small"],
    o && Tt["is-ellipsis"],
    s && Tt[`color-${s}`],
    a && Tt["is-bold"],
    l && Tt[`size-${l}`],
    u && Tt["is-center"],
    i
  ), h = r ? "span" : "div";
  return t ? /* @__PURE__ */ m(h, { className: f, dangerouslySetInnerHTML: t, ...d, title: c }) : /* @__PURE__ */ m(h, { className: f, ...d, children: e });
}
function se(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var kt = globalThis?.document ? g.useLayoutEffect : () => {
}, cm = g[" useInsertionEffect ".trim().toString()] || kt;
function Xn({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, i, s] = lm({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, l = a ? e : r;
  {
    const u = g.useRef(e !== void 0);
    g.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, o]);
  }
  const c = g.useCallback(
    (u) => {
      if (a) {
        const d = um(u) ? u(e) : u;
        d !== e && s.current?.(d);
      } else
        i(u);
    },
    [a, e, i, s]
  );
  return [l, c];
}
function lm({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = g.useState(e), r = g.useRef(n), i = g.useRef(t);
  return cm(() => {
    i.current = t;
  }, [t]), g.useEffect(() => {
    r.current !== n && (i.current?.(n), r.current = n);
  }, [n, r]), [n, o, i];
}
function um(e) {
  return typeof e == "function";
}
function ga(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function fs(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const i = ga(r, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const i = o[r];
          typeof i == "function" ? i() : ga(e[r], null);
        }
      };
  };
}
function Se(...e) {
  return g.useCallback(fs(...e), e);
}
function dm(e, t) {
  const n = g.createContext(t), o = (i) => {
    const { children: s, ...a } = i, l = g.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ m(n.Provider, { value: l, children: s });
  };
  o.displayName = e + "Provider";
  function r(i) {
    const s = g.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function Yt(e, t = []) {
  let n = [];
  function o(i, s) {
    const a = g.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      const { scope: f, children: h, ...b } = d, p = f?.[e]?.[l] || a, y = g.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ m(p.Provider, { value: y, children: h });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      const h = f?.[e]?.[l] || a, b = g.useContext(h);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const r = () => {
    const i = n.map((s) => g.createContext(s));
    return function(s) {
      const a = s?.[e] || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: a } }),
        [s, a]
      );
    };
  };
  return r.scopeName = e, [o, pm(r, ...t)];
}
function pm(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(r) {
      const i = o.reduce((s, { useScope: a, scopeName: l }) => {
        const c = a(r)[`__scope${l}`];
        return { ...s, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function Jo(e) {
  const t = /* @__PURE__ */ fm(e), n = g.forwardRef((o, r) => {
    const { children: i, ...s } = o, a = g.Children.toArray(i), l = a.find(mm);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ m(t, { ...s, ref: r, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: r, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function fm(e) {
  const t = g.forwardRef((n, o) => {
    const { children: r, ...i } = n;
    if (g.isValidElement(r)) {
      const s = vm(r), a = gm(i, r.props);
      return r.type !== g.Fragment && (a.ref = o ? fs(o, s) : s), g.cloneElement(r, a);
    }
    return g.Children.count(r) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var hm = Symbol("radix.slottable");
function mm(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === hm;
}
function gm(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      const a = i(...s);
      return r(...s), a;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function vm(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var bm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], le = bm.reduce((e, t) => {
  const n = /* @__PURE__ */ Jo(`Primitive.${t}`), o = g.forwardRef((r, i) => {
    const { asChild: s, ...a } = r, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(l, { ...a, ref: i });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Ni(e, t) {
  e && Gl.flushSync(() => e.dispatchEvent(t));
}
var ym = g.createContext(void 0);
function wr(e) {
  const t = g.useContext(ym);
  return e || t || "ltr";
}
function hs(e) {
  const t = e + "CollectionProvider", [n, o] = Yt(t), [r, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (p) => {
    const { scope: y, children: $ } = p, v = Te.useRef(null), w = Te.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(r, { scope: y, itemMap: w, collectionRef: v, children: $ });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", l = /* @__PURE__ */ Jo(a), c = Te.forwardRef(
    (p, y) => {
      const { scope: $, children: v } = p, w = i(a, $), _ = Se(y, w.collectionRef);
      return /* @__PURE__ */ m(l, { ref: _, children: v });
    }
  );
  c.displayName = a;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ Jo(u), h = Te.forwardRef(
    (p, y) => {
      const { scope: $, children: v, ...w } = p, _ = Te.useRef(null), x = Se(y, _), C = i(u, $);
      return Te.useEffect(() => (C.itemMap.set(_, { ref: _, ...w }), () => void C.itemMap.delete(_))), /* @__PURE__ */ m(f, { [d]: "", ref: x, children: v });
    }
  );
  h.displayName = u;
  function b(p) {
    const y = i(e + "CollectionConsumer", p);
    return Te.useCallback(() => {
      const $ = y.collectionRef.current;
      if (!$) return [];
      const v = Array.from($.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (w, _) => v.indexOf(w.ref.current) - v.indexOf(_.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: h },
    b,
    o
  ];
}
var wm = g[" useId ".trim().toString()] || (() => {
}), _m = 0;
function Mt(e) {
  const [t, n] = g.useState(wm());
  return kt(() => {
    n((o) => o ?? String(_m++));
  }, [e]), t ? `radix-${t}` : "";
}
function xm(e, t) {
  return g.useReducer((n, o) => t[n][o] ?? n, e);
}
var Je = (e) => {
  const { present: t, children: n } = e, o = $m(t), r = typeof n == "function" ? n({ present: o.isPresent }) : g.Children.only(n), i = Se(o.ref, km(r));
  return typeof n == "function" || o.isPresent ? g.cloneElement(r, { ref: i }) : null;
};
Je.displayName = "Presence";
function $m(e) {
  const [t, n] = g.useState(), o = g.useRef(null), r = g.useRef(e), i = g.useRef("none"), s = e ? "mounted" : "unmounted", [a, l] = xm(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = fo(o.current);
    i.current = a === "mounted" ? c : "none";
  }, [a]), kt(() => {
    const c = o.current, u = r.current;
    if (u !== e) {
      const d = i.current, f = fo(c);
      e ? l("MOUNT") : f === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== f ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), kt(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const b = fo(o.current).includes(h.animationName);
        if (h.target === t && b && (l("ANIMATION_END"), !r.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = fo(o.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function fo(e) {
  return e?.animationName || "none";
}
function km(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Re(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...n) => t.current?.(...n), []);
}
var qr = "rovingFocusGroup.onEntryFocus", Em = { bubbles: !1, cancelable: !0 }, Qn = "RovingFocusGroup", [Ri, tu, Sm] = hs(Qn), [Cm, nu] = Yt(
  Qn,
  [Sm]
), [Om, Nm] = Cm(Qn), ou = g.forwardRef(
  (e, t) => /* @__PURE__ */ m(Ri.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(Ri.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(Rm, { ...e, ref: t }) }) })
);
ou.displayName = Qn;
var Rm = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = g.useRef(null), h = Se(t, f), b = wr(i), [p, y] = Xn({
    prop: s,
    defaultProp: a ?? null,
    onChange: l,
    caller: Qn
  }), [$, v] = g.useState(!1), w = Re(c), _ = tu(n), x = g.useRef(!1), [C, k] = g.useState(0);
  return g.useEffect(() => {
    const R = f.current;
    if (R)
      return R.addEventListener(qr, w), () => R.removeEventListener(qr, w);
  }, [w]), /* @__PURE__ */ m(
    Om,
    {
      scope: n,
      orientation: o,
      dir: b,
      loop: r,
      currentTabStopId: p,
      onItemFocus: g.useCallback(
        (R) => y(R),
        [y]
      ),
      onItemShiftTab: g.useCallback(() => v(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => k((R) => R + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => k((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ m(
        le.div,
        {
          tabIndex: $ || C === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: se(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: se(e.onFocus, (R) => {
            const N = !x.current;
            if (R.target === R.currentTarget && N && !$) {
              const j = new CustomEvent(qr, Em);
              if (R.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const H = _().filter((ae) => ae.focusable), re = H.find((ae) => ae.active), q = H.find((ae) => ae.id === p), F = [re, q, ...H].filter(
                  Boolean
                ).map((ae) => ae.ref.current);
                su(F, u);
              }
            }
            x.current = !1;
          }),
          onBlur: se(e.onBlur, () => v(!1))
        }
      )
    }
  );
}), ru = "RovingFocusGroupItem", iu = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: i,
      children: s,
      ...a
    } = e, l = Mt(), c = i || l, u = Nm(ru, n), d = u.currentTabStopId === c, f = tu(n), { onFocusableItemAdd: h, onFocusableItemRemove: b, currentTabStopId: p } = u;
    return g.useEffect(() => {
      if (o)
        return h(), () => b();
    }, [o, h, b]), /* @__PURE__ */ m(
      Ri.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ m(
          le.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: t,
            onMouseDown: se(e.onMouseDown, (y) => {
              o ? u.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: se(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: se(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const $ = Pm(y, u.orientation, u.dir);
              if ($ !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let v = f().filter((w) => w.focusable).map((w) => w.ref.current);
                if ($ === "last") v.reverse();
                else if ($ === "prev" || $ === "next") {
                  $ === "prev" && v.reverse();
                  const w = v.indexOf(y.currentTarget);
                  v = u.loop ? Tm(v, w + 1) : v.slice(w + 1);
                }
                setTimeout(() => su(v));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: d, hasTabStop: p != null }) : s
          }
        )
      }
    );
  }
);
iu.displayName = ru;
var Am = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Im(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Pm(e, t, n) {
  const o = Im(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Am[o];
}
function su(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Tm(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Lm = ou, jm = iu;
function Dm(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function zm(e) {
  const [t, n] = De(!1), o = ke(() => n(!0), []), r = ke(() => n(!1), []), i = ke(() => n((s) => !s), []);
  return { value: t, setValue: n, setTrue: o, setFalse: r, toggle: i };
}
function Mm() {
  const [e, t] = De({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return xe(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function Fm() {
  const { width: e } = Mm();
  let t = "desktop";
  return e && e <= ma.MOBILE ? t = "mobile" : e && e <= ma.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
const Vm = "_flex_1taae_29", Um = "_wrap_1taae_67", Bm = "_nowrap_1taae_70", Hm = "_shrink_1taae_88", Ge = {
  flex: Vm,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: Um,
  nowrap: Bm,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: Hm,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function te({
  children: e,
  direction: t = "row",
  justifyContent: n = "start",
  alignItems: o = "start",
  flexWrap: r = "wrap",
  className: i = "",
  isFullWidth: s = !1,
  isFullHeight: a = !1,
  gap: l,
  style: c,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: f = !1,
  shrink: h = !1,
  ...b
}) {
  const p = be(
    Ge.flex,
    Ge[`flex-${t}`],
    Ge[`justify-${n}`],
    Ge[`align-${o}`],
    Ge[r],
    s && Ge["is-full-width"],
    a && Ge["is-full-height"],
    l && Ge[`gap-${l}`],
    u && Ge["no-margin"],
    d && Ge["flex-grow"],
    f && Ge["hide-on-mobile"],
    h && Ge.shrink,
    i
  );
  return /* @__PURE__ */ m("div", { className: p, ...b, style: c, children: e });
}
function Km(e, t = globalThis?.document) {
  const n = Re(e);
  g.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var Wm = "DismissableLayer", Ai = "dismissableLayer.update", qm = "dismissableLayer.pointerDownOutside", Zm = "dismissableLayer.focusOutside", va, au = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ms = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = e, c = g.useContext(au), [u, d] = g.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, h] = g.useState({}), b = Se(t, (k) => d(k)), p = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), $ = p.indexOf(y), v = u ? p.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, _ = v >= $, x = Ym((k) => {
      const R = k.target, N = [...c.branches].some((j) => j.contains(R));
      !_ || N || (r?.(k), s?.(k), k.defaultPrevented || a?.());
    }, f), C = Xm((k) => {
      const R = k.target;
      [...c.branches].some((N) => N.contains(R)) || (i?.(k), s?.(k), k.defaultPrevented || a?.());
    }, f);
    return Km((k) => {
      v === c.layers.size - 1 && (o?.(k), !k.defaultPrevented && a && (k.preventDefault(), a()));
    }, f), g.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (va = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), ba(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = va);
        };
    }, [u, f, n, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), ba());
    }, [u, c]), g.useEffect(() => {
      const k = () => h({});
      return document.addEventListener(Ai, k), () => document.removeEventListener(Ai, k);
    }, []), /* @__PURE__ */ m(
      le.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: w ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: se(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: se(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: se(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
ms.displayName = Wm;
var Jm = "DismissableLayerBranch", Gm = g.forwardRef((e, t) => {
  const n = g.useContext(au), o = g.useRef(null), r = Se(t, o);
  return g.useEffect(() => {
    const i = o.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ m(le.div, { ...e, ref: r });
});
Gm.displayName = Jm;
function Ym(e, t = globalThis?.document) {
  const n = Re(e), o = g.useRef(!1), r = g.useRef(() => {
  });
  return g.useEffect(() => {
    const i = (a) => {
      if (a.target && !o.current) {
        let l = function() {
          cu(
            qm,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Xm(e, t = globalThis?.document) {
  const n = Re(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const r = (i) => {
      i.target && !o.current && cu(Zm, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ba() {
  const e = new CustomEvent(Ai);
  document.dispatchEvent(e);
}
function cu(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? Ni(r, i) : r.dispatchEvent(i);
}
var Qm = "Portal", lu = g.forwardRef((e, t) => {
  const { container: n, ...o } = e, [r, i] = g.useState(!1);
  kt(() => i(!0), []);
  const s = n || r && globalThis?.document?.body;
  return s ? ds.createPortal(/* @__PURE__ */ m(le.div, { ...o, ref: t }), s) : null;
});
lu.displayName = Qm;
var lt = function() {
  return lt = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, lt.apply(this, arguments);
};
function uu(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function eg(e, t, n) {
  for (var o = 0, r = t.length, i; o < r; o++)
    (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Zr = "focusScope.autoFocusOnMount", Jr = "focusScope.autoFocusOnUnmount", ya = { bubbles: !1, cancelable: !0 }, tg = "FocusScope", du = g.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, l] = g.useState(null), c = Re(r), u = Re(i), d = g.useRef(null), f = Se(t, (p) => l(p)), h = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let p = function(w) {
        if (h.paused || !a) return;
        const _ = w.target;
        a.contains(_) ? d.current = _ : Ct(d.current, { select: !0 });
      }, y = function(w) {
        if (h.paused || !a) return;
        const _ = w.relatedTarget;
        _ !== null && (a.contains(_) || Ct(d.current, { select: !0 }));
      }, $ = function(w) {
        if (document.activeElement === document.body)
          for (const _ of w)
            _.removedNodes.length > 0 && Ct(a);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", y);
      const v = new MutationObserver($);
      return a && v.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", y), v.disconnect();
      };
    }
  }, [o, a, h.paused]), g.useEffect(() => {
    if (a) {
      _a.add(h);
      const p = document.activeElement;
      if (!a.contains(p)) {
        const y = new CustomEvent(Zr, ya);
        a.addEventListener(Zr, c), a.dispatchEvent(y), y.defaultPrevented || (ng(ag(pu(a)), { select: !0 }), document.activeElement === p && Ct(a));
      }
      return () => {
        a.removeEventListener(Zr, c), setTimeout(() => {
          const y = new CustomEvent(Jr, ya);
          a.addEventListener(Jr, u), a.dispatchEvent(y), y.defaultPrevented || Ct(p ?? document.body, { select: !0 }), a.removeEventListener(Jr, u), _a.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const b = g.useCallback(
    (p) => {
      if (!n && !o || h.paused) return;
      const y = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, $ = document.activeElement;
      if (y && $) {
        const v = p.currentTarget, [w, _] = og(v);
        w && _ ? !p.shiftKey && $ === _ ? (p.preventDefault(), n && Ct(w, { select: !0 })) : p.shiftKey && $ === w && (p.preventDefault(), n && Ct(_, { select: !0 })) : $ === v && p.preventDefault();
      }
    },
    [n, o, h.paused]
  );
  return /* @__PURE__ */ m(le.div, { tabIndex: -1, ...s, ref: f, onKeyDown: b });
});
du.displayName = tg;
function ng(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Ct(o, { select: t }), document.activeElement !== n) return;
}
function og(e) {
  const t = pu(e), n = wa(t, e), o = wa(t.reverse(), e);
  return [n, o];
}
function pu(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function wa(e, t) {
  for (const n of e)
    if (!rg(n, { upTo: t })) return n;
}
function rg(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function ig(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ct(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ig(e) && t && e.select();
  }
}
var _a = sg();
function sg() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = xa(e, t), e.unshift(t);
    },
    remove(t) {
      e = xa(e, t), e[0]?.resume();
    }
  };
}
function xa(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function ag(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Gr = 0;
function cg() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? $a()), document.body.insertAdjacentElement("beforeend", e[1] ?? $a()), Gr++, () => {
      Gr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Gr--;
    };
  }, []);
}
function $a() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var To = "right-scroll-bar-position", Lo = "width-before-scroll-bar", lg = "with-scroll-bars-hidden", ug = "--removed-body-scroll-bar-size";
function Yr(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function dg(e, t) {
  var n = De(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var pg = typeof window < "u" ? g.useLayoutEffect : g.useEffect, ka = /* @__PURE__ */ new WeakMap();
function fg(e, t) {
  var n = dg(null, function(o) {
    return e.forEach(function(r) {
      return Yr(r, o);
    });
  });
  return pg(function() {
    var o = ka.get(n);
    if (o) {
      var r = new Set(o), i = new Set(e), s = n.current;
      r.forEach(function(a) {
        i.has(a) || Yr(a, null);
      }), i.forEach(function(a) {
        r.has(a) || Yr(a, s);
      });
    }
    ka.set(n, e);
  }, [e]), n;
}
function hg(e) {
  return e;
}
function mg(e, t) {
  t === void 0 && (t = hg);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, o);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (o = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      o = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return r;
}
function gg(e) {
  e === void 0 && (e = {});
  var t = mg(null);
  return t.options = lt({ async: !0, ssr: !1 }, e), t;
}
var fu = function(e) {
  var t = e.sideCar, n = uu(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, lt({}, n));
};
fu.isSideCarExport = !0;
function vg(e, t) {
  return e.useMedium(t), fu;
}
var hu = gg(), Xr = function() {
}, _r = g.forwardRef(function(e, t) {
  var n = g.useRef(null), o = g.useState({
    onScrollCapture: Xr,
    onWheelCapture: Xr,
    onTouchMoveCapture: Xr
  }), r = o[0], i = o[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, b = e.inert, p = e.allowPinchZoom, y = e.as, $ = y === void 0 ? "div" : y, v = e.gapMode, w = uu(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = f, x = fg([n, t]), C = lt(lt({}, w), r);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(_, { sideCar: hu, removeScrollBar: c, shards: d, noIsolation: h, inert: b, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: v }),
    s ? g.cloneElement(g.Children.only(a), lt(lt({}, C), { ref: x })) : g.createElement($, lt({}, C, { className: l, ref: x }), a)
  );
});
_r.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_r.classNames = {
  fullWidth: Lo,
  zeroRight: To
};
var bg = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function yg() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = bg();
  return t && e.setAttribute("nonce", t), e;
}
function wg(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function _g(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var xg = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = yg()) && (wg(t, n), _g(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, $g = function() {
  var e = xg();
  return function(t, n) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, mu = function() {
  var e = $g(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, kg = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Qr = function(e) {
  return parseInt(e || "", 10) || 0;
}, Eg = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Qr(n), Qr(o), Qr(r)];
}, Sg = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return kg;
  var t = Eg(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Cg = mu(), gn = "data-scroll-locked", Og = function(e, t, n, o) {
  var r = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(lg, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(a, "px ").concat(o, `;
  }
  body[`).concat(gn, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(To, ` {
    right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(Lo, ` {
    margin-right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(To, " .").concat(To, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Lo, " .").concat(Lo, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(gn, `] {
    `).concat(ug, ": ").concat(a, `px;
  }
`);
}, Ea = function() {
  var e = parseInt(document.body.getAttribute(gn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ng = function() {
  g.useEffect(function() {
    return document.body.setAttribute(gn, (Ea() + 1).toString()), function() {
      var e = Ea() - 1;
      e <= 0 ? document.body.removeAttribute(gn) : document.body.setAttribute(gn, e.toString());
    };
  }, []);
}, Rg = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  Ng();
  var i = g.useMemo(function() {
    return Sg(r);
  }, [r]);
  return g.createElement(Cg, { styles: Og(i, !t, r, n ? "" : "!important") });
}, Ii = !1;
if (typeof window < "u")
  try {
    var ho = Object.defineProperty({}, "passive", {
      get: function() {
        return Ii = !0, !0;
      }
    });
    window.addEventListener("test", ho, ho), window.removeEventListener("test", ho, ho);
  } catch {
    Ii = !1;
  }
var on = Ii ? { passive: !1 } : !1, Ag = function(e) {
  return e.tagName === "TEXTAREA";
}, gu = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ag(e) && n[t] === "visible")
  );
}, Ig = function(e) {
  return gu(e, "overflowY");
}, Pg = function(e) {
  return gu(e, "overflowX");
}, Sa = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = vu(e, o);
    if (r) {
      var i = bu(e, o), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, Tg = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, Lg = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, vu = function(e, t) {
  return e === "v" ? Ig(t) : Pg(t);
}, bu = function(e, t) {
  return e === "v" ? Tg(t) : Lg(t);
}, jg = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Dg = function(e, t, n, o, r) {
  var i = jg(e, window.getComputedStyle(t).direction), s = i * o, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = bu(e, a), b = h[0], p = h[1], y = h[2], $ = p - y - i * b;
    (b || $) && vu(e, a) && (d += $, f += b), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, mo = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ca = function(e) {
  return [e.deltaX, e.deltaY];
}, Oa = function(e) {
  return e && "current" in e ? e.current : e;
}, zg = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Mg = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Fg = 0, rn = [];
function Vg(e) {
  var t = g.useRef([]), n = g.useRef([0, 0]), o = g.useRef(), r = g.useState(Fg++)[0], i = g.useState(mu)[0], s = g.useRef(e);
  g.useEffect(function() {
    s.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var p = eg([e.lockRef.current], (e.shards || []).map(Oa)).filter(Boolean);
      return p.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), p.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = g.useCallback(function(p, y) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !s.current.allowPinchZoom;
    var $ = mo(p), v = n.current, w = "deltaX" in p ? p.deltaX : v[0] - $[0], _ = "deltaY" in p ? p.deltaY : v[1] - $[1], x, C = p.target, k = Math.abs(w) > Math.abs(_) ? "h" : "v";
    if ("touches" in p && k === "h" && C.type === "range")
      return !1;
    var R = Sa(k, C);
    if (!R)
      return !0;
    if (R ? x = k : (x = k === "v" ? "h" : "v", R = Sa(k, C)), !R)
      return !1;
    if (!o.current && "changedTouches" in p && (w || _) && (o.current = x), !x)
      return !0;
    var N = o.current || x;
    return Dg(N, y, p, N === "h" ? w : _);
  }, []), l = g.useCallback(function(p) {
    var y = p;
    if (!(!rn.length || rn[rn.length - 1] !== i)) {
      var $ = "deltaY" in y ? Ca(y) : mo(y), v = t.current.filter(function(x) {
        return x.name === y.type && (x.target === y.target || y.target === x.shadowParent) && zg(x.delta, $);
      })[0];
      if (v && v.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!v) {
        var w = (s.current.shards || []).map(Oa).filter(Boolean).filter(function(x) {
          return x.contains(y.target);
        }), _ = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        _ && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(p, y, $, v) {
    var w = { name: p, delta: y, target: $, should: v, shadowParent: Ug($) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== w;
      });
    }, 1);
  }, []), u = g.useCallback(function(p) {
    n.current = mo(p), o.current = void 0;
  }, []), d = g.useCallback(function(p) {
    c(p.type, Ca(p), p.target, a(p, e.lockRef.current));
  }, []), f = g.useCallback(function(p) {
    c(p.type, mo(p), p.target, a(p, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return rn.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, on), document.addEventListener("touchmove", l, on), document.addEventListener("touchstart", u, on), function() {
      rn = rn.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, on), document.removeEventListener("touchmove", l, on), document.removeEventListener("touchstart", u, on);
    };
  }, []);
  var h = e.removeScrollBar, b = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    b ? g.createElement(i, { styles: Mg(r) }) : null,
    h ? g.createElement(Rg, { gapMode: e.gapMode }) : null
  );
}
function Ug(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Bg = vg(hu, Vg);
var yu = g.forwardRef(function(e, t) {
  return g.createElement(_r, lt({}, e, { ref: t, sideCar: Bg }));
});
yu.classNames = _r.classNames;
var Hg = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, sn = /* @__PURE__ */ new WeakMap(), go = /* @__PURE__ */ new WeakMap(), vo = {}, ei = 0, wu = function(e) {
  return e && (e.host || wu(e.parentNode));
}, Kg = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = wu(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Wg = function(e, t, n, o) {
  var r = Kg(t, Array.isArray(e) ? e : [e]);
  vo[n] || (vo[n] = /* @__PURE__ */ new WeakMap());
  var i = vo[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(r), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  r.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(o), b = h !== null && h !== "false", p = (sn.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          sn.set(f, p), i.set(f, y), s.push(f), p === 1 && b && go.set(f, !0), y === 1 && f.setAttribute(n, "true"), b || f.setAttribute(o, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", f, $);
        }
    });
  };
  return u(t), a.clear(), ei++, function() {
    s.forEach(function(d) {
      var f = sn.get(d) - 1, h = i.get(d) - 1;
      sn.set(d, f), i.set(d, h), f || (go.has(d) || d.removeAttribute(o), go.delete(d)), h || d.removeAttribute(n);
    }), ei--, ei || (sn = /* @__PURE__ */ new WeakMap(), sn = /* @__PURE__ */ new WeakMap(), go = /* @__PURE__ */ new WeakMap(), vo = {});
  };
}, qg = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = Hg(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live]"))), Wg(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, xr = "Dialog", [_u, YT] = Yt(xr), [Zg, et] = _u(xr), xu = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: i,
    modal: s = !0
  } = e, a = g.useRef(null), l = g.useRef(null), [c, u] = Xn({
    prop: o,
    defaultProp: r ?? !1,
    onChange: i,
    caller: xr
  });
  return /* @__PURE__ */ m(
    Zg,
    {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: Mt(),
      titleId: Mt(),
      descriptionId: Mt(),
      open: c,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((d) => !d), [u]),
      modal: s,
      children: n
    }
  );
};
xu.displayName = xr;
var $u = "DialogTrigger", Jg = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = et($u, n), i = Se(t, r.triggerRef);
    return /* @__PURE__ */ m(
      le.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": bs(r.open),
        ...o,
        ref: i,
        onClick: se(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Jg.displayName = $u;
var gs = "DialogPortal", [Gg, ku] = _u(gs, {
  forceMount: void 0
}), Eu = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, i = et(gs, t);
  return /* @__PURE__ */ m(Gg, { scope: t, forceMount: n, children: g.Children.map(o, (s) => /* @__PURE__ */ m(Je, { present: n || i.open, children: /* @__PURE__ */ m(lu, { asChild: !0, container: r, children: s }) })) });
};
Eu.displayName = gs;
var Go = "DialogOverlay", Su = g.forwardRef(
  (e, t) => {
    const n = ku(Go, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = et(Go, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ m(Je, { present: o || i.open, children: /* @__PURE__ */ m(Xg, { ...r, ref: t }) }) : null;
  }
);
Su.displayName = Go;
var Yg = /* @__PURE__ */ Jo("DialogOverlay.RemoveScroll"), Xg = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = et(Go, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m(yu, { as: Yg, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ m(
        le.div,
        {
          "data-state": bs(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Ut = "DialogContent", Cu = g.forwardRef(
  (e, t) => {
    const n = ku(Ut, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = et(Ut, e.__scopeDialog);
    return /* @__PURE__ */ m(Je, { present: o || i.open, children: i.modal ? /* @__PURE__ */ m(Qg, { ...r, ref: t }) : /* @__PURE__ */ m(ev, { ...r, ref: t }) });
  }
);
Cu.displayName = Ut;
var Qg = g.forwardRef(
  (e, t) => {
    const n = et(Ut, e.__scopeDialog), o = g.useRef(null), r = Se(t, n.contentRef, o);
    return g.useEffect(() => {
      const i = o.current;
      if (i) return qg(i);
    }, []), /* @__PURE__ */ m(
      Ou,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: se(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: se(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: se(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), ev = g.forwardRef(
  (e, t) => {
    const n = et(Ut, e.__scopeDialog), o = g.useRef(!1), r = g.useRef(!1);
    return /* @__PURE__ */ m(
      Ou,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (o.current || n.triggerRef.current?.focus(), i.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const s = i.target;
          n.triggerRef.current?.contains(s) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
        }
      }
    );
  }
), Ou = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, ...s } = e, a = et(Ut, n), l = g.useRef(null), c = Se(t, l);
    return cg(), /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(
        du,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ m(
            ms,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": bs(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ P(ze, { children: [
        /* @__PURE__ */ m(ov, { titleId: a.titleId }),
        /* @__PURE__ */ m(iv, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), vs = "DialogTitle", tv = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = et(vs, n);
    return /* @__PURE__ */ m(le.h2, { id: r.titleId, ...o, ref: t });
  }
);
tv.displayName = vs;
var Nu = "DialogDescription", nv = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = et(Nu, n);
    return /* @__PURE__ */ m(le.p, { id: r.descriptionId, ...o, ref: t });
  }
);
nv.displayName = Nu;
var Ru = "DialogClose", Au = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = et(Ru, n);
    return /* @__PURE__ */ m(
      le.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: se(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Au.displayName = Ru;
function bs(e) {
  return e ? "open" : "closed";
}
var Iu = "DialogTitleWarning", [XT, Pu] = dm(Iu, {
  contentName: Ut,
  titleName: vs,
  docsSlug: "dialog"
}), ov = ({ titleId: e }) => {
  const t = Pu(Iu), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, rv = "DialogDescriptionWarning", iv = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Pu(rv).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, sv = xu, av = Eu, cv = Su, lv = Cu, uv = Au;
function dv(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function pv(e, t) {
  return g.useReducer((n, o) => t[n][o] ?? n, e);
}
var ys = "ScrollArea", [Tu, QT] = Yt(ys), [fv, Xe] = Tu(ys), Lu = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: r,
      scrollHideDelay: i = 600,
      ...s
    } = e, [a, l] = g.useState(null), [c, u] = g.useState(null), [d, f] = g.useState(null), [h, b] = g.useState(null), [p, y] = g.useState(null), [$, v] = g.useState(0), [w, _] = g.useState(0), [x, C] = g.useState(!1), [k, R] = g.useState(!1), N = Se(t, (H) => l(H)), j = wr(r);
    return /* @__PURE__ */ m(
      fv,
      {
        scope: n,
        type: o,
        dir: j,
        scrollHideDelay: i,
        scrollArea: a,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: f,
        scrollbarX: h,
        onScrollbarXChange: b,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: C,
        scrollbarY: p,
        onScrollbarYChange: y,
        scrollbarYEnabled: k,
        onScrollbarYEnabledChange: R,
        onCornerWidthChange: v,
        onCornerHeightChange: _,
        children: /* @__PURE__ */ m(
          le.div,
          {
            dir: j,
            ...s,
            ref: N,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": $ + "px",
              "--radix-scroll-area-corner-height": w + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Lu.displayName = ys;
var ju = "ScrollAreaViewport", Du = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: r, ...i } = e, s = Xe(ju, n), a = g.useRef(null), l = Se(t, a, s.onViewportChange);
    return /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ m(
        le.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ m("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
Du.displayName = ju;
var ht = "ScrollAreaScrollbar", hv = g.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Xe(ht, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: s } = r, a = e.orientation === "horizontal";
    return g.useEffect(() => (a ? i(!0) : s(!0), () => {
      a ? i(!1) : s(!1);
    }), [a, i, s]), r.type === "hover" ? /* @__PURE__ */ m(mv, { ...o, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ m(gv, { ...o, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ m(zu, { ...o, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ m(ws, { ...o, ref: t }) : null;
  }
);
hv.displayName = ht;
var mv = g.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Xe(ht, e.__scopeScrollArea), [i, s] = g.useState(!1);
  return g.useEffect(() => {
    const a = r.scrollArea;
    let l = 0;
    if (a) {
      const c = () => {
        window.clearTimeout(l), s(!0);
      }, u = () => {
        l = window.setTimeout(() => s(!1), r.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", c), a.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), a.removeEventListener("pointerenter", c), a.removeEventListener("pointerleave", u);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ m(Je, { present: n || i, children: /* @__PURE__ */ m(
    zu,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), gv = g.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Xe(ht, e.__scopeScrollArea), i = e.orientation === "horizontal", s = kr(() => l("SCROLL_END"), 100), [a, l] = pv("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (a === "idle") {
      const c = window.setTimeout(() => l("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [a, r.scrollHideDelay, l]), g.useEffect(() => {
    const c = r.viewport, u = i ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const f = () => {
        const h = c[u];
        d !== h && (l("SCROLL"), s()), d = h;
      };
      return c.addEventListener("scroll", f), () => c.removeEventListener("scroll", f);
    }
  }, [r.viewport, i, l, s]), /* @__PURE__ */ m(Je, { present: n || a !== "hidden", children: /* @__PURE__ */ m(
    ws,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: se(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: se(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), zu = g.forwardRef((e, t) => {
  const n = Xe(ht, e.__scopeScrollArea), { forceMount: o, ...r } = e, [i, s] = g.useState(!1), a = e.orientation === "horizontal", l = kr(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(a ? c : u);
    }
  }, 10);
  return bn(n.viewport, l), bn(n.content, l), /* @__PURE__ */ m(Je, { present: o || i, children: /* @__PURE__ */ m(
    ws,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), ws = g.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, r = Xe(ht, e.__scopeScrollArea), i = g.useRef(null), s = g.useRef(0), [a, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Vu(a.viewport, a.content), u = {
    ...o,
    sizes: a,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (f) => i.current = f,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (f) => s.current = f
  };
  function d(f, h) {
    return kv(f, s.current, a, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ m(
    vv,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && i.current) {
          const f = r.viewport.scrollLeft, h = Na(f, a, r.dir);
          i.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (f) => {
        r.viewport && (r.viewport.scrollLeft = f);
      },
      onDragScroll: (f) => {
        r.viewport && (r.viewport.scrollLeft = d(f, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ m(
    bv,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && i.current) {
          const f = r.viewport.scrollTop, h = Na(f, a);
          i.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (f) => {
        r.viewport && (r.viewport.scrollTop = f);
      },
      onDragScroll: (f) => {
        r.viewport && (r.viewport.scrollTop = d(f));
      }
    }
  ) : null;
}), vv = g.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, i = Xe(ht, e.__scopeScrollArea), [s, a] = g.useState(), l = g.useRef(null), c = Se(t, l, i.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ m(
    Fu,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": $r(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const f = i.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(f), Bu(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && o({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Xo(s.paddingLeft),
            paddingEnd: Xo(s.paddingRight)
          }
        });
      }
    }
  );
}), bv = g.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, i = Xe(ht, e.__scopeScrollArea), [s, a] = g.useState(), l = g.useRef(null), c = Se(t, l, i.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ m(
    Fu,
    {
      "data-orientation": "vertical",
      ...r,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": $r(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (i.viewport) {
          const f = i.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(f), Bu(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && s && o({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Xo(s.paddingTop),
            paddingEnd: Xo(s.paddingBottom)
          }
        });
      }
    }
  );
}), [yv, Mu] = Tu(ht), Fu = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: r,
    onThumbChange: i,
    onThumbPointerUp: s,
    onThumbPointerDown: a,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...f
  } = e, h = Xe(ht, n), [b, p] = g.useState(null), y = Se(t, (N) => p(N)), $ = g.useRef(null), v = g.useRef(""), w = h.viewport, _ = o.content - o.viewport, x = Re(u), C = Re(l), k = kr(d, 10);
  function R(N) {
    if ($.current) {
      const j = N.clientX - $.current.left, H = N.clientY - $.current.top;
      c({ x: j, y: H });
    }
  }
  return g.useEffect(() => {
    const N = (j) => {
      const H = j.target;
      b?.contains(H) && x(j, _);
    };
    return document.addEventListener("wheel", N, { passive: !1 }), () => document.removeEventListener("wheel", N, { passive: !1 });
  }, [w, b, _, x]), g.useEffect(C, [o, C]), bn(b, k), bn(h.content, k), /* @__PURE__ */ m(
    yv,
    {
      scope: n,
      scrollbar: b,
      hasThumb: r,
      onThumbChange: Re(i),
      onThumbPointerUp: Re(s),
      onThumbPositionChange: C,
      onThumbPointerDown: Re(a),
      children: /* @__PURE__ */ m(
        le.div,
        {
          ...f,
          ref: y,
          style: { position: "absolute", ...f.style },
          onPointerDown: se(e.onPointerDown, (N) => {
            N.button === 0 && (N.target.setPointerCapture(N.pointerId), $.current = b.getBoundingClientRect(), v.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), R(N));
          }),
          onPointerMove: se(e.onPointerMove, R),
          onPointerUp: se(e.onPointerUp, (N) => {
            const j = N.target;
            j.hasPointerCapture(N.pointerId) && j.releasePointerCapture(N.pointerId), document.body.style.webkitUserSelect = v.current, h.viewport && (h.viewport.style.scrollBehavior = ""), $.current = null;
          })
        }
      )
    }
  );
}), Yo = "ScrollAreaThumb", wv = g.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Mu(Yo, e.__scopeScrollArea);
    return /* @__PURE__ */ m(Je, { present: n || r.hasThumb, children: /* @__PURE__ */ m(_v, { ref: t, ...o }) });
  }
), _v = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...r } = e, i = Xe(Yo, n), s = Mu(Yo, n), { onThumbPositionChange: a } = s, l = Se(
      t,
      (d) => s.onThumbChange(d)
    ), c = g.useRef(void 0), u = kr(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = i.viewport;
      if (d) {
        const f = () => {
          if (u(), !c.current) {
            const h = Ev(d, a);
            c.current = h, a();
          }
        };
        return a(), d.addEventListener("scroll", f), () => d.removeEventListener("scroll", f);
      }
    }, [i.viewport, u, a]), /* @__PURE__ */ m(
      le.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...r,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: se(e.onPointerDownCapture, (d) => {
          const f = d.target.getBoundingClientRect(), h = d.clientX - f.left, b = d.clientY - f.top;
          s.onThumbPointerDown({ x: h, y: b });
        }),
        onPointerUp: se(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
wv.displayName = Yo;
var _s = "ScrollAreaCorner", xv = g.forwardRef(
  (e, t) => {
    const n = Xe(_s, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ m($v, { ...e, ref: t }) : null;
  }
);
xv.displayName = _s;
var $v = g.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, r = Xe(_s, n), [i, s] = g.useState(0), [a, l] = g.useState(0), c = !!(i && a);
  return bn(r.scrollbarX, () => {
    const u = r.scrollbarX?.offsetHeight || 0;
    r.onCornerHeightChange(u), l(u);
  }), bn(r.scrollbarY, () => {
    const u = r.scrollbarY?.offsetWidth || 0;
    r.onCornerWidthChange(u), s(u);
  }), c ? /* @__PURE__ */ m(
    le.div,
    {
      ...o,
      ref: t,
      style: {
        width: i,
        height: a,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Xo(e) {
  return e ? parseInt(e, 10) : 0;
}
function Vu(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function $r(e) {
  const t = Vu(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function kv(e, t, n, o = "ltr") {
  const r = $r(n), i = r / 2, s = t || i, a = r - s, l = n.scrollbar.paddingStart + s, c = n.scrollbar.size - n.scrollbar.paddingEnd - a, u = n.content - n.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return Uu([l, c], d)(e);
}
function Na(e, t, n = "ltr") {
  const o = $r(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - r, s = t.content - t.viewport, a = i - o, l = n === "ltr" ? [0, s] : [s * -1, 0], c = dv(e, l);
  return Uu([0, s], [0, a])(c);
}
function Uu(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function Bu(e, t) {
  return e > 0 && e < t;
}
var Ev = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function r() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== i.left, a = n.top !== i.top;
    (s || a) && t(), n = i, o = window.requestAnimationFrame(r);
  }(), () => window.cancelAnimationFrame(o);
};
function kr(e, t) {
  const n = Re(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function bn(e, t) {
  const n = Re(t);
  kt(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var Sv = Lu, Cv = Du, Ov = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Nv = "VisuallyHidden", Hu = g.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    le.span,
    {
      ...e,
      ref: t,
      style: { ...Ov, ...e.style }
    }
  )
);
Hu.displayName = Nv;
var Rv = Hu;
const Av = "_divider_dlgq8_29", Iv = "_dashed_dlgq8_61", Rn = {
  divider: Av,
  "small-space": "_small-space_dlgq8_35",
  "medium-space": "_medium-space_dlgq8_38",
  "no-space": "_no-space_dlgq8_41",
  "with-text": "_with-text_dlgq8_44",
  dashed: Iv,
  "divider-text": "_divider-text_dlgq8_70",
  "dialog-overlay-show": "_dialog-overlay-show_dlgq8_1",
  "dialog-content-show": "_dialog-content-show_dlgq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dlgq8_1"
};
function Pv({ className: e, text: t, dashed: n, space: o = "medium", ...r }) {
  const i = be(
    Rn.divider,
    Rn[`${o}-space`],
    t && Rn["with-text"],
    n && Rn.dashed,
    e
  );
  return /* @__PURE__ */ m("div", { className: i, role: "separator", "aria-label": t || "divider", ...r, children: t && /* @__PURE__ */ m("span", { className: Rn["divider-text"], children: t }) });
}
function Pi(e) {
  return e.replace(/\s/g, "-");
}
function Ku(e, t) {
  return Pi(`${t}-${e}`);
}
function Tv(e) {
  const [t, n] = De([]);
  return xe(() => {
    const o = [];
    let r = 0;
    for (const i of e) {
      const s = document.getElementById(Ku(i.title, r));
      s && (o.push(s.clientWidth), r++);
    }
    n(o);
  }, [e]), t;
}
function Lv(e) {
  return Zo(() => e.map((t, n) => ({
    ...t,
    value: Ku(t.title, n)
  })), [e]);
}
function jv(e = 0) {
  const [t, n] = De(e);
  return {
    activeTabIndex: t,
    setActiveTabIndex: n
  };
}
var Er = "Tabs", [Dv, eL] = Yt(Er, [
  nu
]), Wu = nu(), [zv, xs] = Dv(Er), qu = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: r,
      defaultValue: i,
      orientation: s = "horizontal",
      dir: a,
      activationMode: l = "automatic",
      ...c
    } = e, u = wr(a), [d, f] = Xn({
      prop: o,
      onChange: r,
      defaultProp: i ?? "",
      caller: Er
    });
    return /* @__PURE__ */ m(
      zv,
      {
        scope: n,
        baseId: Mt(),
        value: d,
        onValueChange: f,
        orientation: s,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ m(
          le.div,
          {
            dir: u,
            "data-orientation": s,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
qu.displayName = Er;
var Zu = "TabsList", Ju = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...r } = e, i = xs(Zu, n), s = Wu(n);
    return /* @__PURE__ */ m(
      Lm,
      {
        asChild: !0,
        ...s,
        orientation: i.orientation,
        dir: i.dir,
        loop: o,
        children: /* @__PURE__ */ m(
          le.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...r,
            ref: t
          }
        )
      }
    );
  }
);
Ju.displayName = Zu;
var Gu = "TabsTrigger", Yu = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: r = !1, ...i } = e, s = xs(Gu, n), a = Wu(n), l = ed(s.baseId, o), c = td(s.baseId, o), u = o === s.value;
    return /* @__PURE__ */ m(
      jm,
      {
        asChild: !0,
        ...a,
        focusable: !r,
        active: u,
        children: /* @__PURE__ */ m(
          le.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: l,
            ...i,
            ref: t,
            onMouseDown: se(e.onMouseDown, (d) => {
              !r && d.button === 0 && d.ctrlKey === !1 ? s.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: se(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && s.onValueChange(o);
            }),
            onFocus: se(e.onFocus, () => {
              const d = s.activationMode !== "manual";
              !u && !r && d && s.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
Yu.displayName = Gu;
var Xu = "TabsContent", Qu = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: r, children: i, ...s } = e, a = xs(Xu, n), l = ed(a.baseId, o), c = td(a.baseId, o), u = o === a.value, d = g.useRef(u);
    return g.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ m(Je, { present: r || u, children: ({ present: f }) => /* @__PURE__ */ m(
      le.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && i
      }
    ) });
  }
);
Qu.displayName = Xu;
function ed(e, t) {
  return `${e}-trigger-${t}`;
}
function td(e, t) {
  return `${e}-content-${t}`;
}
var Mv = qu, Fv = Ju, Vv = Yu, Uv = Qu;
const Bv = "_tabs_11da8_29", st = {
  tabs: Bv,
  "is-full-width": "_is-full-width_11da8_32",
  "tabs-content": "_tabs-content_11da8_35",
  "tabs-list": "_tabs-list_11da8_38",
  "is-small": "_is-small_11da8_41",
  "tabs-trigger-list": "_tabs-trigger-list_11da8_44",
  "tabs-trigger": "_tabs-trigger_11da8_44",
  "is-medium": "_is-medium_11da8_67",
  "tabs-underline": "_tabs-underline_11da8_77",
  "tabs-divider": "_tabs-divider_11da8_86",
  "dialog-overlay-show": "_dialog-overlay-show_11da8_1",
  "dialog-content-show": "_dialog-content-show_11da8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11da8_1"
};
function Hv({
  tabs: e,
  isFullWidth: t,
  size: n = "medium",
  className: o = "",
  tabIndex: r = 0,
  onTabChange: i,
  ...s
}) {
  const { activeTabIndex: a, setActiveTabIndex: l } = jv(r), c = Lv(e), u = Tv(e), d = be(st.tabs, t && st["is-full-width"], o), f = be(st["tabs-trigger"], n && st[`is-${n}`]);
  return /* @__PURE__ */ P(
    Mv,
    {
      onValueChange: (h) => {
        const b = c.findIndex((p) => Pi(p.value) === h);
        l(b), i?.(b);
      },
      className: d,
      defaultValue: c[a]?.value,
      orientation: "horizontal",
      ...s,
      children: [
        /* @__PURE__ */ m(Sv, { children: /* @__PURE__ */ m(Cv, { children: /* @__PURE__ */ P(Fv, { className: be(st["tabs-list"], n === "small" && st["is-small"]), children: [
          /* @__PURE__ */ P("div", { className: st["tabs-trigger-list"], children: [
            c.map((h) => {
              const b = h.value;
              return /* @__PURE__ */ m(
                Vv,
                {
                  id: b,
                  "aria-controls": b,
                  "aria-labelledby": b,
                  className: f,
                  value: b,
                  children: h.title
                },
                b
              );
            }),
            /* @__PURE__ */ m(
              "span",
              {
                className: st["tabs-underline"],
                style: {
                  width: u[a],
                  transform: `translateX(${u.slice(0, a).reduce((h, b) => h + b, 0) + a * 16}px)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ m("div", { className: st["tabs-divider"] })
        ] }) }) }),
        c.map((h) => {
          const b = Pi(h.value);
          return /* @__PURE__ */ m(Uv, { className: st["tabs-content"], "aria-labelledby": b, value: b, children: h.content }, b);
        })
      ]
    }
  );
}
const Kv = "_drawer_1xu3v_29", ti = {
  "drawer-overlay": "_drawer-overlay_1xu3v_29",
  drawer: Kv,
  "drawer-close": "_drawer-close_1xu3v_60"
};
function Wv({ children: e, isOpen: t, onClose: n, className: o }) {
  const r = be(ti.drawer, o);
  return /* @__PURE__ */ m(sv, { defaultOpen: t, open: t, children: /* @__PURE__ */ P(av, { children: [
    /* @__PURE__ */ m(cv, { className: ti["drawer-overlay"], onClick: n }),
    /* @__PURE__ */ P(lv, { className: r, children: [
      e,
      /* @__PURE__ */ m(uv, { asChild: !0, children: /* @__PURE__ */ m("button", { onClick: n, className: ti["drawer-close"], "aria-label": "Close", children: /* @__PURE__ */ m(he, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
var $s = "Progress", ks = 100, [qv, tL] = Yt($s), [Zv, Jv] = qv($s), nd = g.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: r,
      getValueLabel: i = Gv,
      ...s
    } = e;
    (r || r === 0) && !Ra(r) && console.error(Yv(`${r}`, "Progress"));
    const a = Ra(r) ? r : ks;
    o !== null && !Aa(o, a) && console.error(Xv(`${o}`, "Progress"));
    const l = Aa(o, a) ? o : null, c = Qo(l) ? i(l, a) : void 0;
    return /* @__PURE__ */ m(Zv, { scope: n, value: l, max: a, children: /* @__PURE__ */ m(
      le.div,
      {
        "aria-valuemax": a,
        "aria-valuemin": 0,
        "aria-valuenow": Qo(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": id(l, a),
        "data-value": l ?? void 0,
        "data-max": a,
        ...s,
        ref: t
      }
    ) });
  }
);
nd.displayName = $s;
var od = "ProgressIndicator", rd = g.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, r = Jv(od, n);
    return /* @__PURE__ */ m(
      le.div,
      {
        "data-state": id(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...o,
        ref: t
      }
    );
  }
);
rd.displayName = od;
function Gv(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function id(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Qo(e) {
  return typeof e == "number";
}
function Ra(e) {
  return Qo(e) && !isNaN(e) && e > 0;
}
function Aa(e, t) {
  return Qo(e) && !isNaN(e) && e <= t && e >= 0;
}
function Yv(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${ks}\`.`;
}
function Xv(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${ks} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var Qv = nd, eb = rd;
const tb = "_small_ghhu4_36", nb = "_indicator_ghhu4_40", ob = "_primary_ghhu4_49", rb = "_secondary_ghhu4_55", ib = "_tertiary_ghhu4_61", sb = "_success_ghhu4_67", ab = "_error_ghhu4_79", An = {
  "progress-bar": "_progress-bar_ghhu4_29",
  small: tb,
  indicator: nb,
  "full-width": "_full-width_ghhu4_46",
  primary: ob,
  secondary: rb,
  tertiary: ib,
  success: sb,
  "eco-green": "_eco-green_ghhu4_73",
  error: ab,
  "dialog-overlay-show": "_dialog-overlay-show_ghhu4_1",
  "dialog-content-show": "_dialog-content-show_ghhu4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_ghhu4_1"
}, Ia = ({ value: e = 0, color: t = "primary", size: n, isFullWidth: o, ariaLabel: r }) => {
  const [i, s] = De(0), a = be(
    An["progress-bar"],
    n && An[n],
    t && An[t],
    o && An["full-width"]
  );
  return xe(() => {
    const l = setTimeout(() => s(e), 500);
    return () => clearTimeout(l);
  }, [e]), /* @__PURE__ */ m(Qv, { className: a, "aria-label": r, children: /* @__PURE__ */ m(eb, { className: An.indicator, style: { transform: `translateX(-${100 - i}%)` } }) });
}, Pa = {
  "is-hidden-desktop": "_is-hidden-desktop_1m12x_29",
  "is-hidden-mobile": "_is-hidden-mobile_1m12x_40",
  "unset-ul": "_unset-ul_1m12x_54",
  "dialog-overlay-show": "_dialog-overlay-show_1m12x_1",
  "dialog-content-show": "_dialog-content-show_1m12x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1m12x_1"
}, yn = ({ children: e, hideOn: t, className: n }) => {
  const o = be(t && Pa[`is-hidden-${t}`], n);
  return /* @__PURE__ */ m("li", { className: o, children: /* @__PURE__ */ m("ul", { className: Pa["unset-ul"], children: e }) });
}, cb = "_badge_zy4sa_29", lb = "_root_zy4sa_58", In = {
  badge: cb,
  "is-small": "_is-small_zy4sa_42",
  "has-child": "_has-child_zy4sa_48",
  "on-icon": "_on-icon_zy4sa_53",
  root: lb
};
function Es({ value: e, isSmall: t = !1, onIcon: n = !1, children: o, className: r, ...i }) {
  const s = be(
    In.badge,
    t && In["is-small"],
    n && In["on-icon"],
    !!o && In["has-child"],
    r
  );
  return o ? /* @__PURE__ */ P("span", { className: In.root, ...i, children: [
    /* @__PURE__ */ m("span", { className: s, children: !t && e }),
    o
  ] }) : /* @__PURE__ */ m("span", { className: s, ...i, children: !t && e });
}
var Xt = "NavigationMenu", [Ss, sd, ub] = hs(Xt), [Ti, db, pb] = hs(Xt), [Cs, nL] = Yt(
  Xt,
  [ub, pb]
), [fb, Qe] = Cs(Xt), [hb, mb] = Cs(Xt), ad = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: i,
      delayDuration: s = 200,
      skipDelayDuration: a = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = e, [d, f] = g.useState(null), h = Se(t, (N) => f(N)), b = wr(c), p = g.useRef(0), y = g.useRef(0), $ = g.useRef(0), [v, w] = g.useState(!0), [_, x] = Xn({
      prop: o,
      onChange: (N) => {
        const j = N !== "", H = a > 0;
        j ? (window.clearTimeout($.current), H && w(!1)) : (window.clearTimeout($.current), $.current = window.setTimeout(
          () => w(!0),
          a
        )), r?.(N);
      },
      defaultProp: i ?? "",
      caller: Xt
    }), C = g.useCallback(() => {
      window.clearTimeout(y.current), y.current = window.setTimeout(() => x(""), 150);
    }, [x]), k = g.useCallback(
      (N) => {
        window.clearTimeout(y.current), x(N);
      },
      [x]
    ), R = g.useCallback(
      (N) => {
        _ === N ? window.clearTimeout(y.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(y.current), x(N);
        }, s);
      },
      [_, x, s]
    );
    return g.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(y.current), window.clearTimeout($.current);
    }, []), /* @__PURE__ */ m(
      cd,
      {
        scope: n,
        isRootMenu: !0,
        value: _,
        dir: b,
        orientation: l,
        rootNavigationMenu: d,
        onTriggerEnter: (N) => {
          window.clearTimeout(p.current), v ? R(N) : k(N);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), C();
        },
        onContentEnter: () => window.clearTimeout(y.current),
        onContentLeave: C,
        onItemSelect: (N) => {
          x((j) => j === N ? "" : N);
        },
        onItemDismiss: () => x(""),
        children: /* @__PURE__ */ m(
          le.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: b,
            ...u,
            ref: h
          }
        )
      }
    );
  }
);
ad.displayName = Xt;
var Li = "NavigationMenuSub", gb = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: i,
      orientation: s = "horizontal",
      ...a
    } = e, l = Qe(Li, n), [c, u] = Xn({
      prop: o,
      onChange: r,
      defaultProp: i ?? "",
      caller: Li
    });
    return /* @__PURE__ */ m(
      cd,
      {
        scope: n,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: s,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (d) => u(d),
        onItemSelect: (d) => u(d),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ m(le.div, { "data-orientation": s, ...a, ref: t })
      }
    );
  }
);
gb.displayName = Li;
var cd = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    dir: r,
    orientation: i,
    children: s,
    value: a,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: d,
    onContentEnter: f,
    onContentLeave: h
  } = e, [b, p] = g.useState(null), [y, $] = g.useState(/* @__PURE__ */ new Map()), [v, w] = g.useState(null);
  return /* @__PURE__ */ m(
    fb,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: o,
      value: a,
      previousValue: Dm(a),
      baseId: Mt(),
      dir: r,
      orientation: i,
      viewport: b,
      onViewportChange: p,
      indicatorTrack: v,
      onIndicatorTrackChange: w,
      onTriggerEnter: Re(u),
      onTriggerLeave: Re(d),
      onContentEnter: Re(f),
      onContentLeave: Re(h),
      onItemSelect: Re(l),
      onItemDismiss: Re(c),
      onViewportContentChange: g.useCallback((_, x) => {
        $((C) => (C.set(_, x), new Map(C)));
      }, []),
      onViewportContentRemove: g.useCallback((_) => {
        $((x) => x.has(_) ? (x.delete(_), new Map(x)) : x);
      }, []),
      children: /* @__PURE__ */ m(Ss.Provider, { scope: t, children: /* @__PURE__ */ m(hb, { scope: t, items: y, children: s }) })
    }
  );
}, ld = "NavigationMenuList", ud = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Qe(ld, n), i = /* @__PURE__ */ m(le.ul, { "data-orientation": r.orientation, ...o, ref: t });
    return /* @__PURE__ */ m(le.div, { style: { position: "relative" }, ref: r.onIndicatorTrackChange, children: /* @__PURE__ */ m(Ss.Slot, { scope: n, children: r.isRootMenu ? /* @__PURE__ */ m(bd, { asChild: !0, children: i }) : i }) });
  }
);
ud.displayName = ld;
var dd = "NavigationMenuItem", [vb, pd] = Cs(dd), fd = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: o, ...r } = e, i = Mt(), s = o || i || "LEGACY_REACT_AUTO_VALUE", a = g.useRef(null), l = g.useRef(null), c = g.useRef(null), u = g.useRef(() => {
    }), d = g.useRef(!1), f = g.useCallback((b = "start") => {
      if (a.current) {
        u.current();
        const p = Di(a.current);
        p.length && Rs(b === "start" ? p : p.reverse());
      }
    }, []), h = g.useCallback(() => {
      if (a.current) {
        const b = Di(a.current);
        b.length && (u.current = Sb(b));
      }
    }, []);
    return /* @__PURE__ */ m(
      vb,
      {
        scope: n,
        value: s,
        triggerRef: l,
        contentRef: a,
        focusProxyRef: c,
        wasEscapeCloseRef: d,
        onEntryKeyDown: f,
        onFocusProxyEnter: f,
        onRootContentClose: h,
        onContentFocusOutside: h,
        children: /* @__PURE__ */ m(le.li, { ...r, ref: t })
      }
    );
  }
);
fd.displayName = dd;
var ji = "NavigationMenuTrigger", hd = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...r } = e, i = Qe(ji, e.__scopeNavigationMenu), s = pd(ji, e.__scopeNavigationMenu), a = g.useRef(null), l = Se(a, s.triggerRef, t), c = wd(i.baseId, s.value), u = _d(i.baseId, s.value), d = g.useRef(!1), f = g.useRef(!1), h = s.value === i.value;
  return /* @__PURE__ */ P(ze, { children: [
    /* @__PURE__ */ m(Ss.ItemSlot, { scope: n, value: s.value, children: /* @__PURE__ */ m(yd, { asChild: !0, children: /* @__PURE__ */ m(
      le.button,
      {
        id: c,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": As(h),
        "aria-expanded": h,
        "aria-controls": u,
        ...r,
        ref: l,
        onPointerEnter: se(e.onPointerEnter, () => {
          f.current = !1, s.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: se(
          e.onPointerMove,
          er(() => {
            o || f.current || s.wasEscapeCloseRef.current || d.current || (i.onTriggerEnter(s.value), d.current = !0);
          })
        ),
        onPointerLeave: se(
          e.onPointerLeave,
          er(() => {
            o || (i.onTriggerLeave(), d.current = !1);
          })
        ),
        onClick: se(e.onClick, () => {
          i.onItemSelect(s.value), f.current = h;
        }),
        onKeyDown: se(e.onKeyDown, (b) => {
          const p = { horizontal: "ArrowDown", vertical: i.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[i.orientation];
          h && b.key === p && (s.onEntryKeyDown(), b.preventDefault());
        })
      }
    ) }) }),
    h && /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(
        Rv,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: s.focusProxyRef,
          onFocus: (b) => {
            const p = s.contentRef.current, y = b.relatedTarget, $ = y === a.current, v = p?.contains(y);
            ($ || !v) && s.onFocusProxyEnter($ ? "start" : "end");
          }
        }
      ),
      i.viewport && /* @__PURE__ */ m("span", { "aria-owns": u })
    ] })
  ] });
});
hd.displayName = ji;
var bb = "NavigationMenuLink", Ta = "navigationMenu.linkSelect", md = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: o, onSelect: r, ...i } = e;
    return /* @__PURE__ */ m(yd, { asChild: !0, children: /* @__PURE__ */ m(
      le.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...i,
        ref: t,
        onClick: se(
          e.onClick,
          (s) => {
            const a = s.target, l = new CustomEvent(Ta, {
              bubbles: !0,
              cancelable: !0
            });
            if (a.addEventListener(Ta, (c) => r?.(c), { once: !0 }), Ni(a, l), !l.defaultPrevented && !s.metaKey) {
              const c = new CustomEvent(jo, {
                bubbles: !0,
                cancelable: !0
              });
              Ni(a, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
md.displayName = bb;
var Os = "NavigationMenuIndicator", yb = g.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Qe(Os, e.__scopeNavigationMenu), i = !!r.value;
  return r.indicatorTrack ? ds.createPortal(
    /* @__PURE__ */ m(Je, { present: n || i, children: /* @__PURE__ */ m(wb, { ...o, ref: t }) }),
    r.indicatorTrack
  ) : null;
});
yb.displayName = Os;
var wb = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, r = Qe(Os, n), i = sd(n), [s, a] = g.useState(
    null
  ), [l, c] = g.useState(null), u = r.orientation === "horizontal", d = !!r.value;
  g.useEffect(() => {
    const h = i().find((b) => b.value === r.value)?.ref.current;
    h && a(h);
  }, [i, r.value]);
  const f = () => {
    s && c({
      size: u ? s.offsetWidth : s.offsetHeight,
      offset: u ? s.offsetLeft : s.offsetTop
    });
  };
  return zi(s, f), zi(r.indicatorTrack, f), l ? /* @__PURE__ */ m(
    le.div,
    {
      "aria-hidden": !0,
      "data-state": d ? "visible" : "hidden",
      "data-orientation": r.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), wn = "NavigationMenuContent", gd = g.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Qe(wn, e.__scopeNavigationMenu), i = pd(wn, e.__scopeNavigationMenu), s = Se(i.contentRef, t), a = i.value === r.value, l = {
    value: i.value,
    triggerRef: i.triggerRef,
    focusProxyRef: i.focusProxyRef,
    wasEscapeCloseRef: i.wasEscapeCloseRef,
    onContentFocusOutside: i.onContentFocusOutside,
    onRootContentClose: i.onRootContentClose,
    ...o
  };
  return r.viewport ? /* @__PURE__ */ m(_b, { forceMount: n, ...l, ref: s }) : /* @__PURE__ */ m(Je, { present: n || a, children: /* @__PURE__ */ m(
    vd,
    {
      "data-state": As(a),
      ...l,
      ref: s,
      onPointerEnter: se(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: se(
        e.onPointerLeave,
        er(r.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !a && r.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
gd.displayName = wn;
var _b = g.forwardRef((e, t) => {
  const n = Qe(wn, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: r } = n;
  return kt(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), kt(() => () => r(e.value), [e.value, r]), null;
}), jo = "navigationMenu.rootContentDismiss", vd = g.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: o,
    triggerRef: r,
    focusProxyRef: i,
    wasEscapeCloseRef: s,
    onRootContentClose: a,
    onContentFocusOutside: l,
    ...c
  } = e, u = Qe(wn, n), d = g.useRef(null), f = Se(d, t), h = wd(u.baseId, o), b = _d(u.baseId, o), p = sd(n), y = g.useRef(null), { onItemDismiss: $ } = u;
  g.useEffect(() => {
    const w = d.current;
    if (u.isRootMenu && w) {
      const _ = () => {
        $(), a(), w.contains(document.activeElement) && r.current?.focus();
      };
      return w.addEventListener(jo, _), () => w.removeEventListener(jo, _);
    }
  }, [u.isRootMenu, e.value, r, $, a]);
  const v = g.useMemo(() => {
    const w = p().map((N) => N.value);
    u.dir === "rtl" && w.reverse();
    const _ = w.indexOf(u.value), x = w.indexOf(u.previousValue), C = o === u.value, k = x === w.indexOf(o);
    if (!C && !k) return y.current;
    const R = (() => {
      if (_ !== x) {
        if (C && x !== -1) return _ > x ? "from-end" : "from-start";
        if (k && _ !== -1) return _ > x ? "to-start" : "to-end";
      }
      return null;
    })();
    return y.current = R, R;
  }, [u.previousValue, u.value, u.dir, p, o]);
  return /* @__PURE__ */ m(bd, { asChild: !0, children: /* @__PURE__ */ m(
    ms,
    {
      id: b,
      "aria-labelledby": h,
      "data-motion": v,
      "data-orientation": u.orientation,
      ...c,
      ref: f,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const w = new Event(jo, {
          bubbles: !0,
          cancelable: !0
        });
        d.current?.dispatchEvent(w);
      },
      onFocusOutside: se(e.onFocusOutside, (w) => {
        l();
        const _ = w.target;
        u.rootNavigationMenu?.contains(_) && w.preventDefault();
      }),
      onPointerDownOutside: se(e.onPointerDownOutside, (w) => {
        const _ = w.target, x = p().some((k) => k.ref.current?.contains(_)), C = u.isRootMenu && u.viewport?.contains(_);
        (x || C || !u.isRootMenu) && w.preventDefault();
      }),
      onKeyDown: se(e.onKeyDown, (w) => {
        const _ = w.altKey || w.ctrlKey || w.metaKey;
        if (w.key === "Tab" && !_) {
          const x = Di(w.currentTarget), C = document.activeElement, k = x.findIndex((N) => N === C), R = w.shiftKey ? x.slice(0, k).reverse() : x.slice(k + 1, x.length);
          Rs(R) ? w.preventDefault() : i.current?.focus();
        }
      }),
      onEscapeKeyDown: se(e.onEscapeKeyDown, (w) => {
        s.current = !0;
      })
    }
  ) });
}), Ns = "NavigationMenuViewport", xb = g.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = !!Qe(Ns, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ m(Je, { present: n || r, children: /* @__PURE__ */ m($b, { ...o, ref: t }) });
});
xb.displayName = Ns;
var $b = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: o, ...r } = e, i = Qe(Ns, n), s = Se(t, i.onViewportChange), a = mb(
    wn,
    e.__scopeNavigationMenu
  ), [l, c] = g.useState(null), [u, d] = g.useState(null), f = l ? l?.width + "px" : void 0, h = l ? l?.height + "px" : void 0, b = !!i.value, p = b ? i.value : i.previousValue;
  return zi(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ m(
    le.div,
    {
      "data-state": As(b),
      "data-orientation": i.orientation,
      ...r,
      ref: s,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !b && i.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": f,
        "--radix-navigation-menu-viewport-height": h,
        ...r.style
      },
      onPointerEnter: se(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: se(e.onPointerLeave, er(i.onContentLeave)),
      children: Array.from(a.items).map(([y, { ref: $, forceMount: v, ...w }]) => {
        const _ = p === y;
        return /* @__PURE__ */ m(Je, { present: v || _, children: /* @__PURE__ */ m(
          vd,
          {
            ...w,
            ref: fs($, (x) => {
              _ && x && d(x);
            })
          }
        ) }, y);
      })
    }
  );
}), kb = "FocusGroup", bd = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Qe(kb, n);
    return /* @__PURE__ */ m(Ti.Provider, { scope: n, children: /* @__PURE__ */ m(Ti.Slot, { scope: n, children: /* @__PURE__ */ m(le.div, { dir: r.dir, ...o, ref: t }) }) });
  }
), La = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], Eb = "FocusGroupItem", yd = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = db(n), i = Qe(Eb, n);
    return /* @__PURE__ */ m(Ti.ItemSlot, { scope: n, children: /* @__PURE__ */ m(
      le.button,
      {
        ...o,
        ref: t,
        onKeyDown: se(e.onKeyDown, (s) => {
          if (["Home", "End", ...La].includes(s.key)) {
            let a = r().map((l) => l.ref.current);
            if ([i.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(s.key) && a.reverse(), La.includes(s.key)) {
              const l = a.indexOf(s.currentTarget);
              a = a.slice(l + 1);
            }
            setTimeout(() => Rs(a)), s.preventDefault();
          }
        })
      }
    ) });
  }
);
function Di(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Rs(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function Sb(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function zi(e, t) {
  const n = Re(t);
  kt(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
function As(e) {
  return e ? "open" : "closed";
}
function wd(e, t) {
  return `${e}-trigger-${t}`;
}
function _d(e, t) {
  return `${e}-content-${t}`;
}
function er(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Cb = ad, Ob = ud, tr = fd, Nb = hd, Rb = md, Ab = gd;
const Ib = "_arrow_1367h_117", Pb = "_navbar_1367h_29", fe = {
  "navbar-item": "_navbar-item_1367h_29",
  "navbar-item-background-hover": "_navbar-item-background-hover_1367h_33",
  "navbar-drawer": "_navbar-drawer_1367h_37",
  "first-on-mobile": "_first-on-mobile_1367h_52",
  "second-on-mobile": "_second-on-mobile_1367h_61",
  "navbar-end": "_navbar-end_1367h_70",
  "navbar-item-wrapper": "_navbar-item-wrapper_1367h_89",
  "navbar-item-flex-grow": "_navbar-item-flex-grow_1367h_105",
  "navbar-item-button": "_navbar-item-button_1367h_108",
  arrow: Ib,
  "navbar-has-dropdown": "_navbar-has-dropdown_1367h_130",
  "navbar-dropdown": "_navbar-dropdown_1367h_156",
  "is-size-small": "_is-size-small_1367h_161",
  "is-size-medium": "_is-size-medium_1367h_164",
  "navbar-item-no-padding-top-bottom": "_navbar-item-no-padding-top-bottom_1367h_191",
  "navbar-item-is-right": "_navbar-item-is-right_1367h_195",
  "navbar-item-is-center": "_navbar-item-is-center_1367h_200",
  "navbar-item-no-padding": "_navbar-item-no-padding_1367h_191",
  "is-right": "_is-right_1367h_207",
  "is-left": "_is-left_1367h_211",
  navbar: Pb,
  "is-fixed-top": "_is-fixed-top_1367h_228",
  "navbar-burger": "_navbar-burger_1367h_241",
  "navbar-menu": "_navbar-menu_1367h_282",
  "burger-close": "_burger-close_1367h_296",
  "navbar-start": "_navbar-start_1367h_316",
  "unset-li": "_unset-li_1367h_350",
  "margin-auto-top": "_margin-auto-top_1367h_357",
  "navbar-item-larger-padding-bottom": "_navbar-item-larger-padding-bottom_1367h_366",
  "dialog-overlay-show": "_dialog-overlay-show_1367h_1",
  "dialog-content-show": "_dialog-content-show_1367h_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1367h_1"
}, xd = ({ children: e, isFixedTop: t }) => /* @__PURE__ */ m(Cb, { children: /* @__PURE__ */ m(Ob, { className: be(fe.navbar, t && fe["is-fixed-top"]), children: e }) }), $d = ({ children: e, notificationValue: t }) => {
  const { value: n, toggle: o } = zm(), { isMobile: r, isTablet: i } = Fm();
  return /* @__PURE__ */ P(ze, { children: [
    (r || i) && /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(Q, { children: t ? /* @__PURE__ */ m(Es, { value: t, isSmall: !0, children: /* @__PURE__ */ P("button", { onClick: o, className: fe["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ m("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ m("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ m("span", { "aria-hidden": "true" })
      ] }) }) : /* @__PURE__ */ P("button", { onClick: o, className: fe["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ m("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ m("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ m("span", { "aria-hidden": "true" })
      ] }) }),
      /* @__PURE__ */ m(Wv, { isOpen: n, onClose: o, className: be(fe["navbar-drawer"]), children: e })
    ] }),
    /* @__PURE__ */ m("li", { className: be(fe["navbar-menu"]), children: /* @__PURE__ */ P("ul", { children: [
      /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m("button", { className: fe["burger-close"], onClick: o, "aria-label": "burger-close", children: /* @__PURE__ */ m(he, { name: "remove", size: "large" }) }) }),
      e
    ] }) })
  ] });
}, Q = ({
  children: e,
  href: t,
  hideOn: n,
  isFirstOnMobile: o,
  isSecondOnMobile: r,
  noPaddingRight: i,
  largerPaddingBottom: s,
  noTopBottomPadding: a,
  onClick: l,
  marginAutoTop: c,
  isButton: u,
  backgroundOnHover: d = !0,
  isFlexGrow: f = !1
}) => {
  const h = be(
    c && fe["margin-auto-top"],
    o && fe["first-on-mobile"],
    r && fe["second-on-mobile"],
    i && fe["navbar-item-no-padding"],
    u && fe["navbar-item-button"],
    a && fe["navbar-item-no-padding-top-bottom"],
    s && fe["navbar-item-larger-padding-bottom"],
    d && fe["navbar-item-background-hover"],
    f && fe["navbar-item-flex-grow"]
  ), b = t ? /* @__PURE__ */ m(tr, { onClick: l, className: be(fe["navbar-item-wrapper"], h), children: /* @__PURE__ */ m(Rb, { className: be(fe["navbar-item"], h), href: t, children: e }) }) : /* @__PURE__ */ m(tr, { onClick: l, className: be(fe["navbar-item"], h), children: e });
  return n ? /* @__PURE__ */ m(yn, { hideOn: n, className: be(fe["navbar-item-wrapper"], h), children: b }) : b;
}, kd = ({ children: e, position: t }) => {
  const n = be(t && fe[`navbar-${t}`]);
  return /* @__PURE__ */ m("li", { className: n, children: /* @__PURE__ */ m("ul", { className: n, children: e }) });
}, Is = ({ children: e, hideOn: t }) => {
  const n = be(fe["navbar-has-dropdown"], fe["navbar-item-wrapper"]);
  return t ? /* @__PURE__ */ m(yn, { hideOn: t, className: fe["navbar-item-wrapper"], children: /* @__PURE__ */ m(tr, { className: n, children: e }) }) : /* @__PURE__ */ m(tr, { className: n, children: e });
}, Ps = ({ children: e }) => /* @__PURE__ */ m(Nb, { className: fe["navbar-item"], children: /* @__PURE__ */ P(te, { gap: "2", alignItems: "center", isFullWidth: !0, justifyContent: "space-between", children: [
  e,
  /* @__PURE__ */ m(he, { name: "up-arrow", size: "small", className: fe.arrow })
] }) }), Ts = ({ children: e, size: t, align: n = "right" }) => {
  const o = be(
    fe["navbar-dropdown"],
    fe[`is-${n}`],
    fe["navbar-item"],
    t && fe[`is-size-${t}`]
  );
  return /* @__PURE__ */ m(Ab, { className: o, children: /* @__PURE__ */ m("ul", { children: e }) });
}, ja = {
  "unset-list": "_unset-list_50wvn_29",
  "navbar-brand": "_navbar-brand_50wvn_38"
}, Ed = ({ children: e }) => /* @__PURE__ */ m("li", { className: ja["unset-list"], children: /* @__PURE__ */ m("ul", { className: ja["navbar-brand"], children: e }) }), ni = {
  "unset-list": "_unset-list_g6gr1_29",
  "navbar-divider": "_navbar-divider_g6gr1_35"
}, hn = ({ hideOn: e }) => {
  const t = be(ni["navbar-divider"]);
  return e ? /* @__PURE__ */ m(yn, { hideOn: e, children: /* @__PURE__ */ m("li", { className: ni["unset-list"], children: /* @__PURE__ */ m("hr", { className: t }) }) }) : /* @__PURE__ */ m("li", { className: ni["unset-list"], children: /* @__PURE__ */ m("hr", { className: t }) });
}, Tb = {
  "dropdown-divider": "_dropdown-divider_6mcrd_29"
}, Ye = () => /* @__PURE__ */ m("hr", { className: be(Tb["dropdown-divider"]) }), Lb = "_avatar_1ikzc_29", Da = {
  avatar: Lb,
  "is-xsmall": "_is-xsmall_1ikzc_32",
  "is-small": "_is-small_1ikzc_36",
  "is-medium": "_is-medium_1ikzc_40",
  "is-large": "_is-large_1ikzc_44",
  "dialog-overlay-show": "_dialog-overlay-show_1ikzc_1",
  "dialog-content-show": "_dialog-content-show_1ikzc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ikzc_1"
};
function Sd({ url: e, alt: t, size: n = "medium", className: o, ...r }) {
  const i = be(Da.avatar, n && Da[`is-${n}`], o);
  return /* @__PURE__ */ m("img", { className: i, src: e, alt: t, ...r });
}
const za = {
  "communication-banner": "_communication-banner_2kn0i_1"
};
function jb({ text: e, url: t }) {
  return /* @__PURE__ */ m("a", { href: t, children: /* @__PURE__ */ P("div", { className: za["communication-banner"], children: [
    /* @__PURE__ */ m("p", { children: e }),
    /* @__PURE__ */ m(he, { size: "2xl", name: "angle-right", className: za.icon })
  ] }) });
}
function Cd(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Cd(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Db() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Cd(e)) && (o && (o += " "), o += t);
  return o;
}
const zb = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Mb = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Fb = zb.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Mb[e]
})), Vb = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Ub = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function Bb(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ m("span", { className: n }, n));
}
const Hb = At(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...r }, i) => {
    const s = Fb.find((l) => l.name === e), a = Db("icon", `ds-${s?.class}`, Ub[t], Vb[n], o);
    return /* @__PURE__ */ m("i", { className: a, ...r, ref: i, children: Bb(s?.paths) });
  }
);
Hb.displayName = "Icon";
const Kb = ["en", "fr", "it"], Od = Jt({
  locale: "en"
});
function Nd({ children: e, ...t }) {
  return /* @__PURE__ */ m(Od.Provider, { value: t, children: e });
}
const Wb = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function qb(e) {
  return Kb.includes(e) && !0;
}
function Zb(e, t) {
  const n = Wb.test(t);
  let o;
  return qb(e) || n ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function ve(e) {
  const { locale: t } = yr(Od);
  return Zb(t, e);
}
let Ma = class extends Error {
  code;
  errorData;
  constructor(t, n, o) {
    super(t), this.name = "HeError", this.code = n, this.errorData = o;
  }
};
function Rd(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Jb } = Object.prototype, { getPrototypeOf: Ls } = Object, { iterator: Sr, toStringTag: Ad } = Symbol, Cr = /* @__PURE__ */ ((e) => (t) => {
  const n = Jb.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), tt = (e) => (e = e.toLowerCase(), (t) => Cr(t) === e), Or = (e) => (t) => typeof t === e, { isArray: kn } = Array, Bn = Or("undefined");
function eo(e) {
  return e !== null && !Bn(e) && e.constructor !== null && !Bn(e.constructor) && Be(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Id = tt("ArrayBuffer");
function Gb(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Id(e.buffer), t;
}
const Yb = Or("string"), Be = Or("function"), Pd = Or("number"), to = (e) => e !== null && typeof e == "object", Xb = (e) => e === !0 || e === !1, Do = (e) => {
  if (Cr(e) !== "object")
    return !1;
  const t = Ls(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Ad in e) && !(Sr in e);
}, Qb = (e) => {
  if (!to(e) || eo(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, ey = tt("Date"), ty = tt("File"), ny = tt("Blob"), oy = tt("FileList"), ry = (e) => to(e) && Be(e.pipe), iy = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Be(e.append) && ((t = Cr(e)) === "formdata" || // detect form-data instance
  t === "object" && Be(e.toString) && e.toString() === "[object FormData]"));
}, sy = tt("URLSearchParams"), [ay, cy, ly, uy] = ["ReadableStream", "Request", "Response", "Headers"].map(tt), dy = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function no(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, r;
  if (typeof e != "object" && (e = [e]), kn(e))
    for (o = 0, r = e.length; o < r; o++)
      t.call(null, e[o], o, e);
  else {
    if (eo(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let a;
    for (o = 0; o < s; o++)
      a = i[o], t.call(null, e[a], a, e);
  }
}
function Td(e, t) {
  if (eo(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, r;
  for (; o-- > 0; )
    if (r = n[o], t === r.toLowerCase())
      return r;
  return null;
}
const Lt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ld = (e) => !Bn(e) && e !== Lt;
function Mi() {
  const { caseless: e } = Ld(this) && this || {}, t = {}, n = (o, r) => {
    const i = e && Td(t, r) || r;
    Do(t[i]) && Do(o) ? t[i] = Mi(t[i], o) : Do(o) ? t[i] = Mi({}, o) : kn(o) ? t[i] = o.slice() : t[i] = o;
  };
  for (let o = 0, r = arguments.length; o < r; o++)
    arguments[o] && no(arguments[o], n);
  return t;
}
const py = (e, t, n, { allOwnKeys: o } = {}) => (no(t, (r, i) => {
  n && Be(r) ? e[i] = Rd(r, n) : e[i] = r;
}, { allOwnKeys: o }), e), fy = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), hy = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, my = (e, t, n, o) => {
  let r, i, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      s = r[i], (!o || o(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = n !== !1 && Ls(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, gy = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, vy = (e) => {
  if (!e) return null;
  if (kn(e)) return e;
  let t = e.length;
  if (!Pd(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, by = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ls(Uint8Array)), yy = (e, t) => {
  const n = (e && e[Sr]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const r = o.value;
    t.call(e, r[0], r[1]);
  }
}, wy = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, _y = tt("HTMLFormElement"), xy = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, o) {
    return n.toUpperCase() + o;
  }
), Fa = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), $y = tt("RegExp"), jd = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  no(n, (r, i) => {
    let s;
    (s = t(r, i, e)) !== !1 && (o[i] = s || r);
  }), Object.defineProperties(e, o);
}, ky = (e) => {
  jd(e, (t, n) => {
    if (Be(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (Be(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ey = (e, t) => {
  const n = {}, o = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return kn(e) ? o(e) : o(String(e).split(t)), n;
}, Sy = () => {
}, Cy = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Oy(e) {
  return !!(e && Be(e.append) && e[Ad] === "FormData" && e[Sr]);
}
const Ny = (e) => {
  const t = new Array(10), n = (o, r) => {
    if (to(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (eo(o))
        return o;
      if (!("toJSON" in o)) {
        t[r] = o;
        const i = kn(o) ? [] : {};
        return no(o, (s, a) => {
          const l = n(s, r + 1);
          !Bn(l) && (i[a] = l);
        }), t[r] = void 0, i;
      }
    }
    return o;
  };
  return n(e, 0);
}, Ry = tt("AsyncFunction"), Ay = (e) => e && (to(e) || Be(e)) && Be(e.then) && Be(e.catch), Dd = ((e, t) => e ? setImmediate : t ? ((n, o) => (Lt.addEventListener("message", ({ source: r, data: i }) => {
  r === Lt && i === n && o.length && o.shift()();
}, !1), (r) => {
  o.push(r), Lt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Be(Lt.postMessage)
), Iy = typeof queueMicrotask < "u" ? queueMicrotask.bind(Lt) : typeof process < "u" && process.nextTick || Dd, Py = (e) => e != null && Be(e[Sr]), E = {
  isArray: kn,
  isArrayBuffer: Id,
  isBuffer: eo,
  isFormData: iy,
  isArrayBufferView: Gb,
  isString: Yb,
  isNumber: Pd,
  isBoolean: Xb,
  isObject: to,
  isPlainObject: Do,
  isEmptyObject: Qb,
  isReadableStream: ay,
  isRequest: cy,
  isResponse: ly,
  isHeaders: uy,
  isUndefined: Bn,
  isDate: ey,
  isFile: ty,
  isBlob: ny,
  isRegExp: $y,
  isFunction: Be,
  isStream: ry,
  isURLSearchParams: sy,
  isTypedArray: by,
  isFileList: oy,
  forEach: no,
  merge: Mi,
  extend: py,
  trim: dy,
  stripBOM: fy,
  inherits: hy,
  toFlatObject: my,
  kindOf: Cr,
  kindOfTest: tt,
  endsWith: gy,
  toArray: vy,
  forEachEntry: yy,
  matchAll: wy,
  isHTMLForm: _y,
  hasOwnProperty: Fa,
  hasOwnProp: Fa,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: jd,
  freezeMethods: ky,
  toObjectSet: Ey,
  toCamelCase: xy,
  noop: Sy,
  toFiniteNumber: Cy,
  findKey: Td,
  global: Lt,
  isContextDefined: Ld,
  isSpecCompliantForm: Oy,
  toJSONObject: Ny,
  isAsyncFn: Ry,
  isThenable: Ay,
  setImmediate: Dd,
  asap: Iy,
  isIterable: Py
};
function ne(e, t, n, o, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), r && (this.response = r, this.status = r.status ? r.status : null);
}
E.inherits(ne, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const zd = ne.prototype, Md = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Md[e] = { value: e };
});
Object.defineProperties(ne, Md);
Object.defineProperty(zd, "isAxiosError", { value: !0 });
ne.from = (e, t, n, o, r, i) => {
  const s = Object.create(zd);
  return E.toFlatObject(e, s, function(a) {
    return a !== Error.prototype;
  }, (a) => a !== "isAxiosError"), ne.call(s, e.message, t, n, o, r), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const Ty = null;
function Fi(e) {
  return E.isPlainObject(e) || E.isArray(e);
}
function Fd(e) {
  return E.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Va(e, t, n) {
  return e ? e.concat(t).map(function(o, r) {
    return o = Fd(o), !n && r ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function Ly(e) {
  return E.isArray(e) && !e.some(Fi);
}
const jy = E.toFlatObject(E, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Nr(e, t, n) {
  if (!E.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = E.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, b) {
    return !E.isUndefined(b[h]);
  });
  const o = n.metaTokens, r = n.visitor || c, i = n.dots, s = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(t);
  if (!E.isFunction(r))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null) return "";
    if (E.isDate(h))
      return h.toISOString();
    if (E.isBoolean(h))
      return h.toString();
    if (!a && E.isBlob(h))
      throw new ne("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(h) || E.isTypedArray(h) ? a && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, b, p) {
    let y = h;
    if (h && !p && typeof h == "object") {
      if (E.endsWith(b, "{}"))
        b = o ? b : b.slice(0, -2), h = JSON.stringify(h);
      else if (E.isArray(h) && Ly(h) || (E.isFileList(h) || E.endsWith(b, "[]")) && (y = E.toArray(h)))
        return b = Fd(b), y.forEach(function($, v) {
          !(E.isUndefined($) || $ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Va([b], v, i) : s === null ? b : b + "[]",
            l($)
          );
        }), !1;
    }
    return Fi(h) ? !0 : (t.append(Va(p, b, i), l(h)), !1);
  }
  const u = [], d = Object.assign(jy, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Fi
  });
  function f(h, b) {
    if (!E.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      u.push(h), E.forEach(h, function(p, y) {
        (!(E.isUndefined(p) || p === null) && r.call(
          t,
          p,
          E.isString(y) ? y.trim() : y,
          b,
          d
        )) === !0 && f(p, b ? b.concat(y) : [y]);
      }), u.pop();
    }
  }
  if (!E.isObject(e))
    throw new TypeError("data must be an object");
  return f(e), t;
}
function Ua(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function js(e, t) {
  this._pairs = [], e && Nr(e, this, t);
}
const Vd = js.prototype;
Vd.append = function(e, t) {
  this._pairs.push([e, t]);
};
Vd.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Ua);
  } : Ua;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function Dy(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Ud(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || Dy;
  E.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = E.isURLSearchParams(t) ? t.toString() : new js(t, n).toString(o), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
let Ba = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    E.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
};
const Bd = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, zy = typeof URLSearchParams < "u" ? URLSearchParams : js, My = typeof FormData < "u" ? FormData : null, Fy = typeof Blob < "u" ? Blob : null, Vy = {
  isBrowser: !0,
  classes: {
    URLSearchParams: zy,
    FormData: My,
    Blob: Fy
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ds = typeof window < "u" && typeof document < "u", Vi = typeof navigator == "object" && navigator || void 0, Uy = Ds && (!Vi || ["ReactNative", "NativeScript", "NS"].indexOf(Vi.product) < 0), By = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Hy = Ds && window.location.href || "http://localhost", Ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ds,
  hasStandardBrowserEnv: Uy,
  hasStandardBrowserWebWorkerEnv: By,
  navigator: Vi,
  origin: Hy
}, Symbol.toStringTag, { value: "Module" })), Me = {
  ...Ky,
  ...Vy
};
function Wy(e, t) {
  return Nr(e, new Me.classes.URLSearchParams(), {
    visitor: function(n, o, r, i) {
      return Me.isNode && E.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function qy(e) {
  return E.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Zy(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const r = n.length;
  let i;
  for (o = 0; o < r; o++)
    i = n[o], t[i] = e[i];
  return t;
}
function Hd(e) {
  function t(n, o, r, i) {
    let s = n[i++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), l = i >= n.length;
    return s = !s && E.isArray(r) ? r.length : s, l ? (E.hasOwnProp(r, s) ? r[s] = [r[s], o] : r[s] = o, !a) : ((!r[s] || !E.isObject(r[s])) && (r[s] = []), t(n, o, r[s], i) && E.isArray(r[s]) && (r[s] = Zy(r[s])), !a);
  }
  if (E.isFormData(e) && E.isFunction(e.entries)) {
    const n = {};
    return E.forEachEntry(e, (o, r) => {
      t(qy(o), r, n, 0);
    }), n;
  }
  return null;
}
function Jy(e, t, n) {
  if (E.isString(e))
    try {
      return (t || JSON.parse)(e), E.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const oo = {
  transitional: Bd,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", o = n.indexOf("application/json") > -1, r = E.isObject(e);
    if (r && E.isHTMLForm(e) && (e = new FormData(e)), E.isFormData(e))
      return o ? JSON.stringify(Hd(e)) : e;
    if (E.isArrayBuffer(e) || E.isBuffer(e) || E.isStream(e) || E.isFile(e) || E.isBlob(e) || E.isReadableStream(e))
      return e;
    if (E.isArrayBufferView(e))
      return e.buffer;
    if (E.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (r) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Wy(e, this.formSerializer).toString();
      if ((i = E.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return Nr(
          i ? { "files[]": e } : e,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return r || o ? (t.setContentType("application/json", !1), Jy(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || oo.transitional, n = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (E.isResponse(e) || E.isReadableStream(e))
      return e;
    if (e && E.isString(e) && (n && !this.responseType || o)) {
      const r = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (r)
          throw i.name === "SyntaxError" ? ne.from(i, ne.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Me.classes.FormData,
    Blob: Me.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
E.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  oo.headers[e] = {};
});
const Gy = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Yy = (e) => {
  const t = {};
  let n, o, r;
  return e && e.split(`
`).forEach(function(i) {
    r = i.indexOf(":"), n = i.substring(0, r).trim().toLowerCase(), o = i.substring(r + 1).trim(), !(!n || t[n] && Gy[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, Ha = Symbol("internals");
function Pn(e) {
  return e && String(e).trim().toLowerCase();
}
function zo(e) {
  return e === !1 || e == null ? e : E.isArray(e) ? e.map(zo) : String(e);
}
function Xy(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const Qy = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function oi(e, t, n, o, r) {
  if (E.isFunction(o))
    return o.call(this, t, n);
  if (r && (t = n), !!E.isString(t)) {
    if (E.isString(o))
      return t.indexOf(o) !== -1;
    if (E.isRegExp(o))
      return o.test(t);
  }
}
function ew(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function tw(e, t) {
  const n = E.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(r, i, s) {
        return this[o].call(this, t, r, i, s);
      },
      configurable: !0
    });
  });
}
let He = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, o) {
    const r = this;
    function i(a, l, c) {
      const u = Pn(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = E.findKey(r, u);
      (!d || r[d] === void 0 || c === !0 || c === void 0 && r[d] !== !1) && (r[d || l] = zo(a));
    }
    const s = (a, l) => E.forEach(a, (c, u) => i(c, u, l));
    if (E.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (E.isString(t) && (t = t.trim()) && !Qy(t))
      s(Yy(t), n);
    else if (E.isObject(t) && E.isIterable(t)) {
      let a = {}, l, c;
      for (const u of t) {
        if (!E.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        a[c = u[0]] = (l = a[c]) ? E.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      s(a, n);
    } else
      t != null && i(n, t, o);
    return this;
  }
  get(t, n) {
    if (t = Pn(t), t) {
      const o = E.findKey(this, t);
      if (o) {
        const r = this[o];
        if (!n)
          return r;
        if (n === !0)
          return Xy(r);
        if (E.isFunction(n))
          return n.call(this, r, o);
        if (E.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Pn(t), t) {
      const o = E.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!n || oi(this, this[o], o, n)));
    }
    return !1;
  }
  delete(t, n) {
    const o = this;
    let r = !1;
    function i(s) {
      if (s = Pn(s), s) {
        const a = E.findKey(o, s);
        a && (!n || oi(o, o[a], a, n)) && (delete o[a], r = !0);
      }
    }
    return E.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let o = n.length, r = !1;
    for (; o--; ) {
      const i = n[o];
      (!t || oi(this, this[i], i, t, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, o = {};
    return E.forEach(this, (r, i) => {
      const s = E.findKey(o, i);
      if (s) {
        n[s] = zo(r), delete n[i];
        return;
      }
      const a = t ? ew(i) : String(i).trim();
      a !== i && delete n[i], n[a] = zo(r), o[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (o, r) => {
      o != null && o !== !1 && (n[r] = t && E.isArray(o) ? o.join(", ") : o);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const o = new this(t);
    return n.forEach((r) => o.set(r)), o;
  }
  static accessor(t) {
    const n = (this[Ha] = this[Ha] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function r(i) {
      const s = Pn(i);
      n[s] || (tw(o, i), n[s] = !0);
    }
    return E.isArray(t) ? t.forEach(r) : r(t), this;
  }
};
He.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.reduceDescriptors(He.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
E.freezeMethods(He);
function ri(e, t) {
  const n = this || oo, o = t || n, r = He.from(o.headers);
  let i = o.data;
  return E.forEach(e, function(s) {
    i = s.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function Kd(e) {
  return !!(e && e.__CANCEL__);
}
function En(e, t, n) {
  ne.call(this, e ?? "canceled", ne.ERR_CANCELED, t, n), this.name = "CanceledError";
}
E.inherits(En, ne, {
  __CANCEL__: !0
});
function Wd(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new ne(
    "Request failed with status code " + n.status,
    [ne.ERR_BAD_REQUEST, ne.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function nw(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function ow(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let r = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const l = Date.now(), c = o[i];
    s || (s = l), n[r] = a, o[r] = l;
    let u = i, d = 0;
    for (; u !== r; )
      d += n[u++], u = u % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), l - s < t)
      return;
    const f = c && l - c;
    return f ? Math.round(d * 1e3 / f) : void 0;
  };
}
function rw(e, t) {
  let n = 0, o = 1e3 / t, r, i;
  const s = (a, l = Date.now()) => {
    n = l, r = null, i && (clearTimeout(i), i = null), e(...a);
  };
  return [(...a) => {
    const l = Date.now(), c = l - n;
    c >= o ? s(a, l) : (r = a, i || (i = setTimeout(() => {
      i = null, s(r);
    }, o - c)));
  }, () => r && s(r)];
}
const nr = (e, t, n = 3) => {
  let o = 0;
  const r = ow(50, 250);
  return rw((i) => {
    const s = i.loaded, a = i.lengthComputable ? i.total : void 0, l = s - o, c = r(l), u = s <= a;
    o = s;
    const d = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && a && u ? (a - s) / c : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Ka = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, Wa = (e) => (...t) => E.asap(() => e(...t)), iw = Me.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Me.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Me.origin),
  Me.navigator && /(msie|trident)/i.test(Me.navigator.userAgent)
) : () => !0, sw = Me.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, r, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      E.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), E.isString(o) && s.push("path=" + o), E.isString(r) && s.push("domain=" + r), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function aw(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cw(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function qd(e, t, n) {
  let o = !aw(t);
  return e && (o || n == !1) ? cw(e, t) : t;
}
const qa = (e) => e instanceof He ? { ...e } : e;
function Bt(e, t) {
  t = t || {};
  const n = {};
  function o(c, u, d, f) {
    return E.isPlainObject(c) && E.isPlainObject(u) ? E.merge.call({ caseless: f }, c, u) : E.isPlainObject(u) ? E.merge({}, u) : E.isArray(u) ? u.slice() : u;
  }
  function r(c, u, d, f) {
    if (E.isUndefined(u)) {
      if (!E.isUndefined(c))
        return o(void 0, c, d, f);
    } else return o(c, u, d, f);
  }
  function i(c, u) {
    if (!E.isUndefined(u))
      return o(void 0, u);
  }
  function s(c, u) {
    if (E.isUndefined(u)) {
      if (!E.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function a(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (c, u, d) => r(qa(c), qa(u), d, !0)
  };
  return E.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || r, d = u(e[c], t[c], c);
    E.isUndefined(d) && u !== a || (n[c] = d);
  }), n;
}
const Zd = (e) => {
  const t = Bt({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: r, xsrfCookieName: i, headers: s, auth: a } = t;
  t.headers = s = He.from(s), t.url = Ud(qd(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (E.isFormData(n)) {
    if (Me.hasStandardBrowserEnv || Me.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Me.hasStandardBrowserEnv && (o && E.isFunction(o) && (o = o(t)), o || o !== !1 && iw(t.url))) {
    const c = r && i && sw.read(i);
    c && s.set(r, c);
  }
  return t;
}, lw = typeof XMLHttpRequest < "u", uw = lw && function(e) {
  return new Promise(function(t, n) {
    const o = Zd(e);
    let r = o.data;
    const i = He.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: a, onDownloadProgress: l } = o, c, u, d, f, h;
    function b() {
      f && f(), h && h(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function y() {
      if (!p)
        return;
      const v = He.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), w = {
        data: !s || s === "text" || s === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: v,
        config: e,
        request: p
      };
      Wd(function(_) {
        t(_), b();
      }, function(_) {
        n(_), b();
      }, w), p = null;
    }
    "onloadend" in p ? p.onloadend = y : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, p.onabort = function() {
      p && (n(new ne("Request aborted", ne.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      n(new ne("Network Error", ne.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let v = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const w = o.transitional || Bd;
      o.timeoutErrorMessage && (v = o.timeoutErrorMessage), n(new ne(
        v,
        w.clarifyTimeoutError ? ne.ETIMEDOUT : ne.ECONNABORTED,
        e,
        p
      )), p = null;
    }, r === void 0 && i.setContentType(null), "setRequestHeader" in p && E.forEach(i.toJSON(), function(v, w) {
      p.setRequestHeader(w, v);
    }), E.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), s && s !== "json" && (p.responseType = o.responseType), l && ([d, h] = nr(l, !0), p.addEventListener("progress", d)), a && p.upload && ([u, f] = nr(a), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", f)), (o.cancelToken || o.signal) && (c = (v) => {
      p && (n(!v || v.type ? new En(null, e, p) : v), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const $ = nw(o.url);
    if ($ && Me.protocols.indexOf($) === -1) {
      n(new ne("Unsupported protocol " + $ + ":", ne.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(r || null);
  });
}, dw = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), r;
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof ne ? u : new En(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new ne(`timeout ${t} of ms exceeded`, ne.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = o;
    return l.unsubscribe = () => E.asap(a), l;
  }
}, pw = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let o = 0, r;
  for (; o < n; )
    r = o + t, yield e.slice(o, r), o = r;
}, fw = async function* (e, t) {
  for await (const n of hw(e))
    yield* pw(n, t);
}, hw = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Za = (e, t, n, o) => {
  const r = fw(e, t);
  let i = 0, s, a = (l) => {
    s || (s = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await r.next();
        if (c) {
          a(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let f = i += d;
          n(f);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(l) {
      return a(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Rr = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Jd = Rr && typeof ReadableStream == "function", mw = Rr && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Gd = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, gw = Jd && Gd(() => {
  let e = !1;
  const t = new Request(Me.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Ja = 64 * 1024, Ui = Jd && Gd(() => E.isReadableStream(new Response("").body)), or = {
  stream: Ui && ((e) => e.body)
};
Rr && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !or[t] && (or[t] = E.isFunction(e[t]) ? (n) => n[t]() : (n, o) => {
      throw new ne(`Response type '${t}' is not supported`, ne.ERR_NOT_SUPPORT, o);
    });
  });
})(new Response());
const vw = async (e) => {
  if (e == null)
    return 0;
  if (E.isBlob(e))
    return e.size;
  if (E.isSpecCompliantForm(e))
    return (await new Request(Me.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (E.isArrayBufferView(e) || E.isArrayBuffer(e))
    return e.byteLength;
  if (E.isURLSearchParams(e) && (e = e + ""), E.isString(e))
    return (await mw(e)).byteLength;
}, bw = async (e, t) => E.toFiniteNumber(e.getContentLength()) ?? vw(t), yw = Rr && (async (e) => {
  let {
    url: t,
    method: n,
    data: o,
    signal: r,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = Zd(e);
  c = c ? (c + "").toLowerCase() : "text";
  let h = dw([r, i && i.toAbortSignal()], s), b;
  const p = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let y;
  try {
    if (l && gw && n !== "get" && n !== "head" && (y = await bw(u, o)) !== 0) {
      let x = new Request(t, {
        method: "POST",
        body: o,
        duplex: "half"
      }), C;
      if (E.isFormData(o) && (C = x.headers.get("content-type")) && u.setContentType(C), x.body) {
        const [k, R] = Ka(
          y,
          nr(Wa(l))
        );
        o = Za(x.body, Ja, k, R);
      }
    }
    E.isString(d) || (d = d ? "include" : "omit");
    const $ = "credentials" in Request.prototype;
    b = new Request(t, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: o,
      duplex: "half",
      credentials: $ ? d : void 0
    });
    let v = await fetch(b, f);
    const w = Ui && (c === "stream" || c === "response");
    if (Ui && (a || w && p)) {
      const x = {};
      ["status", "statusText", "headers"].forEach((N) => {
        x[N] = v[N];
      });
      const C = E.toFiniteNumber(v.headers.get("content-length")), [k, R] = a && Ka(
        C,
        nr(Wa(a), !0)
      ) || [];
      v = new Response(
        Za(v.body, Ja, k, () => {
          R && R(), p && p();
        }),
        x
      );
    }
    c = c || "text";
    let _ = await or[E.findKey(or, c) || "text"](v, e);
    return !w && p && p(), await new Promise((x, C) => {
      Wd(x, C, {
        data: _,
        headers: He.from(v.headers),
        status: v.status,
        statusText: v.statusText,
        config: e,
        request: b
      });
    });
  } catch ($) {
    throw p && p(), $ && $.name === "TypeError" && /Load failed|fetch/i.test($.message) ? Object.assign(
      new ne("Network Error", ne.ERR_NETWORK, e, b),
      {
        cause: $.cause || $
      }
    ) : ne.from($, $ && $.code, e, b);
  }
}), Bi = {
  http: Ty,
  xhr: uw,
  fetch: yw
};
E.forEach(Bi, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ga = (e) => `- ${e}`, ww = (e) => E.isFunction(e) || e === null || e === !1, Yd = {
  getAdapter: (e) => {
    e = E.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, o;
    const r = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (o = n, !ww(n) && (o = Bi[(s = String(n)).toLowerCase()], o === void 0))
        throw new ne(`Unknown adapter '${s}'`);
      if (o)
        break;
      r[s || "#" + i] = o;
    }
    if (!o) {
      const i = Object.entries(r).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(Ga).join(`
`) : " " + Ga(i[0]) : "as no adapter specified";
      throw new ne(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Bi
};
function ii(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new En(null, e);
}
function Ya(e) {
  return ii(e), e.headers = He.from(e.headers), e.data = ri.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Yd.getAdapter(e.adapter || oo.adapter)(e).then(function(t) {
    return ii(e), t.data = ri.call(
      e,
      e.transformResponse,
      t
    ), t.headers = He.from(t.headers), t;
  }, function(t) {
    return Kd(t) || (ii(e), t && t.response && (t.response.data = ri.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = He.from(t.response.headers))), Promise.reject(t);
  });
}
const Xd = "1.11.0", Ar = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ar[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Xa = {};
Ar.transitional = function(e, t, n) {
  function o(r, i) {
    return "[Axios v" + Xd + "] Transitional option '" + r + "'" + i + (n ? ". " + n : "");
  }
  return (r, i, s) => {
    if (e === !1)
      throw new ne(
        o(i, " has been removed" + (t ? " in " + t : "")),
        ne.ERR_DEPRECATED
      );
    return t && !Xa[i] && (Xa[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(r, i, s) : !0;
  };
};
Ar.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function _w(e, t, n) {
  if (typeof e != "object")
    throw new ne("options must be an object", ne.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let r = o.length;
  for (; r-- > 0; ) {
    const i = o[r], s = t[i];
    if (s) {
      const a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new ne("option " + i + " must be " + l, ne.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new ne("Unknown option " + i, ne.ERR_BAD_OPTION);
  }
}
const Mo = {
  assertOptions: _w,
  validators: Ar
}, at = Mo.validators;
let Ft = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Ba(),
      response: new Ba()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const r = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? r && !String(n.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + r) : n.stack = r;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Bt(this.defaults, t);
    const { transitional: n, paramsSerializer: o, headers: r } = t;
    n !== void 0 && Mo.assertOptions(n, {
      silentJSONParsing: at.transitional(at.boolean),
      forcedJSONParsing: at.transitional(at.boolean),
      clarifyTimeoutError: at.transitional(at.boolean)
    }, !1), o != null && (E.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Mo.assertOptions(o, {
      encode: at.function,
      serialize: at.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Mo.assertOptions(t, {
      baseUrl: at.spelling("baseURL"),
      withXsrfToken: at.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = r && E.merge(
      r.common,
      r[t.method]
    );
    r && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete r[h];
      }
    ), t.headers = He.concat(i, r);
    const s = [];
    let a = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(t) === !1 || (a = a && h.synchronous, s.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let c, u = 0, d;
    if (!a) {
      const h = [Ya.bind(this), void 0];
      for (h.unshift(...s), h.push(...l), d = h.length, c = Promise.resolve(t); u < d; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    d = s.length;
    let f = t;
    for (u = 0; u < d; ) {
      const h = s[u++], b = s[u++];
      try {
        f = h(f);
      } catch (p) {
        b.call(this, p);
        break;
      }
    }
    try {
      c = Ya.call(this, f);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = Bt(this.defaults, e);
    const t = qd(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Ud(t, e.params, e.paramsSerializer);
  }
};
E.forEach(["delete", "get", "head", "options"], function(e) {
  Ft.prototype[e] = function(t, n) {
    return this.request(Bt(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, r, i) {
      return this.request(Bt(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: r
      }));
    };
  }
  Ft.prototype[e] = t(), Ft.prototype[e + "Form"] = t(!0);
});
let xw = class Qd {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(r) {
      n = r;
    });
    const o = this;
    this.promise.then((r) => {
      if (!o._listeners) return;
      let i = o._listeners.length;
      for (; i-- > 0; )
        o._listeners[i](r);
      o._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const s = new Promise((a) => {
        o.subscribe(a), i = a;
      }).then(r);
      return s.cancel = function() {
        o.unsubscribe(i);
      }, s;
    }, t(function(r, i, s) {
      o.reason || (o.reason = new En(r, i, s), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Qd(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function $w(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function kw(e) {
  return E.isObject(e) && e.isAxiosError === !0;
}
const Hi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Hi).forEach(([e, t]) => {
  Hi[t] = e;
});
function ep(e) {
  const t = new Ft(e), n = Rd(Ft.prototype.request, t);
  return E.extend(n, Ft.prototype, t, { allOwnKeys: !0 }), E.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return ep(Bt(e, o));
  }, n;
}
const Ce = ep(oo);
Ce.Axios = Ft;
Ce.CanceledError = En;
Ce.CancelToken = xw;
Ce.isCancel = Kd;
Ce.VERSION = Xd;
Ce.toFormData = Nr;
Ce.AxiosError = ne;
Ce.Cancel = Ce.CanceledError;
Ce.all = function(e) {
  return Promise.all(e);
};
Ce.spread = $w;
Ce.isAxiosError = kw;
Ce.mergeConfig = Bt;
Ce.AxiosHeaders = He;
Ce.formToJSON = (e) => Hd(E.isHTMLForm(e) ? new FormData(e) : e);
Ce.getAdapter = Yd.getAdapter;
Ce.HttpStatusCode = Hi;
Ce.default = Ce;
const {
  Axios: sL,
  AxiosError: Ew,
  CanceledError: aL,
  isCancel: cL,
  CancelToken: lL,
  VERSION: uL,
  all: dL,
  Cancel: pL,
  isAxiosError: fL,
  spread: hL,
  toFormData: mL,
  AxiosHeaders: gL,
  HttpStatusCode: vL,
  formToJSON: bL,
  getAdapter: yL,
  mergeConfig: wL
} = Ce, Sw = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
let Cw = class {
  baseUrl;
  headers;
  constructor(t, n = {}) {
    this.baseUrl = t, this.headers = n?.headers || {};
  }
  async fetch(t, n = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const r = Sw.test(t) ? t : `${this.baseUrl}${t}`;
    r.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Ce(r, {
        ...o,
        method: n,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (i) {
      throw i instanceof Ew ? new Ma(`${i.code} - ${i.status} - ${r}`, i.status, i.response?.data) : new Ma("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
}, tp;
function Ow(e, t = {}) {
  tp = new Cw(e, t);
}
const Nw = "ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT", Rw = "https://api.jawg.io", Aw = "dependency,neighbourhood,locality,borough,localadmin,county,macrocounty,region,macroregion,country,postalcode", bo = {
  "access-token": Nw,
  layers: Aw,
  sources: "wof",
  size: 10
};
async function Iw(e, t = "fr") {
  const n = `${Rw}/places/v1/autocomplete`;
  if (!n)
    throw new Error("JAWG_URL is not defined");
  return tp.get(
    `${n}?text=${e}&access-token=${bo["access-token"]}&layers=${bo.layers}&sources=${bo.sources}&size=${bo.size}`,
    {
      headers: {
        "Accept-Language": t
      }
    }
  );
}
function np(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = np(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function op() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = np(e)) && (o && (o += " "), o += t);
  return o;
}
const Pw = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Tw = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Lw = Pw.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Tw[e]
})), jw = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Dw = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function zw(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ m("span", { className: n }, n));
}
const rp = At(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...r }, i) => {
    const s = Lw.find((l) => l.name === e), a = op("icon", `ds-${s?.class}`, Dw[t], jw[n], o);
    return /* @__PURE__ */ m("i", { className: a, ...r, ref: i, children: zw(s?.paths) });
  }
);
rp.displayName = "Icon";
var _n = function() {
  return _n = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, _n.apply(this, arguments);
};
function Mw(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $t(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    n[o] = e[o];
  }
  return n;
}
function ie() {
  return ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ie.apply(null, arguments);
}
function Ki(e, t) {
  return Ki = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Ki(e, t);
}
function Fw(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ki(e, t);
}
var yo = { exports: {} }, si = { exports: {} }, de = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qa;
function Vw() {
  if (Qa) return de;
  Qa = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(x) {
    if (typeof x == "object" && x !== null) {
      var C = x.$$typeof;
      switch (C) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case o:
            case i:
            case r:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case u:
                case b:
                case h:
                case s:
                  return x;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function _(x) {
    return w(x) === c;
  }
  return de.AsyncMode = l, de.ConcurrentMode = c, de.ContextConsumer = a, de.ContextProvider = s, de.Element = t, de.ForwardRef = u, de.Fragment = o, de.Lazy = b, de.Memo = h, de.Portal = n, de.Profiler = i, de.StrictMode = r, de.Suspense = d, de.isAsyncMode = function(x) {
    return _(x) || w(x) === l;
  }, de.isConcurrentMode = _, de.isContextConsumer = function(x) {
    return w(x) === a;
  }, de.isContextProvider = function(x) {
    return w(x) === s;
  }, de.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, de.isForwardRef = function(x) {
    return w(x) === u;
  }, de.isFragment = function(x) {
    return w(x) === o;
  }, de.isLazy = function(x) {
    return w(x) === b;
  }, de.isMemo = function(x) {
    return w(x) === h;
  }, de.isPortal = function(x) {
    return w(x) === n;
  }, de.isProfiler = function(x) {
    return w(x) === i;
  }, de.isStrictMode = function(x) {
    return w(x) === r;
  }, de.isSuspense = function(x) {
    return w(x) === d;
  }, de.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === o || x === c || x === i || x === r || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === b || x.$$typeof === h || x.$$typeof === s || x.$$typeof === a || x.$$typeof === u || x.$$typeof === y || x.$$typeof === $ || x.$$typeof === v || x.$$typeof === p);
  }, de.typeOf = w, de;
}
var me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ec;
function Uw() {
  return ec || (ec = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === o || z === c || z === i || z === r || z === d || z === f || typeof z == "object" && z !== null && (z.$$typeof === b || z.$$typeof === h || z.$$typeof === s || z.$$typeof === a || z.$$typeof === u || z.$$typeof === y || z.$$typeof === $ || z.$$typeof === v || z.$$typeof === p);
    }
    function _(z) {
      if (typeof z == "object" && z !== null) {
        var Ie = z.$$typeof;
        switch (Ie) {
          case t:
            var U = z.type;
            switch (U) {
              case l:
              case c:
              case o:
              case i:
              case r:
              case d:
                return U;
              default:
                var ot = U && U.$$typeof;
                switch (ot) {
                  case a:
                  case u:
                  case b:
                  case h:
                  case s:
                    return ot;
                  default:
                    return Ie;
                }
            }
          case n:
            return Ie;
        }
      }
    }
    var x = l, C = c, k = a, R = s, N = t, j = u, H = o, re = b, q = h, F = n, ae = i, J = r, ce = d, we = !1;
    function Ae(z) {
      return we || (we = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(z) || _(z) === l;
    }
    function O(z) {
      return _(z) === c;
    }
    function T(z) {
      return _(z) === a;
    }
    function I(z) {
      return _(z) === s;
    }
    function M(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function D(z) {
      return _(z) === u;
    }
    function V(z) {
      return _(z) === o;
    }
    function B(z) {
      return _(z) === b;
    }
    function K(z) {
      return _(z) === h;
    }
    function W(z) {
      return _(z) === n;
    }
    function ee(z) {
      return _(z) === i;
    }
    function Z(z) {
      return _(z) === r;
    }
    function ue(z) {
      return _(z) === d;
    }
    me.AsyncMode = x, me.ConcurrentMode = C, me.ContextConsumer = k, me.ContextProvider = R, me.Element = N, me.ForwardRef = j, me.Fragment = H, me.Lazy = re, me.Memo = q, me.Portal = F, me.Profiler = ae, me.StrictMode = J, me.Suspense = ce, me.isAsyncMode = Ae, me.isConcurrentMode = O, me.isContextConsumer = T, me.isContextProvider = I, me.isElement = M, me.isForwardRef = D, me.isFragment = V, me.isLazy = B, me.isMemo = K, me.isPortal = W, me.isProfiler = ee, me.isStrictMode = Z, me.isSuspense = ue, me.isValidElementType = w, me.typeOf = _;
  }()), me;
}
var tc;
function ip() {
  return tc || (tc = 1, process.env.NODE_ENV === "production" ? si.exports = Vw() : si.exports = Uw()), si.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ai, nc;
function Bw() {
  if (nc) return ai;
  nc = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ai = r() ? Object.assign : function(i, s) {
    for (var a, l = o(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (l[d] = a[d]);
      if (e) {
        c = e(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, ai;
}
var ci, oc;
function zs() {
  if (oc) return ci;
  oc = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ci = e, ci;
}
var rc, ic;
function sp() {
  return ic || (ic = 1, rc = Function.call.bind(Object.prototype.hasOwnProperty)), rc;
}
var li, sc;
function Hw() {
  if (sc) return li;
  sc = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ zs(), n = {}, o = /* @__PURE__ */ sp();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function r(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (o(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, t);
          } catch (b) {
            d = b;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, li = r, li;
}
var ui, ac;
function Kw() {
  if (ac) return ui;
  ac = 1;
  var e = ip(), t = Bw(), n = /* @__PURE__ */ zs(), o = /* @__PURE__ */ sp(), r = /* @__PURE__ */ Hw(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ui = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(O) {
      var T = O && (c && O[c] || O[u]);
      if (typeof T == "function")
        return T;
    }
    var f = "<<anonymous>>", h = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: v(),
      arrayOf: w,
      element: _(),
      elementType: x(),
      instanceOf: C,
      node: j(),
      objectOf: R,
      oneOf: k,
      oneOfType: N,
      shape: re,
      exact: q
    };
    function b(O, T) {
      return O === T ? O !== 0 || 1 / O === 1 / T : O !== O && T !== T;
    }
    function p(O, T) {
      this.message = O, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function y(O) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, I = 0;
      function M(V, B, K, W, ee, Z, ue) {
        if (W = W || f, Z = Z || K, ue !== n) {
          if (l) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ie = W + ":" + K;
            !T[Ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            I < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Z + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[Ie] = !0, I++);
          }
        }
        return B[K] == null ? V ? B[K] === null ? new p("The " + ee + " `" + Z + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new p("The " + ee + " `" + Z + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : O(B, K, W, ee, Z);
      }
      var D = M.bind(null, !1);
      return D.isRequired = M.bind(null, !0), D;
    }
    function $(O) {
      function T(I, M, D, V, B, K) {
        var W = I[M], ee = J(W);
        if (ee !== O) {
          var Z = ce(W);
          return new p(
            "Invalid " + V + " `" + B + "` of type " + ("`" + Z + "` supplied to `" + D + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return y(T);
    }
    function v() {
      return y(s);
    }
    function w(O) {
      function T(I, M, D, V, B) {
        if (typeof O != "function")
          return new p("Property `" + B + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
        var K = I[M];
        if (!Array.isArray(K)) {
          var W = J(K);
          return new p("Invalid " + V + " `" + B + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected an array."));
        }
        for (var ee = 0; ee < K.length; ee++) {
          var Z = O(K, ee, D, V, B + "[" + ee + "]", n);
          if (Z instanceof Error)
            return Z;
        }
        return null;
      }
      return y(T);
    }
    function _() {
      function O(T, I, M, D, V) {
        var B = T[I];
        if (!a(B)) {
          var K = J(B);
          return new p("Invalid " + D + " `" + V + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(O);
    }
    function x() {
      function O(T, I, M, D, V) {
        var B = T[I];
        if (!e.isValidElementType(B)) {
          var K = J(B);
          return new p("Invalid " + D + " `" + V + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(O);
    }
    function C(O) {
      function T(I, M, D, V, B) {
        if (!(I[M] instanceof O)) {
          var K = O.name || f, W = Ae(I[M]);
          return new p("Invalid " + V + " `" + B + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return y(T);
    }
    function k(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function T(I, M, D, V, B) {
        for (var K = I[M], W = 0; W < O.length; W++)
          if (b(K, O[W]))
            return null;
        var ee = JSON.stringify(O, function(Z, ue) {
          var z = ce(ue);
          return z === "symbol" ? String(ue) : ue;
        });
        return new p("Invalid " + V + " `" + B + "` of value `" + String(K) + "` " + ("supplied to `" + D + "`, expected one of " + ee + "."));
      }
      return y(T);
    }
    function R(O) {
      function T(I, M, D, V, B) {
        if (typeof O != "function")
          return new p("Property `" + B + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
        var K = I[M], W = J(K);
        if (W !== "object")
          return new p("Invalid " + V + " `" + B + "` of type " + ("`" + W + "` supplied to `" + D + "`, expected an object."));
        for (var ee in K)
          if (o(K, ee)) {
            var Z = O(K, ee, D, V, B + "." + ee, n);
            if (Z instanceof Error)
              return Z;
          }
        return null;
      }
      return y(T);
    }
    function N(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var T = 0; T < O.length; T++) {
        var I = O[T];
        if (typeof I != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + we(I) + " at index " + T + "."
          ), s;
      }
      function M(D, V, B, K, W) {
        for (var ee = [], Z = 0; Z < O.length; Z++) {
          var ue = O[Z], z = ue(D, V, B, K, W, n);
          if (z == null)
            return null;
          z.data && o(z.data, "expectedType") && ee.push(z.data.expectedType);
        }
        var Ie = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new p("Invalid " + K + " `" + W + "` supplied to " + ("`" + B + "`" + Ie + "."));
      }
      return y(M);
    }
    function j() {
      function O(T, I, M, D, V) {
        return F(T[I]) ? null : new p("Invalid " + D + " `" + V + "` supplied to " + ("`" + M + "`, expected a ReactNode."));
      }
      return y(O);
    }
    function H(O, T, I, M, D) {
      return new p(
        (O || "React class") + ": " + T + " type `" + I + "." + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`."
      );
    }
    function re(O) {
      function T(I, M, D, V, B) {
        var K = I[M], W = J(K);
        if (W !== "object")
          return new p("Invalid " + V + " `" + B + "` of type `" + W + "` " + ("supplied to `" + D + "`, expected `object`."));
        for (var ee in O) {
          var Z = O[ee];
          if (typeof Z != "function")
            return H(D, V, B, ee, ce(Z));
          var ue = Z(K, ee, D, V, B + "." + ee, n);
          if (ue)
            return ue;
        }
        return null;
      }
      return y(T);
    }
    function q(O) {
      function T(I, M, D, V, B) {
        var K = I[M], W = J(K);
        if (W !== "object")
          return new p("Invalid " + V + " `" + B + "` of type `" + W + "` " + ("supplied to `" + D + "`, expected `object`."));
        var ee = t({}, I[M], O);
        for (var Z in ee) {
          var ue = O[Z];
          if (o(O, Z) && typeof ue != "function")
            return H(D, V, B, Z, ce(ue));
          if (!ue)
            return new p(
              "Invalid " + V + " `" + B + "` key `" + Z + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(I[M], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var z = ue(K, Z, D, V, B + "." + Z, n);
          if (z)
            return z;
        }
        return null;
      }
      return y(T);
    }
    function F(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(F);
          if (O === null || a(O))
            return !0;
          var T = d(O);
          if (T) {
            var I = T.call(O), M;
            if (T !== O.entries) {
              for (; !(M = I.next()).done; )
                if (!F(M.value))
                  return !1;
            } else
              for (; !(M = I.next()).done; ) {
                var D = M.value;
                if (D && !F(D[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(O, T) {
      return O === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function J(O) {
      var T = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : ae(T, O) ? "symbol" : T;
    }
    function ce(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var T = J(O);
      if (T === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function we(O) {
      var T = ce(O);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function Ae(O) {
      return !O.constructor || !O.constructor.name ? f : O.constructor.name;
    }
    return h.checkPropTypes = r, h.resetWarningCache = r.resetWarningCache, h.PropTypes = h, h;
  }, ui;
}
var di, cc;
function Ww() {
  if (cc) return di;
  cc = 1;
  var e = /* @__PURE__ */ zs();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, di = function() {
    function o(s, a, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    o.isRequired = o;
    function r() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, di;
}
var lc;
function qw() {
  if (lc) return yo.exports;
  if (lc = 1, process.env.NODE_ENV !== "production") {
    var e = ip(), t = !0;
    yo.exports = /* @__PURE__ */ Kw()(e.isElement, t);
  } else
    yo.exports = /* @__PURE__ */ Ww()();
  return yo.exports;
}
var Zw = /* @__PURE__ */ qw();
const L = /* @__PURE__ */ Mw(Zw);
var pi = { exports: {} }, pe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uc;
function Jw() {
  if (uc) return pe;
  uc = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function p(y) {
    if (typeof y == "object" && y !== null) {
      var $ = y.$$typeof;
      switch ($) {
        case e:
          switch (y = y.type, y) {
            case n:
            case r:
            case o:
            case c:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case s:
                case l:
                case f:
                case d:
                case i:
                  return y;
                default:
                  return $;
              }
          }
        case t:
          return $;
      }
    }
  }
  return pe.ContextConsumer = s, pe.ContextProvider = i, pe.Element = e, pe.ForwardRef = l, pe.Fragment = n, pe.Lazy = f, pe.Memo = d, pe.Portal = t, pe.Profiler = r, pe.StrictMode = o, pe.Suspense = c, pe.SuspenseList = u, pe.isAsyncMode = function() {
    return !1;
  }, pe.isConcurrentMode = function() {
    return !1;
  }, pe.isContextConsumer = function(y) {
    return p(y) === s;
  }, pe.isContextProvider = function(y) {
    return p(y) === i;
  }, pe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, pe.isForwardRef = function(y) {
    return p(y) === l;
  }, pe.isFragment = function(y) {
    return p(y) === n;
  }, pe.isLazy = function(y) {
    return p(y) === f;
  }, pe.isMemo = function(y) {
    return p(y) === d;
  }, pe.isPortal = function(y) {
    return p(y) === t;
  }, pe.isProfiler = function(y) {
    return p(y) === r;
  }, pe.isStrictMode = function(y) {
    return p(y) === o;
  }, pe.isSuspense = function(y) {
    return p(y) === c;
  }, pe.isSuspenseList = function(y) {
    return p(y) === u;
  }, pe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === r || y === o || y === c || y === u || y === h || typeof y == "object" && y !== null && (y.$$typeof === f || y.$$typeof === d || y.$$typeof === i || y.$$typeof === s || y.$$typeof === l || y.$$typeof === b || y.getModuleId !== void 0);
  }, pe.typeOf = p, pe;
}
var ge = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dc;
function Gw() {
  return dc || (dc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), b = !1, p = !1, y = !1, $ = !1, v = !1, w;
    w = Symbol.for("react.module.reference");
    function _(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === n || U === r || v || U === o || U === c || U === u || $ || U === h || b || p || y || typeof U == "object" && U !== null && (U.$$typeof === f || U.$$typeof === d || U.$$typeof === i || U.$$typeof === s || U.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === w || U.getModuleId !== void 0));
    }
    function x(U) {
      if (typeof U == "object" && U !== null) {
        var ot = U.$$typeof;
        switch (ot) {
          case e:
            var rt = U.type;
            switch (rt) {
              case n:
              case r:
              case o:
              case c:
              case u:
                return rt;
              default:
                var It = rt && rt.$$typeof;
                switch (It) {
                  case a:
                  case s:
                  case l:
                  case f:
                  case d:
                  case i:
                    return It;
                  default:
                    return ot;
                }
            }
          case t:
            return ot;
        }
      }
    }
    var C = s, k = i, R = e, N = l, j = n, H = f, re = d, q = t, F = r, ae = o, J = c, ce = u, we = !1, Ae = !1;
    function O(U) {
      return we || (we = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(U) {
      return Ae || (Ae = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(U) {
      return x(U) === s;
    }
    function M(U) {
      return x(U) === i;
    }
    function D(U) {
      return typeof U == "object" && U !== null && U.$$typeof === e;
    }
    function V(U) {
      return x(U) === l;
    }
    function B(U) {
      return x(U) === n;
    }
    function K(U) {
      return x(U) === f;
    }
    function W(U) {
      return x(U) === d;
    }
    function ee(U) {
      return x(U) === t;
    }
    function Z(U) {
      return x(U) === r;
    }
    function ue(U) {
      return x(U) === o;
    }
    function z(U) {
      return x(U) === c;
    }
    function Ie(U) {
      return x(U) === u;
    }
    ge.ContextConsumer = C, ge.ContextProvider = k, ge.Element = R, ge.ForwardRef = N, ge.Fragment = j, ge.Lazy = H, ge.Memo = re, ge.Portal = q, ge.Profiler = F, ge.StrictMode = ae, ge.Suspense = J, ge.SuspenseList = ce, ge.isAsyncMode = O, ge.isConcurrentMode = T, ge.isContextConsumer = I, ge.isContextProvider = M, ge.isElement = D, ge.isForwardRef = V, ge.isFragment = B, ge.isLazy = K, ge.isMemo = W, ge.isPortal = ee, ge.isProfiler = Z, ge.isStrictMode = ue, ge.isSuspense = z, ge.isSuspenseList = Ie, ge.isValidElementType = _, ge.typeOf = x;
  }()), ge;
}
var pc;
function Yw() {
  return pc || (pc = 1, process.env.NODE_ENV === "production" ? pi.exports = Jw() : pi.exports = Gw()), pi.exports;
}
var fc = Yw();
const hc = (e) => typeof e == "object" && e != null && e.nodeType === 1, mc = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", wo = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return mc(n.overflowY, t) || mc(n.overflowX, t) || ((o) => {
      const r = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView) return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!r && (r.clientHeight < o.scrollHeight || r.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, _o = (e, t, n, o, r, i, s, a) => i < e && s > t || i > e && s < t ? 0 : i <= e && a <= n || s >= t && a >= n ? i - e - o : s > t && a < n || i < e && a > n ? s - t + r : 0, Xw = (e) => e.parentElement ?? (e.getRootNode().host || null), Qw = (e, t) => {
  var n, o, r, i;
  if (typeof document > "u") return [];
  const { inline: s, boundary: a, skipOverflowHiddenElements: l } = t, c = typeof a == "function" ? a : (q) => q !== a;
  if (!hc(e)) throw new TypeError("Invalid target");
  const u = document.scrollingElement || document.documentElement, d = [];
  let f = e;
  for (; hc(f) && c(f); ) {
    if (f = Xw(f), f === u) {
      d.push(f);
      break;
    }
    f != null && f === document.body && wo(f) && !wo(document.documentElement) || f != null && wo(f, l) && d.push(f);
  }
  const h = (o = (n = window.visualViewport) == null ? void 0 : n.width) != null ? o : innerWidth, b = (i = (r = window.visualViewport) == null ? void 0 : r.height) != null ? i : innerHeight, { scrollX: p, scrollY: y } = window, { height: $, width: v, top: w, right: _, bottom: x, left: C } = e.getBoundingClientRect(), { top: k, right: R, left: N } = ((q) => {
    const F = window.getComputedStyle(q);
    return { top: parseFloat(F.scrollMarginTop) || 0, right: parseFloat(F.scrollMarginRight) || 0, bottom: parseFloat(F.scrollMarginBottom) || 0, left: parseFloat(F.scrollMarginLeft) || 0 };
  })(e);
  let j = w - k, H = s === "center" ? C + v / 2 - N + R : s === "end" ? _ + R : C - N;
  const re = [];
  for (let q = 0; q < d.length; q++) {
    const F = d[q], { height: ae, width: J, top: ce, right: we, bottom: Ae, left: O } = F.getBoundingClientRect();
    if (w >= 0 && C >= 0 && x <= b && _ <= h && (F === u && !wo(F) || w >= ce && x <= Ae && C >= O && _ <= we)) return re;
    const T = getComputedStyle(F), I = parseInt(T.borderLeftWidth, 10), M = parseInt(T.borderTopWidth, 10), D = parseInt(T.borderRightWidth, 10), V = parseInt(T.borderBottomWidth, 10);
    let B = 0, K = 0;
    const W = "offsetWidth" in F ? F.offsetWidth - F.clientWidth - I - D : 0, ee = "offsetHeight" in F ? F.offsetHeight - F.clientHeight - M - V : 0, Z = "offsetWidth" in F ? F.offsetWidth === 0 ? 0 : J / F.offsetWidth : 0, ue = "offsetHeight" in F ? F.offsetHeight === 0 ? 0 : ae / F.offsetHeight : 0;
    if (u === F) B = _o(y, y + b, b, M, V, y + j, y + j + $, $), K = s === "start" ? H : s === "center" ? H - h / 2 : s === "end" ? H - h : _o(p, p + h, h, I, D, p + H, p + H + v, v), B = Math.max(0, B + y), K = Math.max(0, K + p);
    else {
      B = _o(ce, Ae, ae, M, V + ee, j, j + $, $), K = s === "start" ? H - O - I : s === "center" ? H - (O + J / 2) + W / 2 : s === "end" ? H - we + D + W : _o(O, we, J, I, D + W, H, H + v, v);
      const { scrollLeft: z, scrollTop: Ie } = F;
      B = ue === 0 ? 0 : Math.max(0, Math.min(Ie + B / ue, F.scrollHeight - ae / ue + ee)), K = Z === 0 ? 0 : Math.max(0, Math.min(z + K / Z, F.scrollWidth - J / Z + W)), j += Ie - B, H += z - K;
    }
    re.push({ el: F, top: B, left: K });
  }
  return re;
};
var e_ = 0;
function gc(e) {
  return typeof e == "function" ? e : Ze;
}
function Ze() {
}
function ap(e, t) {
  if (e) {
    var n = Qw(e, {
      boundary: t
    });
    n.forEach(function(o) {
      var r = o.el, i = o.top, s = o.left;
      r.scrollTop = i, r.scrollLeft = s;
    });
  }
}
function vc(e, t, n) {
  var o = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return o;
}
function Ms(e, t) {
  var n;
  function o() {
    n && clearTimeout(n);
  }
  function r() {
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    o(), n = setTimeout(function() {
      n = null, e.apply(void 0, s);
    }, t);
  }
  return r.cancel = o, r;
}
function Pe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      i[s - 1] = arguments[s];
    return t.some(function(a) {
      return a && a.apply(void 0, [o].concat(i)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function mn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    t.forEach(function(r) {
      typeof r == "function" ? r(o) : r && (r.current = o);
    });
  };
}
function cp() {
  return String(e_++);
}
function t_(e) {
  var t = e.isOpen, n = e.resultCount, o = e.previousResultCount;
  return t ? n ? n !== o ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function bc(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function lp(e) {
  return typeof e.type == "string";
}
function up(e) {
  return e.props;
}
function n_(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var o_ = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function xo(e) {
  e === void 0 && (e = {});
  var t = {};
  return o_.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function rr(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(n, o) {
    return n[o] = ir(t, o) ? t[o] : e[o], n;
  }, {});
}
function ir(e, t) {
  return e[t] !== void 0;
}
function Wi(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function r_(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function jt(e, t, n, o, r) {
  var i = n.length;
  if (i === 0)
    return -1;
  var s = i - 1;
  (typeof e != "number" || e < 0 || e > s) && (e = t > 0 ? -1 : s + 1);
  var a = e + t;
  a < 0 ? a = s : a > s && (a = 0);
  var l = xn(a, t < 0, n, o, r);
  return l === -1 ? e >= i ? -1 : e : l;
}
function xn(e, t, n, o, r) {
  r === void 0 && (r = !1);
  var i = n.length;
  if (t) {
    for (var s = e; s >= 0; s--)
      if (!o(n[s], s))
        return s;
  } else
    for (var a = e; a < i; a++)
      if (!o(n[a], a))
        return a;
  return r ? xn(t ? i - 1 : 0, t, n, o) : -1;
}
function sr(e, t, n, o) {
  return o === void 0 && (o = !0), n && t.some(function(r) {
    return r && (vc(r, e, n) || o && vc(r, n.document.activeElement, n));
  });
}
var Fs = Ze;
process.env.NODE_ENV !== "production" && (Fs = function(e, t, n) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(r) {
    t[r] !== void 0 && n[r] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + r + '" to be uncontrolled. ' + o) : t[r] === void 0 && n[r] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + r + '" to be controlled. ' + o);
  });
});
var i_ = Ms(function(e) {
  dp(e).textContent = "";
}, 500);
function dp(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function pp(e, t) {
  if (!(!e || !t)) {
    var n = dp(t);
    n.textContent = e, i_(t);
  }
}
function s_(e) {
  var t = e?.getElementById("a11y-status-message");
  t && t.remove();
}
var fp = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, hp = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, mp = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Fo = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Vo = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, gp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, vp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, bp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, yp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, wp = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, _p = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, xp = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, $p = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, qi = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, kp = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Ep = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Sp = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, a_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: kp,
  blurInput: _p,
  changeInput: xp,
  clickButton: qi,
  clickItem: wp,
  controlledPropUpdatedSelectedItem: Ep,
  itemMouseEnter: mp,
  keyDownArrowDown: Vo,
  keyDownArrowUp: Fo,
  keyDownEnd: yp,
  keyDownEnter: vp,
  keyDownEscape: gp,
  keyDownHome: bp,
  keyDownSpaceButton: $p,
  mouseUp: hp,
  touchEnd: Sp,
  unknown: fp
}), c_ = ["refKey", "ref"], l_ = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], u_ = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], d_ = ["refKey", "ref"], p_ = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], f_ = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function n(r) {
      var i;
      i = t.call(this, r) || this, i.id = i.props.id || "downshift-" + cp(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(v) {
        return i.id + "-item-" + v;
      }, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(v, w) {
        var _ = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(x) {
            return x !== _;
          }), v();
        }, w);
        i.timeoutIds.push(_);
      }, i.setItemCount = function(v) {
        i.itemCount = v;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.isItemDisabled = function(v, w) {
        var _ = i.getItemNodeFromIndex(w);
        return _ && _.hasAttribute("disabled");
      }, i.setHighlightedIndex = function(v, w) {
        v === void 0 && (v = i.props.defaultHighlightedIndex), w === void 0 && (w = {}), w = xo(w), i.internalSetState(ie({
          highlightedIndex: v
        }, w));
      }, i.clearSelection = function(v) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, v);
      }, i.selectItem = function(v, w, _) {
        w = xo(w), i.internalSetState(ie({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: v,
          inputValue: i.props.itemToString(v)
        }, w), _);
      }, i.selectItemAtIndex = function(v, w, _) {
        var x = i.items[v];
        x != null && i.selectItem(x, w, _);
      }, i.selectHighlightedItem = function(v, w) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, v, w);
      }, i.internalSetState = function(v, w) {
        var _, x, C = {}, k = typeof v == "function";
        return !k && v.hasOwnProperty("inputValue") && i.props.onInputValueChange(v.inputValue, ie({}, i.getStateAndHelpers(), v)), i.setState(function(R) {
          var N;
          R = i.getState(R);
          var j = k ? v(R) : v;
          j = i.props.stateReducer(R, j), _ = j.hasOwnProperty("selectedItem");
          var H = {};
          return _ && j.selectedItem !== R.selectedItem && (x = j.selectedItem), (N = j).type || (N.type = fp), Object.keys(j).forEach(function(re) {
            R[re] !== j[re] && (C[re] = j[re]), re !== "type" && (j[re], ir(i.props, re) || (H[re] = j[re]));
          }), k && j.hasOwnProperty("inputValue") && i.props.onInputValueChange(j.inputValue, ie({}, i.getStateAndHelpers(), j)), H;
        }, function() {
          gc(w)();
          var R = Object.keys(C).length > 1;
          R && i.props.onStateChange(C, i.getStateAndHelpers()), _ && i.props.onSelect(v.selectedItem, i.getStateAndHelpers()), x !== void 0 && i.props.onChange(x, i.getStateAndHelpers()), i.props.onUserAction(C, i.getStateAndHelpers());
        });
      }, i.rootRef = function(v) {
        return i._rootNode = v;
      }, i.getRootProps = function(v, w) {
        var _, x = v === void 0 ? {} : v, C = x.refKey, k = C === void 0 ? "ref" : C, R = x.ref, N = $t(x, c_), j = w === void 0 ? {} : w, H = j.suppressRefError, re = H === void 0 ? !1 : H;
        i.getRootProps.called = !0, i.getRootProps.refKey = k, i.getRootProps.suppressRefError = re;
        var q = i.getState(), F = q.isOpen;
        return ie((_ = {}, _[k] = mn(R, i.rootRef), _.role = "combobox", _["aria-expanded"] = F, _["aria-haspopup"] = "listbox", _["aria-owns"] = F ? i.menuId : void 0, _["aria-labelledby"] = i.labelId, _), N);
      }, i.keyDownHandlers = {
        ArrowDown: function(v) {
          var w = this;
          if (v.preventDefault(), this.getState().isOpen) {
            var _ = v.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(_, {
              type: Vo
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Vo
            }, function() {
              var x = w.getItemCount();
              if (x > 0) {
                var C = w.getState(), k = C.highlightedIndex, R = jt(k, 1, {
                  length: x
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(R, {
                  type: Vo
                });
              }
            });
        },
        ArrowUp: function(v) {
          var w = this;
          if (v.preventDefault(), this.getState().isOpen) {
            var _ = v.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(_, {
              type: Fo
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Fo
            }, function() {
              var x = w.getItemCount();
              if (x > 0) {
                var C = w.getState(), k = C.highlightedIndex, R = jt(k, -1, {
                  length: x
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(R, {
                  type: Fo
                });
              }
            });
        },
        Enter: function(v) {
          if (v.which !== 229) {
            var w = this.getState(), _ = w.isOpen, x = w.highlightedIndex;
            if (_ && x != null) {
              v.preventDefault();
              var C = this.items[x], k = this.getItemNodeFromIndex(x);
              if (C == null || k && k.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: vp
              });
            }
          }
        },
        Escape: function(v) {
          v.preventDefault(), this.reset(ie({
            type: gp
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = ie({}, i.keyDownHandlers, {
        " ": function(v) {
          v.preventDefault(), this.toggleMenu({
            type: $p
          });
        }
      }), i.inputKeyDownHandlers = ie({}, i.keyDownHandlers, {
        Home: function(v) {
          var w = this.getState(), _ = w.isOpen;
          if (_) {
            v.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !_)) {
              var C = xn(0, !1, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(C, {
                type: bp
              });
            }
          }
        },
        End: function(v) {
          var w = this.getState(), _ = w.isOpen;
          if (_) {
            v.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !_)) {
              var C = xn(x - 1, !0, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(C, {
                type: yp
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(v) {
        var w = v === void 0 ? {} : v, _ = w.onClick;
        w.onPress;
        var x = w.onKeyDown, C = w.onKeyUp, k = w.onBlur, R = $t(w, l_), N = i.getState(), j = N.isOpen, H = {
          onClick: Pe(_, i.buttonHandleClick),
          onKeyDown: Pe(x, i.buttonHandleKeyDown),
          onKeyUp: Pe(C, i.buttonHandleKeyUp),
          onBlur: Pe(k, i.buttonHandleBlur)
        }, re = R.disabled ? {} : H;
        return ie({
          type: "button",
          role: "button",
          "aria-label": j ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, re, R);
      }, i.buttonHandleKeyUp = function(v) {
        v.preventDefault();
      }, i.buttonHandleKeyDown = function(v) {
        var w = Wi(v);
        i.buttonKeyDownHandlers[w] && i.buttonKeyDownHandlers[w].call(i, v);
      }, i.buttonHandleClick = function(v) {
        if (v.preventDefault(), i.props.environment) {
          var w = i.props.environment.document, _ = w.body, x = w.activeElement;
          _ && _ === x && v.target.focus();
        }
        process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: qi
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: qi
          });
        });
      }, i.buttonHandleBlur = function(v) {
        var w = v.target;
        i.internalSetTimeout(function() {
          if (!(i.isMouseDown || !i.props.environment)) {
            var _ = i.props.environment.document.activeElement;
            (_ == null || _.id !== i.inputId) && _ !== w && i.reset({
              type: kp
            });
          }
        });
      }, i.getLabelProps = function(v) {
        return ie({
          htmlFor: i.inputId,
          id: i.labelId
        }, v);
      }, i.getInputProps = function(v) {
        var w = v === void 0 ? {} : v, _ = w.onKeyDown, x = w.onBlur, C = w.onChange, k = w.onInput;
        w.onChangeText;
        var R = $t(w, u_), N, j = {};
        N = "onChange";
        var H = i.getState(), re = H.inputValue, q = H.isOpen, F = H.highlightedIndex;
        if (!R.disabled) {
          var ae;
          j = (ae = {}, ae[N] = Pe(C, k, i.inputHandleChange), ae.onKeyDown = Pe(_, i.inputHandleKeyDown), ae.onBlur = Pe(x, i.inputHandleBlur), ae);
        }
        return ie({
          "aria-autocomplete": "list",
          "aria-activedescendant": q && typeof F == "number" && F >= 0 ? i.getItemId(F) : void 0,
          "aria-controls": q ? i.menuId : void 0,
          "aria-labelledby": R && R["aria-label"] ? void 0 : i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: re,
          id: i.inputId
        }, j, R);
      }, i.inputHandleKeyDown = function(v) {
        var w = Wi(v);
        w && i.inputKeyDownHandlers[w] && i.inputKeyDownHandlers[w].call(i, v);
      }, i.inputHandleChange = function(v) {
        i.internalSetState({
          type: xp,
          isOpen: !0,
          inputValue: v.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var v;
          if (!(i.isMouseDown || !i.props.environment)) {
            var w = i.props.environment.document.activeElement, _ = (w == null || (v = w.dataset) == null ? void 0 : v.toggle) && i._rootNode && i._rootNode.contains(w);
            _ || i.reset({
              type: _p
            });
          }
        });
      }, i.menuRef = function(v) {
        i._menuNode = v;
      }, i.getMenuProps = function(v, w) {
        var _, x = v === void 0 ? {} : v, C = x.refKey, k = C === void 0 ? "ref" : C, R = x.ref, N = $t(x, d_), j = w === void 0 ? {} : w, H = j.suppressRefError, re = H === void 0 ? !1 : H;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = k, i.getMenuProps.suppressRefError = re, ie((_ = {}, _[k] = mn(R, i.menuRef), _.role = "listbox", _["aria-labelledby"] = N && N["aria-label"] ? void 0 : i.labelId, _.id = i.menuId, _), N);
      }, i.getItemProps = function(v) {
        var w, _ = v === void 0 ? {} : v, x = _.onMouseMove, C = _.onMouseDown, k = _.onClick;
        _.onPress;
        var R = _.index, N = _.item, j = N === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : n_("getItemProps", "item") : N, H = $t(_, p_);
        R === void 0 ? (i.items.push(j), R = i.items.indexOf(j)) : i.items[R] = j;
        var re = "onClick", q = k, F = (w = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Pe(x, function() {
            R !== i.getState().highlightedIndex && (i.setHighlightedIndex(R, {
              type: mp
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Pe(C, function(J) {
            J.preventDefault();
          })
        }, w[re] = Pe(q, function() {
          i.selectItemAtIndex(R, {
            type: wp
          });
        }), w), ae = H.disabled ? {
          onMouseDown: F.onMouseDown
        } : F;
        return ie({
          id: i.getItemId(R),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === R
        }, ae, H);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(v, w) {
        v === void 0 && (v = {}), v = xo(v), i.internalSetState(function(_) {
          var x = _.selectedItem;
          return ie({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(x)
          }, v);
        }, w);
      }, i.toggleMenu = function(v, w) {
        v === void 0 && (v = {}), v = xo(v), i.internalSetState(function(_) {
          var x = _.isOpen;
          return ie({
            isOpen: !x
          }, x && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, v);
        }, function() {
          var _ = i.getState(), x = _.isOpen, C = _.highlightedIndex;
          x && i.getItemCount() > 0 && typeof C == "number" && i.setHighlightedIndex(C, v), gc(w)();
        });
      }, i.openMenu = function(v) {
        i.internalSetState({
          isOpen: !0
        }, v);
      }, i.closeMenu = function(v) {
        i.internalSetState({
          isOpen: !1
        }, v);
      }, i.updateStatus = Ms(function() {
        var v;
        if ((v = i.props) != null && (v = v.environment) != null && v.document) {
          var w = i.getState(), _ = i.items[w.highlightedIndex], x = i.getItemCount(), C = i.props.getA11yStatusMessage(ie({
            itemToString: i.props.itemToString,
            previousResultCount: i.previousResultCount,
            resultCount: x,
            highlightedItem: _
          }, w));
          i.previousResultCount = x, pp(C, i.props.environment.document);
        }
      }, 200);
      var s = i.props, a = s.defaultHighlightedIndex, l = s.initialHighlightedIndex, c = l === void 0 ? a : l, u = s.defaultIsOpen, d = s.initialIsOpen, f = d === void 0 ? u : d, h = s.initialInputValue, b = h === void 0 ? "" : h, p = s.initialSelectedItem, y = p === void 0 ? null : p, $ = i.getState({
        highlightedIndex: c,
        isOpen: f,
        inputValue: b,
        selectedItem: y
      });
      return $.selectedItem != null && i.props.initialInputValue === void 0 && ($.inputValue = i.props.itemToString($.selectedItem)), i.state = $, i;
    }
    Fw(n, t);
    var o = n.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(r) {
        clearTimeout(r);
      }), this.timeoutIds = [];
    }, o.getState = function(r) {
      return r === void 0 && (r = this.state), rr(r, this.props);
    }, o.getItemCount = function() {
      var r = this.items.length;
      return this.itemCount != null ? r = this.itemCount : this.props.itemCount !== void 0 && (r = this.props.itemCount), r;
    }, o.getItemNodeFromIndex = function(r) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(r)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var r = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(r, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(r, i) {
      var s = this.getItemCount(), a = this.getState(), l = a.highlightedIndex;
      if (s > 0) {
        var c = jt(l, r, {
          length: s
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, i);
      }
    }, o.getStateAndHelpers = function() {
      var r = this.getState(), i = r.highlightedIndex, s = r.inputValue, a = r.selectedItem, l = r.isOpen, c = this.props.itemToString, u = this.id, d = this.getRootProps, f = this.getToggleButtonProps, h = this.getLabelProps, b = this.getMenuProps, p = this.getInputProps, y = this.getItemProps, $ = this.openMenu, v = this.closeMenu, w = this.toggleMenu, _ = this.selectItem, x = this.selectItemAtIndex, C = this.selectHighlightedItem, k = this.setHighlightedIndex, R = this.clearSelection, N = this.clearItems, j = this.reset, H = this.setItemCount, re = this.unsetItemCount, q = this.internalSetState;
      return {
        // prop getters
        getRootProps: d,
        getToggleButtonProps: f,
        getLabelProps: h,
        getMenuProps: b,
        getInputProps: p,
        getItemProps: y,
        // actions
        reset: j,
        openMenu: $,
        closeMenu: v,
        toggleMenu: w,
        selectItem: _,
        selectItemAtIndex: x,
        selectHighlightedItem: C,
        setHighlightedIndex: k,
        clearSelection: R,
        clearItems: N,
        setItemCount: H,
        unsetItemCount: re,
        setState: q,
        // props
        itemToString: c,
        // derived
        id: u,
        // state
        highlightedIndex: i,
        inputValue: s,
        isOpen: l,
        selectedItem: a
      };
    }, o.componentDidMount = function() {
      var r = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && yc(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          r.internalClearTimeouts();
        };
      else {
        var i = function() {
          r.isMouseDown = !0;
        }, s = function(d) {
          r.isMouseDown = !1;
          var f = sr(d.target, [r._rootNode, r._menuNode], r.props.environment);
          !f && r.getState().isOpen && r.reset({
            type: hp
          }, function() {
            return r.props.onOuterClick(r.getStateAndHelpers());
          });
        }, a = function() {
          r.isTouchMove = !1;
        }, l = function() {
          r.isTouchMove = !0;
        }, c = function(d) {
          var f = sr(d.target, [r._rootNode, r._menuNode], r.props.environment, !1);
          !r.isTouchMove && !f && r.getState().isOpen && r.reset({
            type: Sp
          }, function() {
            return r.props.onOuterClick(r.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", i), u.addEventListener("mouseup", s), u.addEventListener("touchstart", a), u.addEventListener("touchmove", l), u.addEventListener("touchend", c), this.cleanup = function() {
          r.internalClearTimeouts(), r.updateStatus.cancel(), u.removeEventListener("mousedown", i), u.removeEventListener("mouseup", s), u.removeEventListener("touchstart", a), u.removeEventListener("touchmove", l), u.removeEventListener("touchend", c);
        };
      }
    }, o.shouldScroll = function(r, i) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, a = s.highlightedIndex, l = i.highlightedIndex === void 0 ? r : i, c = l.highlightedIndex, u = a && this.getState().isOpen && !r.isOpen, d = a !== c;
      return u || d;
    }, o.componentDidUpdate = function(r, i) {
      process.env.NODE_ENV !== "production" && (Fs(this.state, r, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && yc(this._menuNode, this.getMenuProps)), ir(this.props, "selectedItem") && this.props.selectedItemChanged(r.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Ep,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(i, r) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var r = bc(this.props.children, Ze);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = bc(r(this.getStateAndHelpers()));
      if (!i)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && h_(i, this.getRootProps), i;
      if (lp(i))
        return /* @__PURE__ */ Jl(i, this.getRootProps(up(i)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(kh);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: t_,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && r_(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: Ze,
    onInputValueChange: Ze,
    onUserAction: Ze,
    onChange: Ze,
    onSelect: Ze,
    onOuterClick: Ze,
    selectedItemChanged: function(t, n) {
      return t !== n;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, n) {
      return n;
    },
    suppressRefError: !1,
    scrollIntoView: ap
  }, e.stateChangeTypes = a_, e;
}();
process.env.NODE_ENV !== "production" && (f_.propTypes = {
  children: L.func,
  defaultHighlightedIndex: L.number,
  defaultIsOpen: L.bool,
  initialHighlightedIndex: L.number,
  initialSelectedItem: L.any,
  initialInputValue: L.string,
  initialIsOpen: L.bool,
  getA11yStatusMessage: L.func,
  itemToString: L.func,
  onChange: L.func,
  onSelect: L.func,
  onStateChange: L.func,
  onInputValueChange: L.func,
  onUserAction: L.func,
  onOuterClick: L.func,
  selectedItemChanged: L.func,
  stateReducer: L.func,
  itemCount: L.number,
  id: L.string,
  environment: L.shape({
    addEventListener: L.func.isRequired,
    removeEventListener: L.func.isRequired,
    document: L.shape({
      createElement: L.func.isRequired,
      getElementById: L.func.isRequired,
      activeElement: L.any.isRequired,
      body: L.any.isRequired
    }).isRequired,
    Node: L.func.isRequired
  }),
  suppressRefError: L.bool,
  scrollIntoView: L.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: L.any,
  isOpen: L.bool,
  inputValue: L.string,
  highlightedIndex: L.number,
  labelId: L.string,
  inputId: L.string,
  menuId: L.string,
  getItemId: L.func
  /* eslint-enable react/no-unused-prop-types */
});
function yc(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function h_(e, t) {
  var n = t.refKey, o = n !== "ref", r = !lp(e);
  r && !o && !fc.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !r && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !fc.isForwardRef(e) && !up(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var Cp = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function m_(e, t, n) {
  var o = e.props, r = e.type, i = {};
  Object.keys(t).forEach(function(s) {
    g_(s, e, t, n), n[s] !== t[s] && (i[s] = n[s]);
  }), o.onStateChange && Object.keys(i).length && o.onStateChange(ie({
    type: r
  }, i));
}
function g_(e, t, n, o) {
  var r = t.props, i = t.type, s = "on" + Vs(e) + "Change";
  r[s] && o[e] !== void 0 && o[e] !== n[e] && r[s](ie({
    type: i
  }, o));
}
function v_(e, t) {
  return t.changes;
}
var wc = Ms(function(e, t) {
  pp(e, t);
}, 200), b_ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? xh : xe, y_ = "useId" in Te ? function(e) {
  var t = e.id, n = e.labelId, o = e.menuId, r = e.getItemId, i = e.toggleButtonId, s = e.inputId, a = "downshift-" + Te.useId();
  t || (t = a);
  var l = Ee({
    labelId: n || t + "-label",
    menuId: o || t + "-menu",
    getItemId: r || function(c) {
      return t + "-item-" + c;
    },
    toggleButtonId: i || t + "-toggle-button",
    inputId: s || t + "-input"
  });
  return l.current;
} : function(e) {
  var t = e.id, n = t === void 0 ? "downshift-" + cp() : t, o = e.labelId, r = e.menuId, i = e.getItemId, s = e.toggleButtonId, a = e.inputId, l = Ee({
    labelId: o || n + "-label",
    menuId: r || n + "-menu",
    getItemId: i || function(c) {
      return n + "-item-" + c;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return l.current;
};
function w_(e, t, n, o) {
  var r, i;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    r = n[t], i = t;
  } else
    i = t === void 0 ? n.indexOf(e) : t, r = e;
  return [r, i];
}
function Vs(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Op(e) {
  var t = Ee(e);
  return t.current = e, t;
}
function __(e, t, n, o) {
  var r = Ee(), i = Ee(), s = ke(function(h, b) {
    i.current = b, h = rr(h, b.props);
    var p = e(h, b), y = b.props.stateReducer(h, ie({}, b, {
      changes: p
    }));
    return y;
  }, [e]), a = $h(s, t, n), l = a[0], c = a[1], u = Op(t), d = ke(function(h) {
    return c(ie({
      props: u.current
    }, h));
  }, [u]), f = i.current;
  return xe(function() {
    var h = rr(r.current, f?.props), b = f && r.current && !o(h, l);
    b && m_(f, h, l), r.current = l;
  }, [l, f, o]), [l, d];
}
var Dn = {
  itemToString: function(e) {
    return e ? String(e) : "";
  },
  itemToKey: function(e) {
    return e;
  },
  stateReducer: v_,
  scrollIntoView: ap,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Nt(e, t, n) {
  n === void 0 && (n = Cp);
  var o = e["default" + Vs(t)];
  return o !== void 0 ? o : n[t];
}
function zn(e, t, n) {
  n === void 0 && (n = Cp);
  var o = e[t];
  if (o !== void 0)
    return o;
  var r = e["initial" + Vs(t)];
  return r !== void 0 ? r : Nt(e, t, n);
}
function x_(e) {
  var t = zn(e, "selectedItem"), n = zn(e, "isOpen"), o = C_(e), r = zn(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && n ? e.items.findIndex(function(i) {
      return e.itemToKey(i) === e.itemToKey(t);
    }) : o,
    isOpen: n,
    selectedItem: t,
    inputValue: r
  };
}
function Mn(e, t, n) {
  var o = e.items, r = e.initialHighlightedIndex, i = e.defaultHighlightedIndex, s = e.isItemDisabled, a = e.itemToKey, l = t.selectedItem, c = t.highlightedIndex;
  return o.length === 0 ? -1 : r !== void 0 && c === r && !s(o[r], r) ? r : i !== void 0 && !s(o[i], i) ? i : l ? o.findIndex(function(u) {
    return a(l) === a(u);
  }) : n < 0 && !s(o[o.length - 1], o.length - 1) ? o.length - 1 : n > 0 && !s(o[0], 0) ? 0 : -1;
}
function $_(e, t, n) {
  var o = Ee({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return xe(function() {
    if (!e)
      return Ze;
    var r = n.map(function(u) {
      return u.current;
    });
    function i() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function s(u) {
      o.current.isMouseDown = !1, sr(u.target, r, e) || t();
    }
    function a() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function l() {
      o.current.isTouchMove = !0;
    }
    function c(u) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !sr(u.target, r, e, !1) && t();
    }
    return e.addEventListener("mousedown", i), e.addEventListener("mouseup", s), e.addEventListener("touchstart", a), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function() {
      e.removeEventListener("mousedown", i), e.removeEventListener("mouseup", s), e.removeEventListener("touchstart", a), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [n, e, t]), o.current;
}
var Np = function() {
  return Ze;
};
process.env.NODE_ENV !== "production" && (Np = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var o = Ee(t.reduce(function(i, s) {
    return i[s] = {}, i;
  }, {}));
  xe(function() {
    Object.keys(o.current).forEach(function(i) {
      var s = o.current[i];
      if (!Object.keys(s).length) {
        console.error("downshift: You forgot to call the " + i + " getter function on your component / element.");
        return;
      }
      var a = s.suppressRefError, l = s.refKey, c = s.elementRef;
      a || c != null && c.current || console.error('downshift: The ref prop "' + l + '" from ' + i + " was not applied correctly on your element.");
    });
  }, []);
  var r = ke(function(i, s, a, l) {
    o.current[i] = {
      suppressRefError: s,
      refKey: a,
      elementRef: l
    };
  }, []);
  return r;
});
function k_(e, t, n, o) {
  o === void 0 && (o = {});
  var r = o.document, i = Ir();
  xe(function() {
    if (!(!e || i || !r)) {
      var s = e(t);
      wc(s, r);
    }
  }, n), xe(function() {
    return function() {
      wc.cancel(), s_(r);
    };
  }, [r]);
}
function E_(e) {
  var t = e.highlightedIndex, n = e.isOpen, o = e.itemRefs, r = e.getItemNodeFromIndex, i = e.menuElement, s = e.scrollIntoView, a = Ee(!0);
  return b_(function() {
    t < 0 || !n || !Object.keys(o.current).length || (a.current === !1 ? a.current = !0 : s(r(t), i));
  }, [t]), a;
}
var Rp = Ze;
process.env.NODE_ENV !== "production" && (Rp = function(e) {
  var t = e.props, n = e.state, o = Ee(t), r = Ir();
  xe(function() {
    r || (Fs(n, o.current, t), o.current = t);
  }, [n, t, r]);
});
function _c(e, t, n) {
  var o;
  n === void 0 && (n = !0);
  var r = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return ie({
    isOpen: !1,
    highlightedIndex: -1
  }, r && ie({
    selectedItem: e.items[t],
    isOpen: Nt(e, "isOpen"),
    highlightedIndex: Nt(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function S_(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function Ir() {
  var e = Te.useRef(!0);
  return Te.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function Zi(e) {
  var t = Nt(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function C_(e) {
  var t = zn(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var Uo = {
  environment: L.shape({
    addEventListener: L.func.isRequired,
    removeEventListener: L.func.isRequired,
    document: L.shape({
      createElement: L.func.isRequired,
      getElementById: L.func.isRequired,
      activeElement: L.any.isRequired,
      body: L.any.isRequired
    }).isRequired,
    Node: L.func.isRequired
  }),
  itemToString: L.func,
  itemToKey: L.func,
  stateReducer: L.func
}, Ap = ie({}, Uo, {
  getA11yStatusMessage: L.func,
  highlightedIndex: L.number,
  defaultHighlightedIndex: L.number,
  initialHighlightedIndex: L.number,
  isOpen: L.bool,
  defaultIsOpen: L.bool,
  initialIsOpen: L.bool,
  selectedItem: L.any,
  initialSelectedItem: L.any,
  defaultSelectedItem: L.any,
  id: L.string,
  labelId: L.string,
  menuId: L.string,
  getItemId: L.func,
  toggleButtonId: L.string,
  onSelectedItemChange: L.func,
  onHighlightedIndexChange: L.func,
  onStateChange: L.func,
  onIsOpenChange: L.func,
  scrollIntoView: L.func
});
function O_(e, t, n) {
  var o = t.type, r = t.props, i;
  switch (o) {
    case n.ItemMouseMove:
      i = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      i = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Mn(r, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      i = {
        isOpen: !0,
        highlightedIndex: Mn(r, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      i = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      i = {
        highlightedIndex: r.isItemDisabled(r.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      i = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      i = {
        highlightedIndex: Zi(r),
        isOpen: Nt(r, "isOpen"),
        selectedItem: Nt(r, "selectedItem"),
        inputValue: Nt(r, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ie({}, e, i);
}
_n(_n({}, Ap), { items: L.array.isRequired, isItemDisabled: L.func });
_n(_n({}, Dn), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Us = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Bs = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Hs = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Ks = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Ws = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, qs = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Zs = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Js = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Gs = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, ar = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Ys = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Ip = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Pp = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Xs = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Tp = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Lp = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, jp = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Dp = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, zp = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Qs = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Mp = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Fp = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ea = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Vp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: ea,
  FunctionCloseMenu: Dp,
  FunctionOpenMenu: jp,
  FunctionReset: Fp,
  FunctionSelectItem: Qs,
  FunctionSetHighlightedIndex: zp,
  FunctionSetInputValue: Mp,
  FunctionToggleMenu: Lp,
  InputBlur: ar,
  InputChange: Gs,
  InputClick: Ys,
  InputKeyDownArrowDown: Us,
  InputKeyDownArrowUp: Bs,
  InputKeyDownEnd: Ws,
  InputKeyDownEnter: Js,
  InputKeyDownEscape: Hs,
  InputKeyDownHome: Ks,
  InputKeyDownPageDown: Zs,
  InputKeyDownPageUp: qs,
  ItemClick: Xs,
  ItemMouseMove: Pp,
  MenuMouseLeave: Ip,
  ToggleButtonClick: Tp
});
function N_(e) {
  var t = x_(e), n = t.selectedItem, o = t.inputValue;
  return o === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(n)), ie({}, t, {
    inputValue: o
  });
}
var R_ = ie({}, Ap, {
  items: L.array.isRequired,
  isItemDisabled: L.func,
  inputValue: L.string,
  defaultInputValue: L.string,
  initialInputValue: L.string,
  inputId: L.string,
  onInputValueChange: L.func
});
function A_(e, t, n, o) {
  var r = Ee(), i = __(e, t, n, o), s = i[0], a = i[1], l = Ir();
  return xe(function() {
    if (ir(t, "selectedItem")) {
      if (!l) {
        var c = t.itemToKey(t.selectedItem) !== t.itemToKey(r.current);
        c && a({
          type: ea,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      r.current = s.selectedItem === r.current ? t.selectedItem : s.selectedItem;
    }
  }, [s.selectedItem, t.selectedItem]), [rr(s, t), a];
}
var Up = Ze;
process.env.NODE_ENV !== "production" && (Up = function(e, t) {
  L.checkPropTypes(R_, e, "prop", t.name);
});
var I_ = ie({}, Dn, {
  isItemDisabled: function() {
    return !1;
  }
});
function P_(e, t) {
  var n, o = t.type, r = t.props, i = t.altKey, s;
  switch (o) {
    case Xs:
      s = {
        isOpen: Nt(r, "isOpen"),
        highlightedIndex: Zi(r),
        selectedItem: r.items[t.index],
        inputValue: r.itemToString(r.items[t.index])
      };
      break;
    case Us:
      e.isOpen ? s = {
        highlightedIndex: jt(e.highlightedIndex, 1, r.items, r.isItemDisabled, !0)
      } : s = {
        highlightedIndex: i && e.selectedItem == null ? -1 : Mn(r, e, 1),
        isOpen: r.items.length >= 0
      };
      break;
    case Bs:
      e.isOpen ? i ? s = _c(r, e.highlightedIndex) : s = {
        highlightedIndex: jt(e.highlightedIndex, -1, r.items, r.isItemDisabled, !0)
      } : s = {
        highlightedIndex: Mn(r, e, -1),
        isOpen: r.items.length >= 0
      };
      break;
    case Js:
      s = _c(r, e.highlightedIndex);
      break;
    case Hs:
      s = ie({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case qs:
      s = {
        highlightedIndex: jt(e.highlightedIndex, -10, r.items, r.isItemDisabled, !0)
      };
      break;
    case Zs:
      s = {
        highlightedIndex: jt(e.highlightedIndex, 10, r.items, r.isItemDisabled, !0)
      };
      break;
    case Ks:
      s = {
        highlightedIndex: xn(0, !1, r.items, r.isItemDisabled)
      };
      break;
    case Ws:
      s = {
        highlightedIndex: xn(r.items.length - 1, !0, r.items, r.isItemDisabled)
      };
      break;
    case ar:
      s = ie({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = r.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: r.items[e.highlightedIndex],
        inputValue: r.itemToString(r.items[e.highlightedIndex])
      });
      break;
    case Gs:
      s = {
        isOpen: !0,
        highlightedIndex: Zi(r),
        inputValue: t.inputValue
      };
      break;
    case Ys:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Mn(r, e, 0)
      };
      break;
    case Qs:
      s = {
        selectedItem: t.selectedItem,
        inputValue: r.itemToString(t.selectedItem)
      };
      break;
    case ea:
      s = {
        inputValue: t.inputValue
      };
      break;
    default:
      return O_(e, t, Vp);
  }
  return ie({}, e, s);
}
var T_ = ["onMouseLeave", "refKey", "ref"], L_ = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], j_ = ["onClick", "onPress", "refKey", "ref"], D_ = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
ta.stateChangeTypes = Vp;
function ta(e) {
  e === void 0 && (e = {}), Up(e, ta);
  var t = ie({}, I_, e), n = t.items, o = t.scrollIntoView, r = t.environment, i = t.getA11yStatusMessage, s = A_(P_, t, N_, S_), a = s[0], l = s[1], c = a.isOpen, u = a.highlightedIndex, d = a.selectedItem, f = a.inputValue, h = Ee(null), b = Ee({}), p = Ee(null), y = Ee(null), $ = Ir(), v = y_(t), w = Ee(), _ = Op({
    state: a,
    props: t
  }), x = ke(function(I) {
    return b.current[v.getItemId(I)];
  }, [v]);
  k_(i, a, [c, u, d, f], r);
  var C = E_({
    menuElement: h.current,
    highlightedIndex: u,
    isOpen: c,
    itemRefs: b,
    scrollIntoView: o,
    getItemNodeFromIndex: x
  });
  Rp({
    props: t,
    state: a
  }), xe(function() {
    var I = zn(t, "isOpen");
    I && p.current && p.current.focus();
  }, []), xe(function() {
    $ || (w.current = n.length);
  });
  var k = $_(r, ke(function() {
    _.current.state.isOpen && l({
      type: ar,
      selectItem: !1
    });
  }, [l, _]), Zo(function() {
    return [h, y, p];
  }, [h.current, y.current, p.current])), R = Np("getInputProps", "getMenuProps");
  xe(function() {
    c || (b.current = {});
  }, [c]), xe(function() {
    var I;
    !c || !(r != null && r.document) || !(p != null && (I = p.current) != null && I.focus) || r.document.activeElement !== p.current && p.current.focus();
  }, [c, r]);
  var N = Zo(function() {
    return {
      ArrowDown: function(I) {
        I.preventDefault(), l({
          type: Us,
          altKey: I.altKey
        });
      },
      ArrowUp: function(I) {
        I.preventDefault(), l({
          type: Bs,
          altKey: I.altKey
        });
      },
      Home: function(I) {
        _.current.state.isOpen && (I.preventDefault(), l({
          type: Ks
        }));
      },
      End: function(I) {
        _.current.state.isOpen && (I.preventDefault(), l({
          type: Ws
        }));
      },
      Escape: function(I) {
        var M = _.current.state;
        (M.isOpen || M.inputValue || M.selectedItem || M.highlightedIndex > -1) && (I.preventDefault(), l({
          type: Hs
        }));
      },
      Enter: function(I) {
        var M = _.current.state;
        !M.isOpen || I.which === 229 || (I.preventDefault(), l({
          type: Js
        }));
      },
      PageUp: function(I) {
        _.current.state.isOpen && (I.preventDefault(), l({
          type: qs
        }));
      },
      PageDown: function(I) {
        _.current.state.isOpen && (I.preventDefault(), l({
          type: Zs
        }));
      }
    };
  }, [l, _]), j = ke(function(I) {
    return ie({
      id: v.labelId,
      htmlFor: v.inputId
    }, I);
  }, [v]), H = ke(function(I, M) {
    var D, V = I === void 0 ? {} : I, B = V.onMouseLeave, K = V.refKey, W = K === void 0 ? "ref" : K, ee = V.ref, Z = $t(V, T_), ue = M === void 0 ? {} : M, z = ue.suppressRefError, Ie = z === void 0 ? !1 : z;
    return R("getMenuProps", Ie, W, h), ie((D = {}, D[W] = mn(ee, function(U) {
      h.current = U;
    }), D.id = v.menuId, D.role = "listbox", D["aria-labelledby"] = Z && Z["aria-label"] ? void 0 : "" + v.labelId, D.onMouseLeave = Pe(B, function() {
      l({
        type: Ip
      });
    }), D), Z);
  }, [l, R, v]), re = ke(function(I) {
    var M, D, V = I === void 0 ? {} : I, B = V.item, K = V.index, W = V.refKey, ee = W === void 0 ? "ref" : W, Z = V.ref, ue = V.onMouseMove, z = V.onMouseDown, Ie = V.onClick;
    V.onPress;
    var U = V.disabled, ot = $t(V, L_);
    U !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var rt = _.current, It = rt.props, bt = rt.state, lo = w_(B, K, It.items, "Pass either item or index to getItemProps!"), Kr = lo[0], yt = lo[1], Nn = It.isItemDisabled(Kr, yt), Wr = "onClick", uo = Ie, Et = function() {
      k.isTouchEnd || yt === bt.highlightedIndex || (C.current = !1, l({
        type: Pp,
        index: yt,
        disabled: Nn
      }));
    }, it = function() {
      l({
        type: Xs,
        index: yt
      });
    }, Pt = function(po) {
      return po.preventDefault();
    };
    return ie((M = {}, M[ee] = mn(Z, function(po) {
      po && (b.current[v.getItemId(yt)] = po);
    }), M["aria-disabled"] = Nn, M["aria-selected"] = yt === bt.highlightedIndex, M.id = v.getItemId(yt), M.role = "option", M), !Nn && (D = {}, D[Wr] = Pe(uo, it), D), {
      onMouseMove: Pe(ue, Et),
      onMouseDown: Pe(z, Pt)
    }, ot);
  }, [l, v, _, k, C]), q = ke(function(I) {
    var M, D = I === void 0 ? {} : I, V = D.onClick;
    D.onPress;
    var B = D.refKey, K = B === void 0 ? "ref" : B, W = D.ref, ee = $t(D, j_), Z = _.current.state, ue = function() {
      l({
        type: Tp
      });
    };
    return ie((M = {}, M[K] = mn(W, function(z) {
      y.current = z;
    }), M["aria-controls"] = v.menuId, M["aria-expanded"] = Z.isOpen, M.id = v.toggleButtonId, M.tabIndex = -1, M), !ee.disabled && ie({}, {
      onClick: Pe(V, ue)
    }), ee);
  }, [l, _, v]), F = ke(function(I, M) {
    var D, V = I === void 0 ? {} : I, B = V.onKeyDown, K = V.onChange, W = V.onInput, ee = V.onBlur;
    V.onChangeText;
    var Z = V.onClick, ue = V.refKey, z = ue === void 0 ? "ref" : ue, Ie = V.ref, U = $t(V, D_), ot = M === void 0 ? {} : M, rt = ot.suppressRefError, It = rt === void 0 ? !1 : rt;
    R("getInputProps", It, z, p);
    var bt = _.current.state, lo = function(it) {
      var Pt = Wi(it);
      Pt && N[Pt] && N[Pt](it);
    }, Kr = function(it) {
      l({
        type: Gs,
        inputValue: it.target.value
      });
    }, yt = function(it) {
      if (r != null && r.document && bt.isOpen && !k.isMouseDown) {
        var Pt = it.relatedTarget === null && r.document.activeElement !== r.document.body;
        l({
          type: ar,
          selectItem: !Pt
        });
      }
    }, Nn = function() {
      l({
        type: Ys
      });
    }, Wr = "onChange", uo = {};
    if (!U.disabled) {
      var Et;
      uo = (Et = {}, Et[Wr] = Pe(K, W, Kr), Et.onKeyDown = Pe(B, lo), Et.onBlur = Pe(ee, yt), Et.onClick = Pe(Z, Nn), Et);
    }
    return ie((D = {}, D[z] = mn(Ie, function(it) {
      p.current = it;
    }), D["aria-activedescendant"] = bt.isOpen && bt.highlightedIndex > -1 ? v.getItemId(bt.highlightedIndex) : "", D["aria-autocomplete"] = "list", D["aria-controls"] = v.menuId, D["aria-expanded"] = bt.isOpen, D["aria-labelledby"] = U && U["aria-label"] ? void 0 : v.labelId, D.autoComplete = "off", D.id = v.inputId, D.role = "combobox", D.value = bt.inputValue, D), uo, U);
  }, [l, v, r, N, _, k, R]), ae = ke(function() {
    l({
      type: Lp
    });
  }, [l]), J = ke(function() {
    l({
      type: Dp
    });
  }, [l]), ce = ke(function() {
    l({
      type: jp
    });
  }, [l]), we = ke(function(I) {
    l({
      type: zp,
      highlightedIndex: I
    });
  }, [l]), Ae = ke(function(I) {
    l({
      type: Qs,
      selectedItem: I
    });
  }, [l]), O = ke(function(I) {
    l({
      type: Mp,
      inputValue: I
    });
  }, [l]), T = ke(function() {
    l({
      type: Fp
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: re,
    getLabelProps: j,
    getMenuProps: H,
    getInputProps: F,
    getToggleButtonProps: q,
    // actions.
    toggleMenu: ae,
    openMenu: ce,
    closeMenu: J,
    setHighlightedIndex: we,
    setInputValue: O,
    selectItem: Ae,
    reset: T,
    // state.
    highlightedIndex: u,
    isOpen: c,
    selectedItem: d,
    inputValue: f
  };
}
Uo.stateReducer, Uo.itemToKey, Uo.environment, L.array, L.array, L.array, L.func, L.number, L.number, L.number, L.func, L.func, L.string, L.string;
Dn.itemToKey, Dn.stateReducer, Dn.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const z_ = "_autocomplete_olk74_29", M_ = "_suggestion_olk74_87", F_ = "_highlight_olk74_107", St = {
  autocomplete: z_,
  "autocomplete-container": "_autocomplete-container_olk74_38",
  "input-button-container": "_input-button-container_olk74_43",
  "autocomplete-input": "_autocomplete-input_olk74_49",
  "autocomplete-button": "_autocomplete-button_olk74_63",
  "suggestions-container": "_suggestions-container_olk74_87",
  suggestion: M_,
  highlight: F_
};
function V_({
  id: e,
  placeholder: t,
  value: n,
  onChange: o,
  suggestions: r = [],
  buttonText: i,
  onSubmit: s,
  hideButtonText: a,
  className: l,
  ...c
}) {
  const { isOpen: u, getLabelProps: d, getMenuProps: f, getInputProps: h, highlightedIndex: b, getItemProps: p, selectedItem: y } = ta({
    id: e,
    onInputValueChange({ inputValue: w }) {
      o && o(w ?? "");
    },
    items: r,
    itemToString(w) {
      return w?.value ?? "";
    }
  }), $ = op(St.autocomplete, l);
  function v(w) {
    w.preventDefault(), s && s(w, y ?? void 0);
  }
  return /* @__PURE__ */ P("div", { className: $, ...c, children: [
    /* @__PURE__ */ m("form", { className: St["autocomplete-container"], onSubmit: v, children: /* @__PURE__ */ P("div", { className: St["input-button-container"], children: [
      /* @__PURE__ */ m("label", { ...d(), hidden: !0, children: t }),
      /* @__PURE__ */ m(
        "input",
        {
          className: St["autocomplete-input"],
          type: "text",
          placeholder: t,
          value: n,
          ...h()
        }
      ),
      /* @__PURE__ */ P("button", { "aria-label": i, className: St["autocomplete-button"], children: [
        /* @__PURE__ */ m(rp, { name: "search" }),
        !a && i
      ] })
    ] }) }),
    /* @__PURE__ */ m("ul", { className: St["suggestions-container"], ...f(), "data-test": u, "aria-busy": !u, children: u && r.map((w, _) => /* @__PURE__ */ m(
      "li",
      {
        className: `${St.suggestion} ${b === _ ? St.highlight : ""}`,
        ...p({ item: w, index: _ }),
        children: w.value
      },
      w.id
    )) })
  ] });
}
const U_ = Jt(void 0), xc = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (a, l) => {
    const c = typeof a == "function" ? a(t) : a;
    if (!Object.is(c, t)) {
      const u = t;
      t = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), n.forEach((d) => d(t, u));
    }
  }, r = () => t, i = { setState: o, getState: r, getInitialState: () => s, subscribe: (a) => (n.add(a), () => n.delete(a)) }, s = t = e(o, r, i);
  return i;
}, B_ = (e) => e ? xc(e) : xc;
function H_(e) {
  const t = {
    apiUrl: ""
  };
  return B_((n) => ({
    ...t,
    ...e,
    setApiUrl: (o) => n({ apiUrl: o })
  }));
}
function K_({ children: e, ...t }) {
  const n = Ee(null);
  return n.current || (n.current = H_(t)), /* @__PURE__ */ m(U_.Provider, { value: n.current, children: e });
}
function W_(e, t = 500) {
  const [n, o] = De(e);
  return xe(() => {
    const r = setTimeout(() => o(e), t);
    return () => {
      clearTimeout(r);
    };
  }, [e, t]), n;
}
function q_(e) {
  const [t, n] = De(e), o = W_(t, 500), [r, i] = De([]);
  xe(() => {
    o.length > 3 && Iw(o).then((a) => {
      const l = a?.features.map((c) => ({ value: c.properties.label, id: c.properties.gid }));
      i(l);
    });
  }, [o]);
  const s = o.length > 2 ? r ?? [] : [];
  return { value: t, setValue: n, suggestedDestinations: s };
}
function Z_() {
  return ke((e, t) => {
    let n;
    t ? n = `${t.value}?location_id=${t.id}&provider=Jawg` : n = "everywhere", window !== void 0 && (window.location.href = `/search-v2/${n}`);
  }, []);
}
function J_({
  placeholder: e,
  buttonText: t,
  id: n,
  className: o,
  ...r
}) {
  const { setValue: i, suggestedDestinations: s } = q_(""), a = Z_();
  return /* @__PURE__ */ m(
    V_,
    {
      className: o,
      id: n,
      placeholder: e,
      onChange: i,
      suggestions: s,
      onSubmit: a,
      buttonText: t,
      ...r
    }
  );
}
function G_({
  placeholder: e = "placeholder",
  buttonText: t = "search",
  id: n,
  className: o,
  apiUrl: r,
  ...i
}) {
  return Ow(r), /* @__PURE__ */ m(K_, { apiUrl: r, children: /* @__PURE__ */ m(J_, { placeholder: e, buttonText: t, id: n, className: o, ...i }) });
}
function Y_() {
  const [e, t] = De({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return xe(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
function X_() {
  const { width: e } = Y_();
  let t = "desktop";
  return e && e <= pa.MOBILE ? t = "mobile" : e && e <= pa.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
function Q_(e, t, n) {
  xe(() => {
    if (window)
      return window.addEventListener(e, t, n), () => {
        window.removeEventListener(e, t, n);
      };
  }, [e, t, n]);
}
const $c = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const f = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((h) => h(t, f));
    }
  }, r = () => t, a = { setState: o, getState: r, getInitialState: () => l, subscribe: (c) => (n.add(c), () => n.delete(c)) }, l = t = e(o, r, a);
  return a;
}, Bp = (e) => e ? $c(e) : $c, ex = (e) => e;
function Hp(e, t = ex) {
  const n = Te.useSyncExternalStore(
    e.subscribe,
    Te.useCallback(() => t(e.getState()), [e, t]),
    Te.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return Te.useDebugValue(n), n;
}
function tx(e) {
  const t = {
    conversations: void 0,
    userInfos: void 0,
    apiUrl: "",
    assetsUrl: ""
  };
  return Bp((n) => ({
    ...t,
    ...e,
    setNavigationBarData: (o) => n({
      conversations: o.conversations,
      userInfos: o.userInfos
    }),
    setConversations: (o) => n({ conversations: o }),
    setUserInfos: (o) => n({ userInfos: o }),
    setApiUrl: (o) => n({ apiUrl: o }),
    setAssetsUrl: (o) => n({ assetsUrl: o }),
    clear: () => n({
      conversations: void 0,
      userInfos: void 0
    })
  }));
}
const Kp = Jt(void 0);
function nx({ children: e, ...t }) {
  const n = Ee(null);
  return n.current || (n.current = tx(t)), /* @__PURE__ */ m(Kp.Provider, { value: n.current, children: e });
}
const kc = (e) => Symbol.iterator in e, Ec = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), Sc = (e, t) => {
  const n = e instanceof Map ? e : new Map(e.entries()), o = t instanceof Map ? t : new Map(t.entries());
  if (n.size !== o.size)
    return !1;
  for (const [r, i] of n)
    if (!Object.is(i, o.get(r)))
      return !1;
  return !0;
}, ox = (e, t) => {
  const n = e[Symbol.iterator](), o = t[Symbol.iterator]();
  let r = n.next(), i = o.next();
  for (; !r.done && !i.done; ) {
    if (!Object.is(r.value, i.value))
      return !1;
    r = n.next(), i = o.next();
  }
  return !!r.done && !!i.done;
};
function rx(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : kc(e) && kc(t) ? Ec(e) && Ec(t) ? Sc(e, t) : ox(e, t) : Sc(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function Wp(e) {
  const t = Te.useRef(void 0);
  return (n) => {
    const o = e(n);
    return rx(t.current, o) ? t.current : t.current = o;
  };
}
function Ht(e) {
  const t = yr(Kp);
  if (!t) throw new Error("Missing NavigationContext.Provider in the tree");
  return Hp(t, Wp(e));
}
const qp = Jt(void 0);
function Pr(e) {
  const t = yr(qp);
  if (!t) throw new Error("Missing UserContext.Provider in the tree");
  return Hp(t, Wp(e));
}
function ix(e) {
  const t = {
    isSignedIn: !1
  };
  return Bp((n) => ({
    ...t,
    ...e,
    setIsSignedIn: (o) => n({ isSignedIn: o }),
    signout: () => n({ isSignedIn: !1 })
  }));
}
function sx({ children: e, ...t }) {
  const n = Ee(null);
  return n.current || (n.current = ix(t)), /* @__PURE__ */ m(qp.Provider, { value: n.current, children: e });
}
const Y = (e) => typeof e == "string", Tn = () => {
  let e, t;
  const n = new Promise((o, r) => {
    e = o, t = r;
  });
  return n.resolve = e, n.reject = t, n;
}, Cc = (e) => e == null ? "" : "" + e, ax = (e, t, n) => {
  e.forEach((o) => {
    t[o] && (n[o] = t[o]);
  });
}, cx = /###/g, Oc = (e) => e && e.indexOf("###") > -1 ? e.replace(cx, ".") : e, Nc = (e) => !e || Y(e), Fn = (e, t, n) => {
  const o = Y(t) ? t.split(".") : t;
  let r = 0;
  for (; r < o.length - 1; ) {
    if (Nc(e)) return {};
    const i = Oc(o[r]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++r;
  }
  return Nc(e) ? {} : {
    obj: e,
    k: Oc(o[r])
  };
}, Rc = (e, t, n) => {
  const {
    obj: o,
    k: r
  } = Fn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[r] = n;
    return;
  }
  let i = t[t.length - 1], s = t.slice(0, t.length - 1), a = Fn(e, s, Object);
  for (; a.obj === void 0 && s.length; )
    i = `${s[s.length - 1]}.${i}`, s = s.slice(0, s.length - 1), a = Fn(e, s, Object), a?.obj && typeof a.obj[`${a.k}.${i}`] < "u" && (a.obj = void 0);
  a.obj[`${a.k}.${i}`] = n;
}, lx = (e, t, n, o) => {
  const {
    obj: r,
    k: i
  } = Fn(e, t, Object);
  r[i] = r[i] || [], r[i].push(n);
}, cr = (e, t) => {
  const {
    obj: n,
    k: o
  } = Fn(e, t);
  if (n && Object.prototype.hasOwnProperty.call(n, o))
    return n[o];
}, ux = (e, t, n) => {
  const o = cr(e, n);
  return o !== void 0 ? o : cr(t, n);
}, Zp = (e, t, n) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? Y(e[o]) || e[o] instanceof String || Y(t[o]) || t[o] instanceof String ? n && (e[o] = t[o]) : Zp(e[o], t[o], n) : e[o] = t[o]);
  return e;
}, an = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var dx = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const px = (e) => Y(e) ? e.replace(/[&<>"'\/]/g, (t) => dx[t]) : e;
class fx {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const hx = [" ", ",", "?", "!", ";"], mx = new fx(20), gx = (e, t, n) => {
  t = t || "", n = n || "";
  const o = hx.filter((s) => t.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (o.length === 0) return !0;
  const r = mx.getRegExp(`(${o.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let i = !r.test(e);
  if (!i) {
    const s = e.indexOf(n);
    s > 0 && !r.test(e.substring(0, s)) && (i = !0);
  }
  return i;
}, Ji = (e, t, n = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(n);
  let r = e;
  for (let i = 0; i < o.length; ) {
    if (!r || typeof r != "object")
      return;
    let s, a = "";
    for (let l = i; l < o.length; ++l)
      if (l !== i && (a += n), a += o[l], s = r[a], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < o.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    r = s;
  }
  return r;
}, Hn = (e) => e?.replace("_", "-"), vx = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class lr {
  constructor(t, n = {}) {
    this.init(t, n);
  }
  init(t, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = t || vx, this.options = n, this.debug = n.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, o, r) {
    return r && !this.debug ? null : (Y(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new lr(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new lr(this.logger, t);
  }
}
var dt = new lr();
class Tr {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const r = this.observers[o].get(n) || 0;
      this.observers[o].set(n, r + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t, ...n) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([r, i]) => {
      for (let s = 0; s < i; s++)
        r(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([r, i]) => {
      for (let s = 0; s < i; s++)
        r.apply(r, [t, ...n]);
    });
  }
}
class Ac extends Tr {
  constructor(t, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, o, r = {}) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, s = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a;
    t.indexOf(".") > -1 ? a = t.split(".") : (a = [t, n], o && (Array.isArray(o) ? a.push(...o) : Y(o) && i ? a.push(...o.split(i)) : a.push(o)));
    const l = cr(this.data, a);
    return !l && !n && !o && t.indexOf(".") > -1 && (t = a[0], n = a[1], o = a.slice(2).join(".")), l || !s || !Y(o) ? l : Ji(this.data?.[t]?.[n], o, i);
  }
  addResource(t, n, o, r, i = {
    silent: !1
  }) {
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let a = [t, n];
    o && (a = a.concat(s ? o.split(s) : o)), t.indexOf(".") > -1 && (a = t.split("."), r = n, n = a[1]), this.addNamespaces(n), Rc(this.data, a, r), i.silent || this.emit("added", t, n, o, r);
  }
  addResources(t, n, o, r = {
    silent: !1
  }) {
    for (const i in o)
      (Y(o[i]) || Array.isArray(o[i])) && this.addResource(t, n, i, o[i], {
        silent: !0
      });
    r.silent || this.emit("added", t, n, o);
  }
  addResourceBundle(t, n, o, r, i, s = {
    silent: !1,
    skipCopy: !1
  }) {
    let a = [t, n];
    t.indexOf(".") > -1 && (a = t.split("."), r = o, o = n, n = a[1]), this.addNamespaces(n);
    let l = cr(this.data, a) || {};
    s.skipCopy || (o = JSON.parse(JSON.stringify(o))), r ? Zp(l, o, i) : l = {
      ...l,
      ...o
    }, Rc(this.data, a, l), s.silent || this.emit("added", t, n, o);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Jp = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, o, r) {
    return e.forEach((i) => {
      t = this.processors[i]?.process(t, n, o, r) ?? t;
    }), t;
  }
};
const Ic = {}, Pc = (e) => !Y(e) && typeof e != "boolean" && typeof e != "number";
class ur extends Tr {
  constructor(t, n = {}) {
    super(), ax(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = dt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, n = {
    interpolation: {}
  }) {
    const o = {
      ...n
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, n) {
    let o = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const s = o && t.indexOf(o) > -1, a = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !gx(t, o, r);
    if (s && !a) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: Y(i) ? [i] : i
        };
      const c = t.split(o);
      (o !== r || o === r && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(r);
    }
    return {
      key: t,
      namespaces: Y(i) ? [i] : i
    };
  }
  translate(t, n, o) {
    let r = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (r = {
      ...r
    }), r || (r = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const i = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], r), c = l[l.length - 1];
    let u = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = r.lng || this.language, f = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return f ? i ? {
        res: `${c}${u}${a}`,
        usedKey: a,
        exactUsedKey: a,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(r)
      } : `${c}${u}${a}` : i ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(r)
      } : a;
    const h = this.resolve(t, r);
    let b = h?.res;
    const p = h?.usedKey || a, y = h?.exactUsedKey || a, $ = ["[object Number]", "[object Function]", "[object RegExp]"], v = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, w = !this.i18nFormat || this.i18nFormat.handleAsObject, _ = r.count !== void 0 && !Y(r.count), x = ur.hasDefaultValue(r), C = _ ? this.pluralResolver.getSuffix(d, r.count, r) : "", k = r.ordinal && _ ? this.pluralResolver.getSuffix(d, r.count, {
      ordinal: !1
    }) : "", R = _ && !r.ordinal && r.count === 0, N = R && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${C}`] || r[`defaultValue${k}`] || r.defaultValue;
    let j = b;
    w && !b && x && (j = N);
    const H = Pc(j), re = Object.prototype.toString.apply(j);
    if (w && j && H && $.indexOf(re) < 0 && !(Y(v) && Array.isArray(j))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const q = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, j, {
          ...r,
          ns: l
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return i ? (h.res = q, h.usedParams = this.getUsedParamsDetails(r), h) : q;
      }
      if (s) {
        const q = Array.isArray(j), F = q ? [] : {}, ae = q ? y : p;
        for (const J in j)
          if (Object.prototype.hasOwnProperty.call(j, J)) {
            const ce = `${ae}${s}${J}`;
            x && !b ? F[J] = this.translate(ce, {
              ...r,
              defaultValue: Pc(N) ? N[J] : void 0,
              joinArrays: !1,
              ns: l
            }) : F[J] = this.translate(ce, {
              ...r,
              joinArrays: !1,
              ns: l
            }), F[J] === ce && (F[J] = j[J]);
          }
        b = F;
      }
    } else if (w && Y(v) && Array.isArray(b))
      b = b.join(v), b && (b = this.extendTranslation(b, t, r, o));
    else {
      let q = !1, F = !1;
      !this.isValidLookup(b) && x && (q = !0, b = N), this.isValidLookup(b) || (F = !0, b = a);
      const J = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && F ? void 0 : b, ce = x && N !== b && this.options.updateMissing;
      if (F || q || ce) {
        if (this.logger.log(ce ? "updateKey" : "missingKey", d, c, a, ce ? N : b), s) {
          const T = this.resolve(a, {
            ...r,
            keySeparator: !1
          });
          T && T.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let we = [];
        const Ae = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Ae && Ae[0])
          for (let T = 0; T < Ae.length; T++)
            we.push(Ae[T]);
        else this.options.saveMissingTo === "all" ? we = this.languageUtils.toResolveHierarchy(r.lng || this.language) : we.push(r.lng || this.language);
        const O = (T, I, M) => {
          const D = x && M !== b ? M : J;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(T, c, I, D, ce, r) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(T, c, I, D, ce, r), this.emit("missingKey", T, c, I, b);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && _ ? we.forEach((T) => {
          const I = this.pluralResolver.getSuffixes(T, r);
          R && r[`defaultValue${this.options.pluralSeparator}zero`] && I.indexOf(`${this.options.pluralSeparator}zero`) < 0 && I.push(`${this.options.pluralSeparator}zero`), I.forEach((M) => {
            O([T], a + M, r[`defaultValue${M}`] || N);
          });
        }) : O(we, a, N));
      }
      b = this.extendTranslation(b, t, r, h, o), F && b === a && this.options.appendNamespaceToMissingKey && (b = `${c}${u}${a}`), (F || q) && this.options.parseMissingKeyHandler && (b = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${a}` : a, q ? b : void 0, r));
    }
    return i ? (h.res = b, h.usedParams = this.getUsedParamsDetails(r), h) : b;
  }
  extendTranslation(t, n, o, r, i) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = Y(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !Y(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || r.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), f = d && d.length;
        c < f && (o.nest = !1);
      }
      !o.lng && r && r.res && (o.lng = this.language || r.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => i?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null) : this.translate(...d, n), o)), o.interpolation && this.interpolator.reset();
    }
    const s = o.postProcess || this.options.postProcess, a = Y(s) ? [s] : s;
    return t != null && a?.length && o.applyPostProcessor !== !1 && (t = Jp.handle(a, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, n = {}) {
    let o, r, i, s, a;
    return Y(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const f = n.count !== void 0 && !Y(n.count), h = f && !n.ordinal && n.count === 0, b = n.context !== void 0 && (Y(n.context) || typeof n.context == "number") && n.context !== "", p = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((y) => {
        this.isValidLookup(o) || (a = y, !Ic[`${p[0]}-${y}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(a) && (Ic[`${p[0]}-${y}`] = !0, this.logger.warn(`key "${r}" for languages "${p.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach(($) => {
          if (this.isValidLookup(o)) return;
          s = $;
          const v = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, $, y, n);
          else {
            let _;
            f && (_ = this.pluralResolver.getSuffix($, n.count, n));
            const x = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (v.push(u + _), n.ordinal && _.indexOf(C) === 0 && v.push(u + _.replace(C, this.options.pluralSeparator)), h && v.push(u + x)), b) {
              const k = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(k), f && (v.push(k + _), n.ordinal && _.indexOf(C) === 0 && v.push(k + _.replace(C, this.options.pluralSeparator)), h && v.push(k + x));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(o) || (i = w, o = this.getResource($, y, w, n));
        }));
      });
    }), {
      res: o,
      usedKey: r,
      exactUsedKey: i,
      usedLng: s,
      usedNS: a
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, o, r = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, n, o, r) : this.resourceStore.getResource(t, n, o, r);
  }
  getUsedParamsDetails(t = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !Y(t.replace);
    let r = o ? t.replace : t;
    if (o && typeof t.count < "u" && (r.count = t.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !o) {
      r = {
        ...r
      };
      for (const i of n)
        delete r[i];
    }
    return r;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && n === o.substring(0, n.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class Tc {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = dt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Hn(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Hn(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (Y(t) && t.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((o) => {
      if (n) return;
      const r = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (n = r);
    }), !n && this.options.supportedLngs && t.forEach((o) => {
      if (n) return;
      const r = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(r)) return n = r;
      const i = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(i)) return n = i;
      n = this.options.supportedLngs.find((s) => {
        if (s === i) return s;
        if (!(s.indexOf("-") < 0 && i.indexOf("-") < 0) && (s.indexOf("-") > 0 && i.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === i || s.indexOf(i) === 0 && i.length > 1))
          return s;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), Y(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let o = t[n];
    return o || (o = t[this.getScriptPartFromCode(n)]), o || (o = t[this.formatLanguageCode(n)]), o || (o = t[this.getLanguagePartFromCode(n)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, n) {
    const o = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], t), r = [], i = (s) => {
      s && (this.isSupportedCode(s) ? r.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return Y(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : Y(t) && i(this.formatLanguageCode(t)), o.forEach((s) => {
      r.indexOf(s) < 0 && i(this.formatLanguageCode(s));
    }), r;
  }
}
const Lc = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, jc = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class bx {
  constructor(t, n = {}) {
    this.languageUtils = t, this.options = n, this.logger = dt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, n = {}) {
    const o = Hn(t === "dev" ? "en" : t), r = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
      cleanedCode: o,
      type: r
    });
    if (i in this.pluralRulesCache)
      return this.pluralRulesCache[i];
    let s;
    try {
      s = new Intl.PluralRules(o, {
        type: r
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), jc;
      if (!t.match(/-|_/)) return jc;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      s = this.getRule(l, n);
    }
    return this.pluralRulesCache[i] = s, s;
  }
  needsPlural(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, n, o = {}) {
    return this.getSuffixes(t, o).map((r) => `${n}${r}`);
  }
  getSuffixes(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o ? o.resolvedOptions().pluralCategories.sort((r, i) => Lc[r] - Lc[i]).map((r) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : [];
  }
  getSuffix(t, n, o = {}) {
    const r = this.getRule(t, o);
    return r ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(n)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", n, o));
  }
}
const Dc = (e, t, n, o = ".", r = !0) => {
  let i = ux(e, t, n);
  return !i && r && Y(n) && (i = Ji(e, n, o), i === void 0 && (i = Ji(t, n, o))), i;
}, fi = (e) => e.replace(/\$/g, "$$$$");
class yx {
  constructor(t = {}) {
    this.logger = dt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: o,
      useRawValueToEscape: r,
      prefix: i,
      prefixEscaped: s,
      suffix: a,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: f,
      nestingPrefixEscaped: h,
      nestingSuffix: b,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: y,
      maxReplaces: $,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : px, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = i ? an(i) : s || "{{", this.suffix = a ? an(a) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? an(f) : h || an("$t("), this.nestingSuffix = b ? an(b) : p || an(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = $ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, o) => n?.source === o ? (n.lastIndex = 0, n) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, o, r) {
    let i, s, a;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const $ = Dc(n, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format($, void 0, o, {
          ...r,
          ...n,
          interpolationkey: h
        }) : $;
      }
      const b = h.split(this.formatSeparator), p = b.shift().trim(), y = b.join(this.formatSeparator).trim();
      return this.format(Dc(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure), y, o, {
        ...r,
        ...n,
        interpolationkey: p
      });
    };
    this.resetRegExp();
    const u = r?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => fi(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? fi(this.escape(h)) : fi(h)
    }].forEach((h) => {
      for (a = 0; i = h.regex.exec(t); ) {
        const b = i[1].trim();
        if (s = c(b), s === void 0)
          if (typeof u == "function") {
            const y = u(t, i, r);
            s = Y(y) ? y : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, b))
            s = "";
          else if (d) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${b} for interpolating ${t}`), s = "";
        else !Y(s) && !this.useRawValueToEscape && (s = Cc(s));
        const p = h.safeValue(s);
        if (t = t.replace(i[0], p), d ? (h.regex.lastIndex += s.length, h.regex.lastIndex -= i[0].length) : h.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n, o = {}) {
    let r, i, s;
    const a = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${d[1]}`;
      l = d[0], f = this.interpolate(f, s);
      const h = f.match(/'/g), b = f.match(/"/g);
      ((h?.length ?? 0) % 2 === 0 && !b || b.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        s = JSON.parse(f), c && (s = {
          ...c,
          ...s
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${f}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(t); ) {
      let l = [];
      s = {
        ...o
      }, s = s.replace && !Y(s.replace) ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      const c = /{.*}/.test(r[1]) ? r[1].lastIndexOf("}") + 1 : r[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = r[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), r[1] = r[1].slice(0, c)), i = n(a.call(this, r[1].trim(), s), s), i && r[0] === t && !Y(i)) return i;
      Y(i) || (i = Cc(i)), i || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${t}`), i = ""), l.length && (i = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: r[1].trim()
      }), i.trim())), t = t.replace(r[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const wx = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const r = o[1].substring(0, o[1].length - 1);
    t === "currency" && r.indexOf(":") < 0 ? n.currency || (n.currency = r.trim()) : t === "relativetime" && r.indexOf(":") < 0 ? n.range || (n.range = r.trim()) : r.split(";").forEach((s) => {
      if (s) {
        const [a, ...l] = s.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = a.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, zc = (e) => {
  const t = {};
  return (n, o, r) => {
    let i = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (i = {
      ...i,
      [r.interpolationkey]: void 0
    });
    const s = o + JSON.stringify(i);
    let a = t[s];
    return a || (a = e(Hn(o), r), t[s] = a), a(n);
  };
}, _x = (e) => (t, n, o) => e(Hn(n), o)(t);
class xx {
  constructor(t = {}) {
    this.logger = dt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const o = n.cacheInBuiltFormats ? zc : _x;
    this.formats = {
      number: o((r, i) => {
        const s = new Intl.NumberFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      }),
      currency: o((r, i) => {
        const s = new Intl.NumberFormat(r, {
          ...i,
          style: "currency"
        });
        return (a) => s.format(a);
      }),
      datetime: o((r, i) => {
        const s = new Intl.DateTimeFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      }),
      relativetime: o((r, i) => {
        const s = new Intl.RelativeTimeFormat(r, {
          ...i
        });
        return (a) => s.format(a, i.range || "day");
      }),
      list: o((r, i) => {
        const s = new Intl.ListFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      })
    };
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = zc(n);
  }
  format(t, n, o, r = {}) {
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((a) => a.indexOf(")") > -1)) {
      const a = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, a)].join(this.formatSeparator);
    }
    return i.reduce((a, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = wx(l);
      if (this.formats[c]) {
        let d = a;
        try {
          const f = r?.formatParams?.[r.interpolationkey] || {}, h = f.locale || f.lng || r.locale || r.lng || o;
          d = this.formats[c](a, h, {
            ...u,
            ...r,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return a;
    }, t);
  }
}
const $x = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class kx extends Tr {
  constructor(t, n, o, r = {}) {
    super(), this.backend = t, this.store = n, this.services = o, this.languageUtils = o.languageUtils, this.options = r, this.logger = dt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, r.backend, r);
  }
  queueLoad(t, n, o, r) {
    const i = {}, s = {}, a = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const f = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? s[f] === void 0 && (s[f] = !0) : (this.state[f] = 1, u = !1, s[f] === void 0 && (s[f] = !0), i[f] === void 0 && (i[f] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (a[c] = !0);
    }), (Object.keys(i).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, o) {
    const r = t.split("|"), i = r[0], s = r[1];
    n && this.emit("failedLoading", i, s, n), !n && o && this.store.addResourceBundle(i, s, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && o && (this.state[t] = 0);
    const a = {};
    this.queue.forEach((l) => {
      lx(l.loaded, [i], s), $x(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        a[c] || (a[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          a[c][d] === void 0 && (a[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, o, r = 0, i = this.retryTimeout, s) {
    if (!t.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: o,
        tried: r,
        wait: i,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const a = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, o, r + 1, i * 2, s);
        }, i);
        return;
      }
      s(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => a(null, u)).catch(a) : a(null, c);
      } catch (c) {
        a(c);
      }
      return;
    }
    return l(t, n, a);
  }
  prepareLoading(t, n, o = {}, r) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    Y(t) && (t = this.languageUtils.toResolveHierarchy(t)), Y(n) && (n = [n]);
    const i = this.queueLoad(t, n, o, r);
    if (!i.toLoad.length)
      return i.pending.length || r(), null;
    i.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(t, n, o) {
    this.prepareLoading(t, n, {}, o);
  }
  reload(t, n, o) {
    this.prepareLoading(t, n, {
      reload: !0
    }, o);
  }
  loadOne(t, n = "") {
    const o = t.split("|"), r = o[0], i = o[1];
    this.read(r, i, "read", void 0, void 0, (s, a) => {
      s && this.logger.warn(`${n}loading namespace ${i} for language ${r} failed`, s), !s && a && this.logger.log(`${n}loaded namespace ${i} for language ${r}`, a), this.loaded(t, s, a);
    });
  }
  saveMissing(t, n, o, r, i, s = {}, a = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...s,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, o, r, l) : u = c(t, n, o, r), u && typeof u.then == "function" ? u.then((d) => a(null, d)).catch(a) : a(null, u);
          } catch (u) {
            a(u);
          }
        else
          c(t, n, o, r, a, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, o, r);
    }
  }
}
const Mc = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Y(e[1]) && (t.defaultValue = e[1]), Y(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((o) => {
        t[o] = n[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Fc = (e) => (Y(e.ns) && (e.ns = [e.ns]), Y(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Y(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), $o = () => {
}, Ex = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class Kn extends Tr {
  constructor(t = {}, n) {
    if (super(), this.options = Fc(t), this.services = {}, this.logger = dt, this.modules = {
      external: []
    }, Ex(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init(t = {}, n) {
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), t.defaultNS == null && t.ns && (Y(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Mc();
    this.options = {
      ...o,
      ...this.options,
      ...Fc(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const r = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? dt.init(r(this.modules.logger), this.options) : dt.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = xx;
      const u = new Tc(this.options);
      this.store = new Ac(this.options.resources, this.options);
      const d = this.services;
      d.logger = dt, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new bx(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.warn("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = r(c), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new yx(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new kx(r(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (h, ...b) => {
        this.emit(h, ...b);
      }), this.modules.languageDetector && (d.languageDetector = r(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = r(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new ur(this.services, this.options), this.translator.on("*", (h, ...b) => {
        this.emit(h, ...b);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = $o), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...u) => this.store[c](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...u) => (this.store[c](...u), this);
    });
    const a = Tn(), l = () => {
      const c = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), a.resolve(d), n(u, d);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), a;
  }
  loadResources(t, n = $o) {
    let o = n;
    const r = Y(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const i = [], s = (a) => {
        if (!a || a === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(a).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      r ? s(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => s(l)), this.options.preload?.forEach?.((a) => s(a)), this.services.backendConnector.load(i, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(a);
      });
    } else
      o(null);
  }
  reloadResources(t, n, o) {
    const r = Tn();
    return typeof t == "function" && (o = t, t = void 0), typeof n == "function" && (o = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), o || (o = $o), this.services.backendConnector.reload(t, n, (i) => {
      r.resolve(), o(i);
    }), r;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Jp.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const o = this.languages[n];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, n) {
    this.isLanguageChangingTo = t;
    const o = Tn();
    this.emit("languageChanging", t);
    const r = (a) => {
      this.language = a, this.languages = this.services.languageUtils.toResolveHierarchy(a), this.resolvedLanguage = void 0, this.setResolvedLanguage(a);
    }, i = (a, l) => {
      l ? this.isLanguageChangingTo === t && (r(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), n && n(a, (...c) => this.t(...c));
    }, s = (a) => {
      !t && !a && this.services.languageDetector && (a = []);
      const l = Y(a) ? a : a && a[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(Y(a) ? [a] : a);
      c && (this.language || r(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), o;
  }
  getFixedT(t, n, o) {
    const r = (i, s, ...a) => {
      let l;
      typeof s != "object" ? l = this.options.overloadTranslationOptionHandler([i, s].concat(a)) : l = {
        ...s
      }, l.lng = l.lng || r.lng, l.lngs = l.lngs || r.lngs, l.ns = l.ns || r.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || r.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(i) ? u = i.map((d) => `${l.keyPrefix}${c}${d}`) : u = l.keyPrefix ? `${l.keyPrefix}${c}${i}` : i, this.t(u, l);
    };
    return Y(t) ? r.lng = t : r.lngs = t, r.ns = n, r.keyPrefix = o, r;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = n.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const s = (a, l) => {
      const c = this.services.backendConnector.state[`${a}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const a = n.precheck(this, s);
      if (a !== void 0) return a;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(o, t) && (!r || s(i, t)));
  }
  loadNamespaces(t, n) {
    const o = Tn();
    return this.options.ns ? (Y(t) && (t = [t]), t.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      o.resolve(), n && n(r);
    }), o) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const o = Tn();
    Y(t) && (t = [t]);
    const r = this.options.preload || [], i = t.filter((s) => r.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return i.length ? (this.options.preload = r.concat(i), this.loadResources((s) => {
      o.resolve(), n && n(s);
    }), o) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const r = new Intl.Locale(t);
      if (r && r.getTextInfo) {
        const i = r.getTextInfo();
        if (i && i.direction) return i.direction;
      }
    } catch {
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Tc(Mc());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, n) {
    return new Kn(t, n);
  }
  cloneInstance(t = {}, n = $o) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const r = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Kn(r);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((a) => {
      i[a] = this[a];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, o) {
      const a = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), l[c]), l), {});
      i.store = new Ac(a, r), i.services.resourceStore = i.store;
    }
    return i.translator = new ur(i.services, r), i.translator.on("*", (a, ...l) => {
      i.emit(a, ...l);
    }), i.init(r, n), i.translator.options = r, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Ve = Kn.createInstance();
Ve.createInstance = Kn.createInstance;
const Sx = Ve.createInstance;
Ve.dir;
Ve.init;
Ve.loadResources;
Ve.reloadResources;
Ve.use;
Ve.changeLanguage;
Ve.getFixedT;
Ve.t;
Ve.exists;
Ve.setDefaultNamespace;
Ve.hasLoadedNamespace;
Ve.loadNamespaces;
Ve.loadLanguages;
const Cx = "Studio", Ox = "{{count}} soveværelse", Nx = "{{count}} soveværelser", Rx = "", Ax = "{{count}} seng", Ix = "{{count}} senge", Px = "", Tx = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: Cx,
  bedroomsNumbers_one: Ox,
  bedroomsNumbers_other: Nx,
  beds_zero: Rx,
  beds_one: Ax,
  beds_other: Ix,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: Px,
  "privacy-policy": "Privatpolitik"
}, Lx = "Kontakt os", jx = "FAQ", Dx = "Garantier", zx = "GuestPoints", Mx = "Hjælp", Fx = "Log out", Vx = "Messages", Ux = "Settings", Bx = {
  "about-the-calendar": "Kalenderen",
  "add-home": "Add a home",
  contact: Lx,
  faq: jx,
  guarantees: Dx,
  guestpoints: zx,
  help: Mx,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor meget koster det?",
  logout: Fx,
  messages: Vx,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Ux,
  "sign-in": "Log ind",
  "sign-up": "Tilmeld dig",
  "sign-up-for-free": "Tilmeld dig gratis",
  "signin.modal.apple-button": "Log ind med Apple",
  "signin.modal.facebook-button": "Log ind med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Hx = "https://www.homeexchange.com/blog/", Kx = "/p/general-terms-of-use", Wx = "https://www.homeexchange.com/da/p/community-da", qx = "https://homeexchangehelp.zendesk.com/hc/en-us", Zx = "", Jx = "https://www.homeexchange.com/da/p/service-homeexchange-da", Gx = "https://www.homeexchange.com/da/p/guestpoints-da", Yx = "https://www.homeexchange.com/da/p/press-da", Xx = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", Qx = "", e$ = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", t$ = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: Hx,
  cgu: Kx,
  community: Wx,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: qx,
  forum: Zx,
  guarantees: Jx,
  guestpoints: Gx,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Yx,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Xx,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Qx,
  values: e$
}, n$ = "Studio", o$ = "{{count}} schlafzimmer", r$ = "{{count}} schlafzimmer", i$ = "", s$ = "{{count}} Bett", a$ = "{{count}} Betten", c$ = "", l$ = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: n$,
  bedroomsNumbers_one: o$,
  bedroomsNumbers_other: r$,
  beds_zero: i$,
  beds_one: s$,
  beds_other: a$,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: c$,
  "privacy-policy": "Datenschutz"
}, u$ = "Kontaktieren Sie uns", d$ = "FAQ", p$ = "Garantien", f$ = "GuestPoints", h$ = "Hilfe", m$ = "Log out", g$ = "Messages", v$ = "Settings", b$ = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: u$,
  faq: d$,
  guarantees: p$,
  guestpoints: f$,
  help: h$,
  "how-it-works": "Wie funktioniert es?",
  "how-much-does-it-cost": "Wieviel kostet es?",
  logout: m$,
  messages: g$,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: v$,
  "sign-in": "Einloggen",
  "sign-up": "Anmelden",
  "sign-up-for-free": "Kostenlos anmelden",
  "signin.modal.apple-button": "Melden Sie sich mit Apple an",
  "signin.modal.facebook-button": "Mit Facebook anmelden",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, y$ = "https://www.homeexchange.com/de/blog/", w$ = "/de/p/homeexchangenutzungsbedingungen", _$ = "https://www.homeexchange.com/de/p/our-community-de", x$ = "https://homeexchangehelp.zendesk.com/hc/de", $$ = "", k$ = "https://www.homeexchange.com/de/p/service-homeexchange-de", E$ = "https://www.homeexchange.com/de/p/guestpoints-de", S$ = "https://www.homeexchange.com/de/p/press-de", C$ = "https://www.homeexchange.com/p/worte-homeexchanger", O$ = "", N$ = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", R$ = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: y$,
  cgu: w$,
  community: _$,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: x$,
  forum: $$,
  guarantees: k$,
  guestpoints: E$,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: S$,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: C$,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: O$,
  values: N$
}, A$ = "Studio", I$ = "{{count}} bedroom", P$ = "{{count}} bedrooms", T$ = "", L$ = "{{count}} bed", j$ = "{{count}} beds", D$ = "No result", z$ = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: A$,
  bedroomsNumbers_one: I$,
  bedroomsNumbers_other: P$,
  beds_zero: T$,
  beds_one: L$,
  beds_other: j$,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: D$,
  "privacy-policy": "Privacy Policy"
}, M$ = "Contact us", F$ = "FAQ", V$ = "Guarantees", U$ = "GuestPoints", B$ = "Help", H$ = "Log out", K$ = "Messages", W$ = "Settings", q$ = {
  "about-the-calendar": "Calendar",
  "add-home": "Add a home",
  contact: M$,
  faq: F$,
  guarantees: V$,
  guestpoints: U$,
  help: B$,
  "how-it-works": "How does it work?",
  "how-much-does-it-cost": "How much does it cost?",
  logout: H$,
  messages: K$,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Complete your home!",
  "notification.home.complete_home_first_time": "Complete your home and earn {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Add availability to your calendar for the coming year",
  "notification.home.new_calendar_type": "New calendar!",
  "notification.home.offline": "Publish your home!",
  "notification.membership.expired": "Membership expired",
  "notification.membership.lead": "Activate your membership and receive {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Complete your profile!",
  "notification.user_profile.motivate_incomplete": "Complete your profile and earn {{gp}} GuestPoints!",
  "refer-your-friends": "Refer your friends",
  settings: W$,
  "sign-in": "Sign in",
  "sign-up": "Sign up",
  "sign-up-for-free": "Sign up for free",
  "signin.modal.apple-button": "Sign in with Apple",
  "signin.modal.facebook-button": "Sign in with Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Z$ = "https://www.homeexchange.com/blog/", J$ = "/p/general-terms-of-use", G$ = "https://www.homeexchange.com/p/community", Y$ = "https://homeexchangehelp.zendesk.com/hc/en-us", X$ = "https://forum.homeexchange.com/c/english/20", Q$ = "https://www.homeexchange.com/p/service-homeexchange-en", ek = "https://www.homeexchange.com/p/guestpoints-en", tk = "https://www.homeexchange.com/p/press", nk = "https://www.homeexchange.com/p/words-of-homeexchanges", ok = "https://www.homeexchange.com/p/where-the-welcome-really-begins", rk = "https://www.homeexchange.com/p/where-the-welcome-really-begins", ik = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: Z$,
  cgu: J$,
  community: G$,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Y$,
  forum: X$,
  guarantees: Q$,
  guestpoints: ek,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: tk,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: nk,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ok,
  values: rk
}, sk = "Estudio", ak = "{{count}} dormitorio", ck = "{{count}} dormitorios", lk = "", uk = "{{count}} cama", dk = "{{count}} camas", pk = "", fk = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: sk,
  bedroomsNumbers_one: ak,
  bedroomsNumbers_other: ck,
  beds_zero: lk,
  beds_one: uk,
  beds_other: dk,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: pk,
  "privacy-policy": "Política de Privacidad"
}, hk = "Contacte con nosotros", mk = "Preguntas frecuentes", gk = "Guarantías", vk = "GuestPoints", bk = "Ayuda", yk = "Log out", wk = "Messages", _k = "Settings", xk = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: hk,
  faq: mk,
  guarantees: gk,
  guestpoints: vk,
  help: bk,
  "how-it-works": "¿Cómo funciona?",
  "how-much-does-it-cost": "¿Cuánto cuesta?",
  logout: yk,
  messages: wk,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: _k,
  "sign-in": "Inicia sesión",
  "sign-up": "Regístrate",
  "sign-up-for-free": "Regístrate gratis",
  "signin.modal.apple-button": "Inicia sesión con Apple",
  "signin.modal.facebook-button": "Inicia sesión con Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, $k = "https://www.homeexchange.com/es/blog/", kk = "/es/p/homeexchange-condiciones-de-uso", Ek = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", Sk = "https://homeexchangehelp.zendesk.com/hc/es", Ck = "https://forum.homeexchange.com/c/espanol/22", Ok = "https://www.homeexchange.com/es/p/service-homeexchange-es", Nk = "https://www.homeexchange.com/es/p/los-guestpoints", Rk = "https://www.homeexchange.com/es/p/prensa", Ak = "https://www.homeexchange.com/p/palabra-de-homeexchanger", Ik = "https://www.homeexchange.com/es/p/principios-intercambio-casa", Pk = "https://www.homeexchange.com/es/p/principios-intercambio-casa", Tk = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: $k,
  cgu: kk,
  community: Ek,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: Sk,
  forum: Ck,
  guarantees: Ok,
  guestpoints: Nk,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: Rk,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: Ak,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: Ik,
  values: Pk
}, Lk = "Studio", jk = "{{count}} chambre", Dk = "{{count}} chambres", zk = "", Mk = "{{count}} lit", Fk = "{{count}} lits", Vk = "", Uk = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: Lk,
  bedroomsNumbers_one: jk,
  bedroomsNumbers_other: Dk,
  beds_zero: zk,
  beds_one: Mk,
  beds_other: Fk,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: Vk,
  "privacy-policy": "Charte de vie privée"
}, Bk = "Contact", Hk = "FAQ", Kk = "Garanties", Wk = "GuestPoints", qk = "Aide", Zk = "Log out", Jk = "Messages", Gk = "Settings", Yk = {
  "about-the-calendar": "Calendrier",
  "add-home": "Add a home",
  contact: Bk,
  faq: Hk,
  guarantees: Kk,
  guestpoints: Wk,
  help: qk,
  "how-it-works": "Comment ça marche ?",
  "how-much-does-it-cost": "Combien ça coûte ?",
  logout: Zk,
  messages: Jk,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Gk,
  "sign-in": "Se connecter",
  "sign-up": "S'inscrire",
  "sign-up-for-free": "Inscrivez-vous gratuitement",
  "signin.modal.apple-button": "Se connecter avec Apple",
  "signin.modal.facebook-button": "Se connecter avec Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Xk = "https://www.homeexchange.fr/blog/", Qk = "/p/conditions-generale-d-utilisation", eE = "https://www.homeexchange.fr/p/communaute", tE = "https://homeexchangehelp.zendesk.com/hc/fr", nE = "https://forum.homeexchange.com/c/francais/21", oE = "https://www.homeexchange.fr/p/service-homeexchange-fr", rE = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", iE = "https://www.homeexchange.fr/p/presse", sE = "https://www.homeexchange.com/p/paroles-homeexchangers", aE = "https://www.homeexchange.fr/p/les-fondamentaux ", cE = "https://www.homeexchange.fr/p/les-fondamentaux", lE = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: Xk,
  cgu: Qk,
  community: eE,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: tE,
  forum: nE,
  guarantees: oE,
  guestpoints: rE,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: iE,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: sE,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: aE,
  values: cE
}, uE = "Studio", dE = "{{count}} soba", pE = "{{count}} sobe", fE = "{{count}} sobe", hE = "", mE = "{{count}} krevet", gE = "{{count}} kreveti", vE = "{{count}} kreveti", bE = "", yE = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: uE,
  bedroomsNumbers_one: dE,
  bedroomsNumbers_few: pE,
  bedroomsNumbers_other: fE,
  beds_zero: hE,
  beds_one: mE,
  beds_few: gE,
  beds_other: vE,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: bE,
  "privacy-policy": "Pravila o privatnosti"
}, wE = "Kontaktirajte nas", _E = "FAQ", xE = "Garancije", $E = "GuestPoints", kE = "Pomoć", EE = "Log out", SE = "Messages", CE = "Settings", OE = {
  "about-the-calendar": "Kalendar",
  "add-home": "Add a home",
  contact: wE,
  faq: _E,
  guarantees: xE,
  guestpoints: $E,
  help: kE,
  "how-it-works": "Kako funkcionira?",
  "how-much-does-it-cost": "Koliko košta?",
  logout: EE,
  messages: SE,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: CE,
  "sign-in": "Prijavite se",
  "sign-up": "Registrirajte se",
  "sign-up-for-free": "Prijavite se besplatno",
  "signin.modal.apple-button": "Prijavite se s Apple ID-om",
  "signin.modal.facebook-button": "Prijavite se putem Facebooka",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, NE = "https://www.homeexchange.com/blog/", RE = "/p/general-terms-of-use", AE = "https://www.homeexchange.com/hr/p/zajednica", IE = "https://homeexchangehelp.zendesk.com/hc/en-us", PE = "", TE = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", LE = "https://www.homeexchange.com/hr/p/guestpoints-hr", jE = "https://www.homeexchange.com/hr/p/press-hr", DE = "https://www.homeexchange.com/p/rijeci-homeexchange", zE = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", ME = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", FE = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: NE,
  cgu: RE,
  community: AE,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: IE,
  forum: PE,
  guarantees: TE,
  guestpoints: LE,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: jE,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: DE,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: zE,
  values: ME
}, VE = "Monolocale", UE = "{{count}} camera da letto", BE = "{{count}} camere da letto", HE = "", KE = "{{count}} letto", WE = "{{count}} letti", qE = "", ZE = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: VE,
  bedroomsNumbers_one: UE,
  bedroomsNumbers_other: BE,
  beds_zero: HE,
  beds_one: KE,
  beds_other: WE,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "",
  "global.select": "",
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: qE,
  "privacy-policy": "Informativa sulla privacy"
}, JE = "Contatti", GE = "Domande frequenti", YE = "Garanzie", XE = "GuestPoints", QE = "Aiuto", e0 = "Log out", t0 = "Messages", n0 = "Settings", o0 = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: JE,
  faq: GE,
  guarantees: YE,
  guestpoints: XE,
  help: QE,
  "how-it-works": "Come funziona?",
  "how-much-does-it-cost": "Quanto costa?",
  logout: e0,
  messages: t0,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: n0,
  "sign-in": "Accedi",
  "sign-up": "Registrati",
  "sign-up-for-free": "Iscriviti gratis",
  "signin.modal.apple-button": "Accedi con Apple",
  "signin.modal.facebook-button": "Accedi tramite Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, r0 = "https://www.homeexchange.it/blog/", i0 = "/p/homeexchange-condizioni-di-uso", s0 = "https://www.homeexchange.it/p/comunita", a0 = "https://homeexchangehelp.zendesk.com/hc/it", c0 = "", l0 = "https://www.homeexchange.it/p/service-homeexchange-it", u0 = "https://www.homeexchange.it/p/guestpoints-it", d0 = "https://www.homeexchange.it/p/stampa", p0 = "https://www.homeexchange.com/p/racconti-homeexchangers", f0 = "", h0 = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", m0 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: r0,
  cgu: i0,
  community: s0,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: a0,
  forum: c0,
  guarantees: l0,
  guestpoints: u0,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: d0,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: p0,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: f0,
  values: h0
}, g0 = "Studio", v0 = "{{count}} soverom", b0 = "{{count}} soverom", y0 = "", w0 = "{{count}} seng", _0 = "{{count}} senger", x0 = "", $0 = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: g0,
  bedroomsNumbers_one: v0,
  bedroomsNumbers_other: b0,
  beds_zero: y0,
  beds_one: w0,
  beds_other: _0,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: x0,
  "privacy-policy": "Personvernpolicy"
}, k0 = "Kontakt oss", E0 = "FAQ", S0 = "Garantier", C0 = "About the Guestpoints", O0 = "Hjelp", N0 = "Log out", R0 = "Messages", A0 = "Settings", I0 = {
  "about-the-calendar": "About the calendar",
  "add-home": "Add a home",
  contact: k0,
  faq: E0,
  guarantees: S0,
  guestpoints: C0,
  help: O0,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor mye koster det?",
  logout: N0,
  messages: R0,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: A0,
  "sign-in": "Logg inn",
  "sign-up": "Registrer deg",
  "sign-up-for-free": "Registrer deg gratis",
  "signin.modal.apple-button": "Logg inn med Apple",
  "signin.modal.facebook-button": "Logg inn med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, P0 = "https://www.homeexchange.com/blog/", T0 = "/p/general-terms-of-use", L0 = "https://www.homeexchange.com/nb/p/nettverk", j0 = "https://homeexchangehelp.zendesk.com/hc/pt", D0 = "", z0 = "https://www.homeexchange.com/nb/p/service-homeexchange-no", M0 = "https://www.homeexchange.com/nb/p/guestpoints-no", F0 = "https://www.homeexchange.com/nb/p/press-no", V0 = "https://www.homeexchange.com/p/ifolge-homeexchangers", U0 = "", B0 = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", H0 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: P0,
  cgu: T0,
  community: L0,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: j0,
  forum: D0,
  guarantees: z0,
  guestpoints: M0,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: F0,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: V0,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: U0,
  values: B0
}, K0 = "Studio", W0 = "{{count}} slaapkamer", q0 = "{{count}} slaapkamers", Z0 = "", J0 = "{{count}} bed", G0 = "{{count}} bedden", Y0 = "Geen resultaat", X0 = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: K0,
  bedroomsNumbers_one: W0,
  bedroomsNumbers_other: q0,
  beds_zero: Z0,
  beds_one: J0,
  beds_other: G0,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: Y0,
  "privacy-policy": "Privacy"
}, Q0 = "Neem contact met ons op", e1 = "FAQ", t1 = "Garanties", n1 = "GuestPoints", o1 = "Help", r1 = "Log out", i1 = "Messages", s1 = "Settings", a1 = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: Q0,
  faq: e1,
  guarantees: t1,
  guestpoints: n1,
  help: o1,
  "how-it-works": "Hoe werkt het?",
  "how-much-does-it-cost": "Hoeveel kost het?",
  logout: r1,
  messages: i1,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Voltooi de advertentie van je woning!",
  "notification.home.complete_home_first_time": "Voltooi de advertentie van je huis en ontvang {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Voeg beschikbaarheid toe aan je kalender voor het komende jaar",
  "notification.home.new_calendar_type": "Nieuwe kalender!",
  "notification.home.offline": "Publiceer je huis!",
  "notification.membership.expired": "Lidmaatschap verlopen",
  "notification.membership.lead": "Activeer je lidmaatschap en ontvang {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Voltooi je profiel",
  "notification.user_profile.motivate_incomplete": "Voltooi je profiel en ontvang {{gp}} GuestPoints",
  "refer-your-friends": "Refer your friends",
  settings: s1,
  "sign-in": "Inloggen",
  "sign-up": "Inschrijven",
  "sign-up-for-free": "Meld je gratis aan",
  "signin.modal.apple-button": "Inloggen met Apple",
  "signin.modal.facebook-button": "Meld je aan met Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, c1 = "https://www.homeexchange.com/nl/blog/", l1 = "/nl/p/homeexchangegebruiksvoorwaarden", u1 = "https://www.homeexchange.com/nl/p/gemeenschap", d1 = "https://homeexchangehelp.zendesk.com/hc/en-us", p1 = "https://forum.homeexchange.com/c/english/20", f1 = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", h1 = "https://www.homeexchange.com/nl/p/guestpoints-nl", m1 = "https://www.homeexchange.com/nl/p/pers", g1 = "https://www.homeexchange.com/p/wordsonhomeexchange", v1 = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", b1 = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", y1 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: c1,
  cgu: l1,
  community: u1,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: d1,
  forum: p1,
  guarantees: f1,
  guestpoints: h1,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: m1,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: g1,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: v1,
  values: b1
}, w1 = "Studio", _1 = "{{count}} quarto", x1 = "{{count}} quartos", $1 = "", k1 = "{{count}} cama", E1 = "{{count}} camas", S1 = "", C1 = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: w1,
  bedroomsNumbers_one: _1,
  bedroomsNumbers_other: x1,
  beds_zero: $1,
  beds_one: k1,
  beds_other: E1,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: S1,
  "privacy-policy": "Privacidade"
}, O1 = "Contacte-nos", N1 = "Perguntas frequentes", R1 = "Guarantias", A1 = "GuestPoints", I1 = "Ajuda", P1 = "Log out", T1 = "Messages", L1 = "Settings", j1 = {
  "about-the-calendar": "Calendário",
  "add-home": "Add a home",
  contact: O1,
  faq: N1,
  guarantees: R1,
  guestpoints: A1,
  help: I1,
  "how-it-works": "Como funciona?",
  "how-much-does-it-cost": "Quanto custa?",
  logout: P1,
  messages: T1,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: L1,
  "sign-in": "Iniciar sessão",
  "sign-up": "Inscreva-se",
  "sign-up-for-free": "Filie-se gratuitamente",
  "signin.modal.apple-button": "Iniciar sessão com a Apple",
  "signin.modal.facebook-button": "Iniciar sessão com o Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, D1 = "https://www.homeexchange.com/pt/blog/", z1 = "/p/general-terms-of-use", M1 = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", F1 = "https://homeexchangehelp.zendesk.com/hc/en-us", V1 = "", U1 = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", B1 = "https://www.homeexchange.com/pt/p/os-guestpoints", H1 = "https://www.homeexchange.com/pt/p/press-pt", K1 = "https://www.homeexchange.com/p/palavras-de-homeexchangers", W1 = "", q1 = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", Z1 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: D1,
  cgu: z1,
  community: M1,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: F1,
  forum: V1,
  guarantees: U1,
  guestpoints: B1,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: H1,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: K1,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: W1,
  values: q1
}, J1 = "Studio", G1 = "{{count}} sovrum", Y1 = "{{count}} sovrum", X1 = "", Q1 = "{{count}} säng", eS = "{{count}} sängar", tS = "", nS = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: J1,
  bedroomsNumbers_one: G1,
  bedroomsNumbers_other: Y1,
  beds_zero: X1,
  beds_one: Q1,
  beds_other: eS,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "",
  "global.select": "",
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: tS,
  "privacy-policy": "Sekretesspolicy"
}, oS = "Kontakta oss", rS = "FAQ", iS = "Garantier", sS = "GuestPoints", aS = "Hjälp", cS = "Log out", lS = "Messages", uS = "Settings", dS = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: oS,
  faq: rS,
  guarantees: iS,
  guestpoints: sS,
  help: aS,
  "how-it-works": "Hur fungerar det?",
  "how-much-does-it-cost": "Hur mycket kostar det?",
  logout: cS,
  messages: lS,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: uS,
  "sign-in": "Logga in",
  "sign-up": "Registrera dig",
  "sign-up-for-free": "Registrera dig gratis",
  "signin.modal.apple-button": "Logga in med Apple",
  "signin.modal.facebook-button": "Logga in med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, pS = "https://www.homeexchange.com/blog/", fS = "/p/general-terms-of-use", hS = "https://www.homeexchange.com/sv/p/natverket", mS = "https://homeexchangehelp.zendesk.com/hc/es", gS = "", vS = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", bS = "https://www.homeexchange.com/sv/p/guestpoints-sv", yS = "https://www.homeexchange.com/sv/p/press-sv", wS = "https://www.homeexchange.com/p/medlemmarna-har-ordet", _S = "", xS = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", $S = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: pS,
  cgu: fS,
  community: hS,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: mS,
  forum: gS,
  guarantees: vS,
  guestpoints: bS,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: yS,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: wS,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: _S,
  values: xS
}, kS = "en", Gp = Sx({
  fallbackLng: kS,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: Tx,
      links: t$,
      header: Bx
    },
    de: {
      common: l$,
      links: R$,
      header: b$
    },
    en: {
      common: z$,
      links: ik,
      header: q$
    },
    es: {
      common: fk,
      links: Tk,
      header: xk
    },
    fr: {
      common: Uk,
      links: lE,
      header: Yk
    },
    hr: {
      common: yE,
      links: FE,
      header: OE
    },
    it: {
      common: ZE,
      links: m0,
      header: o0
    },
    nb: {
      common: $0,
      links: H0,
      header: I0
    },
    nl: {
      common: X0,
      links: y1,
      header: a1
    },
    pt: {
      common: C1,
      links: Z1,
      header: j1
    },
    sv: {
      common: nS,
      links: $S,
      header: dS
    }
  }
});
Gp.init();
const Vc = Gp;
async function ES() {
  return $f.post("/legacy-auth/logout");
}
class Uc extends Error {
  code;
  errorData;
  constructor(t, n, o) {
    super(t), this.name = "HeError", this.code = n, this.errorData = o;
  }
}
function Yp(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: SS } = Object.prototype, { getPrototypeOf: na } = Object, { iterator: Lr, toStringTag: Xp } = Symbol, jr = /* @__PURE__ */ ((e) => (t) => {
  const n = SS.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), nt = (e) => (e = e.toLowerCase(), (t) => jr(t) === e), Dr = (e) => (t) => typeof t === e, { isArray: Sn } = Array, Wn = Dr("undefined");
function ro(e) {
  return e !== null && !Wn(e) && e.constructor !== null && !Wn(e.constructor) && Ke(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Qp = nt("ArrayBuffer");
function CS(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Qp(e.buffer), t;
}
const OS = Dr("string"), Ke = Dr("function"), ef = Dr("number"), io = (e) => e !== null && typeof e == "object", NS = (e) => e === !0 || e === !1, Bo = (e) => {
  if (jr(e) !== "object")
    return !1;
  const t = na(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Xp in e) && !(Lr in e);
}, RS = (e) => {
  if (!io(e) || ro(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, AS = nt("Date"), IS = nt("File"), PS = nt("Blob"), TS = nt("FileList"), LS = (e) => io(e) && Ke(e.pipe), jS = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ke(e.append) && ((t = jr(e)) === "formdata" || // detect form-data instance
  t === "object" && Ke(e.toString) && e.toString() === "[object FormData]"));
}, DS = nt("URLSearchParams"), [zS, MS, FS, VS] = ["ReadableStream", "Request", "Response", "Headers"].map(nt), US = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function so(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, r;
  if (typeof e != "object" && (e = [e]), Sn(e))
    for (o = 0, r = e.length; o < r; o++)
      t.call(null, e[o], o, e);
  else {
    if (ro(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let a;
    for (o = 0; o < s; o++)
      a = i[o], t.call(null, e[a], a, e);
  }
}
function tf(e, t) {
  if (ro(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, r;
  for (; o-- > 0; )
    if (r = n[o], t === r.toLowerCase())
      return r;
  return null;
}
const Dt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, nf = (e) => !Wn(e) && e !== Dt;
function Gi() {
  const { caseless: e } = nf(this) && this || {}, t = {}, n = (o, r) => {
    const i = e && tf(t, r) || r;
    Bo(t[i]) && Bo(o) ? t[i] = Gi(t[i], o) : Bo(o) ? t[i] = Gi({}, o) : Sn(o) ? t[i] = o.slice() : t[i] = o;
  };
  for (let o = 0, r = arguments.length; o < r; o++)
    arguments[o] && so(arguments[o], n);
  return t;
}
const BS = (e, t, n, { allOwnKeys: o } = {}) => (so(t, (r, i) => {
  n && Ke(r) ? e[i] = Yp(r, n) : e[i] = r;
}, { allOwnKeys: o }), e), HS = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), KS = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, WS = (e, t, n, o) => {
  let r, i, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      s = r[i], (!o || o(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = n !== !1 && na(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, qS = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, ZS = (e) => {
  if (!e) return null;
  if (Sn(e)) return e;
  let t = e.length;
  if (!ef(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, JS = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && na(Uint8Array)), GS = (e, t) => {
  const n = (e && e[Lr]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const r = o.value;
    t.call(e, r[0], r[1]);
  }
}, YS = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, XS = nt("HTMLFormElement"), QS = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, o) {
    return n.toUpperCase() + o;
  }
), Bc = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), eC = nt("RegExp"), of = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  so(n, (r, i) => {
    let s;
    (s = t(r, i, e)) !== !1 && (o[i] = s || r);
  }), Object.defineProperties(e, o);
}, tC = (e) => {
  of(e, (t, n) => {
    if (Ke(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (Ke(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, nC = (e, t) => {
  const n = {}, o = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return Sn(e) ? o(e) : o(String(e).split(t)), n;
}, oC = () => {
}, rC = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function iC(e) {
  return !!(e && Ke(e.append) && e[Xp] === "FormData" && e[Lr]);
}
const sC = (e) => {
  const t = new Array(10), n = (o, r) => {
    if (io(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (ro(o))
        return o;
      if (!("toJSON" in o)) {
        t[r] = o;
        const i = Sn(o) ? [] : {};
        return so(o, (s, a) => {
          const l = n(s, r + 1);
          !Wn(l) && (i[a] = l);
        }), t[r] = void 0, i;
      }
    }
    return o;
  };
  return n(e, 0);
}, aC = nt("AsyncFunction"), cC = (e) => e && (io(e) || Ke(e)) && Ke(e.then) && Ke(e.catch), rf = ((e, t) => e ? setImmediate : t ? ((n, o) => (Dt.addEventListener("message", ({ source: r, data: i }) => {
  r === Dt && i === n && o.length && o.shift()();
}, !1), (r) => {
  o.push(r), Dt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Ke(Dt.postMessage)
), lC = typeof queueMicrotask < "u" ? queueMicrotask.bind(Dt) : typeof process < "u" && process.nextTick || rf, uC = (e) => e != null && Ke(e[Lr]), S = {
  isArray: Sn,
  isArrayBuffer: Qp,
  isBuffer: ro,
  isFormData: jS,
  isArrayBufferView: CS,
  isString: OS,
  isNumber: ef,
  isBoolean: NS,
  isObject: io,
  isPlainObject: Bo,
  isEmptyObject: RS,
  isReadableStream: zS,
  isRequest: MS,
  isResponse: FS,
  isHeaders: VS,
  isUndefined: Wn,
  isDate: AS,
  isFile: IS,
  isBlob: PS,
  isRegExp: eC,
  isFunction: Ke,
  isStream: LS,
  isURLSearchParams: DS,
  isTypedArray: JS,
  isFileList: TS,
  forEach: so,
  merge: Gi,
  extend: BS,
  trim: US,
  stripBOM: HS,
  inherits: KS,
  toFlatObject: WS,
  kindOf: jr,
  kindOfTest: nt,
  endsWith: qS,
  toArray: ZS,
  forEachEntry: GS,
  matchAll: YS,
  isHTMLForm: XS,
  hasOwnProperty: Bc,
  hasOwnProp: Bc,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: of,
  freezeMethods: tC,
  toObjectSet: nC,
  toCamelCase: QS,
  noop: oC,
  toFiniteNumber: rC,
  findKey: tf,
  global: Dt,
  isContextDefined: nf,
  isSpecCompliantForm: iC,
  toJSONObject: sC,
  isAsyncFn: aC,
  isThenable: cC,
  setImmediate: rf,
  asap: lC,
  isIterable: uC
};
function oe(e, t, n, o, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), r && (this.response = r, this.status = r.status ? r.status : null);
}
S.inherits(oe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: S.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const sf = oe.prototype, af = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  af[e] = { value: e };
});
Object.defineProperties(oe, af);
Object.defineProperty(sf, "isAxiosError", { value: !0 });
oe.from = (e, t, n, o, r, i) => {
  const s = Object.create(sf);
  return S.toFlatObject(e, s, function(a) {
    return a !== Error.prototype;
  }, (a) => a !== "isAxiosError"), oe.call(s, e.message, t, n, o, r), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const dC = null;
function Yi(e) {
  return S.isPlainObject(e) || S.isArray(e);
}
function cf(e) {
  return S.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Hc(e, t, n) {
  return e ? e.concat(t).map(function(o, r) {
    return o = cf(o), !n && r ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function pC(e) {
  return S.isArray(e) && !e.some(Yi);
}
const fC = S.toFlatObject(S, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function zr(e, t, n) {
  if (!S.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = S.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, b) {
    return !S.isUndefined(b[h]);
  });
  const o = n.metaTokens, r = n.visitor || c, i = n.dots, s = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && S.isSpecCompliantForm(t);
  if (!S.isFunction(r))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null) return "";
    if (S.isDate(h))
      return h.toISOString();
    if (S.isBoolean(h))
      return h.toString();
    if (!a && S.isBlob(h))
      throw new oe("Blob is not supported. Use a Buffer instead.");
    return S.isArrayBuffer(h) || S.isTypedArray(h) ? a && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, b, p) {
    let y = h;
    if (h && !p && typeof h == "object") {
      if (S.endsWith(b, "{}"))
        b = o ? b : b.slice(0, -2), h = JSON.stringify(h);
      else if (S.isArray(h) && pC(h) || (S.isFileList(h) || S.endsWith(b, "[]")) && (y = S.toArray(h)))
        return b = cf(b), y.forEach(function($, v) {
          !(S.isUndefined($) || $ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Hc([b], v, i) : s === null ? b : b + "[]",
            l($)
          );
        }), !1;
    }
    return Yi(h) ? !0 : (t.append(Hc(p, b, i), l(h)), !1);
  }
  const u = [], d = Object.assign(fC, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Yi
  });
  function f(h, b) {
    if (!S.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      u.push(h), S.forEach(h, function(p, y) {
        (!(S.isUndefined(p) || p === null) && r.call(
          t,
          p,
          S.isString(y) ? y.trim() : y,
          b,
          d
        )) === !0 && f(p, b ? b.concat(y) : [y]);
      }), u.pop();
    }
  }
  if (!S.isObject(e))
    throw new TypeError("data must be an object");
  return f(e), t;
}
function Kc(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function oa(e, t) {
  this._pairs = [], e && zr(e, this, t);
}
const lf = oa.prototype;
lf.append = function(e, t) {
  this._pairs.push([e, t]);
};
lf.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, Kc);
  } : Kc;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function hC(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function uf(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || hC;
  S.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = S.isURLSearchParams(t) ? t.toString() : new oa(t, n).toString(o), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Wc {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    S.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const df = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, mC = typeof URLSearchParams < "u" ? URLSearchParams : oa, gC = typeof FormData < "u" ? FormData : null, vC = typeof Blob < "u" ? Blob : null, bC = {
  isBrowser: !0,
  classes: {
    URLSearchParams: mC,
    FormData: gC,
    Blob: vC
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ra = typeof window < "u" && typeof document < "u", Xi = typeof navigator == "object" && navigator || void 0, yC = ra && (!Xi || ["ReactNative", "NativeScript", "NS"].indexOf(Xi.product) < 0), wC = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", _C = ra && window.location.href || "http://localhost", xC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ra,
  hasStandardBrowserEnv: yC,
  hasStandardBrowserWebWorkerEnv: wC,
  navigator: Xi,
  origin: _C
}, Symbol.toStringTag, { value: "Module" })), Fe = {
  ...xC,
  ...bC
};
function $C(e, t) {
  return zr(e, new Fe.classes.URLSearchParams(), {
    visitor: function(n, o, r, i) {
      return Fe.isNode && S.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function kC(e) {
  return S.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function EC(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const r = n.length;
  let i;
  for (o = 0; o < r; o++)
    i = n[o], t[i] = e[i];
  return t;
}
function pf(e) {
  function t(n, o, r, i) {
    let s = n[i++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), l = i >= n.length;
    return s = !s && S.isArray(r) ? r.length : s, l ? (S.hasOwnProp(r, s) ? r[s] = [r[s], o] : r[s] = o, !a) : ((!r[s] || !S.isObject(r[s])) && (r[s] = []), t(n, o, r[s], i) && S.isArray(r[s]) && (r[s] = EC(r[s])), !a);
  }
  if (S.isFormData(e) && S.isFunction(e.entries)) {
    const n = {};
    return S.forEachEntry(e, (o, r) => {
      t(kC(o), r, n, 0);
    }), n;
  }
  return null;
}
function SC(e, t, n) {
  if (S.isString(e))
    try {
      return (t || JSON.parse)(e), S.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const ao = {
  transitional: df,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", o = n.indexOf("application/json") > -1, r = S.isObject(e);
    if (r && S.isHTMLForm(e) && (e = new FormData(e)), S.isFormData(e))
      return o ? JSON.stringify(pf(e)) : e;
    if (S.isArrayBuffer(e) || S.isBuffer(e) || S.isStream(e) || S.isFile(e) || S.isBlob(e) || S.isReadableStream(e))
      return e;
    if (S.isArrayBufferView(e))
      return e.buffer;
    if (S.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (r) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return $C(e, this.formSerializer).toString();
      if ((i = S.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return zr(
          i ? { "files[]": e } : e,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return r || o ? (t.setContentType("application/json", !1), SC(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || ao.transitional, n = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (S.isResponse(e) || S.isReadableStream(e))
      return e;
    if (e && S.isString(e) && (n && !this.responseType || o)) {
      const r = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (r)
          throw i.name === "SyntaxError" ? oe.from(i, oe.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Fe.classes.FormData,
    Blob: Fe.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
S.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ao.headers[e] = {};
});
const CC = S.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), OC = (e) => {
  const t = {};
  let n, o, r;
  return e && e.split(`
`).forEach(function(i) {
    r = i.indexOf(":"), n = i.substring(0, r).trim().toLowerCase(), o = i.substring(r + 1).trim(), !(!n || t[n] && CC[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, qc = Symbol("internals");
function Ln(e) {
  return e && String(e).trim().toLowerCase();
}
function Ho(e) {
  return e === !1 || e == null ? e : S.isArray(e) ? e.map(Ho) : String(e);
}
function NC(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const RC = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function hi(e, t, n, o, r) {
  if (S.isFunction(o))
    return o.call(this, t, n);
  if (r && (t = n), !!S.isString(t)) {
    if (S.isString(o))
      return t.indexOf(o) !== -1;
    if (S.isRegExp(o))
      return o.test(t);
  }
}
function AC(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function IC(e, t) {
  const n = S.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(r, i, s) {
        return this[o].call(this, t, r, i, s);
      },
      configurable: !0
    });
  });
}
let We = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const o = this;
    function r(s, a, l) {
      const c = Ln(a);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = S.findKey(o, c);
      (!u || o[u] === void 0 || l === !0 || l === void 0 && o[u] !== !1) && (o[u || a] = Ho(s));
    }
    const i = (s, a) => S.forEach(s, (l, c) => r(l, c, a));
    if (S.isPlainObject(e) || e instanceof this.constructor)
      i(e, t);
    else if (S.isString(e) && (e = e.trim()) && !RC(e))
      i(OC(e), t);
    else if (S.isObject(e) && S.isIterable(e)) {
      let s = {}, a, l;
      for (const c of e) {
        if (!S.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        s[l = c[0]] = (a = s[l]) ? S.isArray(a) ? [...a, c[1]] : [a, c[1]] : c[1];
      }
      i(s, t);
    } else
      e != null && r(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = Ln(e), e) {
      const n = S.findKey(this, e);
      if (n) {
        const o = this[n];
        if (!t)
          return o;
        if (t === !0)
          return NC(o);
        if (S.isFunction(t))
          return t.call(this, o, n);
        if (S.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Ln(e), e) {
      const n = S.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || hi(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let o = !1;
    function r(i) {
      if (i = Ln(i), i) {
        const s = S.findKey(n, i);
        s && (!t || hi(n, n[s], s, t)) && (delete n[s], o = !0);
      }
    }
    return S.isArray(e) ? e.forEach(r) : r(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, o = !1;
    for (; n--; ) {
      const r = t[n];
      (!e || hi(this, this[r], r, e, !0)) && (delete this[r], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, n = {};
    return S.forEach(this, (o, r) => {
      const i = S.findKey(n, r);
      if (i) {
        t[i] = Ho(o), delete t[r];
        return;
      }
      const s = e ? AC(r) : String(r).trim();
      s !== r && delete t[r], t[s] = Ho(o), n[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return S.forEach(this, (n, o) => {
      n != null && n !== !1 && (t[o] = e && S.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((o) => n.set(o)), n;
  }
  static accessor(e) {
    const t = (this[qc] = this[qc] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function o(r) {
      const i = Ln(r);
      t[i] || (IC(n, r), t[i] = !0);
    }
    return S.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
We.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
S.reduceDescriptors(We.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
S.freezeMethods(We);
function mi(e, t) {
  const n = this || ao, o = t || n, r = We.from(o.headers);
  let i = o.data;
  return S.forEach(e, function(s) {
    i = s.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function ff(e) {
  return !!(e && e.__CANCEL__);
}
function Cn(e, t, n) {
  oe.call(this, e ?? "canceled", oe.ERR_CANCELED, t, n), this.name = "CanceledError";
}
S.inherits(Cn, oe, {
  __CANCEL__: !0
});
function hf(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new oe(
    "Request failed with status code " + n.status,
    [oe.ERR_BAD_REQUEST, oe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function PC(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function TC(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let r = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const l = Date.now(), c = o[i];
    s || (s = l), n[r] = a, o[r] = l;
    let u = i, d = 0;
    for (; u !== r; )
      d += n[u++], u = u % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), l - s < t)
      return;
    const f = c && l - c;
    return f ? Math.round(d * 1e3 / f) : void 0;
  };
}
function LC(e, t) {
  let n = 0, o = 1e3 / t, r, i;
  const s = (a, l = Date.now()) => {
    n = l, r = null, i && (clearTimeout(i), i = null), e(...a);
  };
  return [(...a) => {
    const l = Date.now(), c = l - n;
    c >= o ? s(a, l) : (r = a, i || (i = setTimeout(() => {
      i = null, s(r);
    }, o - c)));
  }, () => r && s(r)];
}
const dr = (e, t, n = 3) => {
  let o = 0;
  const r = TC(50, 250);
  return LC((i) => {
    const s = i.loaded, a = i.lengthComputable ? i.total : void 0, l = s - o, c = r(l), u = s <= a;
    o = s;
    const d = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && a && u ? (a - s) / c : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Zc = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, Jc = (e) => (...t) => S.asap(() => e(...t)), jC = Fe.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Fe.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Fe.origin),
  Fe.navigator && /(msie|trident)/i.test(Fe.navigator.userAgent)
) : () => !0, DC = Fe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, r, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      S.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), S.isString(o) && s.push("path=" + o), S.isString(r) && s.push("domain=" + r), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function zC(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function MC(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function mf(e, t, n) {
  let o = !zC(t);
  return e && (o || n == !1) ? MC(e, t) : t;
}
const Gc = (e) => e instanceof We ? { ...e } : e;
function Kt(e, t) {
  t = t || {};
  const n = {};
  function o(c, u, d, f) {
    return S.isPlainObject(c) && S.isPlainObject(u) ? S.merge.call({ caseless: f }, c, u) : S.isPlainObject(u) ? S.merge({}, u) : S.isArray(u) ? u.slice() : u;
  }
  function r(c, u, d, f) {
    if (S.isUndefined(u)) {
      if (!S.isUndefined(c))
        return o(void 0, c, d, f);
    } else return o(c, u, d, f);
  }
  function i(c, u) {
    if (!S.isUndefined(u))
      return o(void 0, u);
  }
  function s(c, u) {
    if (S.isUndefined(u)) {
      if (!S.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function a(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (c, u, d) => r(Gc(c), Gc(u), d, !0)
  };
  return S.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || r, d = u(e[c], t[c], c);
    S.isUndefined(d) && u !== a || (n[c] = d);
  }), n;
}
const gf = (e) => {
  const t = Kt({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: r, xsrfCookieName: i, headers: s, auth: a } = t;
  t.headers = s = We.from(s), t.url = uf(mf(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (S.isFormData(n)) {
    if (Fe.hasStandardBrowserEnv || Fe.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Fe.hasStandardBrowserEnv && (o && S.isFunction(o) && (o = o(t)), o || o !== !1 && jC(t.url))) {
    const c = r && i && DC.read(i);
    c && s.set(r, c);
  }
  return t;
}, FC = typeof XMLHttpRequest < "u", VC = FC && function(e) {
  return new Promise(function(t, n) {
    const o = gf(e);
    let r = o.data;
    const i = We.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: a, onDownloadProgress: l } = o, c, u, d, f, h;
    function b() {
      f && f(), h && h(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function y() {
      if (!p)
        return;
      const v = We.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), w = {
        data: !s || s === "text" || s === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: v,
        config: e,
        request: p
      };
      hf(function(_) {
        t(_), b();
      }, function(_) {
        n(_), b();
      }, w), p = null;
    }
    "onloadend" in p ? p.onloadend = y : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, p.onabort = function() {
      p && (n(new oe("Request aborted", oe.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      n(new oe("Network Error", oe.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let v = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const w = o.transitional || df;
      o.timeoutErrorMessage && (v = o.timeoutErrorMessage), n(new oe(
        v,
        w.clarifyTimeoutError ? oe.ETIMEDOUT : oe.ECONNABORTED,
        e,
        p
      )), p = null;
    }, r === void 0 && i.setContentType(null), "setRequestHeader" in p && S.forEach(i.toJSON(), function(v, w) {
      p.setRequestHeader(w, v);
    }), S.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), s && s !== "json" && (p.responseType = o.responseType), l && ([d, h] = dr(l, !0), p.addEventListener("progress", d)), a && p.upload && ([u, f] = dr(a), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", f)), (o.cancelToken || o.signal) && (c = (v) => {
      p && (n(!v || v.type ? new Cn(null, e, p) : v), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const $ = PC(o.url);
    if ($ && Fe.protocols.indexOf($) === -1) {
      n(new oe("Unsupported protocol " + $ + ":", oe.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(r || null);
  });
}, UC = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), r;
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof oe ? u : new Cn(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new oe(`timeout ${t} of ms exceeded`, oe.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = o;
    return l.unsubscribe = () => S.asap(a), l;
  }
}, BC = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let o = 0, r;
  for (; o < n; )
    r = o + t, yield e.slice(o, r), o = r;
}, HC = async function* (e, t) {
  for await (const n of KC(e))
    yield* BC(n, t);
}, KC = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Yc = (e, t, n, o) => {
  const r = HC(e, t);
  let i = 0, s, a = (l) => {
    s || (s = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await r.next();
        if (c) {
          a(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let f = i += d;
          n(f);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(l) {
      return a(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Mr = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", vf = Mr && typeof ReadableStream == "function", WC = Mr && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), bf = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, qC = vf && bf(() => {
  let e = !1;
  const t = new Request(Fe.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Xc = 64 * 1024, Qi = vf && bf(() => S.isReadableStream(new Response("").body)), pr = {
  stream: Qi && ((e) => e.body)
};
Mr && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !pr[t] && (pr[t] = S.isFunction(e[t]) ? (n) => n[t]() : (n, o) => {
      throw new oe(`Response type '${t}' is not supported`, oe.ERR_NOT_SUPPORT, o);
    });
  });
})(new Response());
const ZC = async (e) => {
  if (e == null)
    return 0;
  if (S.isBlob(e))
    return e.size;
  if (S.isSpecCompliantForm(e))
    return (await new Request(Fe.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (S.isArrayBufferView(e) || S.isArrayBuffer(e))
    return e.byteLength;
  if (S.isURLSearchParams(e) && (e = e + ""), S.isString(e))
    return (await WC(e)).byteLength;
}, JC = async (e, t) => S.toFiniteNumber(e.getContentLength()) ?? ZC(t), GC = Mr && (async (e) => {
  let {
    url: t,
    method: n,
    data: o,
    signal: r,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = gf(e);
  c = c ? (c + "").toLowerCase() : "text";
  let h = UC([r, i && i.toAbortSignal()], s), b;
  const p = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let y;
  try {
    if (l && qC && n !== "get" && n !== "head" && (y = await JC(u, o)) !== 0) {
      let x = new Request(t, {
        method: "POST",
        body: o,
        duplex: "half"
      }), C;
      if (S.isFormData(o) && (C = x.headers.get("content-type")) && u.setContentType(C), x.body) {
        const [k, R] = Zc(
          y,
          dr(Jc(l))
        );
        o = Yc(x.body, Xc, k, R);
      }
    }
    S.isString(d) || (d = d ? "include" : "omit");
    const $ = "credentials" in Request.prototype;
    b = new Request(t, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: o,
      duplex: "half",
      credentials: $ ? d : void 0
    });
    let v = await fetch(b, f);
    const w = Qi && (c === "stream" || c === "response");
    if (Qi && (a || w && p)) {
      const x = {};
      ["status", "statusText", "headers"].forEach((N) => {
        x[N] = v[N];
      });
      const C = S.toFiniteNumber(v.headers.get("content-length")), [k, R] = a && Zc(
        C,
        dr(Jc(a), !0)
      ) || [];
      v = new Response(
        Yc(v.body, Xc, k, () => {
          R && R(), p && p();
        }),
        x
      );
    }
    c = c || "text";
    let _ = await pr[S.findKey(pr, c) || "text"](v, e);
    return !w && p && p(), await new Promise((x, C) => {
      hf(x, C, {
        data: _,
        headers: We.from(v.headers),
        status: v.status,
        statusText: v.statusText,
        config: e,
        request: b
      });
    });
  } catch ($) {
    throw p && p(), $ && $.name === "TypeError" && /Load failed|fetch/i.test($.message) ? Object.assign(
      new oe("Network Error", oe.ERR_NETWORK, e, b),
      {
        cause: $.cause || $
      }
    ) : oe.from($, $ && $.code, e, b);
  }
}), es = {
  http: dC,
  xhr: VC,
  fetch: GC
};
S.forEach(es, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Qc = (e) => `- ${e}`, YC = (e) => S.isFunction(e) || e === null || e === !1, yf = {
  getAdapter: (e) => {
    e = S.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, o;
    const r = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (o = n, !YC(n) && (o = es[(s = String(n)).toLowerCase()], o === void 0))
        throw new oe(`Unknown adapter '${s}'`);
      if (o)
        break;
      r[s || "#" + i] = o;
    }
    if (!o) {
      const i = Object.entries(r).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(Qc).join(`
`) : " " + Qc(i[0]) : "as no adapter specified";
      throw new oe(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: es
};
function gi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Cn(null, e);
}
function el(e) {
  return gi(e), e.headers = We.from(e.headers), e.data = mi.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), yf.getAdapter(e.adapter || ao.adapter)(e).then(function(t) {
    return gi(e), t.data = mi.call(
      e,
      e.transformResponse,
      t
    ), t.headers = We.from(t.headers), t;
  }, function(t) {
    return ff(t) || (gi(e), t && t.response && (t.response.data = mi.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = We.from(t.response.headers))), Promise.reject(t);
  });
}
const wf = "1.11.0", Fr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Fr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const tl = {};
Fr.transitional = function(e, t, n) {
  function o(r, i) {
    return "[Axios v" + wf + "] Transitional option '" + r + "'" + i + (n ? ". " + n : "");
  }
  return (r, i, s) => {
    if (e === !1)
      throw new oe(
        o(i, " has been removed" + (t ? " in " + t : "")),
        oe.ERR_DEPRECATED
      );
    return t && !tl[i] && (tl[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(r, i, s) : !0;
  };
};
Fr.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function XC(e, t, n) {
  if (typeof e != "object")
    throw new oe("options must be an object", oe.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let r = o.length;
  for (; r-- > 0; ) {
    const i = o[r], s = t[i];
    if (s) {
      const a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new oe("option " + i + " must be " + l, oe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new oe("Unknown option " + i, oe.ERR_BAD_OPTION);
  }
}
const Ko = {
  assertOptions: XC,
  validators: Fr
}, ct = Ko.validators;
let Vt = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Wc(),
      response: new Wc()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const r = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? r && !String(n.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + r) : n.stack = r;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Kt(this.defaults, t);
    const { transitional: n, paramsSerializer: o, headers: r } = t;
    n !== void 0 && Ko.assertOptions(n, {
      silentJSONParsing: ct.transitional(ct.boolean),
      forcedJSONParsing: ct.transitional(ct.boolean),
      clarifyTimeoutError: ct.transitional(ct.boolean)
    }, !1), o != null && (S.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Ko.assertOptions(o, {
      encode: ct.function,
      serialize: ct.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Ko.assertOptions(t, {
      baseUrl: ct.spelling("baseURL"),
      withXsrfToken: ct.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = r && S.merge(
      r.common,
      r[t.method]
    );
    r && S.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete r[h];
      }
    ), t.headers = We.concat(i, r);
    const s = [];
    let a = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(t) === !1 || (a = a && h.synchronous, s.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let c, u = 0, d;
    if (!a) {
      const h = [el.bind(this), void 0];
      for (h.unshift(...s), h.push(...l), d = h.length, c = Promise.resolve(t); u < d; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    d = s.length;
    let f = t;
    for (u = 0; u < d; ) {
      const h = s[u++], b = s[u++];
      try {
        f = h(f);
      } catch (p) {
        b.call(this, p);
        break;
      }
    }
    try {
      c = el.call(this, f);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = Kt(this.defaults, e);
    const t = mf(e.baseURL, e.url, e.allowAbsoluteUrls);
    return uf(t, e.params, e.paramsSerializer);
  }
};
S.forEach(["delete", "get", "head", "options"], function(e) {
  Vt.prototype[e] = function(t, n) {
    return this.request(Kt(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
S.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, r, i) {
      return this.request(Kt(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: r
      }));
    };
  }
  Vt.prototype[e] = t(), Vt.prototype[e + "Form"] = t(!0);
});
let QC = class _f {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(r) {
      n = r;
    });
    const o = this;
    this.promise.then((r) => {
      if (!o._listeners) return;
      let i = o._listeners.length;
      for (; i-- > 0; )
        o._listeners[i](r);
      o._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const s = new Promise((a) => {
        o.subscribe(a), i = a;
      }).then(r);
      return s.cancel = function() {
        o.unsubscribe(i);
      }, s;
    }, t(function(r, i, s) {
      o.reason || (o.reason = new Cn(r, i, s), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new _f(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function eO(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function tO(e) {
  return S.isObject(e) && e.isAxiosError === !0;
}
const ts = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ts).forEach(([e, t]) => {
  ts[t] = e;
});
function xf(e) {
  const t = new Vt(e), n = Yp(Vt.prototype.request, t);
  return S.extend(n, Vt.prototype, t, { allOwnKeys: !0 }), S.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return xf(Kt(e, o));
  }, n;
}
const Oe = xf(ao);
Oe.Axios = Vt;
Oe.CanceledError = Cn;
Oe.CancelToken = QC;
Oe.isCancel = ff;
Oe.VERSION = wf;
Oe.toFormData = zr;
Oe.AxiosError = oe;
Oe.Cancel = Oe.CanceledError;
Oe.all = function(e) {
  return Promise.all(e);
};
Oe.spread = eO;
Oe.isAxiosError = tO;
Oe.mergeConfig = Kt;
Oe.AxiosHeaders = We;
Oe.formToJSON = (e) => pf(S.isHTMLForm(e) ? new FormData(e) : e);
Oe.getAdapter = yf.getAdapter;
Oe.HttpStatusCode = ts;
Oe.default = Oe;
const {
  Axios: xL,
  AxiosError: nO,
  CanceledError: $L,
  isCancel: kL,
  CancelToken: EL,
  VERSION: SL,
  all: CL,
  Cancel: OL,
  isAxiosError: NL,
  spread: RL,
  toFormData: AL,
  AxiosHeaders: IL,
  HttpStatusCode: PL,
  formToJSON: TL,
  getAdapter: LL,
  mergeConfig: jL
} = Oe, oO = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class rO {
  baseUrl;
  headers;
  constructor(t, n = {}) {
    this.baseUrl = t, this.headers = n?.headers || {};
  }
  async fetch(t, n = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const r = oO.test(t) ? t : `${this.baseUrl}${t}`;
    r.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Oe(r, {
        ...o,
        method: n,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (i) {
      throw i instanceof nO ? new Uc(`${i.code} - ${i.status} - ${r}`, i.status, i.response?.data) : new Uc("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
}
let $f;
function iO(e, t = {}) {
  $f = new rO(e, t);
}
Jt();
function kf(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = kf(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function pt() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = kf(e)) && (o && (o += " "), o += t);
  return o;
}
const sO = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], aO = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, cO = sO.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: aO[e]
})), lO = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, uO = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function dO(e = 0) {
  const t = [];
  for (let n = 0; n < e; n++)
    t[n] = `path${n + 1}`;
  return t.map((n) => /* @__PURE__ */ m("span", { className: n }, n));
}
const fr = At(
  ({ name: e, size: t = "medium", color: n = "base", className: o = "", ...r }, i) => {
    const s = cO.find((l) => l.name === e), a = pt("icon", `ds-${s?.class}`, uO[t], lO[n], o);
    return /* @__PURE__ */ m("i", { className: a, ...r, ref: i, children: dO(s?.paths) });
  }
);
fr.displayName = "Icon";
const pO = "_loader_1ksyv_29", fO = "_circle_1ksyv_41", cn = {
  loader: pO,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: fO,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, hO = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, mO = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function gO({ onDark: e, size: t = "medium", color: n = "primary", className: o }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      className: pt(
        cn.loader,
        cn[hO[t]],
        cn[mO[n]],
        e && cn["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ m("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ m("circle", { className: cn.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ P(
          "circle",
          {
            className: cn["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ m("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ m(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const vO = "_button_z1os6_29", bO = "_disabled_z1os6_43", yO = "_loader_z1os6_263", _t = {
  button: vO,
  disabled: bO,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: yO,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, wO = At(
  ({
    text: e,
    color: t = "primary",
    size: n = "medium",
    isFullWidth: o = !1,
    icon: r,
    iconPosition: i = "left",
    isLoading: s = !1,
    iconSize: a = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...f
  }, h) => {
    const b = pt(
      _t.button,
      _t[_O[t]],
      _t[xO[n]],
      o && _t["is-full-width"],
      c && _t.disabled,
      i === "right" && _t["has-icon-right"],
      l && _t["is-contrasted"],
      s && _t["is-loading"],
      u
    ), p = /* @__PURE__ */ P(ze, { children: [
      s && /* @__PURE__ */ m(gO, { className: _t.loader, onDark: !0, size: "small" }),
      r && i === "left" && /* @__PURE__ */ m(fr, { color: "inherit", size: a, name: r }),
      d ?? e,
      r && i === "right" && /* @__PURE__ */ m(fr, { color: "inherit", size: a, name: r })
    ] });
    if ($O(f))
      return /* @__PURE__ */ m(
        "a",
        {
          ...f,
          href: c ? void 0 : f.href,
          className: b,
          target: f.target,
          ref: h,
          children: p
        }
      );
    if (kO(f))
      return /* @__PURE__ */ m(
        "button",
        {
          disabled: s || c,
          ...f,
          className: b,
          ref: h,
          children: p
        }
      );
  }
);
wO.displayName = "Button";
const _O = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, xO = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function $O(e) {
  return "href" in e && typeof e.href == "string";
}
function kO(e) {
  return !("href" in e);
}
const EO = 0;
function SO(e, t, n, o) {
  const [r, i] = De(!1), s = r ? e : t, [a, l] = De(s ? s.length : EO), [c, u] = De(!1);
  return {
    valueCounter: a,
    isOnBlur: c,
    handleBlur: () => {
      u(!0), o && o();
    },
    handleChange: (d) => {
      i(!0), l(d.target.value.length), n && n(d), u(!1);
    }
  };
}
const nl = {
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, vi = {
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
}, CO = "_input_1cutg_29", OO = "_filled_1cutg_47", NO = "_error_1cutg_150", RO = "_counter_1cutg_170", qe = {
  input: CO,
  "group-label": "_group-label_1cutg_29",
  filled: OO,
  "is-error": "_is-error_1cutg_50",
  "is-success": "_is-success_1cutg_53",
  "is-warning": "_is-warning_1cutg_56",
  "helper-text": "_helper-text_1cutg_59",
  "is-disabled": "_is-disabled_1cutg_86",
  "is-full-width": "_is-full-width_1cutg_101",
  "container-counter-icon": "_container-counter-icon_1cutg_144",
  error: NO,
  "container-icon": "_container-icon_1cutg_153",
  counter: RO,
  "dialog-overlay-show": "_dialog-overlay-show_1cutg_1",
  "dialog-content-show": "_dialog-content-show_1cutg_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1cutg_1"
}, AO = At(
  ({
    className: e,
    type: t = "text",
    value: n,
    message: o,
    status: r,
    placeholder: i,
    onChange: s,
    onBlur: a,
    disabled: l,
    label: c,
    helperText: u,
    name: d,
    isFullWidth: f,
    defaultValue: h,
    id: b,
    optionalMessage: p,
    maxLength: y,
    ...$
  }, v) => {
    const {
      valueCounter: w,
      handleBlur: _,
      handleChange: x
    } = SO(
      n?.toString(),
      h?.toString(),
      s,
      a ? () => a({}) : void 0
    ), C = pt(
      qe.input,
      r && qe[vi[r]],
      l && qe["is-disabled"],
      f && qe["is-full-width"],
      e
    );
    return /* @__PURE__ */ P("div", { className: C, children: [
      /* @__PURE__ */ P("div", { className: qe["group-label"], children: [
        /* @__PURE__ */ P("div", { children: [
          c && /* @__PURE__ */ m("label", { className: pt(r && qe[r]), children: c }),
          p && /* @__PURE__ */ m("span", { children: p })
        ] }),
        u && /* @__PURE__ */ m("div", { className: qe["helper-text"], children: u })
      ] }),
      /* @__PURE__ */ m(
        "input",
        {
          id: b,
          ref: v,
          value: n,
          className: pt(r && !l && qe[vi[r]]),
          type: t,
          placeholder: i,
          onChange: x,
          onBlur: _,
          name: d,
          defaultValue: h,
          "aria-label": c,
          disabled: l,
          ...$
        }
      ),
      (o && r && !l || y) && /* @__PURE__ */ P("div", { className: qe["container-counter-icon"], children: [
        o && r && !l && /* @__PURE__ */ P("div", { className: qe["container-icon"], children: [
          /* @__PURE__ */ m(fr, { name: nl[r].name, size: "medium", color: nl[r].color }),
          /* @__PURE__ */ m("span", { className: qe[vi[r]], children: o })
        ] }),
        y && /* @__PURE__ */ P("div", { className: pt(qe.counter, w > y && qe.error), children: [
          w,
          "/",
          y
        ] })
      ] })
    ] });
  }
);
AO.displayName = "Input";
const IO = "_container_1iybi_29", PO = "_message_1iybi_33", TO = "_error_1iybi_39", LO = "_disabled_1iybi_49", xt = {
  container: IO,
  message: PO,
  error: TO,
  "input-container": "_input-container_1iybi_43",
  disabled: LO,
  "checkbox-input": "_checkbox-input_1iybi_52",
  "label-container": "_label-container_1iybi_99"
}, jO = At(
  ({ label: e, value: t, onChange: n, name: o, message: r, hasError: i, disabled: s, checked: a }, l) => {
    const c = pt(xt["checkbox-input"], i && xt.error, s && xt.disabled);
    return /* @__PURE__ */ P("div", { className: xt.container, children: [
      /* @__PURE__ */ P("label", { className: pt(xt["input-container"], s && xt.disabled), children: [
        /* @__PURE__ */ m(
          "input",
          {
            type: "checkbox",
            className: c,
            name: o,
            value: t,
            onChange: n,
            disabled: s,
            checked: a,
            ref: l
          }
        ),
        /* @__PURE__ */ m("div", { className: xt["label-container"], children: e })
      ] }),
      r && /* @__PURE__ */ m("span", { className: pt(xt.message, i && xt.error), children: r })
    ] });
  }
);
jO.displayName = "Checkbox";
function Rt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ns = globalThis?.document ? g.useLayoutEffect : () => {
};
function ol(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ef(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const i = ol(r, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const i = o[r];
          typeof i == "function" ? i() : ol(e[r], null);
        }
      };
  };
}
function Qt(...e) {
  return g.useCallback(Ef(...e), e);
}
function DO(e, t) {
  const n = g.createContext(t), o = (i) => {
    const { children: s, ...a } = i, l = g.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ m(n.Provider, { value: l, children: s });
  };
  o.displayName = e + "Provider";
  function r(i) {
    const s = g.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function zO(e, t = []) {
  let n = [];
  function o(i, s) {
    const a = g.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      const { scope: f, children: h, ...b } = d, p = f?.[e]?.[l] || a, y = g.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ m(p.Provider, { value: y, children: h });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      const h = f?.[e]?.[l] || a, b = g.useContext(h);
      if (b) return b;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const r = () => {
    const i = n.map((s) => g.createContext(s));
    return function(s) {
      const a = s?.[e] || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: a } }),
        [s, a]
      );
    };
  };
  return r.scopeName = e, [o, MO(r, ...t)];
}
function MO(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(r) {
      const i = o.reduce((s, { useScope: a, scopeName: l }) => {
        const c = a(r)[`__scope${l}`];
        return { ...s, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function Sf(e) {
  const t = /* @__PURE__ */ FO(e), n = g.forwardRef((o, r) => {
    const { children: i, ...s } = o, a = g.Children.toArray(i), l = a.find(UO);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ m(t, { ...s, ref: r, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ m(t, { ...s, ref: r, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function FO(e) {
  const t = g.forwardRef((n, o) => {
    const { children: r, ...i } = n;
    if (g.isValidElement(r)) {
      const s = HO(r), a = BO(i, r.props);
      return r.type !== g.Fragment && (a.ref = o ? Ef(o, s) : s), g.cloneElement(r, a);
    }
    return g.Children.count(r) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var VO = Symbol("radix.slottable");
function UO(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === VO;
}
function BO(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...s) => {
      const a = i(...s);
      return r(...s), a;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...i } : o === "className" && (n[o] = [r, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function HO(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var KO = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], mt = KO.reduce((e, t) => {
  const n = /* @__PURE__ */ Sf(`Primitive.${t}`), o = g.forwardRef((r, i) => {
    const { asChild: s, ...a } = r, l = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(l, { ...a, ref: i });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function WO(e, t) {
  e && Gl.flushSync(() => e.dispatchEvent(t));
}
function qO(e, t) {
  return g.useReducer((n, o) => t[n][o] ?? n, e);
}
var ia = (e) => {
  const { present: t, children: n } = e, o = ZO(t), r = typeof n == "function" ? n({ present: o.isPresent }) : g.Children.only(n), i = Qt(o.ref, JO(r));
  return typeof n == "function" || o.isPresent ? g.cloneElement(r, { ref: i }) : null;
};
ia.displayName = "Presence";
function ZO(e) {
  const [t, n] = g.useState(), o = g.useRef(null), r = g.useRef(e), i = g.useRef("none"), s = e ? "mounted" : "unmounted", [a, l] = qO(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = ko(o.current);
    i.current = a === "mounted" ? c : "none";
  }, [a]), ns(() => {
    const c = o.current, u = r.current;
    if (u !== e) {
      const d = i.current, f = ko(c);
      e ? l("MOUNT") : f === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== f ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), ns(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const b = ko(o.current).includes(h.animationName);
        if (h.target === t && b && (l("ANIMATION_END"), !r.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = ko(o.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function ko(e) {
  return e?.animationName || "none";
}
function JO(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function qn(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...n) => t.current?.(...n), []);
}
function GO(e, t = globalThis?.document) {
  const n = qn(e);
  g.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var YO = "DismissableLayer", os = "dismissableLayer.update", XO = "dismissableLayer.pointerDownOutside", QO = "dismissableLayer.focusOutside", rl, Cf = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Of = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = e, c = g.useContext(Cf), [u, d] = g.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, h] = g.useState({}), b = Qt(t, (k) => d(k)), p = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), $ = p.indexOf(y), v = u ? p.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, _ = v >= $, x = nN((k) => {
      const R = k.target, N = [...c.branches].some((j) => j.contains(R));
      !_ || N || (r?.(k), s?.(k), k.defaultPrevented || a?.());
    }, f), C = oN((k) => {
      const R = k.target;
      [...c.branches].some((N) => N.contains(R)) || (i?.(k), s?.(k), k.defaultPrevented || a?.());
    }, f);
    return GO((k) => {
      v === c.layers.size - 1 && (o?.(k), !k.defaultPrevented && a && (k.preventDefault(), a()));
    }, f), g.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (rl = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), il(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = rl);
        };
    }, [u, f, n, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), il());
    }, [u, c]), g.useEffect(() => {
      const k = () => h({});
      return document.addEventListener(os, k), () => document.removeEventListener(os, k);
    }, []), /* @__PURE__ */ m(
      mt.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: w ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Rt(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: Rt(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: Rt(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Of.displayName = YO;
var eN = "DismissableLayerBranch", tN = g.forwardRef((e, t) => {
  const n = g.useContext(Cf), o = g.useRef(null), r = Qt(t, o);
  return g.useEffect(() => {
    const i = o.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ m(mt.div, { ...e, ref: r });
});
tN.displayName = eN;
function nN(e, t = globalThis?.document) {
  const n = qn(e), o = g.useRef(!1), r = g.useRef(() => {
  });
  return g.useEffect(() => {
    const i = (a) => {
      if (a.target && !o.current) {
        let l = function() {
          Nf(
            XO,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function oN(e, t = globalThis?.document) {
  const n = qn(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const r = (i) => {
      i.target && !o.current && Nf(QO, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function il() {
  const e = new CustomEvent(os);
  document.dispatchEvent(e);
}
function Nf(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? WO(r, i) : r.dispatchEvent(i);
}
var rN = "Portal", iN = g.forwardRef((e, t) => {
  const { container: n, ...o } = e, [r, i] = g.useState(!1);
  ns(() => i(!0), []);
  const s = n || r && globalThis?.document?.body;
  return s ? ds.createPortal(/* @__PURE__ */ m(mt.div, { ...o, ref: t }), s) : null;
});
iN.displayName = rN;
var ut = function() {
  return ut = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, ut.apply(this, arguments);
};
function Rf(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function sN(e, t, n) {
  for (var o = 0, r = t.length, i; o < r; o++)
    (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var bi = "focusScope.autoFocusOnMount", yi = "focusScope.autoFocusOnUnmount", sl = { bubbles: !1, cancelable: !0 }, aN = "FocusScope", Af = g.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, l] = g.useState(null), c = qn(r), u = qn(i), d = g.useRef(null), f = Qt(t, (p) => l(p)), h = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let p = function(w) {
        if (h.paused || !a) return;
        const _ = w.target;
        a.contains(_) ? d.current = _ : Ot(d.current, { select: !0 });
      }, y = function(w) {
        if (h.paused || !a) return;
        const _ = w.relatedTarget;
        _ !== null && (a.contains(_) || Ot(d.current, { select: !0 }));
      }, $ = function(w) {
        if (document.activeElement === document.body)
          for (const _ of w)
            _.removedNodes.length > 0 && Ot(a);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", y);
      const v = new MutationObserver($);
      return a && v.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", y), v.disconnect();
      };
    }
  }, [o, a, h.paused]), g.useEffect(() => {
    if (a) {
      cl.add(h);
      const p = document.activeElement;
      if (!a.contains(p)) {
        const y = new CustomEvent(bi, sl);
        a.addEventListener(bi, c), a.dispatchEvent(y), y.defaultPrevented || (cN(fN(If(a)), { select: !0 }), document.activeElement === p && Ot(a));
      }
      return () => {
        a.removeEventListener(bi, c), setTimeout(() => {
          const y = new CustomEvent(yi, sl);
          a.addEventListener(yi, u), a.dispatchEvent(y), y.defaultPrevented || Ot(p ?? document.body, { select: !0 }), a.removeEventListener(yi, u), cl.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const b = g.useCallback(
    (p) => {
      if (!n && !o || h.paused) return;
      const y = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, $ = document.activeElement;
      if (y && $) {
        const v = p.currentTarget, [w, _] = lN(v);
        w && _ ? !p.shiftKey && $ === _ ? (p.preventDefault(), n && Ot(w, { select: !0 })) : p.shiftKey && $ === w && (p.preventDefault(), n && Ot(_, { select: !0 })) : $ === v && p.preventDefault();
      }
    },
    [n, o, h.paused]
  );
  return /* @__PURE__ */ m(mt.div, { tabIndex: -1, ...s, ref: f, onKeyDown: b });
});
Af.displayName = aN;
function cN(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Ot(o, { select: t }), document.activeElement !== n) return;
}
function lN(e) {
  const t = If(e), n = al(t, e), o = al(t.reverse(), e);
  return [n, o];
}
function If(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function al(e, t) {
  for (const n of e)
    if (!uN(n, { upTo: t })) return n;
}
function uN(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function dN(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ot(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && dN(e) && t && e.select();
  }
}
var cl = pN();
function pN() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = ll(e, t), e.unshift(t);
    },
    remove(t) {
      e = ll(e, t), e[0]?.resume();
    }
  };
}
function ll(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function fN(e) {
  return e.filter((t) => t.tagName !== "A");
}
var wi = 0;
function hN() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ul()), document.body.insertAdjacentElement("beforeend", e[1] ?? ul()), wi++, () => {
      wi === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), wi--;
    };
  }, []);
}
function ul() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Wo = "right-scroll-bar-position", qo = "width-before-scroll-bar", mN = "with-scroll-bars-hidden", gN = "--removed-body-scroll-bar-size";
function _i(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function vN(e, t) {
  var n = De(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var bN = typeof window < "u" ? g.useLayoutEffect : g.useEffect, dl = /* @__PURE__ */ new WeakMap();
function yN(e, t) {
  var n = vN(null, function(o) {
    return e.forEach(function(r) {
      return _i(r, o);
    });
  });
  return bN(function() {
    var o = dl.get(n);
    if (o) {
      var r = new Set(o), i = new Set(e), s = n.current;
      r.forEach(function(a) {
        i.has(a) || _i(a, null);
      }), i.forEach(function(a) {
        r.has(a) || _i(a, s);
      });
    }
    dl.set(n, e);
  }, [e]), n;
}
function wN(e) {
  return e;
}
function _N(e, t) {
  t === void 0 && (t = wN);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, o);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (o = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      o = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return r;
}
function xN(e) {
  e === void 0 && (e = {});
  var t = _N(null);
  return t.options = ut({ async: !0, ssr: !1 }, e), t;
}
var Pf = function(e) {
  var t = e.sideCar, n = Rf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, ut({}, n));
};
Pf.isSideCarExport = !0;
function $N(e, t) {
  return e.useMedium(t), Pf;
}
var Tf = xN(), xi = function() {
}, Vr = g.forwardRef(function(e, t) {
  var n = g.useRef(null), o = g.useState({
    onScrollCapture: xi,
    onWheelCapture: xi,
    onTouchMoveCapture: xi
  }), r = o[0], i = o[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, b = e.inert, p = e.allowPinchZoom, y = e.as, $ = y === void 0 ? "div" : y, v = e.gapMode, w = Rf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), _ = f, x = yN([n, t]), C = ut(ut({}, w), r);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(_, { sideCar: Tf, removeScrollBar: c, shards: d, noIsolation: h, inert: b, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: v }),
    s ? g.cloneElement(g.Children.only(a), ut(ut({}, C), { ref: x })) : g.createElement($, ut({}, C, { className: l, ref: x }), a)
  );
});
Vr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Vr.classNames = {
  fullWidth: qo,
  zeroRight: Wo
};
var kN = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function EN() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = kN();
  return t && e.setAttribute("nonce", t), e;
}
function SN(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function CN(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ON = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = EN()) && (SN(t, n), CN(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, NN = function() {
  var e = ON();
  return function(t, n) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Lf = function() {
  var e = NN(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, RN = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, $i = function(e) {
  return parseInt(e || "", 10) || 0;
}, AN = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [$i(n), $i(o), $i(r)];
}, IN = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return RN;
  var t = AN(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, PN = Lf(), vn = "data-scroll-locked", TN = function(e, t, n, o) {
  var r = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(mN, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(a, "px ").concat(o, `;
  }
  body[`).concat(vn, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Wo, ` {
    right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(qo, ` {
    margin-right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(Wo, " .").concat(Wo, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(qo, " .").concat(qo, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(vn, `] {
    `).concat(gN, ": ").concat(a, `px;
  }
`);
}, pl = function() {
  var e = parseInt(document.body.getAttribute(vn) || "0", 10);
  return isFinite(e) ? e : 0;
}, LN = function() {
  g.useEffect(function() {
    return document.body.setAttribute(vn, (pl() + 1).toString()), function() {
      var e = pl() - 1;
      e <= 0 ? document.body.removeAttribute(vn) : document.body.setAttribute(vn, e.toString());
    };
  }, []);
}, jN = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  LN();
  var i = g.useMemo(function() {
    return IN(r);
  }, [r]);
  return g.createElement(PN, { styles: TN(i, !t, r, n ? "" : "!important") });
}, rs = !1;
if (typeof window < "u")
  try {
    var Eo = Object.defineProperty({}, "passive", {
      get: function() {
        return rs = !0, !0;
      }
    });
    window.addEventListener("test", Eo, Eo), window.removeEventListener("test", Eo, Eo);
  } catch {
    rs = !1;
  }
var ln = rs ? { passive: !1 } : !1, DN = function(e) {
  return e.tagName === "TEXTAREA";
}, jf = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !DN(e) && n[t] === "visible")
  );
}, zN = function(e) {
  return jf(e, "overflowY");
}, MN = function(e) {
  return jf(e, "overflowX");
}, fl = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Df(e, o);
    if (r) {
      var i = zf(e, o), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, FN = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, VN = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Df = function(e, t) {
  return e === "v" ? zN(t) : MN(t);
}, zf = function(e, t) {
  return e === "v" ? FN(t) : VN(t);
}, UN = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, BN = function(e, t, n, o, r) {
  var i = UN(e, window.getComputedStyle(t).direction), s = i * o, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = zf(e, a), b = h[0], p = h[1], y = h[2], $ = p - y - i * b;
    (b || $) && Df(e, a) && (d += $, f += b), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, So = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, hl = function(e) {
  return [e.deltaX, e.deltaY];
}, ml = function(e) {
  return e && "current" in e ? e.current : e;
}, HN = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, KN = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, WN = 0, un = [];
function qN(e) {
  var t = g.useRef([]), n = g.useRef([0, 0]), o = g.useRef(), r = g.useState(WN++)[0], i = g.useState(Lf)[0], s = g.useRef(e);
  g.useEffect(function() {
    s.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var p = sN([e.lockRef.current], (e.shards || []).map(ml)).filter(Boolean);
      return p.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), p.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = g.useCallback(function(p, y) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !s.current.allowPinchZoom;
    var $ = So(p), v = n.current, w = "deltaX" in p ? p.deltaX : v[0] - $[0], _ = "deltaY" in p ? p.deltaY : v[1] - $[1], x, C = p.target, k = Math.abs(w) > Math.abs(_) ? "h" : "v";
    if ("touches" in p && k === "h" && C.type === "range")
      return !1;
    var R = fl(k, C);
    if (!R)
      return !0;
    if (R ? x = k : (x = k === "v" ? "h" : "v", R = fl(k, C)), !R)
      return !1;
    if (!o.current && "changedTouches" in p && (w || _) && (o.current = x), !x)
      return !0;
    var N = o.current || x;
    return BN(N, y, p, N === "h" ? w : _);
  }, []), l = g.useCallback(function(p) {
    var y = p;
    if (!(!un.length || un[un.length - 1] !== i)) {
      var $ = "deltaY" in y ? hl(y) : So(y), v = t.current.filter(function(x) {
        return x.name === y.type && (x.target === y.target || y.target === x.shadowParent) && HN(x.delta, $);
      })[0];
      if (v && v.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!v) {
        var w = (s.current.shards || []).map(ml).filter(Boolean).filter(function(x) {
          return x.contains(y.target);
        }), _ = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        _ && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(p, y, $, v) {
    var w = { name: p, delta: y, target: $, should: v, shadowParent: ZN($) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== w;
      });
    }, 1);
  }, []), u = g.useCallback(function(p) {
    n.current = So(p), o.current = void 0;
  }, []), d = g.useCallback(function(p) {
    c(p.type, hl(p), p.target, a(p, e.lockRef.current));
  }, []), f = g.useCallback(function(p) {
    c(p.type, So(p), p.target, a(p, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return un.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, ln), document.addEventListener("touchmove", l, ln), document.addEventListener("touchstart", u, ln), function() {
      un = un.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", l, ln), document.removeEventListener("touchmove", l, ln), document.removeEventListener("touchstart", u, ln);
    };
  }, []);
  var h = e.removeScrollBar, b = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    b ? g.createElement(i, { styles: KN(r) }) : null,
    h ? g.createElement(jN, { gapMode: e.gapMode }) : null
  );
}
function ZN(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const JN = $N(Tf, qN);
var Mf = g.forwardRef(function(e, t) {
  return g.createElement(Vr, ut({}, e, { ref: t, sideCar: JN }));
});
Mf.classNames = Vr.classNames;
var GN = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, dn = /* @__PURE__ */ new WeakMap(), Co = /* @__PURE__ */ new WeakMap(), Oo = {}, ki = 0, Ff = function(e) {
  return e && (e.host || Ff(e.parentNode));
}, YN = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Ff(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, XN = function(e, t, n, o) {
  var r = YN(t, Array.isArray(e) ? e : [e]);
  Oo[n] || (Oo[n] = /* @__PURE__ */ new WeakMap());
  var i = Oo[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(r), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  r.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(o), b = h !== null && h !== "false", p = (dn.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          dn.set(f, p), i.set(f, y), s.push(f), p === 1 && b && Co.set(f, !0), y === 1 && f.setAttribute(n, "true"), b || f.setAttribute(o, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", f, $);
        }
    });
  };
  return u(t), a.clear(), ki++, function() {
    s.forEach(function(d) {
      var f = dn.get(d) - 1, h = i.get(d) - 1;
      dn.set(d, f), i.set(d, h), f || (Co.has(d) || d.removeAttribute(o), Co.delete(d)), h || d.removeAttribute(n);
    }), ki--, ki || (dn = /* @__PURE__ */ new WeakMap(), dn = /* @__PURE__ */ new WeakMap(), Co = /* @__PURE__ */ new WeakMap(), Oo = {});
  };
}, QN = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = GN(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live]"))), XN(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, Vf = "Dialog", [Uf, DL] = zO(Vf), [zL, gt] = Uf(Vf), Bf = "DialogTrigger", eR = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = gt(Bf, n), i = Qt(t, r.triggerRef);
    return /* @__PURE__ */ m(
      mt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": aa(r.open),
        ...o,
        ref: i,
        onClick: Rt(e.onClick, r.onOpenToggle)
      }
    );
  }
);
eR.displayName = Bf;
var tR = "DialogPortal", [ML, Hf] = Uf(tR, {
  forceMount: void 0
}), hr = "DialogOverlay", nR = g.forwardRef(
  (e, t) => {
    const n = Hf(hr, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = gt(hr, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ m(ia, { present: o || i.open, children: /* @__PURE__ */ m(rR, { ...r, ref: t }) }) : null;
  }
);
nR.displayName = hr;
var oR = /* @__PURE__ */ Sf("DialogOverlay.RemoveScroll"), rR = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = gt(hr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ m(Mf, { as: oR, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ m(
        mt.div,
        {
          "data-state": aa(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Wt = "DialogContent", iR = g.forwardRef(
  (e, t) => {
    const n = Hf(Wt, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = gt(Wt, e.__scopeDialog);
    return /* @__PURE__ */ m(ia, { present: o || i.open, children: i.modal ? /* @__PURE__ */ m(sR, { ...r, ref: t }) : /* @__PURE__ */ m(aR, { ...r, ref: t }) });
  }
);
iR.displayName = Wt;
var sR = g.forwardRef(
  (e, t) => {
    const n = gt(Wt, e.__scopeDialog), o = g.useRef(null), r = Qt(t, n.contentRef, o);
    return g.useEffect(() => {
      const i = o.current;
      if (i) return QN(i);
    }, []), /* @__PURE__ */ m(
      Kf,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Rt(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Rt(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: Rt(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), aR = g.forwardRef(
  (e, t) => {
    const n = gt(Wt, e.__scopeDialog), o = g.useRef(!1), r = g.useRef(!1);
    return /* @__PURE__ */ m(
      Kf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (o.current || n.triggerRef.current?.focus(), i.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (o.current = !0, i.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const s = i.target;
          n.triggerRef.current?.contains(s) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && r.current && i.preventDefault();
        }
      }
    );
  }
), Kf = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, ...s } = e, a = gt(Wt, n), l = g.useRef(null), c = Qt(t, l);
    return hN(), /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(
        Af,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ m(
            Of,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": aa(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ P(ze, { children: [
        /* @__PURE__ */ m(dR, { titleId: a.titleId }),
        /* @__PURE__ */ m(fR, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), sa = "DialogTitle", cR = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = gt(sa, n);
    return /* @__PURE__ */ m(mt.h2, { id: r.titleId, ...o, ref: t });
  }
);
cR.displayName = sa;
var Wf = "DialogDescription", lR = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = gt(Wf, n);
    return /* @__PURE__ */ m(mt.p, { id: r.descriptionId, ...o, ref: t });
  }
);
lR.displayName = Wf;
var qf = "DialogClose", uR = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = gt(qf, n);
    return /* @__PURE__ */ m(
      mt.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: Rt(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
uR.displayName = qf;
function aa(e) {
  return e ? "open" : "closed";
}
var Zf = "DialogTitleWarning", [FL, Jf] = DO(Zf, {
  contentName: Wt,
  titleName: sa,
  docsSlug: "dialog"
}), dR = ({ titleId: e }) => {
  const t = Jf(Zf), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, pR = "DialogDescriptionWarning", fR = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Jf(pR).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, hR = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), mR = "VisuallyHidden", gR = g.forwardRef(
  (e, t) => /* @__PURE__ */ m(
    mt.span,
    {
      ...e,
      ref: t,
      style: { ...hR, ...e.style }
    }
  )
);
gR.displayName = mR;
const vR = Jt(void 0), gl = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), o = (a, l) => {
    const c = typeof a == "function" ? a(t) : a;
    if (!Object.is(c, t)) {
      const u = t;
      t = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), n.forEach((d) => d(t, u));
    }
  }, r = () => t, i = { setState: o, getState: r, getInitialState: () => s, subscribe: (a) => (n.add(a), () => n.delete(a)) }, s = t = e(o, r, i);
  return i;
}, bR = (e) => e ? gl(e) : gl;
function yR(e) {
  const t = {
    apiUrl: ""
  };
  return bR((n) => ({
    ...t,
    ...e,
    setApiUrl: (o) => n({ apiUrl: o })
  }));
}
function wR({ children: e, ...t }) {
  const n = Ee(null);
  return n.current || (n.current = yR(t)), /* @__PURE__ */ m(vR.Provider, { value: n.current, children: e });
}
const X = (e) => typeof e == "string", jn = () => {
  let e, t;
  const n = new Promise((o, r) => {
    e = o, t = r;
  });
  return n.resolve = e, n.reject = t, n;
}, vl = (e) => e == null ? "" : "" + e, _R = (e, t, n) => {
  e.forEach((o) => {
    t[o] && (n[o] = t[o]);
  });
}, xR = /###/g, bl = (e) => e && e.indexOf("###") > -1 ? e.replace(xR, ".") : e, yl = (e) => !e || X(e), Vn = (e, t, n) => {
  const o = X(t) ? t.split(".") : t;
  let r = 0;
  for (; r < o.length - 1; ) {
    if (yl(e)) return {};
    const i = bl(o[r]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++r;
  }
  return yl(e) ? {} : {
    obj: e,
    k: bl(o[r])
  };
}, wl = (e, t, n) => {
  const {
    obj: o,
    k: r
  } = Vn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[r] = n;
    return;
  }
  let i = t[t.length - 1], s = t.slice(0, t.length - 1), a = Vn(e, s, Object);
  for (; a.obj === void 0 && s.length; )
    i = `${s[s.length - 1]}.${i}`, s = s.slice(0, s.length - 1), a = Vn(e, s, Object), a?.obj && typeof a.obj[`${a.k}.${i}`] < "u" && (a.obj = void 0);
  a.obj[`${a.k}.${i}`] = n;
}, $R = (e, t, n, o) => {
  const {
    obj: r,
    k: i
  } = Vn(e, t, Object);
  r[i] = r[i] || [], r[i].push(n);
}, mr = (e, t) => {
  const {
    obj: n,
    k: o
  } = Vn(e, t);
  if (n && Object.prototype.hasOwnProperty.call(n, o))
    return n[o];
}, kR = (e, t, n) => {
  const o = mr(e, n);
  return o !== void 0 ? o : mr(t, n);
}, Gf = (e, t, n) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? X(e[o]) || e[o] instanceof String || X(t[o]) || t[o] instanceof String ? n && (e[o] = t[o]) : Gf(e[o], t[o], n) : e[o] = t[o]);
  return e;
}, pn = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ER = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const SR = (e) => X(e) ? e.replace(/[&<>"'\/]/g, (t) => ER[t]) : e;
class CR {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const OR = [" ", ",", "?", "!", ";"], NR = new CR(20), RR = (e, t, n) => {
  t = t || "", n = n || "";
  const o = OR.filter((s) => t.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (o.length === 0) return !0;
  const r = NR.getRegExp(`(${o.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let i = !r.test(e);
  if (!i) {
    const s = e.indexOf(n);
    s > 0 && !r.test(e.substring(0, s)) && (i = !0);
  }
  return i;
}, is = (e, t, n = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(n);
  let r = e;
  for (let i = 0; i < o.length; ) {
    if (!r || typeof r != "object")
      return;
    let s, a = "";
    for (let l = i; l < o.length; ++l)
      if (l !== i && (a += n), a += o[l], s = r[a], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < o.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    r = s;
  }
  return r;
}, Zn = (e) => e?.replace("_", "-"), AR = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class gr {
  constructor(t, n = {}) {
    this.init(t, n);
  }
  init(t, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = t || AR, this.options = n, this.debug = n.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, o, r) {
    return r && !this.debug ? null : (X(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new gr(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new gr(this.logger, t);
  }
}
var ft = new gr();
class Ur {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const r = this.observers[o].get(n) || 0;
      this.observers[o].set(n, r + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t, ...n) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, r]) => {
      for (let i = 0; i < r; i++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, r]) => {
      for (let i = 0; i < r; i++)
        o.apply(o, [t, ...n]);
    });
  }
}
class _l extends Ur {
  constructor(t, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, o, r = {}) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, s = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a;
    t.indexOf(".") > -1 ? a = t.split(".") : (a = [t, n], o && (Array.isArray(o) ? a.push(...o) : X(o) && i ? a.push(...o.split(i)) : a.push(o)));
    const l = mr(this.data, a);
    return !l && !n && !o && t.indexOf(".") > -1 && (t = a[0], n = a[1], o = a.slice(2).join(".")), l || !s || !X(o) ? l : is(this.data?.[t]?.[n], o, i);
  }
  addResource(t, n, o, r, i = {
    silent: !1
  }) {
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let a = [t, n];
    o && (a = a.concat(s ? o.split(s) : o)), t.indexOf(".") > -1 && (a = t.split("."), r = n, n = a[1]), this.addNamespaces(n), wl(this.data, a, r), i.silent || this.emit("added", t, n, o, r);
  }
  addResources(t, n, o, r = {
    silent: !1
  }) {
    for (const i in o)
      (X(o[i]) || Array.isArray(o[i])) && this.addResource(t, n, i, o[i], {
        silent: !0
      });
    r.silent || this.emit("added", t, n, o);
  }
  addResourceBundle(t, n, o, r, i, s = {
    silent: !1,
    skipCopy: !1
  }) {
    let a = [t, n];
    t.indexOf(".") > -1 && (a = t.split("."), r = o, o = n, n = a[1]), this.addNamespaces(n);
    let l = mr(this.data, a) || {};
    s.skipCopy || (o = JSON.parse(JSON.stringify(o))), r ? Gf(l, o, i) : l = {
      ...l,
      ...o
    }, wl(this.data, a, l), s.silent || this.emit("added", t, n, o);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Yf = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, o, r) {
    return e.forEach((i) => {
      t = this.processors[i]?.process(t, n, o, r) ?? t;
    }), t;
  }
};
const xl = {}, $l = (e) => !X(e) && typeof e != "boolean" && typeof e != "number";
class vr extends Ur {
  constructor(t, n = {}) {
    super(), _R(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ft.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, n = {
    interpolation: {}
  }) {
    const o = {
      ...n
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, n) {
    let o = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const s = o && t.indexOf(o) > -1, a = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !RR(t, o, r);
    if (s && !a) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: X(i) ? [i] : i
        };
      const c = t.split(o);
      (o !== r || o === r && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(r);
    }
    return {
      key: t,
      namespaces: X(i) ? [i] : i
    };
  }
  translate(t, n, o) {
    let r = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (r = {
      ...r
    }), r || (r = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const i = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], r), c = l[l.length - 1];
    let u = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = r.lng || this.language, f = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return f ? i ? {
        res: `${c}${u}${a}`,
        usedKey: a,
        exactUsedKey: a,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(r)
      } : `${c}${u}${a}` : i ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(r)
      } : a;
    const h = this.resolve(t, r);
    let b = h?.res;
    const p = h?.usedKey || a, y = h?.exactUsedKey || a, $ = ["[object Number]", "[object Function]", "[object RegExp]"], v = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, w = !this.i18nFormat || this.i18nFormat.handleAsObject, _ = r.count !== void 0 && !X(r.count), x = vr.hasDefaultValue(r), C = _ ? this.pluralResolver.getSuffix(d, r.count, r) : "", k = r.ordinal && _ ? this.pluralResolver.getSuffix(d, r.count, {
      ordinal: !1
    }) : "", R = _ && !r.ordinal && r.count === 0, N = R && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${C}`] || r[`defaultValue${k}`] || r.defaultValue;
    let j = b;
    w && !b && x && (j = N);
    const H = $l(j), re = Object.prototype.toString.apply(j);
    if (w && j && H && $.indexOf(re) < 0 && !(X(v) && Array.isArray(j))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const q = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, j, {
          ...r,
          ns: l
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return i ? (h.res = q, h.usedParams = this.getUsedParamsDetails(r), h) : q;
      }
      if (s) {
        const q = Array.isArray(j), F = q ? [] : {}, ae = q ? y : p;
        for (const J in j)
          if (Object.prototype.hasOwnProperty.call(j, J)) {
            const ce = `${ae}${s}${J}`;
            x && !b ? F[J] = this.translate(ce, {
              ...r,
              defaultValue: $l(N) ? N[J] : void 0,
              joinArrays: !1,
              ns: l
            }) : F[J] = this.translate(ce, {
              ...r,
              joinArrays: !1,
              ns: l
            }), F[J] === ce && (F[J] = j[J]);
          }
        b = F;
      }
    } else if (w && X(v) && Array.isArray(b))
      b = b.join(v), b && (b = this.extendTranslation(b, t, r, o));
    else {
      let q = !1, F = !1;
      !this.isValidLookup(b) && x && (q = !0, b = N), this.isValidLookup(b) || (F = !0, b = a);
      const ae = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && F ? void 0 : b, J = x && N !== b && this.options.updateMissing;
      if (F || q || J) {
        if (this.logger.log(J ? "updateKey" : "missingKey", d, c, a, J ? N : b), s) {
          const O = this.resolve(a, {
            ...r,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ce = [];
        const we = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && we && we[0])
          for (let O = 0; O < we.length; O++)
            ce.push(we[O]);
        else this.options.saveMissingTo === "all" ? ce = this.languageUtils.toResolveHierarchy(r.lng || this.language) : ce.push(r.lng || this.language);
        const Ae = (O, T, I) => {
          const M = x && I !== b ? I : ae;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, c, T, M, J, r) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(O, c, T, M, J, r), this.emit("missingKey", O, c, T, b);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && _ ? ce.forEach((O) => {
          const T = this.pluralResolver.getSuffixes(O, r);
          R && r[`defaultValue${this.options.pluralSeparator}zero`] && T.indexOf(`${this.options.pluralSeparator}zero`) < 0 && T.push(`${this.options.pluralSeparator}zero`), T.forEach((I) => {
            Ae([O], a + I, r[`defaultValue${I}`] || N);
          });
        }) : Ae(ce, a, N));
      }
      b = this.extendTranslation(b, t, r, h, o), F && b === a && this.options.appendNamespaceToMissingKey && (b = `${c}${u}${a}`), (F || q) && this.options.parseMissingKeyHandler && (b = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${a}` : a, q ? b : void 0, r));
    }
    return i ? (h.res = b, h.usedParams = this.getUsedParamsDetails(r), h) : b;
  }
  extendTranslation(t, n, o, r, i) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = X(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !X(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || r.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), f = d && d.length;
        c < f && (o.nest = !1);
      }
      !o.lng && r && r.res && (o.lng = this.language || r.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => i?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null) : this.translate(...d, n), o)), o.interpolation && this.interpolator.reset();
    }
    const s = o.postProcess || this.options.postProcess, a = X(s) ? [s] : s;
    return t != null && a?.length && o.applyPostProcessor !== !1 && (t = Yf.handle(a, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, n = {}) {
    let o, r, i, s, a;
    return X(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const f = n.count !== void 0 && !X(n.count), h = f && !n.ordinal && n.count === 0, b = n.context !== void 0 && (X(n.context) || typeof n.context == "number") && n.context !== "", p = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((y) => {
        this.isValidLookup(o) || (a = y, !xl[`${p[0]}-${y}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(a) && (xl[`${p[0]}-${y}`] = !0, this.logger.warn(`key "${r}" for languages "${p.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach(($) => {
          if (this.isValidLookup(o)) return;
          s = $;
          const v = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, $, y, n);
          else {
            let _;
            f && (_ = this.pluralResolver.getSuffix($, n.count, n));
            const x = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (v.push(u + _), n.ordinal && _.indexOf(C) === 0 && v.push(u + _.replace(C, this.options.pluralSeparator)), h && v.push(u + x)), b) {
              const k = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(k), f && (v.push(k + _), n.ordinal && _.indexOf(C) === 0 && v.push(k + _.replace(C, this.options.pluralSeparator)), h && v.push(k + x));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(o) || (i = w, o = this.getResource($, y, w, n));
        }));
      });
    }), {
      res: o,
      usedKey: r,
      exactUsedKey: i,
      usedLng: s,
      usedNS: a
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, o, r = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, n, o, r) : this.resourceStore.getResource(t, n, o, r);
  }
  getUsedParamsDetails(t = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !X(t.replace);
    let r = o ? t.replace : t;
    if (o && typeof t.count < "u" && (r.count = t.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !o) {
      r = {
        ...r
      };
      for (const i of n)
        delete r[i];
    }
    return r;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && n === o.substring(0, n.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class kl {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ft.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Zn(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Zn(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (X(t) && t.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((o) => {
      if (n) return;
      const r = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (n = r);
    }), !n && this.options.supportedLngs && t.forEach((o) => {
      if (n) return;
      const r = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(r)) return n = r;
      const i = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(i)) return n = i;
      n = this.options.supportedLngs.find((s) => {
        if (s === i || !(s.indexOf("-") < 0 && i.indexOf("-") < 0) && (s.indexOf("-") > 0 && i.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === i || s.indexOf(i) === 0 && i.length > 1))
          return s;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), X(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let o = t[n];
    return o || (o = t[this.getScriptPartFromCode(n)]), o || (o = t[this.formatLanguageCode(n)]), o || (o = t[this.getLanguagePartFromCode(n)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, n) {
    const o = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], t), r = [], i = (s) => {
      s && (this.isSupportedCode(s) ? r.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return X(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : X(t) && i(this.formatLanguageCode(t)), o.forEach((s) => {
      r.indexOf(s) < 0 && i(this.formatLanguageCode(s));
    }), r;
  }
}
const El = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Sl = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class IR {
  constructor(t, n = {}) {
    this.languageUtils = t, this.options = n, this.logger = ft.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, n = {}) {
    const o = Zn(t === "dev" ? "en" : t), r = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
      cleanedCode: o,
      type: r
    });
    if (i in this.pluralRulesCache)
      return this.pluralRulesCache[i];
    let s;
    try {
      s = new Intl.PluralRules(o, {
        type: r
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Sl;
      if (!t.match(/-|_/)) return Sl;
      const a = this.languageUtils.getLanguagePartFromCode(t);
      s = this.getRule(a, n);
    }
    return this.pluralRulesCache[i] = s, s;
  }
  needsPlural(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, n, o = {}) {
    return this.getSuffixes(t, o).map((r) => `${n}${r}`);
  }
  getSuffixes(t, n = {}) {
    let o = this.getRule(t, n);
    return o || (o = this.getRule("dev", n)), o ? o.resolvedOptions().pluralCategories.sort((r, i) => El[r] - El[i]).map((r) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : [];
  }
  getSuffix(t, n, o = {}) {
    const r = this.getRule(t, o);
    return r ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(n)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", n, o));
  }
}
const Cl = (e, t, n, o = ".", r = !0) => {
  let i = kR(e, t, n);
  return !i && r && X(n) && (i = is(e, n, o), i === void 0 && (i = is(t, n, o))), i;
}, Ei = (e) => e.replace(/\$/g, "$$$$");
class PR {
  constructor(t = {}) {
    this.logger = ft.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: o,
      useRawValueToEscape: r,
      prefix: i,
      prefixEscaped: s,
      suffix: a,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: f,
      nestingPrefixEscaped: h,
      nestingSuffix: b,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: y,
      maxReplaces: $,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : SR, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = i ? pn(i) : s || "{{", this.suffix = a ? pn(a) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? pn(f) : h || pn("$t("), this.nestingSuffix = b ? pn(b) : p || pn(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = $ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, o) => n?.source === o ? (n.lastIndex = 0, n) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, o, r) {
    let i, s, a;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const y = Cl(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, o, {
          ...r,
          ...n,
          interpolationkey: f
        }) : y;
      }
      const h = f.split(this.formatSeparator), b = h.shift().trim(), p = h.join(this.formatSeparator).trim();
      return this.format(Cl(n, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), p, o, {
        ...r,
        ...n,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const u = r?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => Ei(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? Ei(this.escape(f)) : Ei(f)
    }].forEach((f) => {
      for (a = 0; i = f.regex.exec(t); ) {
        const h = i[1].trim();
        if (s = c(h), s === void 0)
          if (typeof u == "function") {
            const p = u(t, i, r);
            s = X(p) ? p : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, h))
            s = "";
          else if (d) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), s = "";
        else !X(s) && !this.useRawValueToEscape && (s = vl(s));
        const b = f.safeValue(s);
        if (t = t.replace(i[0], b), d ? (f.regex.lastIndex += s.length, f.regex.lastIndex -= i[0].length) : f.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n, o = {}) {
    let r, i, s;
    const a = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${d[1]}`;
      l = d[0], f = this.interpolate(f, s);
      const h = f.match(/'/g), b = f.match(/"/g);
      ((h?.length ?? 0) % 2 === 0 && !b || b.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        s = JSON.parse(f), c && (s = {
          ...c,
          ...s
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${f}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(t); ) {
      let l = [];
      s = {
        ...o
      }, s = s.replace && !X(s.replace) ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      const c = /{.*}/.test(r[1]) ? r[1].lastIndexOf("}") + 1 : r[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = r[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), r[1] = r[1].slice(0, c)), i = n(a.call(this, r[1].trim(), s), s), i && r[0] === t && !X(i)) return i;
      X(i) || (i = vl(i)), i || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${t}`), i = ""), l.length && (i = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: r[1].trim()
      }), i.trim())), t = t.replace(r[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const TR = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const r = o[1].substring(0, o[1].length - 1);
    t === "currency" && r.indexOf(":") < 0 ? n.currency || (n.currency = r.trim()) : t === "relativetime" && r.indexOf(":") < 0 ? n.range || (n.range = r.trim()) : r.split(";").forEach((i) => {
      if (i) {
        const [s, ...a] = i.split(":"), l = a.join(":").trim().replace(/^'+|'+$/g, ""), c = s.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, Ol = (e) => {
  const t = {};
  return (n, o, r) => {
    let i = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (i = {
      ...i,
      [r.interpolationkey]: void 0
    });
    const s = o + JSON.stringify(i);
    let a = t[s];
    return a || (a = e(Zn(o), r), t[s] = a), a(n);
  };
}, LR = (e) => (t, n, o) => e(Zn(n), o)(t);
class jR {
  constructor(t = {}) {
    this.logger = ft.create("formatter"), this.options = t, this.init(t);
  }
  init(t, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const o = n.cacheInBuiltFormats ? Ol : LR;
    this.formats = {
      number: o((r, i) => {
        const s = new Intl.NumberFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      }),
      currency: o((r, i) => {
        const s = new Intl.NumberFormat(r, {
          ...i,
          style: "currency"
        });
        return (a) => s.format(a);
      }),
      datetime: o((r, i) => {
        const s = new Intl.DateTimeFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      }),
      relativetime: o((r, i) => {
        const s = new Intl.RelativeTimeFormat(r, {
          ...i
        });
        return (a) => s.format(a, i.range || "day");
      }),
      list: o((r, i) => {
        const s = new Intl.ListFormat(r, {
          ...i
        });
        return (a) => s.format(a);
      })
    };
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Ol(n);
  }
  format(t, n, o, r = {}) {
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((a) => a.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, a) => {
      const {
        formatName: l,
        formatOptions: c
      } = TR(a);
      if (this.formats[l]) {
        let u = s;
        try {
          const d = r?.formatParams?.[r.interpolationkey] || {}, f = d.locale || d.lng || r.locale || r.lng || o;
          u = this.formats[l](s, f, {
            ...c,
            ...r,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return s;
    }, t);
  }
}
const DR = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class zR extends Ur {
  constructor(t, n, o, r = {}) {
    super(), this.backend = t, this.store = n, this.services = o, this.languageUtils = o.languageUtils, this.options = r, this.logger = ft.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, r.backend, r);
  }
  queueLoad(t, n, o, r) {
    const i = {}, s = {}, a = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const f = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? s[f] === void 0 && (s[f] = !0) : (this.state[f] = 1, u = !1, s[f] === void 0 && (s[f] = !0), i[f] === void 0 && (i[f] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (a[c] = !0);
    }), (Object.keys(i).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, o) {
    const r = t.split("|"), i = r[0], s = r[1];
    n && this.emit("failedLoading", i, s, n), !n && o && this.store.addResourceBundle(i, s, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && o && (this.state[t] = 0);
    const a = {};
    this.queue.forEach((l) => {
      $R(l.loaded, [i], s), DR(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        a[c] || (a[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          a[c][d] === void 0 && (a[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, o, r = 0, i = this.retryTimeout, s) {
    if (!t.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: o,
        tried: r,
        wait: i,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const a = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, o, r + 1, i * 2, s);
        }, i);
        return;
      }
      s(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => a(null, u)).catch(a) : a(null, c);
      } catch (c) {
        a(c);
      }
      return;
    }
    return l(t, n, a);
  }
  prepareLoading(t, n, o = {}, r) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    X(t) && (t = this.languageUtils.toResolveHierarchy(t)), X(n) && (n = [n]);
    const i = this.queueLoad(t, n, o, r);
    if (!i.toLoad.length)
      return i.pending.length || r(), null;
    i.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(t, n, o) {
    this.prepareLoading(t, n, {}, o);
  }
  reload(t, n, o) {
    this.prepareLoading(t, n, {
      reload: !0
    }, o);
  }
  loadOne(t, n = "") {
    const o = t.split("|"), r = o[0], i = o[1];
    this.read(r, i, "read", void 0, void 0, (s, a) => {
      s && this.logger.warn(`${n}loading namespace ${i} for language ${r} failed`, s), !s && a && this.logger.log(`${n}loaded namespace ${i} for language ${r}`, a), this.loaded(t, s, a);
    });
  }
  saveMissing(t, n, o, r, i, s = {}, a = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...s,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, o, r, l) : u = c(t, n, o, r), u && typeof u.then == "function" ? u.then((d) => a(null, d)).catch(a) : a(null, u);
          } catch (u) {
            a(u);
          }
        else
          c(t, n, o, r, a, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, o, r);
    }
  }
}
const Nl = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), X(e[1]) && (t.defaultValue = e[1]), X(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((o) => {
        t[o] = n[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Rl = (e) => (X(e.ns) && (e.ns = [e.ns]), X(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), X(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), No = () => {
}, MR = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Jn extends Ur {
  constructor(t = {}, n) {
    if (super(), this.options = Rl(t), this.services = {}, this.logger = ft, this.modules = {
      external: []
    }, MR(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init(t = {}, n) {
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), t.defaultNS == null && t.ns && (X(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Nl();
    this.options = {
      ...o,
      ...this.options,
      ...Rl(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const r = (a) => a ? typeof a == "function" ? new a() : a : null;
    if (!this.options.isClone) {
      this.modules.logger ? ft.init(r(this.modules.logger), this.options) : ft.init(null, this.options);
      let a;
      this.modules.formatter ? a = this.modules.formatter : a = jR;
      const l = new kl(this.options);
      this.store = new _l(this.options.resources, this.options);
      const c = this.services;
      c.logger = ft, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new IR(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.warn("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), a && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = r(a), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new PR(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new zR(r(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = r(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = r(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new vr(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = No), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      a.length > 0 && a[0] !== "dev" && (this.options.lng = a[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((a) => {
      this[a] = (...l) => this.store[a](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((a) => {
      this[a] = (...l) => (this.store[a](...l), this);
    });
    const i = jn(), s = () => {
      const a = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(c), n(l, c);
      };
      if (this.languages && !this.isInitialized) return a(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, a);
    };
    return this.options.resources || !this.options.initAsync ? s() : setTimeout(s, 0), i;
  }
  loadResources(t, n = No) {
    let o = n;
    const r = X(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const i = [], s = (a) => {
        !a || a === "cimode" || this.services.languageUtils.toResolveHierarchy(a).forEach((l) => {
          l !== "cimode" && i.indexOf(l) < 0 && i.push(l);
        });
      };
      r ? s(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((a) => s(a)), this.options.preload?.forEach?.((a) => s(a)), this.services.backendConnector.load(i, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(a);
      });
    } else
      o(null);
  }
  reloadResources(t, n, o) {
    const r = jn();
    return typeof t == "function" && (o = t, t = void 0), typeof n == "function" && (o = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), o || (o = No), this.services.backendConnector.reload(t, n, (i) => {
      r.resolve(), o(i);
    }), r;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Yf.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const o = this.languages[n];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, n) {
    this.isLanguageChangingTo = t;
    const o = jn();
    this.emit("languageChanging", t);
    const r = (a) => {
      this.language = a, this.languages = this.services.languageUtils.toResolveHierarchy(a), this.resolvedLanguage = void 0, this.setResolvedLanguage(a);
    }, i = (a, l) => {
      l ? this.isLanguageChangingTo === t && (r(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), n && n(a, (...c) => this.t(...c));
    }, s = (a) => {
      !t && !a && this.services.languageDetector && (a = []);
      const l = X(a) ? a : a && a[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(X(a) ? [a] : a);
      c && (this.language || r(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        i(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), o;
  }
  getFixedT(t, n, o) {
    const r = (i, s, ...a) => {
      let l;
      typeof s != "object" ? l = this.options.overloadTranslationOptionHandler([i, s].concat(a)) : l = {
        ...s
      }, l.lng = l.lng || r.lng, l.lngs = l.lngs || r.lngs, l.ns = l.ns || r.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || r.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(i) ? u = i.map((d) => `${l.keyPrefix}${c}${d}`) : u = l.keyPrefix ? `${l.keyPrefix}${c}${i}` : i, this.t(u, l);
    };
    return X(t) ? r.lng = t : r.lngs = t, r.ns = n, r.keyPrefix = o, r;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = n.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const s = (a, l) => {
      const c = this.services.backendConnector.state[`${a}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const a = n.precheck(this, s);
      if (a !== void 0) return a;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(o, t) && (!r || s(i, t)));
  }
  loadNamespaces(t, n) {
    const o = jn();
    return this.options.ns ? (X(t) && (t = [t]), t.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      o.resolve(), n && n(r);
    }), o) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const o = jn();
    X(t) && (t = [t]);
    const r = this.options.preload || [], i = t.filter((s) => r.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return i.length ? (this.options.preload = r.concat(i), this.loadResources((s) => {
      o.resolve(), n && n(s);
    }), o) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const r = new Intl.Locale(t);
      if (r && r.getTextInfo) {
        const i = r.getTextInfo();
        if (i && i.direction) return i.direction;
      }
    } catch {
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new kl(Nl());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, n) {
    return new Jn(t, n);
  }
  cloneInstance(t = {}, n = No) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const r = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Jn(r);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, o) {
      const s = Object.keys(this.store.data).reduce((a, l) => (a[l] = {
        ...this.store.data[l]
      }, a[l] = Object.keys(a[l]).reduce((c, u) => (c[u] = {
        ...a[l][u]
      }, c), a[l]), a), {});
      i.store = new _l(s, r), i.services.resourceStore = i.store;
    }
    return i.translator = new vr(i.services, r), i.translator.on("*", (s, ...a) => {
      i.emit(s, ...a);
    }), i.init(r, n), i.translator.options = r, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Ue = Jn.createInstance();
Ue.createInstance = Jn.createInstance;
const FR = Ue.createInstance;
Ue.dir;
Ue.init;
Ue.loadResources;
Ue.reloadResources;
Ue.use;
Ue.changeLanguage;
Ue.getFixedT;
Ue.t;
Ue.exists;
Ue.setDefaultNamespace;
Ue.hasLoadedNamespace;
Ue.loadNamespaces;
Ue.loadLanguages;
const VR = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-mail er klar! Log ind for at fortsætte.",
  "modal.emailVerif.alreadyVerified.title": "Din e-mailadresse er allerede blevet bekræftet",
  "modal.emailVerif.callout": "Vi har sendt en bekræftelsesmail.",
  "modal.emailVerif.desc": "Vi har sendt en bekræftelsesmail til <b>{{email}}</b>.<br/>Tjek din indbakke. Linket i denne e-mail udløber om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "Log ind for at modtage et nyt bekræftelseslink i din indbakke.",
  "modal.emailVerif.linkExpired.title": "Dette link er udløbet",
  "modal.emailVerif.resend-email-link": "Send ny bekræftelsesmail.",
  "modal.emailVerif.resend-link": "Send ny bekræftelsesmail.",
  "modal.emailVerif.title": "Bekræft din e-mailadresse",
  "modal.finishCreatingAccount.adv": "I en reklame",
  "modal.finishCreatingAccount.event": "Til en begivenhed",
  "modal.finishCreatingAccount.everyone": "Alle kender til HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Indtast dit fornavn",
  "modal.finishCreatingAccount.friends": "Gennem venner, familie eller bekendte",
  "modal.finishCreatingAccount.hearAboutHE": "Hvor har du hørt om HomeExchange? <span>(valgfrit)</span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Indtast dit efternavn",
  "modal.finishCreatingAccount.onTV": "I fjernsynet",
  "modal.finishCreatingAccount.online": "Online",
  "modal.finishCreatingAccount.other": "Andet",
  "modal.finishCreatingAccount.otherSocial": "Andre sociale medier (angiv venligst)",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Indtast dit telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Angiv venligst",
  "modal.finishCreatingAccount.press": "I pressen",
  "modal.finishCreatingAccount.print": "Trykte medier",
  "modal.finishCreatingAccount.radio": "I radioen",
  "modal.finishCreatingAccount.referral": "Henvisningskode<span>(valgfrit)</span>",
  "modal.finishCreatingAccount.referralCode.error": "Denne henvisningskode er ugyldig",
  "modal.finishCreatingAccount.report": "Under et tv-indslag/tv-program",
  "modal.finishCreatingAccount.search": "På en søgemaskine",
  "modal.finishCreatingAccount.socialMedia": "Via sociale medier",
  "modal.finishCreatingAccount.title": "Færdiggør oprettelsen af din konto",
  "modal.genericError.desc": "Platformen kan være nede, eller der kan være en midlertidig fejl hos os, så prøv venligst igen.<br><br>Vi registrerer automatisk disse fejl, men hvis problemet fortsætter, er du velkommen til at kontakte os på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hov! Der opstod en fejl",
  "modal.noEmailRecieved.desc": "<b>Har du ikke modtaget en e-mail?</b>Tjek din spammappe, og at du har stavet din e-mail korrekt, inden du anmoder om en ny bekræftelsesmail.",
  "modal.noEmailRecieved.error": "Der opstod en fejl. Prøv igen senere.",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt dig en ny bekræftelsesmail.",
  "signin-modal.apple.button": "Log ind med Apple",
  "signin-modal.button": "Log ind",
  "signin-modal.email.button": "Log ind",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Log ind med Facebook",
  "signin-modal.no-account": "Nyt medlem?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Skift kodeord",
  "signup-modal.accept-cgu": "Ved at oprette en profil accepterer jeg de",
  "signup-modal.apple.button": "Log ind med Apple",
  "signup-modal.button": "Tilmeld dig",
  "signup-modal.cgu.link": "Generelle brugervilkår",
  "signup-modal.description": "Rejs på en ny måde med HomeExchange: Bliv budt velkommen over hele verden og spar penge!",
  "signup-modal.email.button": "Tilmeld dig med din e-mailadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Tilmeld dig med Facebook",
  "signup-modal.have-an-account": "Har du allerede en profil?"
}, UR = {
  "modal.emailVerif.alreadyVerified.desc": "Ihre E-Mail ist fertig! Melden Sie sich an, um fortzufahren.",
  "modal.emailVerif.alreadyVerified.title": "Ihre E-Mail-Adresse wurde bereits verifiziert",
  "modal.emailVerif.callout": "Eine Bestätigungs-E-Mail wurde versandt.",
  "modal.emailVerif.desc": "Wir haben eine Bestätigungs-E-Mail an <b> {{email}} </b> gesendet. <br/> Überprüfen Sie Ihren Posteingang. Der Link in dieser E-Mail läuft in 24 Stunden ab.",
  "modal.emailVerif.linkExpired.desc": "Um einen neuen Verifizierungslink per E-Mail zu erhalten, melden Sie sich bitte an.",
  "modal.emailVerif.linkExpired.title": "Dieser Link ist abgelaufen",
  "modal.emailVerif.resend-email-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.resend-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.title": "Verifizieren Sie Ihre E-Mail-Adresse",
  "modal.finishCreatingAccount.adv": "In der Werbung",
  "modal.finishCreatingAccount.event": "Bei einer Veranstaltung",
  "modal.finishCreatingAccount.everyone": "Jeder kennt HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Geben Sie Ihren Vornamen ein",
  "modal.finishCreatingAccount.friends": "Durch Freunde, Familie oder Bekannte",
  "modal.finishCreatingAccount.hearAboutHE": "Wie haben Sie von HomeExchange erfahren? <span> (optional) </span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Geben Sie Ihren Nachnamen ein",
  "modal.finishCreatingAccount.onTV": "Im Fernsehen",
  "modal.finishCreatingAccount.online": "Im Internet",
  "modal.finishCreatingAccount.other": "Anderes",
  "modal.finishCreatingAccount.otherSocial": "Anderes soziales Netzwerk (bitte angeben)",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Bitte geben sie ihre Telefonnummer ein",
  "modal.finishCreatingAccount.pleaseSpecify": "Bitte angeben",
  "modal.finishCreatingAccount.press": "In der Presse",
  "modal.finishCreatingAccount.print": "Gedruckte Ausgabe",
  "modal.finishCreatingAccount.radio": "Im Radio",
  "modal.finishCreatingAccount.referral": "Empfehlungscode <span> (optional) </span>",
  "modal.finishCreatingAccount.referralCode.error": "Dieser Empfehlungscode ist ungültig",
  "modal.finishCreatingAccount.report": "In einer Reportage / TV-Sendung",
  "modal.finishCreatingAccount.search": "Über eine Suchmaschine",
  "modal.finishCreatingAccount.socialMedia": "Über soziale Medien",
  "modal.finishCreatingAccount.title": "Schließen Sie die Erstellung Ihres Kontos ab",
  "modal.genericError.desc": "Die Plattform ist möglicherweise nicht erreichbar oder es liegt ein vorübergehender Fehler auf unserer Seite vor. Bitte versuchen Sie es noch einmal.<br><br>Wir erfassen diese Fehler automatisch, aber wenn das Problem weiterhin besteht, können Sie uns gerne unter <br><a>tech@homeexchange.com</a> kontaktieren.",
  "modal.genericError.title": "Hoppla! Da ist etwas schiefgelaufen",
  "modal.noEmailRecieved.desc": "<b>Sie haben keine E-Mail erhalten?</b>Überprüfen Sie Ihren Spam-Ordner und die Schreibweise Ihrer E-Mail, bevor Sie eine weitere Bestätigungs-E-Mail anfordern.",
  "modal.noEmailRecieved.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
  "modal.verifyEmail.emailResent.toast": "Wir haben Ihnen eine neue E-Mail zur Verifizierung geschickt.",
  "signin-modal.apple.button": "Mit Google verbinden",
  "signin-modal.button": "Einloggen",
  "signin-modal.email.button": "Einloggen",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Mit Facebook verbinden",
  "signin-modal.no-account": "Noch keinen Account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Passwort zurücksetzen",
  "signup-modal.accept-cgu": "Mit der Erstellung des Kontos akzeptiere ich die",
  "signup-modal.apple.button": "Melden Sie sich mit Apple an",
  "signup-modal.button": "Anmelden",
  "signup-modal.cgu.link": "Allgemeine Nutzungsbedingungen",
  "signup-modal.description": "Entdecken Sie dank Wohnungs-und Haustausch eine neue Art des Reisens: Seien Sie auf der ganzen Welt willkommen und sparen Sie Geld!",
  "signup-modal.email.button": "Mit E-Mail-Adresse anmelden",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Mit Facebook anmelden",
  "signup-modal.have-an-account": "Sie haben bereits ein Konto?"
}, BR = {
  "modal.emailVerif.alreadyVerified.desc": "Your email is ready! Log in to continue.",
  "modal.emailVerif.alreadyVerified.title": "Your email address has already been verified",
  "modal.emailVerif.callout": "A verification email has been sent.",
  "modal.emailVerif.desc": "We have sent a verification email to <b>{{email}}</b>.<br/>Check your inbox. The link in this email will expire in 24-hours.",
  "modal.emailVerif.linkExpired.desc": "To receive a new verification link in your inbox, please log in.",
  "modal.emailVerif.linkExpired.title": "This link has expired",
  "modal.emailVerif.resend-email-link": "Resend verification email",
  "modal.emailVerif.resend-link": "Resend verification email",
  "modal.emailVerif.title": "Verify your email address",
  "modal.finishCreatingAccount.adv": "Through an advertisement",
  "modal.finishCreatingAccount.event": "At an event",
  "modal.finishCreatingAccount.everyone": "Everyone knows HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Enter your first name",
  "modal.finishCreatingAccount.friends": "Through friends, family, or acquaintances",
  "modal.finishCreatingAccount.hearAboutHE": "How did you hear about HomeExchange? <span>(optional)</span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Enter your last name",
  "modal.finishCreatingAccount.onTV": "On TV",
  "modal.finishCreatingAccount.online": "Online",
  "modal.finishCreatingAccount.other": "Other ",
  "modal.finishCreatingAccount.otherSocial": "Other social network (please specify)",
  "modal.finishCreatingAccount.phone_number": "Phone number",
  "modal.finishCreatingAccount.phone_number.error": "Please enter your phone number",
  "modal.finishCreatingAccount.pleaseSpecify": "Please specify",
  "modal.finishCreatingAccount.press": "In the press",
  "modal.finishCreatingAccount.print": "Print",
  "modal.finishCreatingAccount.radio": "On the radio",
  "modal.finishCreatingAccount.referral": "Referral code <span>(optional)</span>",
  "modal.finishCreatingAccount.referralCode.error": "This referral code is invalid",
  "modal.finishCreatingAccount.report": "During a report / TV show",
  "modal.finishCreatingAccount.search": "On a search engine",
  "modal.finishCreatingAccount.socialMedia": "Via social media",
  "modal.finishCreatingAccount.title": "Finish creating your account",
  "modal.genericError.desc": "The platform might be down or there might be a temporary glitch on our side, so please try again.<br><br>We track these errors automatically, but if the problem persists feel free to contact us at:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! something went wrong",
  "modal.noEmailRecieved.desc": "<b>Didn’t receive an email?</b>Check your spam folder and the spelling of your email before requesting another verification email.",
  "modal.noEmailRecieved.error": "Something went wrong, please try again later",
  "modal.verifyEmail.emailResent.toast": "We've sent you a new verification email.",
  "signin-modal.apple.button": "Connect with Apple",
  "signin-modal.button": "Sign in",
  "signin-modal.email.button": "Sign in",
  "signin-modal.error.content": "An error occured",
  "signin-modal.error.email_no_verified.content": "Email not verified",
  "signin-modal.error.email_no_verified.title": "Error",
  "signin-modal.error.title": "Error",
  "signin-modal.facebook.button": "Connect with Facebook",
  "signin-modal.no-account": "Don't have an account yet?",
  "signin-modal.reset-password": "Reset password",
  "signin-modal.title": "Sign in ",
  "signin.modal.reset-password": "Reset password",
  "signup-modal.accept-cgu": "By creating an account, I accept the",
  "signup-modal.apple.button": "Sign in with Apple",
  "signup-modal.button": "Sign up",
  "signup-modal.cgu.link": "General Terms of Use",
  "signup-modal.description": "Discover a new way of traveling with HomeExchange: Be welcomed all over the world and save money!",
  "signup-modal.email.button": "Sign up with your email address",
  "signup-modal.email.form.submit": "Sign up",
  "signup-modal.error.content": "An error occured",
  "signup-modal.error.title": "Error",
  "signup-modal.facebook.button": "Sign up with Facebook",
  "signup-modal.have-an-account": "Already have an account?"
}, HR = {
  "modal.emailVerif.alreadyVerified.desc": "¡Tu correo electrónico está listo! Inicia sesión para continuar.",
  "modal.emailVerif.alreadyVerified.title": "Tu dirección de correo electrónico ya está verificada",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "Para recibir un nuevo enlace de verificación en tu buzón de mensajes, inicia sesión.",
  "modal.emailVerif.linkExpired.title": "Este enlace ha caducado",
  "modal.emailVerif.resend-email-link": "Reenviar correo electrónico de verificación",
  "modal.emailVerif.resend-link": "Reenviar correo electrónico de verificación",
  "modal.emailVerif.title": "Verifica tu dirección de correo electrónico",
  "modal.finishCreatingAccount.adv": "En un anuncio",
  "modal.finishCreatingAccount.event": "En un evento",
  "modal.finishCreatingAccount.everyone": "Todo el mundo conoce HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Introduce tu nombre",
  "modal.finishCreatingAccount.friends": "Por amigos, familiares o conocidos",
  "modal.finishCreatingAccount.hearAboutHE": "¿Cómo has descubierto HomeExchange? <span>(opcional)</span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Introduce tus apellidos",
  "modal.finishCreatingAccount.onTV": "En la televisión",
  "modal.finishCreatingAccount.online": "Online",
  "modal.finishCreatingAccount.other": "Otros",
  "modal.finishCreatingAccount.otherSocial": "Otra red social (especifica cuál)",
  "modal.finishCreatingAccount.phone_number": "Número de teléfono",
  "modal.finishCreatingAccount.phone_number.error": "Introduce tu número de teléfono",
  "modal.finishCreatingAccount.pleaseSpecify": "Por favor, especifica",
  "modal.finishCreatingAccount.press": "Por la prensa",
  "modal.finishCreatingAccount.print": "Imprimir",
  "modal.finishCreatingAccount.radio": "Por la radio",
  "modal.finishCreatingAccount.referral": "Código de invitación <span>(opcional)</span>",
  "modal.finishCreatingAccount.referralCode.error": "Este código de invitación no es válido",
  "modal.finishCreatingAccount.report": "En un reportaje/programa de televisión",
  "modal.finishCreatingAccount.search": "En un motor de búsqueda",
  "modal.finishCreatingAccount.socialMedia": "Por las redes sociales",
  "modal.finishCreatingAccount.title": "Termina de crear tu cuenta",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Inicia sesión con Apple",
  "signin-modal.button": "Inicia sesión",
  "signin-modal.email.button": "Inicia sesión",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Inicia sesión con Facebook",
  "signin-modal.no-account": "¿Aún no tienes una cuenta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Restablecer la contraseña",
  "signup-modal.accept-cgu": "Al crear una cuenta acepto las",
  "signup-modal.apple.button": "Inicia sesión con Apple",
  "signup-modal.button": "Regístrate",
  "signup-modal.cgu.link": "Condiciones Generales de Uso",
  "signup-modal.description": "Descubre otra forma de viajar con el intercambio de casas: ¡siéntete bienvenido/a en todo el mundo y ahorra en alojamiento!",
  "signup-modal.email.button": "Regístrate con tu correo electrónico",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Regístrate con Facebook",
  "signup-modal.have-an-account": "¿Ya tienes una cuenta?"
}, KR = {
  "modal.emailVerif.alreadyVerified.desc": "Votre adresse email est prête ! Connectez-vous pour continuer.",
  "modal.emailVerif.alreadyVerified.title": "Votre adresse email a déjà été vérifiée",
  "modal.emailVerif.callout": "Un email de vérification a été envoyé.",
  "modal.emailVerif.desc": "Nous avons envoyé un email de vérification à l'adresse <b>{{email}}</b>. <br/>Consultez votre boîte de réception. Le lien inclus dans cet email expirera au bout de 24 heures.",
  "modal.emailVerif.linkExpired.desc": "Veuillez vous connecter pour recevoir un nouveau lien de vérification dans votre boîte de réception.",
  "modal.emailVerif.linkExpired.title": "Ce lien a expiré",
  "modal.emailVerif.resend-email-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.resend-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.title": "Confirmez votre adresse email",
  "modal.finishCreatingAccount.adv": "Dans une publicité",
  "modal.finishCreatingAccount.event": "Lors d'un événement",
  "modal.finishCreatingAccount.everyone": "Tout le monde connaît HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Merci de saisir votre prénom",
  "modal.finishCreatingAccount.friends": "Par l'intermédiaire d'amis, de membres de ma famille ou de connaissances",
  "modal.finishCreatingAccount.hearAboutHE": "Comment avez-vous entendu parler de HomeExchange ? <span>(facultatif)</span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Merci de saisir votre nom de famille",
  "modal.finishCreatingAccount.onTV": "À la télévision",
  "modal.finishCreatingAccount.online": "En ligne",
  "modal.finishCreatingAccount.other": "Autre",
  "modal.finishCreatingAccount.otherSocial": "Autre réseau social (merci de préciser)",
  "modal.finishCreatingAccount.phone_number": "Téléphone",
  "modal.finishCreatingAccount.phone_number.error": "Merci de renseigner votre numéro de téléphone",
  "modal.finishCreatingAccount.pleaseSpecify": "Merci de préciser",
  "modal.finishCreatingAccount.press": "Dans la presse",
  "modal.finishCreatingAccount.print": "Écrite",
  "modal.finishCreatingAccount.radio": "À la radio",
  "modal.finishCreatingAccount.referral": "Code de parrainage <span>(facultatif)</span>",
  "modal.finishCreatingAccount.referralCode.error": "Ce code de parrainage n'est pas valide",
  "modal.finishCreatingAccount.report": "Dans un reportage/une émission TV",
  "modal.finishCreatingAccount.search": "Sur un moteur de recherche",
  "modal.finishCreatingAccount.socialMedia": "Sur les réseaux sociaux",
  "modal.finishCreatingAccount.title": "Complétez la création de votre compte",
  "modal.genericError.desc": "Notre plateforme pourrait être indisponible ou victime d'une panne temporaire. Merci de réessayer.<br><br> Nous détectons ces erreurs automatiquement, mais n'hésitez pas à nous contacter à l'adresse suivante si le problème persiste :<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oups ! Une erreur est survenue",
  "modal.noEmailRecieved.desc": "<b>Vous n'avez pas reçu d'email ?</b> Vérifiez votre dossier spam et l'orthographe de votre adresse email avant de demander l'envoi d'un nouvel email de vérification.",
  "modal.noEmailRecieved.error": "Une erreur est survenue, veuillez réessayer plus tard",
  "modal.verifyEmail.emailResent.toast": "Nous vous avons envoyé un nouvel email de vérification.",
  "signin-modal.apple.button": "Se connecter avec Google",
  "signin-modal.button": "Se connecter",
  "signin-modal.email.button": "Se connecter",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Se connecter avec Facebook",
  "signin-modal.no-account": "Pas encore de compte ?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Réinitialiser le mot de passe",
  "signup-modal.accept-cgu": "En créant un compte, j’accepte les",
  "signup-modal.apple.button": "Se connecter avec Apple",
  "signup-modal.button": "S'inscrire",
  "signup-modal.cgu.link": "Conditions Générales d’Utilisation",
  "signup-modal.description": "Découvrez une autre manière de voyager avec l’échange de maison : soyez accueilli(e) partout dans le monde et faites des économies !",
  "signup-modal.email.button": "S’inscrire avec votre adresse email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "S’inscrire avec Facebook",
  "signup-modal.have-an-account": "Vous avez déjà un compte ?"
}, WR = {
  "modal.emailVerif.alreadyVerified.desc": "Vaša adresa e-pošte je spremna! Prijavite se kako biste nastavili.",
  "modal.emailVerif.alreadyVerified.title": "Ova adresa e-pošte je već potvrđena",
  "modal.emailVerif.callout": "E-poruka s potvrdom je poslana.",
  "modal.emailVerif.desc": "Poslali smo e-poruku s potvrdom na <b>{{email}}</b>.<br/>Provjerite svoju dolaznu poštu. Poveznica u ovoj poruci će isteći u roku od 24 sata.",
  "modal.emailVerif.linkExpired.desc": "Ako želite dobiti novu poveznicu s potvrdom, morate se prijaviti.",
  "modal.emailVerif.linkExpired.title": "Ova je poveznica istekla",
  "modal.emailVerif.resend-email-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.resend-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.title": "Potvrdite adresu e-pošte",
  "modal.finishCreatingAccount.adv": "u reklami",
  "modal.finishCreatingAccount.event": "na nekom događaju",
  "modal.finishCreatingAccount.everyone": "svi znaju za HomeExchange",
  "modal.finishCreatingAccount.facebook": "na Facebooku",
  "modal.finishCreatingAccount.firstName.error": "Upišite svoje ime",
  "modal.finishCreatingAccount.friends": "preko obitelji, prijatelja ili poznanika",
  "modal.finishCreatingAccount.hearAboutHE": "Kako ste čuli za HomeExchange? <span> (nije obavezno) </span>",
  "modal.finishCreatingAccount.instagram": "na Instagramu",
  "modal.finishCreatingAccount.lastName.error": "Upišite svoje prezime",
  "modal.finishCreatingAccount.onTV": "na televiziji",
  "modal.finishCreatingAccount.online": "na internetu",
  "modal.finishCreatingAccount.other": "ostalo",
  "modal.finishCreatingAccount.otherSocial": "na drugoj društvenoj mreži (napišite kojoj)",
  "modal.finishCreatingAccount.phone_number": "Broj telefona",
  "modal.finishCreatingAccount.phone_number.error": "Molimo unesite svoj broj telefona",
  "modal.finishCreatingAccount.pleaseSpecify": "napišite konkretnije",
  "modal.finishCreatingAccount.press": "u novinama",
  "modal.finishCreatingAccount.print": "u tiskanim medijima",
  "modal.finishCreatingAccount.radio": "na radiju",
  "modal.finishCreatingAccount.referral": "Kod za preporuku <span>(nije obavezno)</span>",
  "modal.finishCreatingAccount.referralCode.error": "Ovaj kod za preporuku nije valjan",
  "modal.finishCreatingAccount.report": "u nekoj reportaži/TV emisiji",
  "modal.finishCreatingAccount.search": "u tražilici",
  "modal.finishCreatingAccount.socialMedia": "na društvenim mrežama",
  "modal.finishCreatingAccount.title": "Dovršite izradu svojeg računa",
  "modal.genericError.desc": "Platforma možda trenutačno nije dostupna ili možda imamo nekih problema, zbog čega Vas molimo da pokušate ponovno.<br><br>Automatski pratimo ove greške, ali ako i dalje budete nailazili na problem, slobodno nam se javite na:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Ajoj! Nešto nije u redu",
  "modal.noEmailRecieved.desc": "<b>Niste primili e-poruku?</b>Provjerite svoj pretinac neželjene pošte i jeste li točno upisali svoju adresu e-pošte prije nego što zatražite još jednu e-poruku s potvrdom.",
  "modal.noEmailRecieved.error": "Nešto nije u redu, pokušajte ponovno kasnije",
  "modal.verifyEmail.emailResent.toast": "Poslali smo Vam novu e-poruku s potvrdom.",
  "signin-modal.apple.button": "Prijavite se s Apple ID-om",
  "signin-modal.button": "Prijavite se",
  "signin-modal.email.button": "Prijavite se",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Prijavite se putem Facebooka",
  "signin-modal.no-account": "Još nemate račun?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Resetirajte lozinku",
  "signup-modal.accept-cgu": "Izradom računa, prihvaćam",
  "signup-modal.apple.button": "Prijavite se s Apple ID-om",
  "signup-modal.button": "Registrirajte se",
  "signup-modal.cgu.link": "Opće Uvjete korištenja",
  "signup-modal.description": "Otkrijte novi način putovanja sa zamjenom domova: odsjedajte svugdje po svijetu i uštedite novac!",
  "signup-modal.email.button": "Registrirajte se sa Vašom email adresom",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrirajte se putem Facebooka",
  "signup-modal.have-an-account": "Već imate račun?"
}, qR = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Invia di nuovo la mail di verifica",
  "modal.emailVerif.resend-link": "Invia di nuovo la mail di verifica",
  "modal.emailVerif.title": "Verifica il tuo indirizzo email",
  "modal.finishCreatingAccount.adv": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.onTV": "",
  "modal.finishCreatingAccount.online": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.otherSocial": "",
  "modal.finishCreatingAccount.phone_number": "Numero di telefono",
  "modal.finishCreatingAccount.phone_number.error": "Si prega di inserire il suo numero di telefono",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.report": "",
  "modal.finishCreatingAccount.search": "",
  "modal.finishCreatingAccount.socialMedia": "",
  "modal.finishCreatingAccount.title": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Accedi tramite Google",
  "signin-modal.button": "Accedi",
  "signin-modal.email.button": "Accedi",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Accedi tramite Facebook",
  "signin-modal.no-account": "Non hai ancora un account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Reimposta la password",
  "signup-modal.accept-cgu": "Creando un account, accetto le",
  "signup-modal.apple.button": "Accedi con Apple",
  "signup-modal.button": "Registrati",
  "signup-modal.cgu.link": "Condizioni Generali di Utilizzo",
  "signup-modal.description": "Scopri un nuovo modo di viaggiare con lo scambio casa: lasciati accogliere in tutto il mondo e risparmia!",
  "signup-modal.email.button": "Registrati con il tuo indirizzo email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrati tramite Facebook",
  "signup-modal.have-an-account": "Hai già un account?"
}, ZR = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.resend-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.title": "Verifiser din e-postadresse",
  "modal.finishCreatingAccount.adv": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.onTV": "",
  "modal.finishCreatingAccount.online": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.otherSocial": "",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Skriv inn telefonnummeret",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.report": "",
  "modal.finishCreatingAccount.search": "",
  "modal.finishCreatingAccount.socialMedia": "",
  "modal.finishCreatingAccount.title": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Logg inn med Apple",
  "signin-modal.button": "Logg inn",
  "signin-modal.email.button": "Logg inn",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logg inn med Facebook",
  "signin-modal.no-account": "Ingen konto ennå?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Tilbakestill passord",
  "signup-modal.accept-cgu": "Ved å opprette en konto, aksepterer jeg",
  "signup-modal.apple.button": "Logg inn med Apple",
  "signup-modal.button": "Registrer deg",
  "signup-modal.cgu.link": "Generelle vilkår for bruk",
  "signup-modal.description": "Oppdag en ny måte å reise på med HomeExchange: bli ønsket velkommen over hele verden og spar penger!",
  "signup-modal.email.button": "Registrer deg med e-postadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrer deg med Facebook",
  "signup-modal.have-an-account": "Har du allerede en konto?"
}, JR = {
  "modal.emailVerif.alreadyVerified.desc": "Je e-mailadres is klaar! Log in om verder te gaan.",
  "modal.emailVerif.alreadyVerified.title": "Je e-mailadres is al geverifieerd",
  "modal.emailVerif.callout": "Er is een verificatie-e-mail verzonden.",
  "modal.emailVerif.desc": "We hebben een verificatie-e-mail gestuurd naar <b>{{email}}</b>.<br/>Controleer je inbox. De link in deze e-mail verloopt binnen 24 uur.",
  "modal.emailVerif.linkExpired.desc": "Log in om een nieuwe verificatielink in je inbox te ontvangen.",
  "modal.emailVerif.linkExpired.title": "Deze link is verlopen",
  "modal.emailVerif.resend-email-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.resend-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.title": "Verifieer je e-mailadres",
  "modal.finishCreatingAccount.adv": "Via een advertentie",
  "modal.finishCreatingAccount.event": "Op een evenement",
  "modal.finishCreatingAccount.everyone": "Iedereen kent HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Voer je voornaam in",
  "modal.finishCreatingAccount.friends": "Via vrienden, familie of kennissen",
  "modal.finishCreatingAccount.hearAboutHE": "Hoe heb je over HomeExchange gehoord? <span>(optioneel)</span>",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Voer je achternaam in",
  "modal.finishCreatingAccount.onTV": "Op tv",
  "modal.finishCreatingAccount.online": "Online",
  "modal.finishCreatingAccount.other": "Andere",
  "modal.finishCreatingAccount.otherSocial": "Ander sociaal netwerk (specificeer)",
  "modal.finishCreatingAccount.phone_number": "Telefoonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Voer je telefoonnummer in",
  "modal.finishCreatingAccount.pleaseSpecify": "Gelieve te specificeren",
  "modal.finishCreatingAccount.press": "In de pers",
  "modal.finishCreatingAccount.print": "Afdrukken",
  "modal.finishCreatingAccount.radio": "Op de radio",
  "modal.finishCreatingAccount.referral": "Doorverwijzingscode <span>(optioneel)</span>",
  "modal.finishCreatingAccount.referralCode.error": "Deze doorverwijzingscode is ongeldig",
  "modal.finishCreatingAccount.report": "Tijdens een reportage/tv-programma",
  "modal.finishCreatingAccount.search": "Op een zoekmachine",
  "modal.finishCreatingAccount.socialMedia": "Via sociale media",
  "modal.finishCreatingAccount.title": "Voltooi het aanmaken van je account",
  "modal.genericError.desc": "Het platform is mogelijk niet beschikbaar of er kan een tijdelijke storing zijn aan onze kant, dus probeer het opnieuw.<br><br> We traceren deze fouten automatisch, maar als het probleem zich blijft voordoen, neem dan gerust contact met ons op:<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oeps! Er is iets misgegaan",
  "modal.noEmailRecieved.desc": "<b>Geen e-mail ontvangen?</b>Controleer je spammap en de spelling van je e-mail voordat je een nieuwe verificatiemail aanvraagt.",
  "modal.noEmailRecieved.error": "Er is iets misgegaan, probeer het later opnieuw",
  "modal.verifyEmail.emailResent.toast": "We hebben je een nieuwe verificatiemail gestuurd.",
  "signin-modal.apple.button": "Meld je aan zonder Google",
  "signin-modal.button": "Inloggen",
  "signin-modal.email.button": "Inloggen",
  "signin-modal.error.content": "Er is een fout opgetreden",
  "signin-modal.error.email_no_verified.content": "E-mailadres niet geverifieerd",
  "signin-modal.error.email_no_verified.title": "Fout",
  "signin-modal.error.title": "Fout",
  "signin-modal.facebook.button": "Meld je aan zonder Facebook",
  "signin-modal.no-account": "Heb je nog geen account?",
  "signin-modal.reset-password": "Wachtwoord opnieuw instellen",
  "signin-modal.title": "Inloggen",
  "signin.modal.reset-password": "Wachtwoord opnieuw instellen",
  "signup-modal.accept-cgu": "Door een account aan te maken, accepteer ik de",
  "signup-modal.apple.button": "Inloggen met Apple",
  "signup-modal.button": "Inschrijven",
  "signup-modal.cgu.link": "Wettelijke bepalingen",
  "signup-modal.description": "Ontdek een nieuwe manier van reizen met HomeExchange: word overal ter wereld verwelkomd en bespaar geld!",
  "signup-modal.email.button": "Meld je aan met je e-mail adres",
  "signup-modal.email.form.submit": "Registreren",
  "signup-modal.error.content": "Er is een fout opgetreden",
  "signup-modal.error.title": "Fout",
  "signup-modal.facebook.button": "Inloggen met Facebook",
  "signup-modal.have-an-account": "Heb je al een account?"
}, GR = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "",
  "modal.emailVerif.resend-link": "",
  "modal.emailVerif.title": "",
  "modal.finishCreatingAccount.adv": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.onTV": "",
  "modal.finishCreatingAccount.online": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.otherSocial": "",
  "modal.finishCreatingAccount.phone_number": "",
  "modal.finishCreatingAccount.phone_number.error": "",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.report": "",
  "modal.finishCreatingAccount.search": "",
  "modal.finishCreatingAccount.socialMedia": "",
  "modal.finishCreatingAccount.title": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "",
  "signin-modal.apple.button": "Iniciar sessão com a Apple",
  "signin-modal.button": "Iniciar sessão",
  "signin-modal.email.button": "Iniciar sessão",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Iniciar sessão com o Facebook",
  "signin-modal.no-account": "Ainda não tem conta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Redefinir palavra-passe",
  "signup-modal.accept-cgu": "Ao criar uma conta, eu aceito os",
  "signup-modal.apple.button": "Iniciar sessão com a Apple",
  "signup-modal.button": "Inscreva-se",
  "signup-modal.cgu.link": "Termos Gerais de Utilização",
  "signup-modal.description": "Descubra uma nova forma de viajar com a HomeExchange: sinta-se bem-vindo/a em todo o mundo e poupe dinheiro!",
  "signup-modal.email.button": "Inscreva-se com o seu endereço de e-mail",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Inscreva-se com o Facebook",
  "signup-modal.have-an-account": "Já possui uma conta?"
}, YR = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Skicka bekräftelse av e-postadressen igen",
  "modal.emailVerif.resend-link": "Skicka bekräftelse av e-postadressen igen",
  "modal.emailVerif.title": "Verifiera din emailadress",
  "modal.finishCreatingAccount.adv": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.onTV": "",
  "modal.finishCreatingAccount.online": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.otherSocial": "",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Ange ditt telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.report": "",
  "modal.finishCreatingAccount.search": "",
  "modal.finishCreatingAccount.socialMedia": "",
  "modal.finishCreatingAccount.title": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "Vi har skickat ett nytt verifieringsmail till dig.",
  "signin-modal.apple.button": "Logga in med Apple",
  "signin-modal.button": "Logga in",
  "signin-modal.email.button": "Logga in",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logga in med Facebook",
  "signin-modal.no-account": "Har du inget konto ännu?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Återställ lösenord",
  "signup-modal.accept-cgu": "Genom att skapa ett konto godkänner jag",
  "signup-modal.apple.button": "Logga in med Apple",
  "signup-modal.button": "Registrera dig",
  "signup-modal.cgu.link": "de allmänna villkoren",
  "signup-modal.description": "Upptäck ett nytt sätt att resa med HomeExchange: bli välkomnad över hela världen och spara pengar!",
  "signup-modal.email.button": "Registrera dig med din e-postadress",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrera dig med Facebook",
  "signup-modal.have-an-account": "Har du redan ett konto?"
}, XR = "en", QR = FR({
  fallbackLng: XR,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      auth: VR
    },
    de: {
      auth: UR
    },
    en: {
      auth: BR
    },
    es: {
      auth: HR
    },
    fr: {
      auth: KR
    },
    hr: {
      auth: WR
    },
    it: {
      auth: qR
    },
    nb: {
      auth: ZR
    },
    nl: {
      auth: JR
    },
    pt: {
      auth: GR
    },
    sv: {
      auth: YR
    }
  }
});
QR.init();
const eA = Te.createContext(null);
eA.displayName = "HookFormContext";
typeof window < "u" ? Te.useLayoutEffect : Te.useEffect;
function A(e, t, n) {
  function o(a, l) {
    var c;
    Object.defineProperty(a, "_zod", {
      value: a._zod ?? {},
      enumerable: !1
    }), (c = a._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), a._zod.traits.add(e), t(a, l);
    for (const u in s.prototype)
      u in a || Object.defineProperty(a, u, { value: s.prototype[u].bind(a) });
    a._zod.constr = s, a._zod.def = l;
  }
  const r = n?.Parent ?? Object;
  class i extends r {
  }
  Object.defineProperty(i, "name", { value: e });
  function s(a) {
    var l;
    const c = n?.Parent ? new i() : this;
    o(c, a), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(s, "init", { value: o }), Object.defineProperty(s, Symbol.hasInstance, {
    value: (a) => n?.Parent && a instanceof n.Parent ? !0 : a?._zod?.traits?.has(e)
  }), Object.defineProperty(s, "name", { value: e }), s;
}
class Gn extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
const Xf = {};
function qt(e) {
  return Xf;
}
function tA(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, o]) => t.indexOf(+n) === -1).map(([n, o]) => o);
}
function ss(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Qf(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function ca(e) {
  return e == null;
}
function la(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const Al = Symbol("evaluating");
function ye(e, t, n) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== Al)
        return o === void 0 && (o = Al, o = n()), o;
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function nA(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function en(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function On(...e) {
  const t = {};
  for (const n of e) {
    const o = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Il(e) {
  return JSON.stringify(e);
}
const eh = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function as(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const oA = Qf(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function cs(e) {
  if (as(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(as(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
const rA = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function $n(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function tn(e, t, n) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (o._zod.parent = e), o;
}
function G(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function iA(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function sA(e, t) {
  const n = e._zod.def, o = On(e._zod.def, {
    get shape() {
      const r = {};
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && (r[i] = n.shape[i]);
      }
      return en(this, "shape", r), r;
    },
    checks: []
  });
  return tn(e, o);
}
function aA(e, t) {
  const n = e._zod.def, o = On(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape };
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && delete r[i];
      }
      return en(this, "shape", r), r;
    },
    checks: []
  });
  return tn(e, o);
}
function cA(e, t) {
  if (!cs(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = On(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return en(this, "shape", o), o;
    },
    checks: []
  });
  return tn(e, n);
}
function lA(e, t) {
  const n = On(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return en(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return tn(e, n);
}
function uA(e, t, n) {
  const o = On(t._zod.def, {
    get shape() {
      const r = t._zod.def.shape, i = { ...r };
      if (n)
        for (const s in n) {
          if (!(s in r))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (i[s] = e ? new e({
            type: "optional",
            innerType: r[s]
          }) : r[s]);
        }
      else
        for (const s in r)
          i[s] = e ? new e({
            type: "optional",
            innerType: r[s]
          }) : r[s];
      return en(this, "shape", i), i;
    },
    checks: []
  });
  return tn(t, o);
}
function dA(e, t, n) {
  const o = On(t._zod.def, {
    get shape() {
      const r = t._zod.def.shape, i = { ...r };
      if (n)
        for (const s in n) {
          if (!(s in i))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (i[s] = new e({
            type: "nonoptional",
            innerType: r[s]
          }));
        }
      else
        for (const s in r)
          i[s] = new e({
            type: "nonoptional",
            innerType: r[s]
          });
      return en(this, "shape", i), i;
    },
    checks: []
  });
  return tn(t, o);
}
function Un(e, t = 0) {
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function th(e, t) {
  return t.map((n) => {
    var o;
    return (o = n).path ?? (o.path = []), n.path.unshift(e), n;
  });
}
function Ro(e) {
  return typeof e == "string" ? e : e?.message;
}
function Zt(e, t, n) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const r = Ro(e.inst?._zod.def?.error?.(e)) ?? Ro(t?.error?.(e)) ?? Ro(n.customError?.(e)) ?? Ro(n.localeError?.(e)) ?? "Invalid input";
    o.message = r;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function ua(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Yn(...e) {
  const [t, n, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: o
  } : { ...t };
}
const nh = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, ss, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, oh = A("$ZodError", nh), rh = A("$ZodError", nh, { Parent: Error });
function pA(e, t = (n) => n.message) {
  const n = {}, o = [];
  for (const r of e.issues)
    r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : o.push(t(r));
  return { formErrors: o, fieldErrors: n };
}
function fA(e, t) {
  const n = t || function(i) {
    return i.message;
  }, o = { _errors: [] }, r = (i) => {
    for (const s of i.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((a) => r({ issues: a }));
      else if (s.code === "invalid_key")
        r({ issues: s.issues });
      else if (s.code === "invalid_element")
        r({ issues: s.issues });
      else if (s.path.length === 0)
        o._errors.push(n(s));
      else {
        let a = o, l = 0;
        for (; l < s.path.length; ) {
          const c = s.path[l];
          l === s.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(s))) : a[c] = a[c] || { _errors: [] }, a = a[c], l++;
        }
      }
  };
  return r(e), o;
}
const hA = (e) => (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !1 }) : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise)
    throw new Gn();
  if (s.issues.length) {
    const a = new (r?.Err ?? e)(s.issues.map((l) => Zt(l, i, qt())));
    throw eh(a, r?.callee), a;
  }
  return s.value;
}, mA = (e) => async (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const a = new (r?.Err ?? e)(s.issues.map((l) => Zt(l, i, qt())));
    throw eh(a, r?.callee), a;
  }
  return s.value;
}, ih = (e) => (t, n, o) => {
  const r = o ? { ...o, async: !1 } : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise)
    throw new Gn();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? oh)(i.issues.map((s) => Zt(s, r, qt())))
  } : { success: !0, data: i.value };
}, gA = /* @__PURE__ */ ih(rh), sh = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, r);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((s) => Zt(s, r, qt())))
  } : { success: !0, data: i.value };
}, vA = /* @__PURE__ */ sh(rh), bA = /^[cC][^\s-]{8,}$/, yA = /^[0-9a-z]+$/, wA = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, _A = /^[0-9a-vA-V]{20}$/, xA = /^[A-Za-z0-9]{27}$/, $A = /^[a-zA-Z0-9_-]{21}$/, kA = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, EA = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Pl = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/, SA = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, CA = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function OA() {
  return new RegExp(CA, "u");
}
const NA = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, RA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, AA = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, IA = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, PA = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ah = /^[A-Za-z0-9_-]*$/, TA = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, LA = /^\+(?:[0-9]){6,14}[0-9]$/, ch = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", jA = /* @__PURE__ */ new RegExp(`^${ch}$`);
function lh(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function DA(e) {
  return new RegExp(`^${lh(e)}$`);
}
function zA(e) {
  const t = lh({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${ch}T(?:${o})$`);
}
const MA = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, FA = /^[^A-Z]*$/, VA = /^[^a-z]*$/, vt = /* @__PURE__ */ A("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), UA = /* @__PURE__ */ A("$ZodCheckMaxLength", (e, t) => {
  var n;
  vt.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ca(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < r && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length <= t.maximum)
      return;
    const i = ua(r);
    o.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), BA = /* @__PURE__ */ A("$ZodCheckMinLength", (e, t) => {
  var n;
  vt.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ca(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > r && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length >= t.minimum)
      return;
    const i = ua(r);
    o.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), HA = /* @__PURE__ */ A("$ZodCheckLengthEquals", (e, t) => {
  var n;
  vt.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ca(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.minimum = t.length, r.maximum = t.length, r.length = t.length;
  }), e._zod.check = (o) => {
    const r = o.value, i = r.length;
    if (i === t.length)
      return;
    const s = ua(r), a = i > t.length;
    o.issues.push({
      origin: s,
      ...a ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Br = /* @__PURE__ */ A("$ZodCheckStringFormat", (e, t) => {
  var n, o;
  vt.init(e, t), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: r.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), KA = /* @__PURE__ */ A("$ZodCheckRegex", (e, t) => {
  Br.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), WA = /* @__PURE__ */ A("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = FA), Br.init(e, t);
}), qA = /* @__PURE__ */ A("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = VA), Br.init(e, t);
}), ZA = /* @__PURE__ */ A("$ZodCheckIncludes", (e, t) => {
  vt.init(e, t);
  const n = $n(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = o, e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(o);
  }), e._zod.check = (r) => {
    r.value.includes(t.includes, t.position) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), JA = /* @__PURE__ */ A("$ZodCheckStartsWith", (e, t) => {
  vt.init(e, t);
  const n = new RegExp(`^${$n(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), GA = /* @__PURE__ */ A("$ZodCheckEndsWith", (e, t) => {
  vt.init(e, t);
  const n = new RegExp(`.*${$n(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), YA = /* @__PURE__ */ A("$ZodCheckOverwrite", (e, t) => {
  vt.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class XA {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((i) => i), o = Math.min(...n.map((i) => i.length - i.trimStart().length)), r = n.map((i) => i.slice(o)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of r)
      this.content.push(i);
  }
  compile() {
    const t = Function, n = this?.args, o = [...(this?.content ?? [""]).map((r) => `  ${r}`)];
    return new t(...n, o.join(`
`));
  }
}
const QA = {
  major: 4,
  minor: 0,
  patch: 15
}, Ne = /* @__PURE__ */ A("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = QA;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const r of o)
    for (const i of r._zod.onattach)
      i(e);
  if (o.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const r = (i, s, a) => {
      let l = Un(i), c;
      for (const u of s) {
        if (u._zod.def.when) {
          if (!u._zod.def.when(i))
            continue;
        } else if (l)
          continue;
        const d = i.issues.length, f = u._zod.check(i);
        if (f instanceof Promise && a?.async === !1)
          throw new Gn();
        if (c || f instanceof Promise)
          c = (c ?? Promise.resolve()).then(async () => {
            await f, i.issues.length !== d && (l || (l = Un(i, d)));
          });
        else {
          if (i.issues.length === d)
            continue;
          l || (l = Un(i, d));
        }
      }
      return c ? c.then(() => i) : i;
    };
    e._zod.run = (i, s) => {
      const a = e._zod.parse(i, s);
      if (a instanceof Promise) {
        if (s.async === !1)
          throw new Gn();
        return a.then((l) => r(l, o, s));
      }
      return r(a, o, s);
    };
  }
  e["~standard"] = {
    validate: (r) => {
      try {
        const i = gA(e, r);
        return i.success ? { value: i.data } : { issues: i.error?.issues };
      } catch {
        return vA(e, r).then((i) => i.success ? { value: i.data } : { issues: i.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), da = /* @__PURE__ */ A("$ZodString", (e, t) => {
  Ne.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? MA(e._zod.bag), e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), _e = /* @__PURE__ */ A("$ZodStringFormat", (e, t) => {
  Br.init(e, t), da.init(e, t);
}), eI = /* @__PURE__ */ A("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = EA), _e.init(e, t);
}), tI = /* @__PURE__ */ A("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Pl(n));
  } else
    t.pattern ?? (t.pattern = Pl());
  _e.init(e, t);
}), nI = /* @__PURE__ */ A("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = SA), _e.init(e, t);
}), oI = /* @__PURE__ */ A("$ZodURL", (e, t) => {
  _e.init(e, t), e._zod.check = (n) => {
    try {
      const o = n.value.trim(), r = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(r.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: TA.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = r.href : n.value = o;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), rI = /* @__PURE__ */ A("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = OA()), _e.init(e, t);
}), iI = /* @__PURE__ */ A("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = $A), _e.init(e, t);
}), sI = /* @__PURE__ */ A("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = bA), _e.init(e, t);
}), aI = /* @__PURE__ */ A("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = yA), _e.init(e, t);
}), cI = /* @__PURE__ */ A("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = wA), _e.init(e, t);
}), lI = /* @__PURE__ */ A("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = _A), _e.init(e, t);
}), uI = /* @__PURE__ */ A("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = xA), _e.init(e, t);
}), dI = /* @__PURE__ */ A("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = zA(t)), _e.init(e, t);
}), pI = /* @__PURE__ */ A("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = jA), _e.init(e, t);
}), fI = /* @__PURE__ */ A("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = DA(t)), _e.init(e, t);
}), hI = /* @__PURE__ */ A("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = kA), _e.init(e, t);
}), mI = /* @__PURE__ */ A("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = NA), _e.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv4";
  });
}), gI = /* @__PURE__ */ A("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = RA), _e.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), vI = /* @__PURE__ */ A("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = AA), _e.init(e, t);
}), bI = /* @__PURE__ */ A("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = IA), _e.init(e, t), e._zod.check = (n) => {
    const [o, r] = n.value.split("/");
    try {
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${o}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function uh(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const yI = /* @__PURE__ */ A("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = PA), _e.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    uh(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function wI(e) {
  if (!ah.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return uh(n);
}
const _I = /* @__PURE__ */ A("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ah), _e.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    wI(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xI = /* @__PURE__ */ A("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = LA), _e.init(e, t);
});
function $I(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [o] = n;
    if (!o)
      return !1;
    const r = JSON.parse(atob(o));
    return !("typ" in r && r?.typ !== "JWT" || !r.alg || t && (!("alg" in r) || r.alg !== t));
  } catch {
    return !1;
  }
}
const kI = /* @__PURE__ */ A("$ZodJWT", (e, t) => {
  _e.init(e, t), e._zod.check = (n) => {
    $I(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), EI = /* @__PURE__ */ A("$ZodUnknown", (e, t) => {
  Ne.init(e, t), e._zod.parse = (n) => n;
}), SI = /* @__PURE__ */ A("$ZodNever", (e, t) => {
  Ne.init(e, t), e._zod.parse = (n, o) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function Tl(e, t, n) {
  e.issues.length && t.issues.push(...th(n, e.issues)), t.value[n] = e.value;
}
const CI = /* @__PURE__ */ A("$ZodArray", (e, t) => {
  Ne.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value;
    if (!Array.isArray(r))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: r,
        inst: e
      }), n;
    n.value = Array(r.length);
    const i = [];
    for (let s = 0; s < r.length; s++) {
      const a = r[s], l = t.element._zod.run({
        value: a,
        issues: []
      }, o);
      l instanceof Promise ? i.push(l.then((c) => Tl(c, n, s))) : Tl(l, n, s);
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
});
function Ao(e, t, n, o) {
  e.issues.length && t.issues.push(...th(n, e.issues)), e.value === void 0 ? n in o && (t.value[n] = void 0) : t.value[n] = e.value;
}
const OI = /* @__PURE__ */ A("$ZodObject", (e, t) => {
  Ne.init(e, t);
  const n = Qf(() => {
    const u = Object.keys(t.shape);
    for (const f of u)
      if (!(t.shape[f] instanceof Ne))
        throw new Error(`Invalid element at key "${f}": expected a Zod schema`);
    const d = iA(t.shape);
    return {
      shape: t.shape,
      keys: u,
      keySet: new Set(u),
      numKeys: u.length,
      optionalKeys: new Set(d)
    };
  });
  ye(e._zod, "propValues", () => {
    const u = t.shape, d = {};
    for (const f in u) {
      const h = u[f]._zod;
      if (h.values) {
        d[f] ?? (d[f] = /* @__PURE__ */ new Set());
        for (const b of h.values)
          d[f].add(b);
      }
    }
    return d;
  });
  const o = (u) => {
    const d = new XA(["shape", "payload", "ctx"]), f = n.value, h = ($) => {
      const v = Il($);
      return `shape[${v}]._zod.run({ value: input[${v}], issues: [] }, ctx)`;
    };
    d.write("const input = payload.value;");
    const b = /* @__PURE__ */ Object.create(null);
    let p = 0;
    for (const $ of f.keys)
      b[$] = `key_${p++}`;
    d.write("const newResult = {}");
    for (const $ of f.keys) {
      const v = b[$], w = Il($);
      d.write(`const ${v} = ${h($)};`), d.write(`
        if (${v}.issues.length) {
          payload.issues = payload.issues.concat(${v}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${w}, ...iss.path] : [${w}]
          })));
        }
        
        if (${v}.value === undefined) {
          if (${w} in input) {
            newResult[${w}] = undefined;
          }
        } else {
          newResult[${w}] = ${v}.value;
        }
      `);
    }
    d.write("payload.value = newResult;"), d.write("return payload;");
    const y = d.compile();
    return ($, v) => y(u, $, v);
  };
  let r;
  const i = as, s = !Xf.jitless, a = s && oA.value, l = t.catchall;
  let c;
  e._zod.parse = (u, d) => {
    c ?? (c = n.value);
    const f = u.value;
    if (!i(f))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: f,
        inst: e
      }), u;
    const h = [];
    if (s && a && d?.async === !1 && d.jitless !== !0)
      r || (r = o(t.shape)), u = r(u, d);
    else {
      u.value = {};
      const v = c.shape;
      for (const w of c.keys) {
        const _ = v[w]._zod.run({ value: f[w], issues: [] }, d);
        _ instanceof Promise ? h.push(_.then((x) => Ao(x, u, w, f))) : Ao(_, u, w, f);
      }
    }
    if (!l)
      return h.length ? Promise.all(h).then(() => u) : u;
    const b = [], p = c.keySet, y = l._zod, $ = y.def.type;
    for (const v of Object.keys(f)) {
      if (p.has(v))
        continue;
      if ($ === "never") {
        b.push(v);
        continue;
      }
      const w = y.run({ value: f[v], issues: [] }, d);
      w instanceof Promise ? h.push(w.then((_) => Ao(_, u, v, f))) : Ao(w, u, v, f);
    }
    return b.length && u.issues.push({
      code: "unrecognized_keys",
      keys: b,
      input: f,
      inst: e
    }), h.length ? Promise.all(h).then(() => u) : u;
  };
});
function Ll(e, t, n, o) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const r = e.filter((i) => !Un(i));
  return r.length === 1 ? (t.value = r[0].value, r[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((i) => i.issues.map((s) => Zt(s, o, qt())))
  }), t);
}
const NI = /* @__PURE__ */ A("$ZodUnion", (e, t) => {
  Ne.init(e, t), ye(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), ye(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), ye(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), ye(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${r.map((i) => la(i.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (r, i) => {
    if (n)
      return o(r, i);
    let s = !1;
    const a = [];
    for (const l of t.options) {
      const c = l._zod.run({
        value: r.value,
        issues: []
      }, i);
      if (c instanceof Promise)
        a.push(c), s = !0;
      else {
        if (c.issues.length === 0)
          return c;
        a.push(c);
      }
    }
    return s ? Promise.all(a).then((l) => Ll(l, r, e, i)) : Ll(a, r, e, i);
  };
}), RI = /* @__PURE__ */ A("$ZodIntersection", (e, t) => {
  Ne.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value, i = t.left._zod.run({ value: r, issues: [] }, o), s = t.right._zod.run({ value: r, issues: [] }, o);
    return i instanceof Promise || s instanceof Promise ? Promise.all([i, s]).then(([a, l]) => jl(n, a, l)) : jl(n, i, s);
  };
});
function ls(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (cs(e) && cs(t)) {
    const n = Object.keys(t), o = Object.keys(e).filter((i) => n.indexOf(i) !== -1), r = { ...e, ...t };
    for (const i of o) {
      const s = ls(e[i], t[i]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...s.mergeErrorPath]
        };
      r[i] = s.data;
    }
    return { valid: !0, data: r };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let o = 0; o < e.length; o++) {
      const r = e[o], i = t[o], s = ls(r, i);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...s.mergeErrorPath]
        };
      n.push(s.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function jl(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), Un(e))
    return e;
  const o = ls(t.value, n.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const AI = /* @__PURE__ */ A("$ZodEnum", (e, t) => {
  Ne.init(e, t);
  const n = tA(t.entries), o = new Set(n);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${n.filter((r) => rA.has(typeof r)).map((r) => typeof r == "string" ? $n(r) : r.toString()).join("|")})$`), e._zod.parse = (r, i) => {
    const s = r.value;
    return o.has(s) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: s,
      inst: e
    }), r;
  };
}), II = /* @__PURE__ */ A("$ZodLiteral", (e, t) => {
  if (Ne.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(t.values), e._zod.pattern = new RegExp(`^(${t.values.map((n) => typeof n == "string" ? $n(n) : n ? $n(n.toString()) : String(n)).join("|")})$`), e._zod.parse = (n, o) => {
    const r = n.value;
    return e._zod.values.has(r) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: r,
      inst: e
    }), n;
  };
}), PI = /* @__PURE__ */ A("$ZodTransform", (e, t) => {
  Ne.init(e, t), e._zod.parse = (n, o) => {
    const r = t.transform(n.value, n);
    if (o.async)
      return (r instanceof Promise ? r : Promise.resolve(r)).then((i) => (n.value = i, n));
    if (r instanceof Promise)
      throw new Gn();
    return n.value = r, n;
  };
});
function Dl(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const TI = /* @__PURE__ */ A("$ZodOptional", (e, t) => {
  Ne.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", ye(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), ye(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${la(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, o) => {
    if (t.innerType._zod.optin === "optional") {
      const r = t.innerType._zod.run(n, o);
      return r instanceof Promise ? r.then((i) => Dl(i, n.value)) : Dl(r, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, o);
  };
}), LI = /* @__PURE__ */ A("$ZodNullable", (e, t) => {
  Ne.init(e, t), ye(e._zod, "optin", () => t.innerType._zod.optin), ye(e._zod, "optout", () => t.innerType._zod.optout), ye(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${la(n.source)}|null)$`) : void 0;
  }), ye(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, o) => n.value === null ? n : t.innerType._zod.run(n, o);
}), jI = /* @__PURE__ */ A("$ZodDefault", (e, t) => {
  Ne.init(e, t), e._zod.optin = "optional", ye(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => zl(i, t)) : zl(r, t);
  };
});
function zl(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const DI = /* @__PURE__ */ A("$ZodPrefault", (e, t) => {
  Ne.init(e, t), e._zod.optin = "optional", ye(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => (n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, o));
}), zI = /* @__PURE__ */ A("$ZodNonOptional", (e, t) => {
  Ne.init(e, t), ye(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (n, o) => {
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => Ml(i, e)) : Ml(r, e);
  };
});
function Ml(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const MI = /* @__PURE__ */ A("$ZodCatch", (e, t) => {
  Ne.init(e, t), ye(e._zod, "optin", () => t.innerType._zod.optin), ye(e._zod, "optout", () => t.innerType._zod.optout), ye(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((s) => Zt(s, o, qt()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = r.value, r.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: r.issues.map((i) => Zt(i, o, qt()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), FI = /* @__PURE__ */ A("$ZodPipe", (e, t) => {
  Ne.init(e, t), ye(e._zod, "values", () => t.in._zod.values), ye(e._zod, "optin", () => t.in._zod.optin), ye(e._zod, "optout", () => t.out._zod.optout), ye(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, o) => {
    const r = t.in._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => Fl(i, t, o)) : Fl(r, t, o);
  };
});
function Fl(e, t, n) {
  return e.issues.length ? e : t.out._zod.run({ value: e.value, issues: e.issues }, n);
}
const VI = /* @__PURE__ */ A("$ZodReadonly", (e, t) => {
  Ne.init(e, t), ye(e._zod, "propValues", () => t.innerType._zod.propValues), ye(e._zod, "values", () => t.innerType._zod.values), ye(e._zod, "optin", () => t.innerType._zod.optin), ye(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, o) => {
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then(Vl) : Vl(r);
  };
});
function Vl(e) {
  return e.value = Object.freeze(e.value), e;
}
const UI = /* @__PURE__ */ A("$ZodCustom", (e, t) => {
  vt.init(e, t), Ne.init(e, t), e._zod.parse = (n, o) => n, e._zod.check = (n) => {
    const o = n.value, r = t.fn(o);
    if (r instanceof Promise)
      return r.then((i) => Ul(i, n, o, e));
    Ul(r, n, o, e);
  };
});
function Ul(e, t, n, o) {
  if (!e) {
    const r = {
      code: "custom",
      input: n,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (r.params = o._zod.def.params), t.issues.push(Yn(r));
  }
}
class BI {
  constructor() {
    this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const o = n[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new Map(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const o = { ...this.get(n) ?? {} };
      delete o.id;
      const r = { ...o, ...this._map.get(t) };
      return Object.keys(r).length ? r : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function HI() {
  return new BI();
}
const Io = /* @__PURE__ */ HI();
function KI(e, t) {
  return new e({
    type: "string",
    ...G(t)
  });
}
function dh(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function Bl(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function WI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function qI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...G(t)
  });
}
function ZI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...G(t)
  });
}
function JI(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...G(t)
  });
}
function GI(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function YI(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function XI(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function QI(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function eP(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function tP(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function nP(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function oP(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function rP(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function iP(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function sP(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function aP(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function cP(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function lP(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function uP(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function dP(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...G(t)
  });
}
function pP(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...G(t)
  });
}
function fP(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...G(t)
  });
}
function hP(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...G(t)
  });
}
function mP(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...G(t)
  });
}
function gP(e) {
  return new e({
    type: "unknown"
  });
}
function vP(e, t) {
  return new e({
    type: "never",
    ...G(t)
  });
}
function ph(e, t) {
  return new UA({
    check: "max_length",
    ...G(t),
    maximum: e
  });
}
function br(e, t) {
  return new BA({
    check: "min_length",
    ...G(t),
    minimum: e
  });
}
function fh(e, t) {
  return new HA({
    check: "length_equals",
    ...G(t),
    length: e
  });
}
function bP(e, t) {
  return new KA({
    check: "string_format",
    format: "regex",
    ...G(t),
    pattern: e
  });
}
function yP(e) {
  return new WA({
    check: "string_format",
    format: "lowercase",
    ...G(e)
  });
}
function wP(e) {
  return new qA({
    check: "string_format",
    format: "uppercase",
    ...G(e)
  });
}
function _P(e, t) {
  return new ZA({
    check: "string_format",
    format: "includes",
    ...G(t),
    includes: e
  });
}
function xP(e, t) {
  return new JA({
    check: "string_format",
    format: "starts_with",
    ...G(t),
    prefix: e
  });
}
function $P(e, t) {
  return new GA({
    check: "string_format",
    format: "ends_with",
    ...G(t),
    suffix: e
  });
}
function co(e) {
  return new YA({
    check: "overwrite",
    tx: e
  });
}
function kP(e) {
  return co((t) => t.normalize(e));
}
function EP() {
  return co((e) => e.trim());
}
function SP() {
  return co((e) => e.toLowerCase());
}
function CP() {
  return co((e) => e.toUpperCase());
}
function OP(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...G(n)
  });
}
function NP(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...G(n)
  });
}
function RP(e) {
  const t = AP((n) => (n.addIssue = (o) => {
    if (typeof o == "string")
      n.issues.push(Yn(o, n.value, t._zod.def));
    else {
      const r = o;
      r.fatal && (r.continue = !1), r.code ?? (r.code = "custom"), r.input ?? (r.input = n.value), r.inst ?? (r.inst = t), r.continue ?? (r.continue = !t._zod.def.abort), n.issues.push(Yn(r));
    }
  }, e(n.value, n)));
  return t;
}
function AP(e, t) {
  const n = new vt({
    check: "custom",
    ...G(t)
  });
  return n._zod.check = e, n;
}
const IP = /* @__PURE__ */ A("ZodISODateTime", (e, t) => {
  dI.init(e, t), $e.init(e, t);
});
function PP(e) {
  return pP(IP, e);
}
const TP = /* @__PURE__ */ A("ZodISODate", (e, t) => {
  pI.init(e, t), $e.init(e, t);
});
function LP(e) {
  return fP(TP, e);
}
const jP = /* @__PURE__ */ A("ZodISOTime", (e, t) => {
  fI.init(e, t), $e.init(e, t);
});
function DP(e) {
  return hP(jP, e);
}
const zP = /* @__PURE__ */ A("ZodISODuration", (e, t) => {
  hI.init(e, t), $e.init(e, t);
});
function MP(e) {
  return mP(zP, e);
}
const FP = (e, t) => {
  oh.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => fA(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => pA(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, ss, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, ss, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Hr = A("ZodError", FP, {
  Parent: Error
}), VP = /* @__PURE__ */ hA(Hr), UP = /* @__PURE__ */ mA(Hr), BP = /* @__PURE__ */ ih(Hr), HP = /* @__PURE__ */ sh(Hr), je = /* @__PURE__ */ A("ZodType", (e, t) => (Ne.init(e, t), e.def = t, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...n.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (n, o) => tn(e, n, o), e.brand = () => e, e.register = (n, o) => (n.add(e, o), e), e.parse = (n, o) => VP(e, n, o, { callee: e.parse }), e.safeParse = (n, o) => BP(e, n, o), e.parseAsync = async (n, o) => UP(e, n, o, { callee: e.parseAsync }), e.safeParseAsync = async (n, o) => HP(e, n, o), e.spa = e.safeParseAsync, e.refine = (n, o) => e.check(jT(n, o)), e.superRefine = (n) => e.check(DT(n)), e.overwrite = (n) => e.check(co(n)), e.optional = () => Wl(e), e.nullable = () => ql(e), e.nullish = () => Wl(ql(e)), e.nonoptional = (n) => NT(e, n), e.array = () => fT(e), e.or = (n) => gT([e, n]), e.and = (n) => bT(e, n), e.transform = (n) => Zl(e, $T(n)), e.default = (n) => ST(e, n), e.prefault = (n) => OT(e, n), e.catch = (n) => AT(e, n), e.pipe = (n) => Zl(e, n), e.readonly = () => TT(e), e.describe = (n) => {
  const o = e.clone();
  return Io.add(o, { description: n }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Io.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Io.get(e);
  const o = e.clone();
  return Io.add(o, n[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), hh = /* @__PURE__ */ A("_ZodString", (e, t) => {
  da.init(e, t), je.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...o) => e.check(bP(...o)), e.includes = (...o) => e.check(_P(...o)), e.startsWith = (...o) => e.check(xP(...o)), e.endsWith = (...o) => e.check($P(...o)), e.min = (...o) => e.check(br(...o)), e.max = (...o) => e.check(ph(...o)), e.length = (...o) => e.check(fh(...o)), e.nonempty = (...o) => e.check(br(1, ...o)), e.lowercase = (o) => e.check(yP(o)), e.uppercase = (o) => e.check(wP(o)), e.trim = () => e.check(EP()), e.normalize = (...o) => e.check(kP(...o)), e.toLowerCase = () => e.check(SP()), e.toUpperCase = () => e.check(CP());
}), KP = /* @__PURE__ */ A("ZodString", (e, t) => {
  da.init(e, t), hh.init(e, t), e.email = (n) => e.check(dh(mh, n)), e.url = (n) => e.check(GI(qP, n)), e.jwt = (n) => e.check(dP(cT, n)), e.emoji = (n) => e.check(YI(ZP, n)), e.guid = (n) => e.check(Bl(Hl, n)), e.uuid = (n) => e.check(WI(Po, n)), e.uuidv4 = (n) => e.check(qI(Po, n)), e.uuidv6 = (n) => e.check(ZI(Po, n)), e.uuidv7 = (n) => e.check(JI(Po, n)), e.nanoid = (n) => e.check(XI(JP, n)), e.guid = (n) => e.check(Bl(Hl, n)), e.cuid = (n) => e.check(QI(GP, n)), e.cuid2 = (n) => e.check(eP(YP, n)), e.ulid = (n) => e.check(tP(XP, n)), e.base64 = (n) => e.check(cP(iT, n)), e.base64url = (n) => e.check(lP(sT, n)), e.xid = (n) => e.check(nP(QP, n)), e.ksuid = (n) => e.check(oP(eT, n)), e.ipv4 = (n) => e.check(rP(tT, n)), e.ipv6 = (n) => e.check(iP(nT, n)), e.cidrv4 = (n) => e.check(sP(oT, n)), e.cidrv6 = (n) => e.check(aP(rT, n)), e.e164 = (n) => e.check(uP(aT, n)), e.datetime = (n) => e.check(PP(n)), e.date = (n) => e.check(LP(n)), e.time = (n) => e.check(DP(n)), e.duration = (n) => e.check(MP(n));
});
function fn(e) {
  return KI(KP, e);
}
const $e = /* @__PURE__ */ A("ZodStringFormat", (e, t) => {
  _e.init(e, t), hh.init(e, t);
}), mh = /* @__PURE__ */ A("ZodEmail", (e, t) => {
  nI.init(e, t), $e.init(e, t);
});
function WP(e) {
  return dh(mh, e);
}
const Hl = /* @__PURE__ */ A("ZodGUID", (e, t) => {
  eI.init(e, t), $e.init(e, t);
}), Po = /* @__PURE__ */ A("ZodUUID", (e, t) => {
  tI.init(e, t), $e.init(e, t);
}), qP = /* @__PURE__ */ A("ZodURL", (e, t) => {
  oI.init(e, t), $e.init(e, t);
}), ZP = /* @__PURE__ */ A("ZodEmoji", (e, t) => {
  rI.init(e, t), $e.init(e, t);
}), JP = /* @__PURE__ */ A("ZodNanoID", (e, t) => {
  iI.init(e, t), $e.init(e, t);
}), GP = /* @__PURE__ */ A("ZodCUID", (e, t) => {
  sI.init(e, t), $e.init(e, t);
}), YP = /* @__PURE__ */ A("ZodCUID2", (e, t) => {
  aI.init(e, t), $e.init(e, t);
}), XP = /* @__PURE__ */ A("ZodULID", (e, t) => {
  cI.init(e, t), $e.init(e, t);
}), QP = /* @__PURE__ */ A("ZodXID", (e, t) => {
  lI.init(e, t), $e.init(e, t);
}), eT = /* @__PURE__ */ A("ZodKSUID", (e, t) => {
  uI.init(e, t), $e.init(e, t);
}), tT = /* @__PURE__ */ A("ZodIPv4", (e, t) => {
  mI.init(e, t), $e.init(e, t);
}), nT = /* @__PURE__ */ A("ZodIPv6", (e, t) => {
  gI.init(e, t), $e.init(e, t);
}), oT = /* @__PURE__ */ A("ZodCIDRv4", (e, t) => {
  vI.init(e, t), $e.init(e, t);
}), rT = /* @__PURE__ */ A("ZodCIDRv6", (e, t) => {
  bI.init(e, t), $e.init(e, t);
}), iT = /* @__PURE__ */ A("ZodBase64", (e, t) => {
  yI.init(e, t), $e.init(e, t);
}), sT = /* @__PURE__ */ A("ZodBase64URL", (e, t) => {
  _I.init(e, t), $e.init(e, t);
}), aT = /* @__PURE__ */ A("ZodE164", (e, t) => {
  xI.init(e, t), $e.init(e, t);
}), cT = /* @__PURE__ */ A("ZodJWT", (e, t) => {
  kI.init(e, t), $e.init(e, t);
}), lT = /* @__PURE__ */ A("ZodUnknown", (e, t) => {
  EI.init(e, t), je.init(e, t);
});
function Kl() {
  return gP(lT);
}
const uT = /* @__PURE__ */ A("ZodNever", (e, t) => {
  SI.init(e, t), je.init(e, t);
});
function dT(e) {
  return vP(uT, e);
}
const pT = /* @__PURE__ */ A("ZodArray", (e, t) => {
  CI.init(e, t), je.init(e, t), e.element = t.element, e.min = (n, o) => e.check(br(n, o)), e.nonempty = (n) => e.check(br(1, n)), e.max = (n, o) => e.check(ph(n, o)), e.length = (n, o) => e.check(fh(n, o)), e.unwrap = () => e.element;
});
function fT(e, t) {
  return OP(pT, e, t);
}
const hT = /* @__PURE__ */ A("ZodObject", (e, t) => {
  OI.init(e, t), je.init(e, t), ye(e, "shape", () => t.shape), e.keyof = () => yT(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Kl() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Kl() }), e.strict = () => e.clone({ ...e._zod.def, catchall: dT() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => cA(e, n), e.merge = (n) => lA(e, n), e.pick = (n) => sA(e, n), e.omit = (n) => aA(e, n), e.partial = (...n) => uA(vh, e, n[0]), e.required = (...n) => dA(bh, e, n[0]);
});
function gh(e, t) {
  const n = {
    type: "object",
    get shape() {
      return en(this, "shape", e ? nA(e) : {}), this.shape;
    },
    ...G(t)
  };
  return new hT(n);
}
const mT = /* @__PURE__ */ A("ZodUnion", (e, t) => {
  NI.init(e, t), je.init(e, t), e.options = t.options;
});
function gT(e, t) {
  return new mT({
    type: "union",
    options: e,
    ...G(t)
  });
}
const vT = /* @__PURE__ */ A("ZodIntersection", (e, t) => {
  RI.init(e, t), je.init(e, t);
});
function bT(e, t) {
  return new vT({
    type: "intersection",
    left: e,
    right: t
  });
}
const us = /* @__PURE__ */ A("ZodEnum", (e, t) => {
  AI.init(e, t), je.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (o, r) => {
    const i = {};
    for (const s of o)
      if (n.has(s))
        i[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new us({
      ...t,
      checks: [],
      ...G(r),
      entries: i
    });
  }, e.exclude = (o, r) => {
    const i = { ...t.entries };
    for (const s of o)
      if (n.has(s))
        delete i[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new us({
      ...t,
      checks: [],
      ...G(r),
      entries: i
    });
  };
});
function yT(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new us({
    type: "enum",
    entries: n,
    ...G(t)
  });
}
const wT = /* @__PURE__ */ A("ZodLiteral", (e, t) => {
  II.init(e, t), je.init(e, t), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function _T(e, t) {
  return new wT({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...G(t)
  });
}
const xT = /* @__PURE__ */ A("ZodTransform", (e, t) => {
  PI.init(e, t), je.init(e, t), e._zod.parse = (n, o) => {
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(Yn(i, n.value, t));
      else {
        const s = i;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = n.value), s.inst ?? (s.inst = e), n.issues.push(Yn(s));
      }
    };
    const r = t.transform(n.value, n);
    return r instanceof Promise ? r.then((i) => (n.value = i, n)) : (n.value = r, n);
  };
});
function $T(e) {
  return new xT({
    type: "transform",
    transform: e
  });
}
const vh = /* @__PURE__ */ A("ZodOptional", (e, t) => {
  TI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Wl(e) {
  return new vh({
    type: "optional",
    innerType: e
  });
}
const kT = /* @__PURE__ */ A("ZodNullable", (e, t) => {
  LI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function ql(e) {
  return new kT({
    type: "nullable",
    innerType: e
  });
}
const ET = /* @__PURE__ */ A("ZodDefault", (e, t) => {
  jI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function ST(e, t) {
  return new ET({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const CT = /* @__PURE__ */ A("ZodPrefault", (e, t) => {
  DI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function OT(e, t) {
  return new CT({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const bh = /* @__PURE__ */ A("ZodNonOptional", (e, t) => {
  zI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function NT(e, t) {
  return new bh({
    type: "nonoptional",
    innerType: e,
    ...G(t)
  });
}
const RT = /* @__PURE__ */ A("ZodCatch", (e, t) => {
  MI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function AT(e, t) {
  return new RT({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const IT = /* @__PURE__ */ A("ZodPipe", (e, t) => {
  FI.init(e, t), je.init(e, t), e.in = t.in, e.out = t.out;
});
function Zl(e, t) {
  return new IT({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const PT = /* @__PURE__ */ A("ZodReadonly", (e, t) => {
  VI.init(e, t), je.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function TT(e) {
  return new PT({
    type: "readonly",
    innerType: e
  });
}
const LT = /* @__PURE__ */ A("ZodCustom", (e, t) => {
  UI.init(e, t), je.init(e, t);
});
function jT(e, t = {}) {
  return NP(LT, e, t);
}
function DT(e) {
  return RP(e);
}
gh({
  email: WP(),
  password: fn().min(8)
}).required();
gh({
  firstname: fn().min(1),
  lastname: fn().min(1),
  email: fn().email(),
  password: fn().min(8),
  sponsor: fn().optional(),
  cgus: _T(!0)
});
function zT({ children: e, onLogout: t }) {
  return e ? Jl(e, {
    onClick: async () => {
      await ES(), t && await t();
    }
  }) : null;
}
function yh({ apiUrl: e, children: t, onLogout: n }) {
  return iO(e), /* @__PURE__ */ m(wR, { apiUrl: e, children: /* @__PURE__ */ m(zT, { onLogout: n, children: t }) });
}
function wh() {
  const { t: e } = Gt("header");
  return /* @__PURE__ */ P(Is, { children: [
    /* @__PURE__ */ m(Ps, { children: /* @__PURE__ */ P(te, { gap: "2", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-help" }),
      e("help")
    ] }) }),
    /* @__PURE__ */ P(Ts, { children: [
      /* @__PURE__ */ m(Q, { href: e("links:faq"), children: e("faq") }),
      /* @__PURE__ */ m(Ye, {}),
      /* @__PURE__ */ m(Q, { href: e("links:guestpoints"), children: e("guestpoints") }),
      /* @__PURE__ */ m(Ye, {}),
      /* @__PURE__ */ m(Q, { href: e("links:about-calendar"), children: e("about-the-calendar") }),
      /* @__PURE__ */ m(Ye, {}),
      /* @__PURE__ */ m(Q, { href: e("links:guarantees"), children: e("guarantees") }),
      /* @__PURE__ */ m(Ye, {}),
      /* @__PURE__ */ m(Q, { href: e("links:contact-us"), children: e("contact") })
    ] })
  ] });
}
function MT() {
  const { url: e } = ve("/conversations"), { conversations: t, userInfos: n } = Ht((r) => ({
    conversations: r.conversations,
    userInfos: r.userInfos
  })), { t: o } = Gt("header");
  return /* @__PURE__ */ P(Is, { hideOn: "mobile", children: [
    /* @__PURE__ */ m(Ps, { children: /* @__PURE__ */ P(te, { gap: "2", alignItems: "center", children: [
      t && t?.notifications > 0 && /* @__PURE__ */ m(Es, { value: t?.notifications, onIcon: !0, children: /* @__PURE__ */ m(he, { name: "header-message-new" }) }),
      o("messages")
    ] }) }),
    /* @__PURE__ */ P(Ts, { size: "medium", children: [
      t?.all?.length ? /* @__PURE__ */ m(Q, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ m(FT, { conversations: t }) }) : /* @__PURE__ */ m(Q, { children: /* @__PURE__ */ P(te, { justifyContent: "center", children: [
        /* @__PURE__ */ m(Le, { children: o("no-messages") }),
        /* @__PURE__ */ m(
          "img",
          {
            src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/header/messages_empty.svg",
            alt: "no messages"
          }
        )
      ] }) }),
      /* @__PURE__ */ m(Q, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ P(te, { justifyContent: "space-between", isFullWidth: !0, alignItems: "center", children: [
        /* @__PURE__ */ P(Le, { size: "sm", children: [
          o("my-response-rate"),
          " ",
          /* @__PURE__ */ P(Le, { isSpan: !0, isBold: !0, size: "sm", children: [
            n?.response_rate,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ m(ps, { color: "tertiary", size: "medium", href: e, children: o("view-inbox") })
      ] }) })
    ] })
  ] });
}
const FT = ({ conversations: e }) => /* @__PURE__ */ m(
  Hv,
  {
    isFullWidth: !0,
    size: "small",
    tabs: [
      {
        title: "All",
        content: /* @__PURE__ */ m(ze, { children: e.all.map((t) => /* @__PURE__ */ m(Si, { conversation: t }, t.id)) })
      },
      {
        title: `Unreplied (${e.stats.unreplied})`,
        content: /* @__PURE__ */ m(ze, { children: e.unreplied.map((t) => /* @__PURE__ */ m(Si, { conversation: t }, t.id)) })
      },
      {
        title: `Finalized (${e.stats.finalized})`,
        content: /* @__PURE__ */ m(ze, { children: e.finalized.map((t) => /* @__PURE__ */ m(Si, { conversation: t }, t.id)) })
      }
    ]
  }
), Si = ({ conversation: e }) => {
  const { url: t } = ve(`/conversations/${e.id}`);
  return /* @__PURE__ */ P("a", { href: t, children: [
    /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", noMargin: !0, children: [
      /* @__PURE__ */ m(
        "img",
        {
          src: e.interlocutor.profilePicture,
          style: { height: "40px", width: "40px", background: "blue", borderRadius: "9999px" },
          alt: "user"
        }
      ),
      /* @__PURE__ */ P(
        "div",
        {
          style: {
            overflow: "hidden",
            flex: "1 0 0"
          },
          children: [
            /* @__PURE__ */ m(
              "div",
              {
                style: {
                  fontWeight: "bold"
                },
                children: e.interlocutor.firstName
              }
            ),
            /* @__PURE__ */ m(Le, { ellipsis: !0, size: "sm", children: e.lastMessage.content })
          ]
        }
      ),
      /* @__PURE__ */ m("div", { children: Eh(e.lastMessage.createdAt) })
    ] }),
    /* @__PURE__ */ m(Pv, { space: "small" })
  ] });
};
function VT() {
  const { t: e } = Gt("header"), { userInfos: t, completionRate: n, userProfile: o, userMembership: r, apiUrl: i } = Ht((p) => ({
    userInfos: p.userInfos,
    completionRate: p.userInfos?.profil.completionRate ?? 0,
    userProfile: p.userInfos?.notifications?.user?.details.userProfile,
    userMembership: p.userInfos?.notifications?.user?.details.membership,
    apiUrl: p.apiUrl
  })), { signout: s } = Pr((p) => ({
    signout: p.signout
  })), { url: a } = ve(`/user/edit/${t?.profil.id}`), { url: l } = ve("/homes/edit"), { url: c } = ve("/homes/create"), { url: u } = ve("/myexchanges"), { url: d } = ve("/my-plan"), { url: f } = ve("/user/favorite"), { url: h } = ve("/user/they-love-my-home"), { url: b } = ve(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ P(ze, { children: [
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: a, children: /* @__PURE__ */ P(te, { gap: "2", isFullWidth: !0, children: [
      /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ m(he, { name: "header-profile-profile" }),
          e("my-profile")
        ] }),
        /* @__PURE__ */ P(te, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ P(Le, { size: "sm", children: [
            n,
            "%"
          ] }),
          /* @__PURE__ */ m(Ia, { value: n, color: "tertiary", size: "small", ariaLabel: "User completion rate" })
        ] })
      ] }),
      /* @__PURE__ */ m(Le, { isBold: !0, size: "sm", color: "tertiary", children: o && e(`notification.user_profile.${o.status}`, {
        gp: o.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    t?.homes?.map((p) => /* @__PURE__ */ P("div", { children: [
      /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: `${l}/${p.id}`, children: /* @__PURE__ */ P(te, { gap: "2", isFullWidth: !0, children: [
        /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "space-between", children: [
          /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
            /* @__PURE__ */ m(he, { name: "header-profile-home" }),
            /* @__PURE__ */ m(Le, { size: "sm", children: "My Home" })
          ] }),
          /* @__PURE__ */ P(te, { alignItems: "center", gap: "2", children: [
            /* @__PURE__ */ P(Le, { size: "sm", children: [
              p.completionRate,
              "%"
            ] }),
            /* @__PURE__ */ m(
              Ia,
              {
                value: p.completionRate,
                color: "tertiary",
                size: "small",
                ariaLabel: "Home completion rate"
              }
            )
          ] })
        ] }),
        p.notifications?.status && /* @__PURE__ */ m(Le, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
          gp: p.notifications.gpReward
        }) })
      ] }) }),
      /* @__PURE__ */ m(Ye, {})
    ] }, p.id)),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: c, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "plus" }),
      e("add-home")
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: u, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "keys" }),
      e("my-exchanges")
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: d, children: /* @__PURE__ */ P(te, { gap: "2", children: [
      /* @__PURE__ */ m(te, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ m(te, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ m(he, { name: "credit-card" }),
        e("my-membership")
      ] }) }) }),
      r && /* @__PURE__ */ m(Le, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${r.status}`, {
        gp: r.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: f, children: /* @__PURE__ */ P(te, { isFullWidth: !0, gap: "4", justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "heart" }),
      e("my-favorite-homes")
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: h, children: /* @__PURE__ */ P(te, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-profile-they-love-my-home" }),
      e("they-love-my-home")
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(Q, { noPaddingRight: !0, href: b, children: /* @__PURE__ */ P(te, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-profile-settings" }),
      e("settings")
    ] }) }),
    /* @__PURE__ */ m(Ye, {}),
    /* @__PURE__ */ m(yh, { apiUrl: i, onLogout: s, children: /* @__PURE__ */ m(Q, { noPaddingRight: !0, children: /* @__PURE__ */ P(te, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function UT() {
  const { t: e } = Gt("header"), { userInfos: t, userProfile: n, userCompletionRate: o, userMemberShip: r } = Ht((p) => ({
    userInfos: p.userInfos,
    userProfile: p.userInfos?.profil,
    userCompletionRate: p.userInfos?.profil.completionRate ?? 0,
    userMemberShip: p.userInfos?.notifications?.user?.details.membership
  })), { url: i } = ve("/conversations"), { url: s } = ve(`/user/edit/${t?.profil.id}`), { url: a } = ve("/homes/edit"), { url: l } = ve("/homes/create"), { url: c } = ve("/myexchanges"), { url: u } = ve("/my-plan"), { url: d } = ve("/user/favorite"), { url: f } = ve("/user/they-love-my-home"), { url: h } = ve("/user/gpdetails"), { url: b } = ve(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ P(ze, { children: [
    /* @__PURE__ */ m(Q, { largerPaddingBottom: !0, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ m(Sd, { url: n?.profilePicture ?? "", alt: "avatar" }),
      /* @__PURE__ */ P("div", { children: [
        /* @__PURE__ */ P(Le, { isBold: !0, isSpan: !0, children: [
          n?.firstName,
          " ",
          t?.profil.lastName
        ] }),
        /* @__PURE__ */ P("div", { children: [
          /* @__PURE__ */ m(Le, { isBold: !0, isSpan: !0, color: "secondary", children: n?.totalGP }),
          " ",
          "GP"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ m(Q, { href: i, children: /* @__PURE__ */ m(te, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-message-new" }),
      "Inbox"
    ] }) }) }),
    /* @__PURE__ */ m(Q, { href: s, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ m(he, { name: "header-profile-profile" }),
        "My Profile"
      ] }),
      /* @__PURE__ */ P(Le, { color: o === 1 ? "primary" : "tertiary", children: [
        o,
        "%"
      ] })
    ] }) }),
    t?.homes?.map((p) => /* @__PURE__ */ m(Q, { href: `${a}/${p.id}`, children: /* @__PURE__ */ P(te, { gap: "0", isFullWidth: !0, children: [
      /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ P(te, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ m(he, { name: "header-profile-home" }),
          "My Home"
        ] }),
        /* @__PURE__ */ P(Le, { color: p.completionRate === 1 ? "primary" : "tertiary", children: [
          p.completionRate,
          "%"
        ] })
      ] }),
      p.notifications?.status && /* @__PURE__ */ m(Le, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
        gp: p.notifications.gpReward
      }) })
    ] }) }, p.id)),
    /* @__PURE__ */ m(Q, { href: l, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "plus" }),
      "Add a home"
    ] }) }),
    /* @__PURE__ */ m(Q, { href: c, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "keys" }),
      "My exchanges"
    ] }) }),
    /* @__PURE__ */ m(Q, { href: u, children: /* @__PURE__ */ P(te, { gap: "0", children: [
      /* @__PURE__ */ m(te, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ P(te, { justifyContent: "start", gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ m(he, { name: "credit-card" }),
        "My membership"
      ] }) }),
      r && /* @__PURE__ */ m(Le, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${r.status}`, {
        gp: r.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ m(Q, { href: d, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "heart" }),
      "My favorite homes"
    ] }) }),
    /* @__PURE__ */ m(Q, { href: f, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-profile-they-love-my-home" }),
      "They love my home"
    ] }) }),
    /* @__PURE__ */ m(Q, { href: b, children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ m(he, { name: "header-profile-settings" }),
      "My settings"
    ] }) }),
    /* @__PURE__ */ m(Q, { href: h, children: /* @__PURE__ */ m(Le, { isSpan: !0, color: "secondary", children: "Sponsor 10 friends and receive up to 2500 GP" }) })
  ] });
}
function BT() {
  const { t: e } = Gt("header"), { url: t } = ve("/user/gpdetails"), { url: n } = ve("/"), { url: o } = ve("/collection"), { userInfos: r, apiUrl: i } = Ht((a) => ({
    userInfos: a.userInfos,
    apiUrl: a.apiUrl
  })), { signout: s } = Pr((a) => ({
    signout: a.signout
  }));
  return /* @__PURE__ */ P($d, { notificationValue: r?.notifications?.user?.total, children: [
    /* @__PURE__ */ P(kd, { position: "end", children: [
      /* @__PURE__ */ m(yn, { hideOn: "desktop", children: /* @__PURE__ */ m(UT, {}) }),
      /* @__PURE__ */ m(hn, { hideOn: "desktop" }),
      /* @__PURE__ */ m(wh, {}),
      /* @__PURE__ */ m(hn, {}),
      /* @__PURE__ */ m(MT, {}),
      /* @__PURE__ */ m(hn, { hideOn: "mobile" }),
      /* @__PURE__ */ m(Q, { href: t, hideOn: "mobile", children: /* @__PURE__ */ P(te, { gap: "1", children: [
        /* @__PURE__ */ m(Le, { isSpan: !0, isBold: !0, color: "secondary", children: r?.profil.totalGP }),
        /* @__PURE__ */ m(Le, { isSpan: !0, children: "GP" })
      ] }) }),
      /* @__PURE__ */ m(hn, { hideOn: "mobile" }),
      /* @__PURE__ */ P(Is, { hideOn: "mobile", children: [
        /* @__PURE__ */ m(Ps, { children: /* @__PURE__ */ P(te, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ m(Es, { value: r?.notifications?.user?.total ?? 0, children: /* @__PURE__ */ m(Sd, { url: r?.profil.profilePicture ?? "", alt: "avatar" }) }),
          e("my-account")
        ] }) }),
        /* @__PURE__ */ m(Ts, { size: "small", children: /* @__PURE__ */ m(VT, {}) })
      ] }),
      /* @__PURE__ */ m(Q, { hideOn: "desktop", href: o, children: "Home Exchange Collection" }),
      /* @__PURE__ */ m(Q, { hideOn: "desktop", href: n, children: "English" }),
      /* @__PURE__ */ m(Q, { hideOn: "desktop", href: n, children: "US dollars - $" })
    ] }),
    /* @__PURE__ */ m(yh, { apiUrl: i, onLogout: s, children: /* @__PURE__ */ m(Q, { marginAutoTop: !0, hideOn: "desktop", children: /* @__PURE__ */ P(te, { isFullWidth: !0, justifyContent: "start", children: [
      /* @__PURE__ */ m(he, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function HT() {
  const [e, t] = De(!1), [n, o] = De(!1), { url: r } = ve("/#signup"), { url: i } = ve("/#signin"), { url: s } = ve("/"), { url: a } = ve("/collection"), { apiUrl: l } = Ht((h) => ({ apiUrl: h.apiUrl })), { currentWidth: c } = X_(), { t: u } = Gt(["header", "links"]), { setIsSignedIn: d } = Pr((h) => ({
    setIsSignedIn: h.setIsSignedIn
  })), { setNavigationBarData: f } = Ht((h) => ({
    setNavigationBarData: h.setNavigationBarData
  }));
  return Q_("navigation-bar:open-signup-modal", () => {
    o(!0);
  }), /* @__PURE__ */ m($d, { children: /* @__PURE__ */ P(kd, { position: "end", children: [
    /* @__PURE__ */ m(Q, { href: u("links:how-it-works"), children: c && c <= 1300 ? /* @__PURE__ */ m(he, { name: "circle-help" }) : u("how-it-works") }),
    /* @__PURE__ */ m(Q, { href: u("links:subscription-cost"), children: c && c <= 1300 ? /* @__PURE__ */ m(he, { name: "dollar" }) : u("how-much-does-it-cost") }),
    /* @__PURE__ */ m(yn, { hideOn: "desktop", children: /* @__PURE__ */ m(hn, {}) }),
    /* @__PURE__ */ m(wh, {}),
    /* @__PURE__ */ m(yn, { hideOn: "desktop", children: /* @__PURE__ */ m(hn, {}) }),
    /* @__PURE__ */ m(Q, { href: a, hideOn: "desktop", children: "Home Exchange Collection" }),
    /* @__PURE__ */ m(Q, { href: s, hideOn: "desktop", children: "English" }),
    /* @__PURE__ */ m(Q, { href: s, hideOn: "desktop", children: "US dollars - $" }),
    /* @__PURE__ */ P(ze, { children: [
      /* @__PURE__ */ m(Q, { href: i, isSecondOnMobile: !0, isButton: !0, children: u("sign-in") }),
      /* @__PURE__ */ m(Q, { isFirstOnMobile: !0, largerPaddingBottom: !0, children: /* @__PURE__ */ m(ps, { href: r, size: "regular", color: "primary", children: u("sign-up-for-free") }) })
    ] })
  ] }) });
}
function KT({ theme: e }) {
  const { t } = Gt("header"), { apiUrl: n, assetsUrl: o } = Ht((a) => ({ apiUrl: a.apiUrl, assetsUrl: a.assetsUrl })), { isSignedIn: r } = Pr((a) => ({ isSignedIn: a.isSignedIn })), { url: i } = ve("/"), s = `${o}/navigation/he-logo${e === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ P(xd, { children: [
    /* @__PURE__ */ P(Ed, { children: [
      /* @__PURE__ */ m(Q, { backgroundOnHover: !1, href: i, children: /* @__PURE__ */ m("img", { src: s, alt: `HomeExchange ${e} logo ` }) }),
      /* @__PURE__ */ m(Q, { isFlexGrow: !0, children: /* @__PURE__ */ m(
        G_,
        {
          apiUrl: n,
          id: "navbar-search-bar",
          placeholder: t("common:autocomplete.placeholder"),
          buttonText: t("common:autocomplete.button"),
          hideButtonText: !0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ m(BT, {}) : /* @__PURE__ */ m(HT, {})
  ] });
}
function VL({
  conversations: e,
  userInfos: t,
  theme: n,
  isSignedIn: o,
  locale: r = "en",
  apiUrl: i,
  assetsUrl: s
}) {
  return Vc.changeLanguage(r), Sh(i), /* @__PURE__ */ m(sx, { isSignedIn: o, children: /* @__PURE__ */ m(nx, { conversations: e, userInfos: t, apiUrl: i, assetsUrl: s, children: /* @__PURE__ */ m(Uh, { i18n: Vc, children: /* @__PURE__ */ m(Nd, { locale: r, children: /* @__PURE__ */ m(KT, { theme: n }) }) }) }) });
}
const WT = ({ logoIsLink: e, theme: t, assetsUrl: n }) => {
  const { url: o } = ve("/"), r = `${n}/navigation/he-logo${t === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ m(xd, { isFixedTop: !0, children: /* @__PURE__ */ m(Ed, { children: /* @__PURE__ */ m(Q, { href: e ? o : void 0, children: /* @__PURE__ */ m("img", { src: r, alt: `HomeExchange ${t} logo ` }) }) }) });
}, UL = ({ logoIsLink: e, locale: t, theme: n, assetsUrl: o }) => /* @__PURE__ */ m(Nd, { locale: t || "en", children: /* @__PURE__ */ m(WT, { logoIsLink: e, theme: n, assetsUrl: o }) });
function BL({ locale: e }) {
  const [t, n] = De();
  return xe(() => {
    t || Ch(e).then(n);
  }, [t, e]), t && /* @__PURE__ */ m(
    jb,
    {
      text: t.communicationBanner.data.text,
      url: t.communicationBanner.data.link
    }
  );
}
export {
  BL as CommunicationBanner,
  VT as DesktopMenu,
  wh as HelpItem,
  UL as LiteHeader,
  BT as LoggedInMenu,
  HT as LoggedOutMenu,
  MT as MessagesItem,
  UT as MobileMenu,
  VL as NavigationBar,
  nx as NavigationBarProvider,
  FT as TabContent,
  qp as UserContext,
  sx as UserProvider,
  tx as createNavigationBarStore,
  ix as createUserStore,
  Ch as getCommunicationBannerData,
  WL as getNavigationBarData,
  qL as heFetch,
  Vc as i18nConfig,
  Sh as setNavigationBarFetchConfig,
  Ht as useNavigationBarContext,
  Pr as useUserContext
};
